export const ctp = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [126.98419895293965, 37.6363374548455],
            [126.96376722201323, 37.6297931165612],
            [126.95710810438416, 37.65283723058892],
            [126.94788243321867, 37.65712581204037],
            [126.94012815926209, 37.65663592719361],
            [126.93570568901892, 37.65120265513925],
            [126.92412290920528, 37.646106302093536],
            [126.91227986046482, 37.644315358282796],
            [126.9070962475348, 37.633397950199026],
            [126.90711746719701, 37.6219414631546],
            [126.90030432159122, 37.61119134558914],
            [126.90182975753098, 37.59514135083601],
            [126.89685903413574, 37.588566622015506],
            [126.8775423437769, 37.58624787215427],
            [126.87626055876719, 37.57818522952819],
            [126.85362858539504, 37.57379912020731],
            [126.81930252899663, 37.592849755415784],
            [126.80258139440184, 37.605032751291745],
            [126.79708249228624, 37.59773892665841],
            [126.80052027640662, 37.59030890238838],
            [126.7876142355346, 37.57558356148317],
            [126.78240829132184, 37.573606208840516],
            [126.77610890964422, 37.561863504965565],
            [126.76740685452621, 37.55422251966149],
            [126.77169082657399, 37.54830722172851],
            [126.78726079639769, 37.546076420216835],
            [126.7939634000023, 37.53736032118798],
            [126.8018499944564, 37.542715950085814],
            [126.820936223837, 37.54075211797072],
            [126.82842776306038, 37.526702780194036],
            [126.82310455528273, 37.51622024183686],
            [126.81964020426688, 37.49921062561295],
            [126.81457493423707, 37.49319333360832],
            [126.82276239353517, 37.489979311624516],
            [126.81899737749872, 37.47916240159528],
            [126.84536055113804, 37.47381246504809],
            [126.8527004669192, 37.48181862100867],
            [126.8697094568138, 37.49409550878434],
            [126.87176262320455, 37.48526938832845],
            [126.88461752785035, 37.46601233903355],
            [126.8864032397281, 37.45617343925105],
            [126.89398299845806, 37.45271733945676],
            [126.90298757178175, 37.43406758545019],
            [126.91926389390531, 37.43985239397997],
            [126.9232532742115, 37.44577274656787],
            [126.93055434562613, 37.44546848182805],
            [126.93774665963934, 37.43738575875866],
            [126.95896605519667, 37.439069769663455],
            [126.97457955999981, 37.45441287569978],
            [126.98661263252625, 37.45721233856852],
            [126.99623104515372, 37.46660839572704],
            [127.00273482078528, 37.46712461071864],
            [127.00853164933473, 37.458051571971964],
            [127.0145096155113, 37.45486122732481],
            [127.03373222200649, 37.461236946839286],
            [127.04005277532582, 37.438237145519594],
            [127.05216948259043, 37.42833977591078],
            [127.06568165843039, 37.428985318752446],
            [127.07062900368742, 37.432044555696],
            [127.07162594518984, 37.441523981851155],
            [127.0801716540251, 37.44105149584893],
            [127.0881613394731, 37.44538538433195],
            [127.09354041502398, 37.45588845591298],
            [127.10434122935226, 37.46217475485487],
            [127.11698929319067, 37.46148450981526],
            [127.13101155994151, 37.46780874168975],
            [127.13285604904866, 37.47462645849722],
            [127.14352658768853, 37.47393041836952],
            [127.14766978194545, 37.48242576587145],
            [127.15851360244915, 37.489665573325226],
            [127.16139035297738, 37.50020144406348],
            [127.14595211458052, 37.50322728244968],
            [127.13996586223696, 37.508641279406284],
            [127.14213625982916, 37.51565324988687],
            [127.15268697654696, 37.5285295056999],
            [127.15356673787608, 37.53366545280511],
            [127.16316277851398, 37.54499140122314],
            [127.18282541356943, 37.54634446534184],
            [127.18199541947102, 37.56099244574451],
            [127.175683133838, 37.574899085610674],
            [127.16674743767011, 37.57897566669599],
            [127.14894981929052, 37.56843431799725],
            [127.12861049299246, 37.56616043567371],
            [127.11733926606031, 37.55946362000007],
            [127.10639618926962, 37.556461722955945],
            [127.10120496463985, 37.56157990173221],
            [127.10423047543429, 37.57138765536828],
            [127.10344074316001, 37.580595296925296],
            [127.1168777580777, 37.595497051019656],
            [127.11714702082818, 37.61788844032129],
            [127.10406649341775, 37.62165311270919],
            [127.11163259457271, 37.63150328312305],
            [127.11075157374883, 37.64273028012444],
            [127.09457024704095, 37.644570600366876],
            [127.09120718723014, 37.659334556147016],
            [127.09623763499523, 37.668829414056155],
            [127.09218986524063, 37.67803011190936],
            [127.0959962350361, 37.68907104654827],
            [127.08653090515686, 37.689912203547586],
            [127.08110504441512, 37.69613746853876],
            [127.06273214168365, 37.694675910873684],
            [127.04982029789387, 37.68797700881461],
            [127.04110878616964, 37.695299782133965],
            [127.03102640957451, 37.693074532525614],
            [127.02928585352649, 37.6992916288796],
            [127.01541538430497, 37.701455284896966],
            [127.00966648935884, 37.69669983610248],
            [127.00844015206046, 37.68543159785317],
            [126.99731144620054, 37.68346620546423],
            [126.99324754614975, 37.67766063757545],
            [126.99222479574557, 37.66523164691455],
            [126.97965838948028, 37.65603864767585],
            [126.98393720731121, 37.64961005680928],
            [126.98419895293965, 37.6363374548455],
          ],
        ],
      },
      properties: { CTPRVN_CD: '11', CTP_ENG_NM: 'Seoul', CTP_KOR_NM: '서울특별시' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [129.28816405060556, 35.32116332291013],
              [129.2992139900427, 35.31855583839474],
              [129.30550336077786, 35.324756260731704],
              [129.3021838944221, 35.33362775635796],
              [129.27966259385985, 35.34137003385243],
              [129.2849312543842, 35.35073144259129],
              [129.28051636650937, 35.356221756925265],
              [129.28202854308287, 35.36396073470394],
              [129.2723458377157, 35.3772146953096],
              [129.26333801849623, 35.385643891895235],
              [129.25289708366816, 35.38683779528706],
              [129.21853631576397, 35.37895475034778],
              [129.21156372553585, 35.38077872006602],
              [129.19936774834358, 35.389037407511765],
              [129.1935948219745, 35.382088538700025],
              [129.19918182751547, 35.37597718849381],
              [129.19876242010815, 35.36649634177536],
              [129.17818815042597, 35.35177488805908],
              [129.16280587125942, 35.35680637855801],
              [129.14875851525412, 35.36425126968926],
              [129.133521096814, 35.36559376219653],
              [129.12703531002106, 35.362400386198004],
              [129.13467752256747, 35.352919845872464],
              [129.1273833959131, 35.345762150489655],
              [129.12533745235714, 35.3314151022696],
              [129.11217583183188, 35.31735046156787],
              [129.1124068363519, 35.31013825490823],
              [129.09909418318728, 35.30402068420253],
              [129.09055061153586, 35.30342335938939],
              [129.07360696352674, 35.290843068592366],
              [129.0705541402195, 35.29452228063901],
              [129.0589450299128, 35.29497904127953],
              [129.05349918298577, 35.28899663268284],
              [129.05386890905777, 35.2828673787907],
              [129.04459794772828, 35.27450348531052],
              [129.03068291840455, 35.27687798627218],
              [129.01712051064942, 35.2754594906067],
              [128.99880303004596, 35.2380821207559],
              [128.98415784279968, 35.229755894929646],
              [128.95669623761813, 35.22525193227874],
              [128.93979668779426, 35.2272498178263],
              [128.92012827581917, 35.216422618276084],
              [128.91250330129762, 35.222515096577084],
              [128.9046680213643, 35.215301286329826],
              [128.88606854250597, 35.21439882396512],
              [128.87035483868544, 35.20155867448291],
              [128.88141717825025, 35.18281577180998],
              [128.88043429080176, 35.17152971760106],
              [128.87603811701663, 35.16554297542393],
              [128.8746945772646, 35.1536007321729],
              [128.86526759214655, 35.15817227931219],
              [128.8720964441775, 35.16261675951221],
              [128.8597432627271, 35.168170710270445],
              [128.84628867044742, 35.16468784775423],
              [128.84293312010624, 35.15798866497323],
              [128.82299256367298, 35.15615870662857],
              [128.81596565658444, 35.16016201894779],
              [128.80059525694912, 35.15806774559782],
              [128.79430332106955, 35.15391326056176],
              [128.8021326186544, 35.14190150468839],
              [128.81535700418456, 35.13263487055223],
              [128.8297929699645, 35.12821814797772],
              [128.8381873462657, 35.12308839370676],
              [128.84170079043918, 35.10598953964202],
              [128.82187823421955, 35.097733819967964],
              [128.83760730242165, 35.08339064474037],
              [128.86833726826248, 35.08342910848232],
              [128.88014075423737, 35.079662385298676],
              [128.88783483632423, 35.09020678293535],
              [128.8894717707601, 35.107837426568445],
              [128.8976247557278, 35.12029059050126],
              [128.90563215914486, 35.118101648475395],
              [128.90058711624172, 35.11126009055913],
              [128.9004917643658, 35.10412299666795],
              [128.8953683512864, 35.086382857808815],
              [128.8953783955615, 35.079037228715954],
              [128.91111231034023, 35.079050516592375],
              [128.91221139599205, 35.08639778052226],
              [128.93301704824955, 35.09460362161289],
              [128.93467161398212, 35.08518401334487],
              [128.94415142094448, 35.08906149160726],
              [128.94866147879202, 35.10714648107295],
              [128.95649437595577, 35.10586108600709],
              [128.9509254131566, 35.07915782651068],
              [128.95816387434903, 35.05064502766284],
              [128.96737695682518, 35.04742171228446],
              [128.9817524491045, 35.04891826136327],
              [128.97810283598406, 35.05715593964625],
              [128.9884257552927, 35.05803105732097],
              [128.99542392467842, 35.045341297927365],
              [129.00121764852037, 35.048315636399195],
              [128.9953273025498, 35.06338232144428],
              [128.99262427470453, 35.080134643248975],
              [129.00263316369592, 35.08466258724076],
              [129.0116470710209, 35.0524450034672],
              [129.02228662784492, 35.06192826335486],
              [129.02128001421943, 35.069671220467484],
              [129.02654443443438, 35.08548596967956],
              [129.02522304001556, 35.09351164503793],
              [129.03687562382206, 35.09657728776634],
              [129.03973840723884, 35.10572764876086],
              [129.04997088017694, 35.12352857459198],
              [129.05597927739387, 35.1183072587338],
              [129.06562546860158, 35.122971575710075],
              [129.0730302196129, 35.12216510940125],
              [129.06737998395712, 35.10816120893153],
              [129.07498811386327, 35.103613890568695],
              [129.09034340916196, 35.10361266229782],
              [129.0956914187179, 35.09358988266926],
              [129.1022774084121, 35.09448784233128],
              [129.11298095159327, 35.103152363620445],
              [129.12339509343687, 35.09943768031036],
              [129.12831635083907, 35.118505504594665],
              [129.1177973605306, 35.132109393043436],
              [129.11442405350786, 35.14728149982124],
              [129.1196578948981, 35.154216784768714],
              [129.13382029109866, 35.154855334654904],
              [129.15281951852637, 35.15188167421899],
              [129.1553864009536, 35.15720543797826],
              [129.1656530940868, 35.15958951570758],
              [129.1809317077833, 35.154853782985576],
              [129.19624140093288, 35.16392483690404],
              [129.20057149902175, 35.179700363854],
              [129.2238191706144, 35.18599582647215],
              [129.22999760791822, 35.20076648355694],
              [129.22203678963132, 35.213093666883374],
              [129.2308235319417, 35.22048734553339],
              [129.2394958059254, 35.22311952567758],
              [129.24281056611164, 35.2371559248636],
              [129.2530838983402, 35.24657537900221],
              [129.2521731219612, 35.25938196015892],
              [129.238837298576, 35.25729973382991],
              [129.2356949180484, 35.265012175556315],
              [129.24352989842916, 35.27013645481528],
              [129.25329950644948, 35.27180905960343],
              [129.25720166360955, 35.28937681718111],
              [129.2611603149461, 35.296705298768735],
              [129.25786870624268, 35.30574370296389],
              [129.26174772191868, 35.31526243362639],
              [129.2681926511545, 35.321924384019454],
              [129.2849886694989, 35.32621538325488],
              [129.28816405060556, 35.32116332291013],
            ],
          ],
          [
            [
              [128.8286558392586, 35.08993277730629],
              [128.81151492504463, 35.07758037184824],
              [128.8351375507166, 35.07761720383122],
              [128.8323894619356, 35.07130338872612],
              [128.80498744938743, 35.066747878235994],
              [128.80500436758058, 35.04807093687787],
              [128.81267930570007, 35.0376400886284],
              [128.80962997763686, 35.03028452748502],
              [128.81562333966133, 35.028032216557314],
              [128.81313574202073, 35.02030081570669],
              [128.82733718566803, 35.013521547086846],
              [128.82223590468632, 35.00157453749011],
              [128.82959902170055, 34.99551124821694],
              [128.8362978046532, 34.99727300375391],
              [128.83974050037762, 35.008411360097014],
              [128.83477404118187, 35.015948708433804],
              [128.84312064742244, 35.02438952168977],
              [128.84170487742196, 35.0294403441201],
              [128.8508996066796, 35.04208294927268],
              [128.84642708956778, 35.05638075189629],
              [128.83770579970286, 35.053459557403514],
              [128.83511205108942, 35.062628640693745],
              [128.8352014736753, 35.08621226071654],
              [128.8286558392586, 35.08993277730629],
            ],
          ],
          [
            [
              [129.07019782390236, 35.060306711598535],
              [129.07744317612813, 35.060705021530936],
              [129.08284431960843, 35.05045006846951],
              [129.09173818704934, 35.051191597697816],
              [129.09621076118862, 35.05975758705809],
              [129.08545825437517, 35.06567871015575],
              [129.07924615106774, 35.08477340448413],
              [129.06837877599787, 35.0959454902915],
              [129.05882143439786, 35.100532114242],
              [129.03163031630174, 35.09401681138782],
              [129.03415510137637, 35.085371843711535],
              [129.04687285622913, 35.07562401422549],
              [129.06545125241396, 35.06852462308169],
              [129.07019782390236, 35.060306711598535],
            ],
          ],
        ],
      },
      properties: { CTPRVN_CD: '26', CTP_ENG_NM: 'Busan', CTP_KOR_NM: '부산광역시' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [128.47278366323025, 35.833449357026986],
            [128.4812171291081, 35.83008647608556],
            [128.48153705235939, 35.81601215235695],
            [128.47043315407822, 35.80592233603556],
            [128.44102906192109, 35.806016721049346],
            [128.44094548287484, 35.80929418173578],
            [128.42082951653015, 35.80935457399662],
            [128.4081191674854, 35.799208369573584],
            [128.39690318160774, 35.777683876913386],
            [128.38963135057793, 35.769987133326126],
            [128.383294161869, 35.75858521798448],
            [128.39124694912587, 35.74835267228071],
            [128.42164607131815, 35.73313466773768],
            [128.43181591139054, 35.72559809983701],
            [128.4348893652981, 35.71475772298941],
            [128.43398078083717, 35.707070291762506],
            [128.4254583406453, 35.69922939970195],
            [128.4122017560316, 35.69584190035295],
            [128.39706277632482, 35.70022325829127],
            [128.3819729682728, 35.70154770445564],
            [128.3588782980828, 35.70870122959309],
            [128.35179674491113, 35.704015637307876],
            [128.35154836598005, 35.69745779351315],
            [128.3571864234718, 35.682195232490685],
            [128.3725111095012, 35.66662063582663],
            [128.39227031919785, 35.6534491480879],
            [128.40003662664995, 35.64555488242525],
            [128.40125141360215, 35.632728695766986],
            [128.38837581523757, 35.617928286850386],
            [128.37341352689617, 35.61248621721472],
            [128.3819175882916, 35.60661490678708],
            [128.39929244817347, 35.61591912303117],
            [128.40654261481504, 35.61419723564397],
            [128.41903981667411, 35.619697783500364],
            [128.4227163739336, 35.62508179839475],
            [128.43098032264066, 35.62163880020092],
            [128.44647601602577, 35.63841360717604],
            [128.46626306315875, 35.63674405140089],
            [128.476187430613, 35.64020682099182],
            [128.48134003287907, 35.635265698745016],
            [128.5062362103738, 35.63955696956706],
            [128.50945505835645, 35.67471463708142],
            [128.52792537813355, 35.68315511432784],
            [128.53526366372037, 35.69405160233104],
            [128.53388666383682, 35.703260183723486],
            [128.52790486607077, 35.71274079389305],
            [128.5440857250863, 35.71943408955178],
            [128.55233077569136, 35.726353824084214],
            [128.58051590398682, 35.738666601719345],
            [128.58960087757518, 35.73150376232901],
            [128.59562182246822, 35.73721135800098],
            [128.6074989616865, 35.73899834945592],
            [128.6147984245231, 35.73094200791001],
            [128.60993447338123, 35.72487576143785],
            [128.6158248970926, 35.72016730121054],
            [128.61391605748443, 35.70984087624313],
            [128.62449760328604, 35.703354953769605],
            [128.63050112407865, 35.70667221435755],
            [128.64621196905685, 35.70817378351944],
            [128.6566102415172, 35.717859552922036],
            [128.68323970851887, 35.72145444394808],
            [128.69096425410896, 35.73088883508122],
            [128.6892839163547, 35.7401935542613],
            [128.69548563411786, 35.75574218307316],
            [128.68635015821877, 35.76872367439351],
            [128.68707047110263, 35.77549885949104],
            [128.68156236196864, 35.78396282249656],
            [128.68251170311984, 35.7901486190313],
            [128.69747084785172, 35.79435144601315],
            [128.71016038770873, 35.804245542371085],
            [128.71605769486249, 35.80528430375373],
            [128.71388535972332, 35.81750817960412],
            [128.70863734633147, 35.826567932787604],
            [128.72436192759298, 35.8404414206923],
            [128.726798417662, 35.84738404229278],
            [128.72551084993827, 35.85780098742449],
            [128.7385723651609, 35.851298225005756],
            [128.75075169427433, 35.857508731135454],
            [128.75979536877617, 35.86607499110693],
            [128.7587321002822, 35.87855294837583],
            [128.76229633468898, 35.88883676988243],
            [128.75750735928355, 35.89626587403616],
            [128.75980138461728, 35.90683328792107],
            [128.7552958341598, 35.91500523544415],
            [128.74267749624264, 35.92039874076461],
            [128.73764612857477, 35.928102892825855],
            [128.7440867070753, 35.94395801895233],
            [128.73890603682432, 35.957237154999845],
            [128.7429946311134, 35.959945389897534],
            [128.746210261466, 35.97286863802332],
            [128.73097394552158, 35.98536143562546],
            [128.7348557068791, 35.9929560397832],
            [128.72781435606888, 36.002226855476465],
            [128.7178649125699, 36.00812713272159],
            [128.70138199267228, 36.010852622985524],
            [128.69559651052666, 36.016165006819186],
            [128.69983930153, 36.02865517840634],
            [128.69686041795444, 36.03624520911845],
            [128.7041064037075, 36.04440505824871],
            [128.70316516669317, 36.056420169180946],
            [128.71146161563092, 36.06781836037871],
            [128.71403901133357, 36.0754840491703],
            [128.72143917116068, 36.07312967945609],
            [128.72938552469728, 36.08096995517677],
            [128.72673702162325, 36.093267431046726],
            [128.73633725738404, 36.099408267405565],
            [128.7516447904074, 36.103049667707815],
            [128.7536734054537, 36.09078022262692],
            [128.7645200614892, 36.100656907012485],
            [128.78762375299513, 36.08914288711465],
            [128.79853153320173, 36.08531733142869],
            [128.81131060743274, 36.08932785310147],
            [128.82228009783353, 36.10046797397884],
            [128.83261903064223, 36.1019919505713],
            [128.83783877026852, 36.113051977263545],
            [128.8509529967127, 36.1181767773717],
            [128.85344317951626, 36.128418468392354],
            [128.8508659104219, 36.13804972055591],
            [128.8585741361697, 36.14496944183862],
            [128.88985883441788, 36.142528312097795],
            [128.89160576255838, 36.1550406226499],
            [128.90019665889142, 36.1623775255328],
            [128.88508455172072, 36.184014700217716],
            [128.88076604159798, 36.198857575197934],
            [128.87121588807472, 36.20515941294576],
            [128.85837441255006, 36.207807288248695],
            [128.8485108292413, 36.21471163759874],
            [128.8342171919454, 36.214601251193805],
            [128.82655683905065, 36.21824196687059],
            [128.80522552729366, 36.20700192951233],
            [128.79644714116478, 36.19081957771242],
            [128.7806611817336, 36.194380464393376],
            [128.76995776075609, 36.19342569216862],
            [128.7579766440633, 36.202862035647755],
            [128.7495908195845, 36.19595939563883],
            [128.7274758734602, 36.20075863585955],
            [128.71913175832518, 36.19808316229516],
            [128.6963324149586, 36.202150582895364],
            [128.69806885886373, 36.21166634289682],
            [128.68271222242248, 36.21529432345302],
            [128.66937833486895, 36.209371158489446],
            [128.66464136142932, 36.218961527826686],
            [128.6597553276225, 36.22138032154586],
            [128.6487011937086, 36.21806849181752],
            [128.63941162023664, 36.20748355206648],
            [128.63431079101974, 36.2136720090787],
            [128.63665195308167, 36.23310046607819],
            [128.63312567331013, 36.23866176469421],
            [128.64136950423878, 36.244804869751114],
            [128.64060022603974, 36.257512989313916],
            [128.62448266949943, 36.26672300539117],
            [128.6089065791427, 36.27120920117853],
            [128.59763008860804, 36.27133025680234],
            [128.59450131681882, 36.2777185422456],
            [128.57581283713407, 36.2799333431721],
            [128.56675378672682, 36.274214077337206],
            [128.55182727961784, 36.27502887136945],
            [128.54551415326918, 36.29195247244926],
            [128.52588221400472, 36.299307949828794],
            [128.50851348877313, 36.30331872507967],
            [128.49643750602732, 36.30295024807478],
            [128.48772934050373, 36.30810987664881],
            [128.4731853634752, 36.31217725004985],
            [128.46857889860422, 36.321798317263735],
            [128.45575607320754, 36.32501782113018],
            [128.44704445481065, 36.322688958255405],
            [128.43803981543587, 36.31404220638877],
            [128.4278899334339, 36.29891464616116],
            [128.41650968697775, 36.298719353112695],
            [128.41043911324016, 36.28720079765964],
            [128.42643694876529, 36.27541312884045],
            [128.42073665116257, 36.266194186440345],
            [128.41765350348487, 36.245856538888674],
            [128.42544825618026, 36.23615681592106],
            [128.43400176361365, 36.23434605409781],
            [128.43784807799244, 36.2227508304761],
            [128.45089722455936, 36.22173550516502],
            [128.47844953155547, 36.234713056140954],
            [128.48506247841772, 36.233202453377885],
            [128.48300815264315, 36.22466247236918],
            [128.49406798399704, 36.206223188607396],
            [128.49321498933855, 36.20069811587173],
            [128.5071113516454, 36.18556903155394],
            [128.51600742973088, 36.199698621607936],
            [128.52277665260428, 36.201424633362386],
            [128.5366098406781, 36.19493314306114],
            [128.54882752636698, 36.177810861866256],
            [128.5568787723304, 36.177174994028356],
            [128.55236996836948, 36.16490839927763],
            [128.54486878279872, 36.166100870360125],
            [128.5400784433219, 36.16109016938275],
            [128.55018583558456, 36.15064806358539],
            [128.54858712571277, 36.13215703735082],
            [128.55487898958856, 36.121616902396674],
            [128.56400288757104, 36.11585808893645],
            [128.56492970136068, 36.10391199587123],
            [128.56900515205004, 36.088499806021524],
            [128.56384185453595, 36.06975615490443],
            [128.5689223430552, 36.06199632010587],
            [128.5944568940213, 36.06283483745738],
            [128.59787945398816, 36.074961343087416],
            [128.61820840448254, 36.07693746265952],
            [128.6277576995303, 36.080162407643385],
            [128.63269469064224, 36.06684292395705],
            [128.6284374019421, 36.05994702687936],
            [128.62790928787228, 36.04566934380001],
            [128.6225905509415, 36.03781053573491],
            [128.6213522140278, 36.02523583223414],
            [128.63690108603248, 36.01688668640306],
            [128.63922986403898, 36.01287425359197],
            [128.6305810976856, 36.00712085203429],
            [128.61748582038734, 36.006737364810704],
            [128.60335923053327, 35.987987343714195],
            [128.58509702292585, 35.97795759228583],
            [128.57283756882117, 35.97831254268843],
            [128.5647073361919, 35.972937372843816],
            [128.5558210047752, 35.97221196623621],
            [128.55338047619406, 35.96069304787832],
            [128.54634010669213, 35.96633542357019],
            [128.54282337318523, 35.97524187010445],
            [128.5312405512563, 35.980562331835166],
            [128.52665053698072, 35.97544743154902],
            [128.53452132181445, 35.93868815782027],
            [128.5290437757736, 35.92369491397714],
            [128.51689771840367, 35.91186115260662],
            [128.51008028519175, 35.90992759718543],
            [128.50503993140987, 35.902850672007446],
            [128.50416087440163, 35.88959019924672],
            [128.49472186665133, 35.89078926922038],
            [128.4906169691326, 35.89757917357058],
            [128.4752695618789, 35.8944575394364],
            [128.46775464851333, 35.900218488964725],
            [128.4653990184411, 35.90859046747493],
            [128.4727553731888, 35.91443592142388],
            [128.4764188660098, 35.934439337202015],
            [128.4541552739197, 35.94314943840826],
            [128.45033817962465, 35.93504165528418],
            [128.43103622595768, 35.93052647223441],
            [128.41829468828874, 35.91663243294942],
            [128.4067715565596, 35.90142308553189],
            [128.39897668668667, 35.899926525587276],
            [128.39806677074657, 35.89270855372734],
            [128.38359481669534, 35.862554688055766],
            [128.38351017124933, 35.85283465059981],
            [128.41598215810066, 35.851757053777355],
            [128.4361822573171, 35.84833354555371],
            [128.45064806980665, 35.84399825318101],
            [128.46365136923296, 35.83777109707654],
            [128.46554007068008, 35.83723314163651],
            [128.4725462810764, 35.8336077919734],
            [128.4726338062446, 35.833554774801044],
            [128.47278366323025, 35.833449357026986],
          ],
        ],
      },
      properties: { CTPRVN_CD: '27', CTP_ENG_NM: 'Daegu', CTP_KOR_NM: '대구광역시' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [125.98540764267092, 37.040034709779796],
              [125.98094158800511, 37.0335183913033],
              [125.99205889481048, 37.027981817333455],
              [125.99425927408257, 37.034694875359534],
              [125.98540764267092, 37.040034709779796],
            ],
          ],
          [
            [
              [126.07983158360564, 37.10802599560712],
              [126.06886873126822, 37.10502134249432],
              [126.07154434347484, 37.09766547021352],
              [126.06292518201195, 37.08883810792051],
              [126.06789336291934, 37.0833522748526],
              [126.07548188878067, 37.08492826868963],
              [126.08879152271307, 37.096627217663595],
              [126.0850943059707, 37.10705532675844],
              [126.07983158360564, 37.10802599560712],
            ],
          ],
          [
            [
              [126.29514876038355, 37.17384355161231],
              [126.29107770142052, 37.17033874250001],
              [126.3087965499037, 37.16221115470594],
              [126.32126619982394, 37.159077553572075],
              [126.31231733223805, 37.171632117142224],
              [126.29514876038355, 37.17384355161231],
            ],
          ],
          [
            [
              [126.25577325389392, 37.1815057800781],
              [126.24558579685045, 37.175307147602346],
              [126.2486304317545, 37.17059676812206],
              [126.2577997093185, 37.17163130772332],
              [126.27298773683599, 37.16511324952258],
              [126.26986621534479, 37.175057568149484],
              [126.25577325389392, 37.1815057800781],
            ],
          ],
          [
            [
              [126.22820890973988, 37.18678059476055],
              [126.22325366903443, 37.180600286113716],
              [126.23819071059813, 37.17837265839234],
              [126.24458173421871, 37.183833303331355],
              [126.22820890973988, 37.18678059476055],
            ],
          ],
          [
            [
              [126.09799827158479, 37.1865534286635],
              [126.09375505190098, 37.18765792321941],
              [126.08502770340674, 37.17778808419801],
              [126.09441300416647, 37.16744613101482],
              [126.10674347143382, 37.16618111710004],
              [126.10777585406318, 37.17645733306062],
              [126.09799827158479, 37.1865534286635],
            ],
          ],
          [
            [
              [125.97357840102143, 37.19487941386578],
              [125.9753746018885, 37.1856600899318],
              [125.98346616534474, 37.19022749948964],
              [125.97357840102143, 37.19487941386578],
            ],
          ],
          [
            [
              [126.17049747717041, 37.226279320333646],
              [126.16036041577591, 37.2180175496202],
              [126.16404855834305, 37.21239591308759],
              [126.17850336759568, 37.21136168650409],
              [126.18143134017663, 37.19652269935888],
              [126.18902411675961, 37.20703438756491],
              [126.18022584134712, 37.20975540250849],
              [126.18003988250437, 37.21732632403589],
              [126.17049747717041, 37.226279320333646],
            ],
          ],
          [
            [
              [126.52180229363059, 37.25814995774604],
              [126.52631281582896, 37.24154897918831],
              [126.52481105475185, 37.2358084707728],
              [126.53732653859144, 37.232476869468364],
              [126.53316441049219, 37.24422904828323],
              [126.52180229363059, 37.25814995774604],
            ],
          ],
          [
            [
              [126.28764537552537, 37.27174832577365],
              [126.28682356525651, 37.260517813237016],
              [126.2967154507063, 37.252738126674885],
              [126.3051317994237, 37.25349453324702],
              [126.3189835502327, 37.24466780052598],
              [126.33965480708795, 37.249568122911676],
              [126.34903131142445, 37.259213503283874],
              [126.3343665695515, 37.26187991738268],
              [126.33296681695451, 37.254888951605075],
              [126.31609951601433, 37.26193382781721],
              [126.28917327072958, 37.266959393972805],
              [126.28764537552537, 37.27174832577365],
            ],
          ],
          [
            [
              [126.10489742299983, 37.273656646818075],
              [126.09462463154347, 37.25178252924532],
              [126.08963928757153, 37.247266706970294],
              [126.09054057979888, 37.239764144339496],
              [126.09614661272222, 37.23060594978437],
              [126.11496901922419, 37.222391645355806],
              [126.11931236585241, 37.211598078594925],
              [126.1435309425713, 37.215723837585685],
              [126.14317053781666, 37.22199714809552],
              [126.16501994181215, 37.23152045196959],
              [126.1546447976273, 37.235236155431835],
              [126.12977930937974, 37.24731597662125],
              [126.12030051468291, 37.24683567649214],
              [126.1181267189602, 37.25775155524187],
              [126.11217034187062, 37.257170775967026],
              [126.10489742299983, 37.273656646818075],
            ],
          ],
          [
            [
              [126.439215829004, 37.23113416628484],
              [126.440567704343, 37.23868264625869],
              [126.44712202375797, 37.2426143612674],
              [126.4566863233117, 37.24053318229094],
              [126.45781951688919, 37.22603814065994],
              [126.4693750626765, 37.23310741443086],
              [126.47034352916461, 37.23915549826268],
              [126.48223683665522, 37.24754168805877],
              [126.47540949618198, 37.25262092897531],
              [126.48635606558292, 37.2596756910276],
              [126.49649461384726, 37.25581676887782],
              [126.49450394654676, 37.27751304839713],
              [126.47139614227898, 37.284522111895654],
              [126.45725751922714, 37.28265100838605],
              [126.44701981369855, 37.271365062046705],
              [126.43502765150505, 37.272916765682744],
              [126.43688413474297, 37.26548734986253],
              [126.43269082044382, 37.260915992115756],
              [126.43622205655707, 37.25426636612373],
              [126.4316513134855, 37.24432898398317],
              [126.43172334784757, 37.23394718474133],
              [126.439215829004, 37.23113416628484],
            ],
          ],
          [
            [
              [126.41078726302709, 37.41103925966939],
              [126.40055944112133, 37.40092946675304],
              [126.41027168271818, 37.38289839804607],
              [126.40820266743404, 37.37336977031574],
              [126.41386011570333, 37.366484488748355],
              [126.43018203011688, 37.36984186553057],
              [126.43997776316311, 37.376904796599796],
              [126.44129435681127, 37.38491394262816],
              [126.43134958886407, 37.38976449854002],
              [126.42205334047148, 37.40039957023935],
              [126.4131202027555, 37.4053382714017],
              [126.41078726302709, 37.41103925966939],
            ],
          ],
          [
            [
              [126.54063214465984, 37.52137205455773],
              [126.52483756608666, 37.524915331680255],
              [126.5225036749286, 37.53044161215396],
              [126.51237343504938, 37.53425940612884],
              [126.49933273996388, 37.530933532708744],
              [126.49674599966599, 37.5261126505213],
              [126.49426957115303, 37.507495537097775],
              [126.47134884661789, 37.49847651602758],
              [126.44925250688627, 37.499082005300245],
              [126.41691275708166, 37.49607054755726],
              [126.37418449668141, 37.47190259511221],
              [126.36416950712704, 37.47456012993618],
              [126.35578510554022, 37.46756799113458],
              [126.36179636696619, 37.457936448190836],
              [126.36712988249074, 37.457743327889126],
              [126.37262659032467, 37.44450926030798],
              [126.38005400084, 37.439907870910766],
              [126.39659743083283, 37.44593434187988],
              [126.40439551792356, 37.438691985636716],
              [126.41140505588544, 37.43725602343708],
              [126.42147671218711, 37.42142889779528],
              [126.42801934373952, 37.423099507441655],
              [126.44308783596793, 37.421525636309845],
              [126.48402189471155, 37.44465612685848],
              [126.49457583167364, 37.45676395892673],
              [126.50766160048242, 37.466180988676214],
              [126.53612264926917, 37.47566769774754],
              [126.5521499326106, 37.476817686323635],
              [126.56575783390147, 37.480128002812734],
              [126.58257529425998, 37.49064655394427],
              [126.57638712982404, 37.502837125694015],
              [126.56400538723615, 37.51475481957099],
              [126.54063214465984, 37.52137205455773],
            ],
          ],
          [
            [
              [126.5441517709064, 37.52285500289348],
              [126.55154303843017, 37.52856297473165],
              [126.55806762675876, 37.52121015657227],
              [126.57507915501196, 37.52123018260086],
              [126.57635582159054, 37.54349457716769],
              [126.56593184352586, 37.540118526401],
              [126.5441517709064, 37.52285500289348],
            ],
          ],
          [
            [
              [126.46112320831675, 37.54410450360747],
              [126.44862169533286, 37.53331641232364],
              [126.43143288139716, 37.52553797676508],
              [126.42976474802698, 37.518658057442835],
              [126.43671053058921, 37.51556202026389],
              [126.44584030806014, 37.519892003221905],
              [126.45920682271824, 37.51693000447435],
              [126.46414545062126, 37.51181133492227],
              [126.47317454953557, 37.528737893153334],
              [126.47289380992689, 37.53685902494406],
              [126.46112320831675, 37.54410450360747],
            ],
          ],
          [
            [
              [126.42735280185313, 37.54805798972415],
              [126.42016321800484, 37.5365121360106],
              [126.42026957837109, 37.52625130034058],
              [126.43185840617133, 37.53097610662826],
              [126.43446626491583, 37.54442506276438],
              [126.42735280185313, 37.54805798972415],
            ],
          ],
          [
            [
              [126.31233744430821, 37.55896718190685],
              [126.3132146554741, 37.55294786509109],
              [126.33036833099627, 37.537032606756156],
              [126.32860527995815, 37.52708669146443],
              [126.36149609133778, 37.53104125284987],
              [126.38212294574966, 37.52843517932586],
              [126.3841787482758, 37.53730234894645],
              [126.3650386862094, 37.53429706679508],
              [126.34550854761277, 37.53809002880675],
              [126.3401714918361, 37.547203655936556],
              [126.31233744430821, 37.55896718190685],
            ],
          ],
          [
            [
              [126.6084320136318, 37.553870876373594],
              [126.59665587047863, 37.54857901033199],
              [126.60262813547892, 37.53328711980847],
              [126.60454310111083, 37.49590424328756],
              [126.63631786566256, 37.495880463516194],
              [126.60805582344996, 37.48676246263301],
              [126.60060066118568, 37.4815228911382],
              [126.59516762247459, 37.47075112528444],
              [126.59777014395206, 37.453991431036904],
              [126.59321018805623, 37.44934687732659],
              [126.59426649692044, 37.43867982161447],
              [126.6081031723077, 37.44095332972262],
              [126.6154503242192, 37.43797748443412],
              [126.61166364956418, 37.42993401627439],
              [126.63234674030423, 37.42999703836869],
              [126.63275641626241, 37.42684672090669],
              [126.60807168344844, 37.426765583458085],
              [126.60102744182561, 37.419655057943366],
              [126.60981481181841, 37.4163215466408],
              [126.60996708541865, 37.387187176506565],
              [126.61627252140985, 37.379449429316004],
              [126.65465802791984, 37.3559596827104],
              [126.64314791826365, 37.34775899867931],
              [126.62961553417898, 37.34784440341443],
              [126.62970073902737, 37.35490116232689],
              [126.583048385168, 37.35472619376944],
              [126.58309065136991, 37.34729368848547],
              [126.62268069153087, 37.34747815868528],
              [126.62270909055984, 37.34180657988157],
              [126.6407645306694, 37.34186327880575],
              [126.65473816156833, 37.355899041895086],
              [126.66344966004517, 37.35053506621422],
              [126.69505736740977, 37.38272842209552],
              [126.72114288972902, 37.38250405560173],
              [126.74440769695892, 37.40189310149788],
              [126.75504646568463, 37.41821036020204],
              [126.7532536647419, 37.42270208349171],
              [126.7692061987954, 37.42750590313029],
              [126.77033344289552, 37.44750031715412],
              [126.77902298838511, 37.451020775983466],
              [126.77711114557613, 37.47222057793231],
              [126.76775797131856, 37.47176433450249],
              [126.7555495338238, 37.48287280481845],
              [126.74235375867006, 37.48694894470053],
              [126.74373713963433, 37.5017922325561],
              [126.74147085470766, 37.508987904695104],
              [126.7451092630634, 37.51413659915948],
              [126.76027632720294, 37.51591563058984],
              [126.76014381163405, 37.53549309178173],
              [126.76718644839676, 37.55664983581414],
              [126.77610901177957, 37.561863374036314],
              [126.782408393568, 37.57360607625452],
              [126.79368162609252, 37.58157596223262],
              [126.78704813698508, 37.58557939595306],
              [126.77299076146736, 37.58504734185382],
              [126.76734488161196, 37.58828825983797],
              [126.7580115873771, 37.58522179925339],
              [126.75469873511949, 37.580137038300975],
              [126.74525895871582, 37.58871652187438],
              [126.72566542890397, 37.591842131461554],
              [126.70840814240262, 37.60491093574721],
              [126.70543647446826, 37.61176362497732],
              [126.67242235746534, 37.63384188397714],
              [126.65125266397112, 37.637987918609376],
              [126.64756407203903, 37.62893366623706],
              [126.63725969062446, 37.62650966187055],
              [126.62581676368086, 37.60268210781601],
              [126.60947023589355, 37.6045437967433],
              [126.59156455632382, 37.59301182393166],
              [126.59734008187486, 37.58198844784975],
              [126.60726495321553, 37.58806494925464],
              [126.61354385385263, 37.58584523183231],
              [126.63985902906262, 37.58548082818596],
              [126.66110720970505, 37.57286025255519],
              [126.63746422145432, 37.570892677306176],
              [126.60109704409003, 37.56153273910411],
              [126.6073038462872, 37.554438682877255],
              [126.62163985869175, 37.55653979257607],
              [126.64073148513931, 37.567016124480766],
              [126.63845761010191, 37.55673038036858],
              [126.63100064510468, 37.558257621727485],
              [126.6084320136318, 37.553870876373594],
            ],
            [
              [126.61881980194562, 37.46899000900274],
              [126.62674358099761, 37.46169974685905],
              [126.62426824673544, 37.45765060891282],
              [126.603938088417, 37.46630208401682],
              [126.61881980194562, 37.46899000900274],
            ],
          ],
          [
            [
              [126.51949944700591, 37.598165748632766],
              [126.51331067426239, 37.59312300194714],
              [126.5031558698583, 37.59049250022664],
              [126.51538355790554, 37.579981751434154],
              [126.52101681361651, 37.586449754118114],
              [126.51949944700591, 37.598165748632766],
            ],
          ],
          [
            [
              [125.71452351448822, 37.615285067743045],
              [125.7077930082974, 37.6098033770121],
              [125.71686205104596, 37.604075226694114],
              [125.72014565838396, 37.614398345933495],
              [125.71452351448822, 37.615285067743045],
            ],
          ],
          [
            [
              [126.23322124451089, 37.655605310617055],
              [126.22560716981195, 37.650505879218834],
              [126.23364677673736, 37.63979628243737],
              [126.24741644976898, 37.631315999548576],
              [126.25619270924389, 37.65180754418491],
              [126.23844935920063, 37.65252489629981],
              [126.23322124451089, 37.655605310617055],
            ],
          ],
          [
            [
              [125.6834473589556, 37.68077858330365],
              [125.67778506236193, 37.67636198083656],
              [125.68468020033059, 37.671045019225154],
              [125.68154811842602, 37.66281271858164],
              [125.6867301821847, 37.65237579855802],
              [125.69189335284486, 37.65313004570424],
              [125.70929963795379, 37.66563110139171],
              [125.71610548827157, 37.67343078210032],
              [125.71442329932391, 37.68095754881488],
              [125.68670178959466, 37.6776039437432],
              [125.6834473589556, 37.68077858330365],
            ],
          ],
          [
            [
              [126.19452862313298, 37.68834045309683],
              [126.1747030796827, 37.6768087427921],
              [126.16771259777862, 37.6791251364424],
              [126.15603177102322, 37.67276285624522],
              [126.16518524275735, 37.66882653271844],
              [126.17926934500784, 37.670400895511456],
              [126.19066422674344, 37.66421167689213],
              [126.19359654197042, 37.65913137976744],
              [126.20507910524555, 37.656969085819334],
              [126.21051562149546, 37.665090879563095],
              [126.19572637506855, 37.68204487786909],
              [126.19452862313298, 37.68834045309683],
            ],
          ],
          [
            [
              [126.23589848503764, 37.73135277089435],
              [126.22697499352824, 37.728282014666014],
              [126.22165645575559, 37.71859923891875],
              [126.23232018086445, 37.71604239237345],
              [126.23811157277657, 37.72180943882144],
              [126.23589848503764, 37.73135277089435],
            ],
          ],
          [
            [
              [126.2656236984719, 37.73787492687194],
              [126.2584485645971, 37.73368537063105],
              [126.25836922417672, 37.725059393933925],
              [126.26817501798509, 37.72733480855472],
              [126.2656236984719, 37.73787492687194],
            ],
          ],
          [
            [
              [126.34273965697058, 37.643550791466474],
              [126.3428206846167, 37.650788207674],
              [126.35651889713003, 37.65564925835224],
              [126.37534940948606, 37.668916375810525],
              [126.37900469554808, 37.68194911750486],
              [126.36312215612817, 37.6957154469178],
              [126.34920617839603, 37.69572276429821],
              [126.33857833034355, 37.699175554290875],
              [126.3199918547529, 37.7116364195172],
              [126.31717402837118, 37.71744072594521],
              [126.31847475611843, 37.729997399692465],
              [126.32393408152969, 37.741312285535024],
              [126.32963771577302, 37.74633655780194],
              [126.31733408187594, 37.752285971235885],
              [126.28981100241272, 37.740722267485154],
              [126.28670460900838, 37.71272295512137],
              [126.28246175096417, 37.702919090210884],
              [126.29303418384704, 37.69302979144406],
              [126.31567695599327, 37.6845766868782],
              [126.3287189351123, 37.670165014784196],
              [126.32521466286934, 37.65847180195182],
              [126.34273965697058, 37.643550791466474],
            ],
          ],
          [
            [
              [124.77050938639192, 37.778414994917625],
              [124.75169760619957, 37.7775409233612],
              [124.74058746604106, 37.77196806169918],
              [124.76787827325634, 37.77091601336268],
              [124.77050938639192, 37.778414994917625],
            ],
          ],
          [
            [
              [126.26451707479617, 37.81778583882873],
              [126.24768247222505, 37.814530303652866],
              [126.24051922825885, 37.81730021026324],
              [126.22322045539728, 37.805036702787],
              [126.21877344341016, 37.79559777851764],
              [126.22289429267276, 37.7914617495575],
              [126.21634667622433, 37.77815916112374],
              [126.20379565658035, 37.77235717251468],
              [126.22668940663414, 37.75350802437201],
              [126.2330146546016, 37.75117996801419],
              [126.2482700850796, 37.7656003456747],
              [126.2604152358958, 37.7645357955733],
              [126.2706924184955, 37.768684887133396],
              [126.28056375703132, 37.768651687502235],
              [126.29081580750622, 37.76294258368397],
              [126.31577075891258, 37.77398861985257],
              [126.31851770504959, 37.77925682693633],
              [126.3313087748442, 37.78965066823467],
              [126.33205966891926, 37.79970059084372],
              [126.3240681597076, 37.80823214454256],
              [126.31480507531184, 37.80227963677418],
              [126.29773328967487, 37.80219904366995],
              [126.28316140060299, 37.80799917177122],
              [126.26451707479617, 37.81778583882873],
            ],
          ],
          [
            [
              [126.43121685573014, 37.82986908192341],
              [126.41523019392245, 37.82139488536801],
              [126.39492954600252, 37.82287154697656],
              [126.38817572692929, 37.80670536625757],
              [126.37102333894316, 37.80117272454221],
              [126.35057985274666, 37.78956506262355],
              [126.35511881940461, 37.78142316051035],
              [126.35573514944994, 37.757003908714154],
              [126.35218140574646, 37.73391557149248],
              [126.35559069868158, 37.706676996583155],
              [126.37443133851113, 37.70046016167187],
              [126.3845576462103, 37.700438678539314],
              [126.39236685339556, 37.69419397336515],
              [126.39150227780759, 37.68499829969342],
              [126.40379349182086, 37.67618513685309],
              [126.40553899977589, 37.667116324048294],
              [126.41263172449412, 37.65640520327147],
              [126.41054464080787, 37.64965232248725],
              [126.4032101422558, 37.642735529530405],
              [126.37676335559372, 37.63629309841253],
              [126.37439508662976, 37.6305850710696],
              [126.37928562570615, 37.60958611330416],
              [126.40316813159335, 37.59428252792171],
              [126.43774896960517, 37.59274386957635],
              [126.4622880880088, 37.59422417968104],
              [126.47794586892198, 37.59884359527934],
              [126.48959015276166, 37.60013138428827],
              [126.51062866491374, 37.59662373948502],
              [126.5200903343629, 37.61095793841045],
              [126.54274511634564, 37.617809082997],
              [126.5344783008426, 37.62898391922433],
              [126.52251279524492, 37.651887425173946],
              [126.52317810953285, 37.65672092437642],
              [126.53252317896795, 37.66099762019841],
              [126.52240736061889, 37.666978441504284],
              [126.5171234357552, 37.67910501952907],
              [126.52160293895194, 37.69829999943823],
              [126.51271306096776, 37.71465060305056],
              [126.5137217232691, 37.725034382828824],
              [126.52507469133491, 37.740171094457075],
              [126.52648366049861, 37.74732612828075],
              [126.52066993596314, 37.75071892370299],
              [126.51155613037446, 37.76233990466632],
              [126.51255189040725, 37.770961143908416],
              [126.50689750080987, 37.78234762307245],
              [126.48932454726621, 37.78864247620863],
              [126.45193605467693, 37.81141741963698],
              [126.43726530438717, 37.82896120808146],
              [126.43121685573014, 37.82986908192341],
            ],
          ],
          [
            [
              [124.70691404851009, 37.84705148178844],
              [124.69956813294685, 37.83989149438708],
              [124.6893831269358, 37.83745216752107],
              [124.68286611979434, 37.82885263601379],
              [124.67998855270838, 37.81702438150207],
              [124.68546280826986, 37.810787674914735],
              [124.7029107226549, 37.80482952677962],
              [124.71788130500559, 37.813837582584455],
              [124.71992185191529, 37.8209938914438],
              [124.71372970204584, 37.83083176273388],
              [124.72128844046185, 37.84462075491256],
              [124.70691404851009, 37.84705148178844],
            ],
          ],
          [
            [
              [124.6871734948797, 37.980473042073385],
              [124.67192715392603, 37.98093163786349],
              [124.66800672723859, 37.97720614190408],
              [124.63852912985128, 37.96844141258994],
              [124.6216329932567, 37.97781867426157],
              [124.60970888585155, 37.969954883438334],
              [124.61169751087154, 37.961413914939385],
              [124.62302020879119, 37.95696971258646],
              [124.62860402472154, 37.94125894431193],
              [124.637386960565, 37.923945354028696],
              [124.65572579645064, 37.92182179110554],
              [124.66439960842189, 37.92375950527148],
              [124.68152026030269, 37.92284801328273],
              [124.68881383227507, 37.9153334566122],
              [124.69626249107037, 37.91707230641909],
              [124.7035102186798, 37.93100259381531],
              [124.70788959953563, 37.94465660026418],
              [124.72382081002439, 37.95399355203325],
              [124.7305104761437, 37.95435587921067],
              [124.73435811475042, 37.962552148128864],
              [124.72972044766466, 37.97811533015578],
              [124.71830063236116, 37.98270099415406],
              [124.70473287426613, 37.98366291020253],
              [124.6871734948797, 37.980473042073385],
            ],
          ],
        ],
      },
      properties: { CTPRVN_CD: '28', CTP_ENG_NM: 'Incheon', CTP_KOR_NM: '인천광역시' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [126.7602893648317, 35.25870397600168],
            [126.73630100004037, 35.25076259421867],
            [126.72990010455078, 35.243388277201866],
            [126.71847734430621, 35.221798690116685],
            [126.71769487049146, 35.21238966196838],
            [126.70255613945079, 35.20756444395869],
            [126.68712233671978, 35.21521282130058],
            [126.66960256055565, 35.19449167906539],
            [126.65907088510308, 35.19226266320256],
            [126.67042955076289, 35.169517507189376],
            [126.65707845491326, 35.16661598258578],
            [126.6535568496047, 35.15301076484865],
            [126.65495154849619, 35.137014098936625],
            [126.65165860824834, 35.120411856203084],
            [126.65705889544111, 35.11328365538142],
            [126.66910870169643, 35.11125796572767],
            [126.6694208878249, 35.10460244541764],
            [126.68510238383968, 35.10843711321382],
            [126.70862254019215, 35.109532624560885],
            [126.73643742682233, 35.108227104512366],
            [126.74912334727897, 35.100290936023356],
            [126.7542820084352, 35.09167765497434],
            [126.76187234958354, 35.09103305417451],
            [126.7648020785048, 35.07875464648583],
            [126.77054431455787, 35.07268178401153],
            [126.76510877384437, 35.06436185467372],
            [126.76921070397367, 35.053971384193886],
            [126.7761033468128, 35.052803030606924],
            [126.79156751964838, 35.06048816233756],
            [126.79921140230624, 35.05941738584281],
            [126.80367730727927, 35.05237098474544],
            [126.81861323241273, 35.05281086914788],
            [126.82185927117767, 35.05994821646435],
            [126.84397733255982, 35.06538123210497],
            [126.85560924868967, 35.078359530473655],
            [126.87167669963911, 35.07433782555615],
            [126.88540282228499, 35.08159026824981],
            [126.90453184391184, 35.08139050688823],
            [126.91071144767272, 35.087431278445145],
            [126.92057624598804, 35.09168622515253],
            [126.92768735053367, 35.08044213678945],
            [126.9359950127323, 35.07448168772764],
            [126.94674300389508, 35.07269878778793],
            [126.95498651341448, 35.07484269163966],
            [126.96304572560393, 35.087330690708214],
            [126.97403360899371, 35.09186204616541],
            [126.98895069186884, 35.094987581610596],
            [126.98635174542797, 35.10594532938534],
            [126.98933598124036, 35.11073964762985],
            [126.99993185318249, 35.11405020295629],
            [127.01183208720728, 35.127816211861905],
            [127.00868038037318, 35.13349598323023],
            [127.00819000018984, 35.15549108580762],
            [127.02227522372881, 35.17135964365156],
            [127.01338536019055, 35.18038352317133],
            [126.99996890795069, 35.18881609408241],
            [126.97212053398628, 35.18495238835343],
            [126.95954618225724, 35.19050677715076],
            [126.96450583100557, 35.20025817337315],
            [126.9541268423971, 35.210587383944805],
            [126.94895758751419, 35.220904815465616],
            [126.95184100162544, 35.22459112466017],
            [126.94280213077691, 35.23549545073576],
            [126.93228483977386, 35.24065233751953],
            [126.93125022176527, 35.250810280238255],
            [126.91466128579636, 35.25820163114901],
            [126.90546612641126, 35.258242297147476],
            [126.88632123960271, 35.24622186376321],
            [126.87420883490995, 35.25005775748653],
            [126.8635193970523, 35.245730179593494],
            [126.86023016689731, 35.240542126953436],
            [126.84080650368985, 35.23439442136963],
            [126.83326454787166, 35.22838068097033],
            [126.81564408455073, 35.22465575720588],
            [126.80622442693267, 35.219308075490204],
            [126.79527046479062, 35.219798618848834],
            [126.78019708151568, 35.22567734828943],
            [126.77536336904191, 35.2305749616062],
            [126.75384980993594, 35.237086744385294],
            [126.7555965963568, 35.24334151654556],
            [126.76370514919934, 35.25336749055866],
            [126.7602893648317, 35.25870397600168],
          ],
        ],
      },
      properties: { CTPRVN_CD: '29', CTP_ENG_NM: 'Gwangju', CTP_KOR_NM: '광주광역시' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [127.40244418174665, 36.48598533284786],
            [127.39811383534598, 36.48983869232018],
            [127.39689732186439, 36.49099676610255],
            [127.39658982721043, 36.49129262167917],
            [127.39614094465637, 36.491708392087794],
            [127.38385525008627, 36.50023067828605],
            [127.36814333529082, 36.48822687207792],
            [127.3609842153368, 36.49088391878518],
            [127.35776358342245, 36.48318119636774],
            [127.36389113081681, 36.47521881379468],
            [127.35606692652584, 36.46401932379854],
            [127.35862181410043, 36.45589570058183],
            [127.35579885646419, 36.450273035359714],
            [127.34426074588042, 36.44315380436093],
            [127.34100922619992, 36.430972130542344],
            [127.3263170069765, 36.42220896408531],
            [127.31637163605009, 36.42049496031719],
            [127.3102955338477, 36.42488285826156],
            [127.29826996908122, 36.42319411127921],
            [127.2910803818913, 36.4161556772057],
            [127.28212456131288, 36.4146039637897],
            [127.27846808707476, 36.396752017088],
            [127.28055195731369, 36.37421041085354],
            [127.27768069591065, 36.36528903572509],
            [127.2707218283083, 36.36117672259139],
            [127.27912600112086, 36.344826578001175],
            [127.26572834043633, 36.33803957740781],
            [127.26611231341919, 36.32853331369393],
            [127.25975274393778, 36.32724953004772],
            [127.25841694929025, 36.31763855539003],
            [127.25927823734575, 36.29713629957732],
            [127.24665299702485, 36.29095962993629],
            [127.25877186484118, 36.276050581352706],
            [127.26535273033504, 36.274361456780554],
            [127.28209271891225, 36.26492795436008],
            [127.27914538107913, 36.25310874057282],
            [127.2831547927403, 36.23529359070117],
            [127.30109482591247, 36.221358746423675],
            [127.30638978288736, 36.22615997894143],
            [127.31564105913766, 36.22081536976062],
            [127.3215503666237, 36.212948089220916],
            [127.32394583489678, 36.20315837259056],
            [127.33200152748478, 36.20151340648667],
            [127.3316978466428, 36.1840555858878],
            [127.34073198380312, 36.188910015962826],
            [127.34686698531998, 36.20412685082235],
            [127.35296769346913, 36.211839057959104],
            [127.36419718015107, 36.21890129249112],
            [127.36011143844964, 36.22668016753284],
            [127.36340238741246, 36.232303248359464],
            [127.36415682765706, 36.2515595790741],
            [127.35950194982408, 36.26258634223363],
            [127.36406038245899, 36.26940075856256],
            [127.37327726755238, 36.27218865405301],
            [127.38286733574729, 36.26869285070814],
            [127.39025797769726, 36.26227094978649],
            [127.38641242182203, 36.25067221481043],
            [127.39037005802678, 36.239524715811484],
            [127.38734317329371, 36.23415246274268],
            [127.40091045494603, 36.23287669775059],
            [127.40799929928748, 36.212892945643944],
            [127.41955940066482, 36.20712691330685],
            [127.42937095808163, 36.20520565530553],
            [127.43353062478455, 36.19857569315631],
            [127.44871641082598, 36.19672289171877],
            [127.45587549150352, 36.20108584736779],
            [127.45409249053164, 36.20658591229519],
            [127.46028392601227, 36.212918809233955],
            [127.46891727594213, 36.21455653307772],
            [127.46730260689709, 36.22234682051698],
            [127.4899701247137, 36.233482080581894],
            [127.49257720191127, 36.237953950461446],
            [127.49264072323955, 36.239355585590154],
            [127.49264605505375, 36.239485956128476],
            [127.49227388927531, 36.2424033626038],
            [127.49270788047168, 36.24306113832144],
            [127.49027054965615, 36.2450007744381],
            [127.48941375814559, 36.24601162039949],
            [127.48939729544963, 36.246524233424836],
            [127.4892495026865, 36.24705005367659],
            [127.48831999431661, 36.249656285983896],
            [127.48808814476763, 36.25028100773443],
            [127.4876078537515, 36.25143929235611],
            [127.48798821140825, 36.251941558895815],
            [127.48872785364759, 36.25273947230291],
            [127.48981284297159, 36.25380209913922],
            [127.4895296026044, 36.25603254692409],
            [127.48985988185353, 36.25758798514338],
            [127.48725298105327, 36.258761409240705],
            [127.4862124423717, 36.259469108811054],
            [127.48658626129424, 36.26202947177803],
            [127.48676391950906, 36.262107892290466],
            [127.48769988095542, 36.265308897566015],
            [127.48833020235062, 36.267217118357166],
            [127.48867432484931, 36.26730273450152],
            [127.49025512587704, 36.26837038003503],
            [127.49004741923592, 36.26866298480979],
            [127.48991518176611, 36.268872480697325],
            [127.4897021876096, 36.269601610237046],
            [127.48944328506323, 36.269826554817456],
            [127.48944035659851, 36.2698600813725],
            [127.48936970740597, 36.2706055259147],
            [127.48927595597344, 36.27090949645107],
            [127.48908472864991, 36.27147717043598],
            [127.48888625139708, 36.27208176854515],
            [127.48907822586094, 36.27300498023834],
            [127.48943575172702, 36.273311048622425],
            [127.48973583429324, 36.27344190016547],
            [127.48989107075738, 36.27348942480344],
            [127.49020824006345, 36.27365455914727],
            [127.49063835237881, 36.2738879534033],
            [127.49069790685282, 36.273929108921386],
            [127.49113503650915, 36.27445168813887],
            [127.49262251355475, 36.27547265018547],
            [127.49298583682466, 36.27631235188009],
            [127.49393307126341, 36.27708627782176],
            [127.49506055196353, 36.27809038861314],
            [127.49703428054328, 36.279780653313225],
            [127.49866165893417, 36.282595990835965],
            [127.49884458003058, 36.28327504964187],
            [127.49771321233958, 36.285191366221206],
            [127.49763231690872, 36.285656373106704],
            [127.4962916810496, 36.28752285247979],
            [127.4957695209265, 36.287792543804514],
            [127.49547224500074, 36.28974706754541],
            [127.49556883038515, 36.29011389652841],
            [127.49464482087002, 36.29134443338097],
            [127.49440892338427, 36.29161463093316],
            [127.49358189793516, 36.29331027890726],
            [127.49277762944297, 36.29450764111756],
            [127.49268312462677, 36.29499747335187],
            [127.4922901780359, 36.2956073796013],
            [127.49184152977485, 36.29615527744207],
            [127.49117725513018, 36.29702312550686],
            [127.4914084664402, 36.29769580473138],
            [127.49146520589817, 36.29845170982824],
            [127.49160792327561, 36.29929766893646],
            [127.49229201916158, 36.29970432793597],
            [127.49248858322058, 36.30017691558989],
            [127.49305231709958, 36.30050127437425],
            [127.49451204346255, 36.30087037688911],
            [127.49601624471671, 36.299411312948905],
            [127.49654310427013, 36.30111178096014],
            [127.49655544776212, 36.301137638094886],
            [127.49733698849627, 36.30242166997986],
            [127.49855188943184, 36.30502044312765],
            [127.49897684528597, 36.305672871822644],
            [127.4989585481984, 36.305777428642486],
            [127.49885681576878, 36.30633122606547],
            [127.49877411718111, 36.30675990567459],
            [127.49617373843535, 36.31063305757592],
            [127.49508935859595, 36.31168515010884],
            [127.49456811525967, 36.311990040572695],
            [127.49646922686722, 36.31383718011537],
            [127.49691919403632, 36.3143937625629],
            [127.49714809538578, 36.31507038443382],
            [127.49764211720007, 36.31612608366595],
            [127.49782766625505, 36.31641256134125],
            [127.49742513731712, 36.31713910499695],
            [127.4971777697028, 36.31769632410295],
            [127.49700449945367, 36.31794936915881],
            [127.49695767736422, 36.3191833180133],
            [127.49888746086285, 36.320523678734006],
            [127.4999309806008, 36.32099414000632],
            [127.50042965999177, 36.321620904820556],
            [127.50070507139719, 36.32213482633602],
            [127.50115098860171, 36.32259030561326],
            [127.5015291004545, 36.322834861298645],
            [127.501827086234, 36.32353004709083],
            [127.50238854387636, 36.32458036824958],
            [127.50259242530275, 36.32492534558555],
            [127.50272367641666, 36.325148951204824],
            [127.50285620125497, 36.325411149948444],
            [127.50292326010417, 36.32588144947309],
            [127.50286034949168, 36.32638382600334],
            [127.50220025567022, 36.32781579070578],
            [127.5016959622876, 36.33018402621441],
            [127.50154195044858, 36.33143645424146],
            [127.50163260181448, 36.332114762565915],
            [127.50097201620949, 36.33312655258345],
            [127.50127686434782, 36.3340447481239],
            [127.50129296935971, 36.334060450776896],
            [127.50124209900753, 36.33500520268565],
            [127.50156646390964, 36.33622548657753],
            [127.50129494444475, 36.33662961504335],
            [127.50055589177434, 36.33896109122962],
            [127.5005552652814, 36.33902699576191],
            [127.5005588858565, 36.33929423075384],
            [127.50100990464792, 36.33982346649115],
            [127.50204892572661, 36.340338984575574],
            [127.50249513658531, 36.3404139933936],
            [127.50383652651804, 36.34085443988585],
            [127.5048820425843, 36.34099282016174],
            [127.5044462456732, 36.34180739031032],
            [127.50483319987374, 36.34211300450162],
            [127.5053753745158, 36.34227630846474],
            [127.50674404285337, 36.342809255341194],
            [127.50788516058208, 36.343757408566475],
            [127.5080264175304, 36.34452617847614],
            [127.50743079735902, 36.346004359599455],
            [127.507459776602, 36.346287265132986],
            [127.50977963776775, 36.34672095654604],
            [127.51042260430468, 36.346478564608084],
            [127.51210148768966, 36.346228088621494],
            [127.51265120236755, 36.34721956067283],
            [127.51300139489835, 36.34745659160118],
            [127.51305690920277, 36.34748282068401],
            [127.51728257032157, 36.34801324008495],
            [127.51711283128986, 36.34906410878016],
            [127.51747982784828, 36.34955027967896],
            [127.51869278375499, 36.3502459705309],
            [127.5197717055304, 36.35086000811884],
            [127.52011307548234, 36.35115224229193],
            [127.52152702923843, 36.35332494890865],
            [127.52160747475811, 36.35374673802014],
            [127.52230121686617, 36.35425343311322],
            [127.52260970596616, 36.355065955848836],
            [127.5230544849814, 36.35598320040117],
            [127.5228704089459, 36.356806026139246],
            [127.52254417494109, 36.35709216221266],
            [127.52209356066359, 36.35812455193825],
            [127.52295091921698, 36.35932386491497],
            [127.52367958324007, 36.360046118250125],
            [127.52408853161533, 36.36103701447487],
            [127.52438557593936, 36.361695814788476],
            [127.52427214175025, 36.36209563447445],
            [127.52450166141367, 36.36327740483336],
            [127.5248494125773, 36.36362818202029],
            [127.52480137859472, 36.364045747008426],
            [127.5244726527844, 36.36505676645879],
            [127.52442478405888, 36.36560443221319],
            [127.52427928368381, 36.36628854495046],
            [127.52482422571325, 36.3664959579067],
            [127.52579365082458, 36.367876963460986],
            [127.52598637349433, 36.371583545420975],
            [127.52592577445586, 36.37204988221516],
            [127.52479507862755, 36.375896872057716],
            [127.52514118769784, 36.37674695182019],
            [127.5251508857988, 36.37676577948932],
            [127.52589314472806, 36.37896417200015],
            [127.5253153014398, 36.37970536865111],
            [127.52508713231155, 36.38213949830068],
            [127.52527525832546, 36.38448478454408],
            [127.52458284471436, 36.386456002591736],
            [127.52512306467467, 36.38762852877632],
            [127.52630095419961, 36.38746565794254],
            [127.52679979859123, 36.387658619477214],
            [127.52708449831023, 36.38804233230587],
            [127.52800137480322, 36.38870964817902],
            [127.52852096506228, 36.38898249856285],
            [127.52905948371736, 36.39009642942814],
            [127.52968215483668, 36.39072504673843],
            [127.53009920731387, 36.3910518437486],
            [127.53014735850282, 36.39119328379012],
            [127.53050256362243, 36.391233390455014],
            [127.5308689298698, 36.391224440209896],
            [127.53177174628973, 36.39091601652533],
            [127.53349561348946, 36.39194750184572],
            [127.53364411388456, 36.39250188958117],
            [127.53367409558417, 36.392939943414916],
            [127.53335559833265, 36.39302275499293],
            [127.53342884712916, 36.39354903695131],
            [127.53452566916103, 36.39402682497976],
            [127.53633477247192, 36.394774303292685],
            [127.53742885083223, 36.394948224841436],
            [127.54465989723226, 36.396158596172384],
            [127.55002646841587, 36.39686963927473],
            [127.55079111503832, 36.3956633625437],
            [127.55107825483309, 36.395209210442324],
            [127.5543637889788, 36.394974671409095],
            [127.55743107302732, 36.39730653743214],
            [127.55915952272314, 36.39781692305376],
            [127.55967899075176, 36.398218889333684],
            [127.5589880370101, 36.39946205031553],
            [127.55878010175519, 36.399856150428015],
            [127.55816537395381, 36.399675965430674],
            [127.55807420958936, 36.399666252198244],
            [127.55700422076313, 36.39956450108753],
            [127.55687893536368, 36.39958142163757],
            [127.55503744298845, 36.400105602104034],
            [127.55501715053168, 36.40011751858551],
            [127.55451064661987, 36.40041274062075],
            [127.55412477953017, 36.40065024186497],
            [127.55395274195237, 36.40075550752152],
            [127.55389393350278, 36.40078929385446],
            [127.5537964961323, 36.40085282592338],
            [127.5519171098468, 36.404827707172394],
            [127.5519133617659, 36.40484011520529],
            [127.55125655764097, 36.405935230292314],
            [127.55047208006178, 36.406737765970085],
            [127.55036605917206, 36.40684526573269],
            [127.54964649111751, 36.40729547951697],
            [127.54848347005284, 36.40775110924396],
            [127.54786423112132, 36.408201428971196],
            [127.54769302152094, 36.408255147279036],
            [127.54716570035544, 36.40842428016071],
            [127.54707951164625, 36.408454519515665],
            [127.5470727467961, 36.40845961574451],
            [127.54607086354923, 36.408646112102744],
            [127.54183912236022, 36.41568757111438],
            [127.54215434310203, 36.41934257157772],
            [127.53923736808296, 36.420426139898225],
            [127.5382612244996, 36.420176802991854],
            [127.53778279146545, 36.420122910184055],
            [127.53743516505256, 36.420317939795424],
            [127.53654961215375, 36.419988764212476],
            [127.53524439216558, 36.41895152135423],
            [127.53365025566966, 36.4192275757928],
            [127.53288129842373, 36.419208750716834],
            [127.52877437563322, 36.419794681965826],
            [127.52872358482173, 36.42032039625115],
            [127.5276407181808, 36.42118745779163],
            [127.52700491437038, 36.42117899282111],
            [127.52699687244046, 36.42117537061363],
            [127.52623036881975, 36.42090050917136],
            [127.52596831046063, 36.421571335626176],
            [127.52600749756755, 36.421931902694936],
            [127.5243193762911, 36.423431840405044],
            [127.52343255277634, 36.42317156559993],
            [127.52283240028918, 36.42258195846768],
            [127.52060429769284, 36.4211019519503],
            [127.52027102251208, 36.42037036679709],
            [127.51906451878716, 36.4200801945575],
            [127.51904469363618, 36.42021630107204],
            [127.5176783925874, 36.42115434117817],
            [127.51749458531091, 36.42149729304104],
            [127.51686477033373, 36.421921303629865],
            [127.51666795077601, 36.422033948944176],
            [127.51666621959644, 36.42203508322306],
            [127.5165576770884, 36.422115529306716],
            [127.5164920312284, 36.42225183151291],
            [127.51614303773954, 36.422487636369524],
            [127.51570517670602, 36.42248361089977],
            [127.51451044329447, 36.42247353795723],
            [127.51362584987079, 36.41941651480182],
            [127.51358978120415, 36.419307972873405],
            [127.51309464519954, 36.417501588101366],
            [127.51263203420247, 36.41581615858156],
            [127.51133729695674, 36.41101966698024],
            [127.51124856128756, 36.41079560343432],
            [127.51101733734019, 36.4103062987686],
            [127.5106860490459, 36.40988558427611],
            [127.51019413059811, 36.40935317811564],
            [127.51006432583216, 36.40921602554106],
            [127.50949727547321, 36.40862029707631],
            [127.50649482188122, 36.40824158699727],
            [127.50231161532129, 36.4085270172253],
            [127.50155485214805, 36.408653817612745],
            [127.49997896146489, 36.4120704323434],
            [127.49963701247971, 36.412699576959504],
            [127.4994347545357, 36.41299976569468],
            [127.49811113801331, 36.4145324553372],
            [127.49775802288798, 36.414915787989024],
            [127.4971586917532, 36.41614328840332],
            [127.49712025739298, 36.41637295420626],
            [127.49710222295755, 36.41649496429442],
            [127.49700247493917, 36.41867280178711],
            [127.49694526253748, 36.419486889125494],
            [127.4965059015565, 36.42034030202523],
            [127.4961653660206, 36.421284825306884],
            [127.49466250081764, 36.424231622475105],
            [127.49361748750678, 36.42542320357696],
            [127.49309714399533, 36.42626567312171],
            [127.49289191776708, 36.42671286801191],
            [127.49259796397024, 36.42720717904558],
            [127.4924116016892, 36.42752362876256],
            [127.49223929019435, 36.42782960147003],
            [127.49190289040315, 36.428420391984275],
            [127.49170290055741, 36.4288422242398],
            [127.49106244280932, 36.42995974861357],
            [127.4909039113787, 36.4303256450164],
            [127.49012888039373, 36.43191231544875],
            [127.48972175558595, 36.434125182565246],
            [127.4905082236587, 36.43569052798665],
            [127.4908416846748, 36.43631828267429],
            [127.49242974626486, 36.439371452230844],
            [127.49258361767822, 36.43964651762143],
            [127.49272369316522, 36.43988981118381],
            [127.49294340701744, 36.44027189532521],
            [127.49301797652107, 36.4404062022656],
            [127.49371612871498, 36.441406136367014],
            [127.4937664672083, 36.441458023885275],
            [127.49610120324262, 36.44371758799962],
            [127.49627848597186, 36.44388919850623],
            [127.49699685561795, 36.44457531960651],
            [127.49714258140891, 36.44471776299447],
            [127.49928582832952, 36.446189273266754],
            [127.49934290486397, 36.44622958687235],
            [127.49996071069576, 36.446691939339125],
            [127.50092108131778, 36.44741109803064],
            [127.50110268352951, 36.44754720501709],
            [127.50132457385968, 36.44771439399264],
            [127.50237266722671, 36.44852047627725],
            [127.50268389761426, 36.44875712814789],
            [127.50291994647371, 36.44893073478193],
            [127.50379527727671, 36.450157124189616],
            [127.50445981627988, 36.45188143209574],
            [127.50445607825743, 36.45189693861687],
            [127.50296250723862, 36.45519128832457],
            [127.50279040155849, 36.455504600772215],
            [127.50059119524357, 36.456203475187436],
            [127.49940914278756, 36.455831902966985],
            [127.498121290221, 36.455431741379726],
            [127.4981087266639, 36.45542955050505],
            [127.49774857131025, 36.45531248478313],
            [127.49757303277981, 36.45525463919211],
            [127.49754963119635, 36.455247978273206],
            [127.49748781124201, 36.45522908580252],
            [127.49747906432093, 36.45522376850415],
            [127.49736816233799, 36.45518903059681],
            [127.497208022349, 36.455140699812645],
            [127.49680266247022, 36.455013968974384],
            [127.49646645707624, 36.45490693785972],
            [127.49397576754568, 36.45411465807194],
            [127.49349930518231, 36.45395976983081],
            [127.490566147601, 36.45322414823641],
            [127.48454222211885, 36.45292904894882],
            [127.48314738744132, 36.45347086890664],
            [127.48210730044279, 36.45388508449654],
            [127.4800642740121, 36.45560181792343],
            [127.47950552222694, 36.456007888644294],
            [127.4781732525656, 36.45741872078654],
            [127.47788898982643, 36.45785128014624],
            [127.47758356194946, 36.458415438486895],
            [127.47748112418239, 36.4589362596416],
            [127.47746100860205, 36.4591258612108],
            [127.47750062969237, 36.45959064212794],
            [127.47759680472977, 36.4600963069468],
            [127.47795245828243, 36.4611892250205],
            [127.47825947127362, 36.46170813252856],
            [127.47848155041069, 36.461993071607075],
            [127.47895393163493, 36.46270225279425],
            [127.47901651527691, 36.46281801591584],
            [127.47905543091159, 36.46296571176314],
            [127.4790881579867, 36.46310131154173],
            [127.47940048965792, 36.46374635519237],
            [127.48010784998547, 36.46465002132279],
            [127.48049851447804, 36.464963288870614],
            [127.48076514730478, 36.46526241773126],
            [127.48078183881368, 36.465282627193766],
            [127.48090021322696, 36.46542605579427],
            [127.48134021448864, 36.46599341629049],
            [127.48165695727543, 36.4665294524958],
            [127.48170287536139, 36.46662642002822],
            [127.48172624176573, 36.466683206741486],
            [127.48179730633666, 36.46684344144444],
            [127.48182068747634, 36.46690445455343],
            [127.48184404167239, 36.46695899679922],
            [127.48191036389971, 36.4671138899921],
            [127.48193147797929, 36.4671723875458],
            [127.48195497828789, 36.46722354194752],
            [127.48213894851078, 36.46765619905216],
            [127.48218719583498, 36.46776357404556],
            [127.48223477673416, 36.46787489965168],
            [127.48226031995503, 36.46791732196729],
            [127.48226511126484, 36.46793082018884],
            [127.48235765609041, 36.46812362628721],
            [127.48257855974961, 36.46849643318174],
            [127.48265061861542, 36.46861864352819],
            [127.48274994996763, 36.46878270295249],
            [127.48287450253466, 36.46899284462886],
            [127.48308336824361, 36.46950199597851],
            [127.48315398446364, 36.46967376776202],
            [127.48337252003971, 36.4703366434371],
            [127.48365429750986, 36.471359712833355],
            [127.48380786383125, 36.4719169560625],
            [127.4842673564706, 36.47356701664678],
            [127.48431314788711, 36.473725091821585],
            [127.48442909501212, 36.474148729309775],
            [127.48450388402986, 36.474682354721125],
            [127.48428166964598, 36.47559397027183],
            [127.48421227188264, 36.47587389523399],
            [127.48413388480635, 36.47619411909549],
            [127.48403294933043, 36.47661749781795],
            [127.48114783666057, 36.47712673277099],
            [127.48078646631363, 36.47719267049221],
            [127.48061100717524, 36.47720999235808],
            [127.47612818216459, 36.476331823170995],
            [127.47420131119222, 36.47567402878578],
            [127.47179919634922, 36.47469705186494],
            [127.47030887097391, 36.47367701356512],
            [127.46956706593102, 36.472840732966134],
            [127.46644755049257, 36.469619500982034],
            [127.46630434235145, 36.46934210918172],
            [127.46615849908778, 36.46906247472934],
            [127.4660824767371, 36.4689152073297],
            [127.46603907041491, 36.46882666759107],
            [127.46590118378846, 36.46856559209051],
            [127.46569074525546, 36.46815328859444],
            [127.46549338874736, 36.46776938336107],
            [127.46530835290423, 36.467406542046675],
            [127.46516105413974, 36.467115368357916],
            [127.46494435902989, 36.46670393477813],
            [127.46494098415042, 36.466693809280244],
            [127.46421841079207, 36.46534573774918],
            [127.46398727590683, 36.464907882846354],
            [127.46378098475631, 36.464514150484305],
            [127.46373897708145, 36.46433886780112],
            [127.46358958503686, 36.46339944027349],
            [127.46358342682532, 36.46289003547725],
            [127.46351341138279, 36.460314146360034],
            [127.46348776864926, 36.460194555487305],
            [127.462580490065, 36.45616176077321],
            [127.46250044303147, 36.45606632296568],
            [127.46212057371801, 36.455672409292916],
            [127.46179282303058, 36.4553371484459],
            [127.4609622853759, 36.45448059717639],
            [127.45857831220616, 36.452444138644495],
            [127.45811375301737, 36.452136712894855],
            [127.45738650124619, 36.451733687126655],
            [127.45653824477077, 36.45125903456054],
            [127.4558384729234, 36.45087307877216],
            [127.45436540458034, 36.45015888165392],
            [127.45396136692166, 36.45003227924802],
            [127.45350308045501, 36.449898563235664],
            [127.45289409968444, 36.44971500528233],
            [127.4525782784052, 36.44962157801889],
            [127.45177816648277, 36.44938917272385],
            [127.44979336231246, 36.449233310102315],
            [127.447162104742, 36.44919472523753],
            [127.44643101060099, 36.44953791605787],
            [127.44539134108521, 36.44992730871074],
            [127.44524943019088, 36.449981625330715],
            [127.44392490319558, 36.4504844283872],
            [127.44328163002398, 36.45079714926851],
            [127.44297207213222, 36.45094726355044],
            [127.44241219964373, 36.45127853242611],
            [127.44233820114, 36.45135371854724],
            [127.44196131645201, 36.451742037608376],
            [127.44170289989482, 36.45203107984582],
            [127.44160175952823, 36.452145502456816],
            [127.44133482525987, 36.45246949494866],
            [127.4411589170411, 36.45261460675066],
            [127.44070852111176, 36.452983204577414],
            [127.44034246820557, 36.45328530952397],
            [127.44005281543218, 36.45353841769393],
            [127.43939331551131, 36.454134471423366],
            [127.43908975231861, 36.45439466647479],
            [127.43894535794307, 36.454505586080806],
            [127.43871164354934, 36.45469568376422],
            [127.43778943568202, 36.45547432763642],
            [127.43762078809857, 36.45561349538777],
            [127.43395318607979, 36.45577806156855],
            [127.43410128483646, 36.456143897102976],
            [127.43412863921587, 36.45614211269369],
            [127.43509932690229, 36.45611070874907],
            [127.43633669635214, 36.456077767254186],
            [127.43700151338233, 36.45605225631414],
            [127.43676728279195, 36.456401459379315],
            [127.43586167395341, 36.45644502188598],
            [127.43540005543635, 36.456465570841516],
            [127.43391708619728, 36.456529527455125],
            [127.43201824962028, 36.45662735212131],
            [127.4306154861276, 36.45669605305661],
            [127.43023005402277, 36.45671996609937],
            [127.42754603695155, 36.45686418138493],
            [127.42470481956288, 36.45617870860726],
            [127.424584476166, 36.45616449153711],
            [127.42377375531761, 36.45602994481879],
            [127.41987799823514, 36.45539314111728],
            [127.41893353911554, 36.45524550463008],
            [127.41788618471257, 36.455053440675],
            [127.41744413298338, 36.454983457349435],
            [127.41703836122133, 36.454918690704964],
            [127.41663349969545, 36.454858703294],
            [127.41629229224827, 36.454808083280234],
            [127.41570795863417, 36.45475885493794],
            [127.41407664924965, 36.45471887946646],
            [127.41303027545119, 36.4548083882918],
            [127.41205658373728, 36.454799630392706],
            [127.40886334309212, 36.45475002262364],
            [127.40796423721122, 36.45473759650643],
            [127.4070577154175, 36.45484094165162],
            [127.40629396019868, 36.45491308607942],
            [127.4031021555594, 36.45531305697113],
            [127.40254952276085, 36.4555641368964],
            [127.40022636299163, 36.455280451614605],
            [127.399909876562, 36.455627054567415],
            [127.39957520582577, 36.45589738180142],
            [127.39927767617894, 36.45637711079573],
            [127.39928813523719, 36.456513654387095],
            [127.39925087426154, 36.45676018982656],
            [127.39936671807406, 36.45688371241107],
            [127.39935213416437, 36.457201975520334],
            [127.39943991828622, 36.45746189913164],
            [127.39954086651261, 36.457536466862166],
            [127.39979511084042, 36.4615105436392],
            [127.39947341864132, 36.46221028867419],
            [127.39911574864682, 36.46303406018792],
            [127.39909916506062, 36.463201116718736],
            [127.39898461067385, 36.46411897838282],
            [127.39900602671831, 36.46425154692237],
            [127.39959376989034, 36.46481561901388],
            [127.39959343207991, 36.46512483194133],
            [127.39913778998529, 36.466360647736025],
            [127.39874841283333, 36.466613689961854],
            [127.39855930684713, 36.46689424366111],
            [127.3983417529096, 36.46751056171041],
            [127.39833330662286, 36.4676331010805],
            [127.39814671168584, 36.46844249463819],
            [127.3981873529832, 36.46878987902709],
            [127.39821425347591, 36.46886666659515],
            [127.39812321327224, 36.46913421403767],
            [127.3982897000989, 36.46950819702247],
            [127.3983196972069, 36.47040051535716],
            [127.39833923543382, 36.47077950099675],
            [127.39832536881214, 36.471206746428464],
            [127.39837320800117, 36.47152790953181],
            [127.39842887351887, 36.47194787694474],
            [127.39858747842787, 36.47235230787421],
            [127.39873139548479, 36.47257205210074],
            [127.40242187197501, 36.473089974114565],
            [127.40283857740575, 36.47390946751753],
            [127.4041606024079, 36.47656931443265],
            [127.40416267740487, 36.47750960232207],
            [127.40329201633055, 36.48440604148276],
            [127.40244418174665, 36.48598533284786],
          ],
        ],
      },
      properties: { CTPRVN_CD: '30', CTP_ENG_NM: 'Daejeon', CTP_KOR_NM: '대전광역시' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [129.34639641211703, 35.464961749695675],
            [129.3609814171933, 35.459428574158714],
            [129.38398945375482, 35.47592156139135],
            [129.38890138235556, 35.48769027447284],
            [129.3793178075032, 35.49986369558272],
            [129.387659981256, 35.5042182357728],
            [129.38481636734915, 35.51594865792775],
            [129.3749900648091, 35.517554460539095],
            [129.37455198018284, 35.53952581003214],
            [129.38804071448035, 35.52699869864381],
            [129.3966672644864, 35.5151071559609],
            [129.39576041246352, 35.501237260569276],
            [129.40322881372208, 35.49980742985945],
            [129.40847679369992, 35.49326850600271],
            [129.4042894184315, 35.48662218832011],
            [129.4043693598799, 35.47716735307308],
            [129.4111727175626, 35.471862307085516],
            [129.4152892981941, 35.48012184550097],
            [129.43925076210408, 35.48712194898502],
            [129.43368154895617, 35.49206874899746],
            [129.43221611605534, 35.49986762445738],
            [129.44191462764192, 35.50673487144571],
            [129.44714563369664, 35.51811607506501],
            [129.43857507341238, 35.52857815869577],
            [129.4509225608474, 35.52898733756112],
            [129.45313046017958, 35.54666075349082],
            [129.45802404955592, 35.55346662922699],
            [129.45214709044103, 35.57211333453772],
            [129.4525760230486, 35.57960548848074],
            [129.46365607559576, 35.58591012730911],
            [129.4638573442194, 35.59958953266884],
            [129.45772164569948, 35.61380237932595],
            [129.4442296029238, 35.62306773234681],
            [129.44078153943178, 35.63023273953856],
            [129.44122646786758, 35.64446868935232],
            [129.44962644929814, 35.651018328571304],
            [129.43926909340215, 35.65524466182408],
            [129.42839884364307, 35.65558032993883],
            [129.41096978938745, 35.66382738043939],
            [129.38184939067003, 35.67118480223221],
            [129.37265443081145, 35.66922678622453],
            [129.36435413357182, 35.67825279182584],
            [129.35355872492323, 35.679380230849674],
            [129.34005786264456, 35.669636927106076],
            [129.33408875303886, 35.669760507985735],
            [129.32782069605827, 35.65883635635844],
            [129.3207143283713, 35.65667625393551],
            [129.31114249648954, 35.66052444021679],
            [129.30427270605904, 35.657006130957775],
            [129.30305929301312, 35.64830270452946],
            [129.29625730643423, 35.644741496870076],
            [129.28289855903773, 35.651733128461984],
            [129.26977730875538, 35.65107946262284],
            [129.26044484353642, 35.654637560051206],
            [129.25474504788227, 35.666411769702506],
            [129.2591045822804, 35.671106928341615],
            [129.26187932730107, 35.693403136432686],
            [129.25685044131862, 35.70070336605593],
            [129.23400761855757, 35.7038746562704],
            [129.2054662232197, 35.721174206539196],
            [129.1976456902254, 35.71579431930918],
            [129.1866492683687, 35.71951813166759],
            [129.17194090956377, 35.713943419240636],
            [129.1603149581578, 35.71481010617725],
            [129.15404851855416, 35.72196760149992],
            [129.14204666245402, 35.72434969248071],
            [129.13529282881552, 35.71234240497352],
            [129.12620535606212, 35.71357270377763],
            [129.12421212330304, 35.70827523133659],
            [129.10175903631864, 35.70606714307112],
            [129.08028509246364, 35.69627966328806],
            [129.06987683100863, 35.682372231180125],
            [129.0680948253507, 35.673190641959366],
            [129.07035914733157, 35.658635896530704],
            [129.08085479876328, 35.64325313997528],
            [129.046901080561, 35.65051760697401],
            [129.04334340362507, 35.64096747110087],
            [129.03548622352494, 35.63202091499031],
            [129.02661072915777, 35.63639548364536],
            [129.00273978946785, 35.62025845605796],
            [129.00791724061582, 35.61619165953984],
            [129.02245485983127, 35.61422335985133],
            [129.0246228576654, 35.59991615397859],
            [129.01889543251946, 35.58381993292998],
            [129.00793072096377, 35.58019162730254],
            [128.9958142337711, 35.56788549811074],
            [128.97790547603248, 35.56344699851636],
            [128.97291613952675, 35.556062629890924],
            [128.98092198058296, 35.546373215341404],
            [128.9893478519716, 35.551604823018515],
            [128.9969937593854, 35.54497222818423],
            [128.99883355086268, 35.538542091048576],
            [128.9953923901782, 35.52782438674046],
            [129.00969338787894, 35.52806099308177],
            [129.0108778929044, 35.52321416500876],
            [129.02734329041022, 35.52711439374078],
            [129.03245577247102, 35.5256799679855],
            [129.05582321042792, 35.53226752608736],
            [129.05211296623634, 35.52440149887029],
            [129.0526370635318, 35.51444823833821],
            [129.0616136481772, 35.50962564536917],
            [129.09045594384713, 35.498379554316855],
            [129.10672324000893, 35.49513585225111],
            [129.10962854022262, 35.47949859965501],
            [129.11727716589567, 35.475976540849956],
            [129.1217660638338, 35.46344269894235],
            [129.13808867578686, 35.45210812444912],
            [129.1395930171366, 35.4485293360357],
            [129.16804993405336, 35.43179254050717],
            [129.19650268921254, 35.43834331379016],
            [129.202112188781, 35.43207423161453],
            [129.20015744833503, 35.424147738619865],
            [129.2102397393288, 35.41974766764236],
            [129.21888378350704, 35.40697148178013],
            [129.2017726134245, 35.38845392728517],
            [129.20509022778472, 35.384341078570436],
            [129.21853628638056, 35.37895479023423],
            [129.25289705369173, 35.386837834855676],
            [129.26333798766, 35.385643933283276],
            [129.27234580808232, 35.377214735732785],
            [129.282028372991, 35.363961346566185],
            [129.2805161964334, 35.35622236945251],
            [129.2849310839525, 35.350732055525015],
            [129.2796624237547, 35.34137064759449],
            [129.31211653279993, 35.330012692928406],
            [129.32216259599775, 35.34652449072402],
            [129.3319165176514, 35.34765325501761],
            [129.3332937425871, 35.35422084560393],
            [129.34186923686198, 35.35642860511371],
            [129.35852891782474, 35.35550050622845],
            [129.36033090731416, 35.363710496536264],
            [129.35511582601532, 35.37137356422206],
            [129.34497471178537, 35.37468468599493],
            [129.34610126093162, 35.38902117924181],
            [129.3540471854247, 35.392833211468805],
            [129.35421939384662, 35.39869053336622],
            [129.3626119045248, 35.401920369504595],
            [129.36292028724367, 35.42858130684504],
            [129.37145620054972, 35.43121130579828],
            [129.3597867091126, 35.44791116547442],
            [129.34981087805517, 35.448206786375394],
            [129.34639641211703, 35.464961749695675],
          ],
        ],
      },
      properties: { CTPRVN_CD: '31', CTP_ENG_NM: 'Ulsan', CTP_KOR_NM: '울산광역시' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [127.17841156617698, 36.596874596325975],
            [127.19403917124251, 36.58064540356763],
            [127.20039928619977, 36.582567613336906],
            [127.20753778298614, 36.57763897733561],
            [127.2031000139994, 36.56744371642205],
            [127.19378772255293, 36.56481251372846],
            [127.18611432793013, 36.55232086945088],
            [127.17266844902493, 36.536143615451934],
            [127.18207214491719, 36.520766722514196],
            [127.16998970179279, 36.50903791485763],
            [127.17346586867033, 36.49920666925125],
            [127.19467549778852, 36.48959359902594],
            [127.19048196206072, 36.47947099592297],
            [127.19388410804797, 36.470117763370844],
            [127.20327670880697, 36.46497773495898],
            [127.2047335114803, 36.45929023987326],
            [127.20138964906673, 36.44197527585023],
            [127.20712118410691, 36.436145735266834],
            [127.21770733940802, 36.43373749978325],
            [127.22564316486444, 36.422294768013764],
            [127.2399365457326, 36.4183929242932],
            [127.2495414941287, 36.40919322783515],
            [127.25790805131437, 36.408232363796024],
            [127.26549270159543, 36.41717477886145],
            [127.27568913325445, 36.41394871967506],
            [127.29108010333991, 36.41615567875921],
            [127.29826969011151, 36.423194113675414],
            [127.31029524245494, 36.42488286124792],
            [127.31637136736518, 36.42049497140216],
            [127.32631672704687, 36.42220897621855],
            [127.34100894709887, 36.4309721340005],
            [127.34426046585182, 36.44315379612059],
            [127.35579857644954, 36.450273037932966],
            [127.35862153302926, 36.45589570017328],
            [127.3560666462257, 36.46401932439732],
            [127.3638908505702, 36.475218814338774],
            [127.3577633032513, 36.48318120662839],
            [127.36098393531825, 36.49088391998911],
            [127.36814305523293, 36.48822687515005],
            [127.38385497104373, 36.50023068983626],
            [127.39612055279737, 36.491721472849974],
            [127.40982635110737, 36.49532080823059],
            [127.40904396840577, 36.5097484321015],
            [127.40149316456137, 36.52365381177491],
            [127.40854429978637, 36.528521253008],
            [127.40182466649665, 36.5412404847658],
            [127.38388437594632, 36.54153274299681],
            [127.38318603185732, 36.54786464276895],
            [127.37500479700788, 36.5602141242329],
            [127.36825983291183, 36.56619653245317],
            [127.36048424074325, 36.562276906105595],
            [127.3471279273406, 36.56445339891614],
            [127.33701677885495, 36.56283939056448],
            [127.33655020881952, 36.56998607370515],
            [127.32741067450887, 36.57603134962625],
            [127.32143936934874, 36.58377968298836],
            [127.30404820324064, 36.58333756626428],
            [127.3064094833486, 36.60203777612474],
            [127.30117426963163, 36.60766150567045],
            [127.2922614119269, 36.63518906085032],
            [127.27932104825312, 36.633555610100274],
            [127.27565045506068, 36.63980367612762],
            [127.28161958747673, 36.64514289106769],
            [127.2891599516238, 36.65932227616381],
            [127.29592742313199, 36.65957002103523],
            [127.30485177797566, 36.66808748151071],
            [127.30762517941392, 36.68202247580496],
            [127.27347689138948, 36.69526587092092],
            [127.26522964120912, 36.69220428956979],
            [127.24804914096032, 36.69504809146237],
            [127.23704731137761, 36.70440877908733],
            [127.21813967413256, 36.71558812673316],
            [127.20480791920832, 36.72087612680021],
            [127.19728340502462, 36.72819286536855],
            [127.15964389368767, 36.73284394816516],
            [127.14981183852963, 36.72588618356333],
            [127.13437853561543, 36.70679198952653],
            [127.14382776980644, 36.688997727133064],
            [127.16144490262484, 36.69021863459104],
            [127.16412363731438, 36.6784975893217],
            [127.15485840345494, 36.664274653623345],
            [127.16056872849484, 36.65611900822385],
            [127.15428939958501, 36.65244978219574],
            [127.15314443859828, 36.645213500536016],
            [127.15755971272938, 36.63917444827533],
            [127.1564899164229, 36.628616849248964],
            [127.15042976488505, 36.619749554133115],
            [127.15495229273519, 36.61654451680509],
            [127.15547820292146, 36.60670289838868],
            [127.16271749536193, 36.604375443965395],
            [127.17349083479947, 36.59602994587725],
            [127.17841156617698, 36.596874596325975],
          ],
        ],
      },
      properties: { CTPRVN_CD: '36', CTP_ENG_NM: 'Sejong-si', CTP_KOR_NM: '세종특별자치시' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [126.38792622519453, 37.11473199660064],
              [126.38072547556457, 37.1132474927439],
              [126.3801689045172, 37.10655545247924],
              [126.3923264681269, 37.099104373450515],
              [126.39383036016329, 37.11311349101357],
              [126.38792622519453, 37.11473199660064],
            ],
          ],
          [
            [
              [126.6226393047637, 37.17830638877997],
              [126.61785991995035, 37.1752342224458],
              [126.61930666794169, 37.1601435869903],
              [126.63063469918283, 37.1734567480478],
              [126.6226393047637, 37.17830638877997],
            ],
          ],
          [
            [
              [127.13101155994151, 37.46780874168975],
              [127.1169892936912, 37.46148450969207],
              [127.1043412288601, 37.462174754525115],
              [127.09354041449099, 37.45588845579511],
              [127.08816133966036, 37.44538538415588],
              [127.0801716543493, 37.44105149545947],
              [127.07162594472807, 37.44152398184968],
              [127.07062900413727, 37.432044555348384],
              [127.06568165793492, 37.4289853182975],
              [127.05216948277747, 37.42833977558507],
              [127.04005277581827, 37.43823714527171],
              [127.0337322220804, 37.461236946443655],
              [127.01450961581895, 37.45486122699881],
              [127.00853164946886, 37.4580515718442],
              [127.00273482094622, 37.467124610385895],
              [126.99623104562409, 37.46660839569667],
              [126.98661263281456, 37.45721233818531],
              [126.97457956036183, 37.454412875676965],
              [126.95896605560684, 37.43906976923244],
              [126.9377466598776, 37.437385758298745],
              [126.93055434616019, 37.44546848153329],
              [126.92325327428252, 37.445772746479484],
              [126.91926389435051, 37.43985239375963],
              [126.90298757232425, 37.4340675852093],
              [126.89398299795293, 37.452717339211425],
              [126.88640323922837, 37.45617343888864],
              [126.88461752729256, 37.46601233941374],
              [126.87176262336948, 37.485269387986236],
              [126.8697094568856, 37.49409550874796],
              [126.85270046730044, 37.48181861263206],
              [126.84536055146752, 37.473812464842354],
              [126.81899737698718, 37.479162394275214],
              [126.82276239363726, 37.48997931117198],
              [126.81457493429467, 37.49319333355601],
              [126.8196402046675, 37.49921061613012],
              [126.82310455539994, 37.516220241426645],
              [126.82842776305907, 37.52670277981219],
              [126.82093622401378, 37.54075210843739],
              [126.80184999394167, 37.5427159496543],
              [126.79396340016996, 37.53736032107562],
              [126.78726079581733, 37.546076420182715],
              [126.77169082605953, 37.548307221283665],
              [126.76339421663678, 37.54673178467567],
              [126.76014371001342, 37.53549322232727],
              [126.76027622579346, 37.515915761305884],
              [126.74510916143765, 37.514136729854485],
              [126.74147075314005, 37.508988034996136],
              [126.74373703839333, 37.50179236328199],
              [126.74235365745976, 37.486949074968905],
              [126.75554943251925, 37.482872935314305],
              [126.76775786926297, 37.471764464974086],
              [126.77711104228965, 37.47222070812474],
              [126.77902288729265, 37.451020906371525],
              [126.7703333420143, 37.44750044905212],
              [126.76920609756478, 37.42750604252062],
              [126.75325356385672, 37.422702213859836],
              [126.75540196536258, 37.41343953885136],
              [126.74905456214022, 37.40344533076778],
              [126.73953522266127, 37.39526443079897],
              [126.70091249800316, 37.354564102834054],
              [126.68863322354811, 37.348595637591],
              [126.68592201585638, 37.3411955744356],
              [126.69049216328835, 37.33510699938911],
              [126.67138318975093, 37.32915174005988],
              [126.67795159903537, 37.319969008299786],
              [126.69281525600951, 37.318674362734136],
              [126.70530076010905, 37.31100523010629],
              [126.71789444913671, 37.30802180464363],
              [126.72392029552941, 37.31458925102408],
              [126.73236591819193, 37.30936520719589],
              [126.7893646218817, 37.293406772010435],
              [126.80125688983914, 37.295616989663316],
              [126.80585953002891, 37.299535150112135],
              [126.82070453813864, 37.29186056430453],
              [126.82942145510874, 37.27876174269726],
              [126.82889895468777, 37.27063957884323],
              [126.80971023719047, 37.28050123411885],
              [126.80336249982996, 37.27963964765314],
              [126.80955927698886, 37.26651061720172],
              [126.7962838534737, 37.27072653863717],
              [126.79054936498027, 37.26682624212986],
              [126.79336961988534, 37.25923040266286],
              [126.78830654820075, 37.25519141905723],
              [126.78956491149354, 37.2441294839499],
              [126.7760631563955, 37.24542496470632],
              [126.77135708808302, 37.248649431804594],
              [126.75772140201987, 37.24891132370937],
              [126.75727798419399, 37.253855495944684],
              [126.74532815458791, 37.25507337587137],
              [126.7337231590533, 37.24936666178913],
              [126.72323333938955, 37.256344058769585],
              [126.7161022441974, 37.25478581385096],
              [126.69816958531014, 37.26103096303542],
              [126.68744043994627, 37.26211115111023],
              [126.68118407441324, 37.25666393444614],
              [126.67717068146948, 37.24626813519221],
              [126.664864777598, 37.24214485538756],
              [126.66687128443871, 37.232028423468705],
              [126.67743042602375, 37.22372632449883],
              [126.66596110860083, 37.21262959898217],
              [126.67271336901103, 37.200155426718204],
              [126.6618825602713, 37.196767199370605],
              [126.65655968827546, 37.19082515012299],
              [126.64717167122008, 37.192523791157605],
              [126.65313980746106, 37.204036701810644],
              [126.64754115660365, 37.20852658077924],
              [126.6502796031282, 37.225093279731816],
              [126.62219950561517, 37.23657370736961],
              [126.623623144691, 37.242498335248655],
              [126.61406064346119, 37.250148166490355],
              [126.61751332155654, 37.256199979862444],
              [126.6028977504448, 37.26205737257275],
              [126.5934451676646, 37.26226478301204],
              [126.58399659568273, 37.27207586074362],
              [126.5673662522823, 37.27982822105523],
              [126.5565754928592, 37.27666272596349],
              [126.55934885364155, 37.25816460457022],
              [126.56074855714621, 37.23672869212552],
              [126.55370752772953, 37.23324315359537],
              [126.5431605308524, 37.23410102607753],
              [126.54091988252969, 37.22702204702013],
              [126.55727493224663, 37.21785426854608],
              [126.54417976974851, 37.21399530973021],
              [126.54538347623443, 37.206125469831996],
              [126.55241338257419, 37.20467349304268],
              [126.56547283884211, 37.19611428049635],
              [126.57642721334956, 37.221984275641866],
              [126.58677557000942, 37.22059957901919],
              [126.58891151440089, 37.214476140978036],
              [126.60135399380599, 37.214023721396586],
              [126.61449706492894, 37.20804706422437],
              [126.60925663046787, 37.22094478503924],
              [126.6023145451692, 37.22382264733264],
              [126.60253769925369, 37.23052117645719],
              [126.62337052734422, 37.233984726228066],
              [126.62372057997796, 37.22593819729073],
              [126.62900121311165, 37.21864696042669],
              [126.64648184723805, 37.211050265441266],
              [126.64146560884672, 37.19713519030156],
              [126.64740560579041, 37.19201857485204],
              [126.6646341117931, 37.19164930033944],
              [126.66520014394466, 37.182364970776035],
              [126.65519956550536, 37.17491702662578],
              [126.66096038122211, 37.162223748127744],
              [126.66968818184806, 37.156035606082035],
              [126.68261604524153, 37.16053853137451],
              [126.69451910701767, 37.1521618489452],
              [126.68339108865499, 37.14875673586773],
              [126.67894361137768, 37.13417018069843],
              [126.68488846372772, 37.122171470769565],
              [126.68383140967997, 37.11233438110448],
              [126.75668110523871, 37.05545536567092],
              [126.74888451382586, 37.048761101675325],
              [126.74577979436806, 37.041520719450475],
              [126.75110191678476, 37.029818938785226],
              [126.7889566933859, 37.02991113909338],
              [126.79525538772495, 37.02582499955334],
              [126.79763776995148, 37.01413114397501],
              [126.7872964129321, 37.012768983304056],
              [126.77901062847081, 37.00724188286645],
              [126.78921884021206, 36.99498236896069],
              [126.82362216585032, 36.98409362538713],
              [126.8425062529224, 36.95720843902147],
              [126.82918370784651, 36.94756141124436],
              [126.83933896486394, 36.91764524242278],
              [126.84353348745056, 36.91176781069037],
              [126.8574822462199, 36.90834109047845],
              [126.90584281477577, 36.91576040064037],
              [126.90965817883816, 36.90159519032457],
              [126.93962592593232, 36.917330902333894],
              [126.97374569529504, 36.92586243686039],
              [126.9855512576119, 36.932485609901086],
              [127.01501692408695, 36.935417250859544],
              [127.02579668130976, 36.9287463816249],
              [127.04757977252122, 36.93321747925454],
              [127.06548675667896, 36.941926053781415],
              [127.07490309027801, 36.93985572735643],
              [127.08621227151465, 36.94773746807158],
              [127.0957641555165, 36.94237387890552],
              [127.09639521146323, 36.9557205564694],
              [127.10250523326604, 36.96476052913922],
              [127.11175093014307, 36.97194967150977],
              [127.12966310909111, 36.966417527559926],
              [127.1436636214292, 36.97105116259442],
              [127.15805608889406, 36.96882541343636],
              [127.16493636687515, 36.96188684054759],
              [127.17819865370524, 36.962516623051954],
              [127.17917642725368, 36.95805481710854],
              [127.19075051640577, 36.95248627806512],
              [127.20129177056168, 36.95200045029803],
              [127.21124705907107, 36.93855744840642],
              [127.20985781968778, 36.931233794110675],
              [127.21948575107068, 36.9303604872148],
              [127.22864946128638, 36.924414180685055],
              [127.23634650680371, 36.92372340095947],
              [127.24404864941168, 36.917598564660025],
              [127.25313213636625, 36.92243651310718],
              [127.25860936407985, 36.915873903482435],
              [127.27328610692334, 36.91224590396757],
              [127.27915694672625, 36.9004100678296],
              [127.28750214268176, 36.89378529871609],
              [127.29643287126599, 36.902684236237874],
              [127.30336476977476, 36.916390367100576],
              [127.29537911106148, 36.92925083453556],
              [127.31330066100337, 36.931241592554294],
              [127.32681215866974, 36.93593603568361],
              [127.34963055932174, 36.952793621011054],
              [127.35761192913422, 36.94768787576237],
              [127.36730178131145, 36.95029857538034],
              [127.37533259691187, 36.94871471258741],
              [127.3787234483613, 36.957894977989085],
              [127.3872675117499, 36.96446340600025],
              [127.40153404660347, 36.96767809282966],
              [127.39431634036272, 36.97698324977141],
              [127.38503080753233, 36.98418614672356],
              [127.39421289798193, 36.99837502964763],
              [127.41391215620524, 36.99947060472874],
              [127.42035045571404, 37.003764171905445],
              [127.42882398697876, 37.00219315108364],
              [127.45974415247296, 37.02506399394239],
              [127.46033178427264, 37.04615558549454],
              [127.47511081915428, 37.05290952398222],
              [127.48647724205331, 37.05478285983648],
              [127.49907784171558, 37.04757627948162],
              [127.50889249884833, 37.049417926165404],
              [127.51251378652168, 37.056349537528554],
              [127.5327985919874, 37.05519718384451],
              [127.55691317298415, 37.04126453740185],
              [127.56708713885736, 37.0475238725589],
              [127.56472312029098, 37.059239827999846],
              [127.5779767457217, 37.075341042184796],
              [127.58927007772625, 37.07281674703303],
              [127.60506990948036, 37.07573790284657],
              [127.59955503754067, 37.082307459623145],
              [127.63181443481238, 37.09647606698443],
              [127.63627266867414, 37.11446416186243],
              [127.63397583467588, 37.12373915105332],
              [127.63776772461799, 37.14119002905039],
              [127.6274548560069, 37.151724012346584],
              [127.63867469139534, 37.153106626882156],
              [127.6480885489461, 37.1506049710252],
              [127.65994358536798, 37.13991513648812],
              [127.6702124942131, 37.136108002773504],
              [127.68859287261736, 37.13554068765368],
              [127.69453452213811, 37.14125890356059],
              [127.69449612511494, 37.14882726541395],
              [127.70427262300528, 37.15764769560379],
              [127.7048548461352, 37.1675201143583],
              [127.71763705125315, 37.18383131446371],
              [127.72640712759656, 37.182540475524526],
              [127.72834996054138, 37.191786917966695],
              [127.7367402301128, 37.210193476050684],
              [127.74635918557658, 37.214476781114456],
              [127.74920740108934, 37.221938260477245],
              [127.74688292923081, 37.23997330290712],
              [127.75944069234967, 37.26429197781731],
              [127.75908407339963, 37.277045845254264],
              [127.75003759333455, 37.291962484393665],
              [127.76814797515796, 37.30952714752871],
              [127.75978391796035, 37.33009834464532],
              [127.7629657128557, 37.33442778491724],
              [127.75798379338632, 37.34577013506269],
              [127.76075790596913, 37.35263518365759],
              [127.76287259254907, 37.369977356114745],
              [127.77736516869027, 37.37123467316569],
              [127.77665843488002, 37.38332589777145],
              [127.78782845118212, 37.40113121889793],
              [127.79364355985172, 37.42250865958249],
              [127.80386886871257, 37.43195412396744],
              [127.79838844479451, 37.44259094862817],
              [127.79938192687219, 37.451770203170234],
              [127.79626622739916, 37.46304395766979],
              [127.80097392516186, 37.470037422720814],
              [127.78775840928941, 37.47642380579052],
              [127.78018809176702, 37.48865116437645],
              [127.77468903565807, 37.49174634839169],
              [127.76019290789428, 37.492218286650726],
              [127.76026387852876, 37.5034192391577],
              [127.77484931795438, 37.50665964015546],
              [127.78663976739709, 37.51427824610642],
              [127.79778027698212, 37.52852162710175],
              [127.80647297816759, 37.531171469134186],
              [127.81046862897301, 37.53778517430345],
              [127.84202294206881, 37.53890089639553],
              [127.8480040983434, 37.552446710673344],
              [127.83232027230879, 37.56156634806101],
              [127.81413011596534, 37.56415202425713],
              [127.80908911857823, 37.57377203676256],
              [127.79997628084148, 37.58277468758188],
              [127.79290245685151, 37.585289559683766],
              [127.78328715739232, 37.57843872939544],
              [127.76657085337253, 37.58266875086186],
              [127.75502258208508, 37.59154462541095],
              [127.73939611244352, 37.587094594605176],
              [127.72312540194886, 37.590626172508486],
              [127.70789503229544, 37.586353111164335],
              [127.69743097282576, 37.59184754645237],
              [127.69998279946077, 37.59695981430809],
              [127.67943033556865, 37.60940769368838],
              [127.66170726870756, 37.62432229243647],
              [127.64985084656693, 37.62414927515972],
              [127.64698792595426, 37.632736800312],
              [127.63943278151976, 37.63264274292244],
              [127.62643938955483, 37.643083216558544],
              [127.61893098058295, 37.64341330918551],
              [127.60903113525218, 37.64988237025991],
              [127.58486111230104, 37.64230252686583],
              [127.58065486830651, 37.63339833404305],
              [127.56468086882775, 37.633157219465446],
              [127.55946121643885, 37.628485721131106],
              [127.54825755586853, 37.633207990917],
              [127.5379368941981, 37.64147839417095],
              [127.53565507463803, 37.650694640692116],
              [127.54385443483521, 37.65173022885945],
              [127.55281588200063, 37.661528346898116],
              [127.54904935484467, 37.66861423205983],
              [127.55063947467437, 37.68704218597891],
              [127.55804503766457, 37.713914849458114],
              [127.56186269409353, 37.72007167633748],
              [127.55660217070022, 37.72922659836511],
              [127.54017196571596, 37.7194579251147],
              [127.52470483818936, 37.72646830686016],
              [127.5134250850838, 37.71759159682551],
              [127.50614812656785, 37.72415265297307],
              [127.50711197519858, 37.73135925391623],
              [127.5168714592926, 37.7402673989824],
              [127.53407555268255, 37.74860215872064],
              [127.54208576929241, 37.754664569514055],
              [127.54498749919722, 37.7636317202564],
              [127.54092422713649, 37.77087514044216],
              [127.5222580812156, 37.7889476212896],
              [127.52304977163715, 37.7961696852791],
              [127.53735445667152, 37.81054056778128],
              [127.53494038158574, 37.81771062309869],
              [127.52563891509593, 37.82287253347723],
              [127.52561877163001, 37.83292399600276],
              [127.52944297527426, 37.839723076690895],
              [127.55008810828494, 37.85193100072532],
              [127.56323900530681, 37.85587956716326],
              [127.568595483036, 37.866972811946376],
              [127.58462089642558, 37.8762940568908],
              [127.6032119670046, 37.87420074191954],
              [127.60909529621982, 37.88351793678545],
              [127.60740254123034, 37.889660287398875],
              [127.61705254486415, 37.90599578767701],
              [127.6120454190986, 37.92405551905413],
              [127.61658396191856, 37.92826564753537],
              [127.61267179878875, 37.94047575599194],
              [127.60373629154027, 37.94449064839089],
              [127.60244477969616, 37.954998571229446],
              [127.58472254436221, 37.9617522811971],
              [127.57133061541491, 37.96399952702436],
              [127.56189121028619, 37.96276978860114],
              [127.54737624478935, 37.96645831005796],
              [127.54716574326154, 37.978281270719826],
              [127.53987715267588, 38.00056775473297],
              [127.53109477026547, 38.00238845932858],
              [127.5039225243893, 37.99795329094023],
              [127.49739960897763, 38.00371426079525],
              [127.47155598091673, 38.00645256611953],
              [127.45752906576806, 38.016990310570904],
              [127.4510219266171, 38.03808511657423],
              [127.4529059712857, 38.047186182571814],
              [127.44458372211722, 38.05726067647142],
              [127.44707594223411, 38.080728650821676],
              [127.44516749212741, 38.09746966575098],
              [127.4404527043368, 38.10883224392154],
              [127.43293655955397, 38.1115059195352],
              [127.41340849120319, 38.10201260032201],
              [127.40552359940507, 38.10295391741828],
              [127.40067167710986, 38.113761214325486],
              [127.38389347014399, 38.11460184768715],
              [127.37861375177563, 38.11842895647178],
              [127.36677509351746, 38.10819031172868],
              [127.34813417368528, 38.10482610456032],
              [127.33926532515478, 38.10076729250321],
              [127.33761766448025, 38.09007292506923],
              [127.32067032629679, 38.094683769630784],
              [127.31347533217077, 38.10601348506257],
              [127.30982187602623, 38.1180254563302],
              [127.29229290158901, 38.114310862624684],
              [127.28275119159184, 38.11648806963476],
              [127.27574620273097, 38.12486291253151],
              [127.2759069347445, 38.13889885816929],
              [127.28640534058106, 38.15263901068459],
              [127.28401315852244, 38.15735248793776],
              [127.28899571736439, 38.169456783216525],
              [127.29619190078809, 38.17248256922387],
              [127.28392166785218, 38.182587998866374],
              [127.2660212156004, 38.180237757155865],
              [127.2643534466105, 38.171576862576536],
              [127.25618910346992, 38.16433229475131],
              [127.23929352772097, 38.1565018249422],
              [127.23465217697336, 38.14710743469623],
              [127.2238214349035, 38.147035311239335],
              [127.22093389872069, 38.138373145197015],
              [127.21255351040602, 38.143420979177144],
              [127.19894524863513, 38.15570746312579],
              [127.18893153415269, 38.16181940116751],
              [127.18585647713877, 38.17387970715122],
              [127.18831998553792, 38.187762823296936],
              [127.18055972516169, 38.186145998722424],
              [127.16961660006511, 38.19812405180389],
              [127.17513513792511, 38.20548403740677],
              [127.17116632445882, 38.213492638885555],
              [127.16008385075745, 38.21919435734842],
              [127.16329360261292, 38.23848137222115],
              [127.14892257085124, 38.24234375458242],
              [127.13115662503752, 38.232753533178034],
              [127.12304883927523, 38.2328038809803],
              [127.111335725643, 38.24104471403249],
              [127.08309558775768, 38.238115759461714],
              [127.06278847608777, 38.240514863289505],
              [127.06074376328363, 38.23213959887004],
              [127.04822328282569, 38.21791537798989],
              [127.05019357918711, 38.20864107223139],
              [127.03477509854044, 38.20552172152555],
              [127.0295925369609, 38.207074407563866],
              [127.02933519270421, 38.21945313900328],
              [127.01800339783676, 38.220275857980106],
              [127.00641006223726, 38.22581351154203],
              [126.98356305788388, 38.226663762947275],
              [126.97891270566095, 38.222678832106155],
              [126.98365410988978, 38.213286944958966],
              [126.98558494917559, 38.19976586783173],
              [126.96962432746557, 38.185132597716645],
              [126.96559799090292, 38.17110253930246],
              [126.95371218943474, 38.16270287009581],
              [126.9515538223628, 38.157818272745686],
              [126.9679793633953, 38.147460289552065],
              [126.96604597990432, 38.13967910398959],
              [126.95753073776085, 38.13465407123971],
              [126.94016853711665, 38.13391010355255],
              [126.9341863855384, 38.125184595397556],
              [126.92596419072139, 38.128453786297726],
              [126.91705819490107, 38.136718216962755],
              [126.90460393336075, 38.137548745586486],
              [126.88800454246208, 38.12808096726791],
              [126.88414008902673, 38.116709077669206],
              [126.86716740555781, 38.11117993279667],
              [126.8609902204584, 38.10689130359472],
              [126.85632394731145, 38.09698472498661],
              [126.86018681185935, 38.08526567250666],
              [126.86889640305318, 38.08012015892265],
              [126.86579303134292, 38.06791829917204],
              [126.85900014554049, 38.06421691229204],
              [126.85784031668366, 38.05301443449313],
              [126.85253465947605, 38.05310298376889],
              [126.85237652496897, 38.03508967173806],
              [126.84073068302801, 38.032906827415786],
              [126.83632748782426, 38.0235406428402],
              [126.8246478485695, 38.02029205491818],
              [126.81871879353947, 38.011099791897465],
              [126.82343854740543, 38.00489058296833],
              [126.81763538245164, 37.99760617125714],
              [126.80150330548781, 37.99006917558831],
              [126.79366522602575, 37.99230254634349],
              [126.78210176491999, 37.98052957192133],
              [126.76313555488512, 37.98507160176161],
              [126.74968196485158, 37.97942716239086],
              [126.73949382638557, 37.971470866152416],
              [126.71939400060957, 37.964952088119766],
              [126.70248604505262, 37.97431878455334],
              [126.68730695894692, 37.95719714075193],
              [126.67184374066551, 37.95799641544954],
              [126.67199191324546, 37.93989181674887],
              [126.66753188259186, 37.93446382194042],
              [126.66599639572604, 37.919060887725486],
              [126.67291806932619, 37.91367454394948],
              [126.67734939289899, 37.897791848961205],
              [126.67172262465992, 37.88683634159534],
              [126.68166277469673, 37.87928914842557],
              [126.6856964896755, 37.858276638272805],
              [126.67996936939406, 37.852758644420945],
              [126.67957465645603, 37.84603034577288],
              [126.67007605972096, 37.84553044272806],
              [126.66017132923771, 37.83888866900231],
              [126.6713524346742, 37.834779305695186],
              [126.6714410344078, 37.8148889427687],
              [126.67711930442653, 37.81490471623415],
              [126.67721117316306, 37.79389851482816],
              [126.67153724914323, 37.79326645642434],
              [126.6716333596068, 37.77164389110357],
              [126.68302504902958, 37.76193844791587],
              [126.68309098791627, 37.746596758937244],
              [126.67543327486207, 37.752952613725284],
              [126.6651062188177, 37.76932800980585],
              [126.6630342060316, 37.780683084564345],
              [126.63207754731789, 37.78094146881625],
              [126.61920847194109, 37.77585509391432],
              [126.60812266231737, 37.7665658348084],
              [126.59377284063545, 37.76115639367417],
              [126.57534545594338, 37.76270390438966],
              [126.55468058945299, 37.777619187353984],
              [126.52278344725596, 37.790098158305625],
              [126.51704986130818, 37.77102869612133],
              [126.51834060303342, 37.76279030738845],
              [126.5306896225047, 37.74999272059538],
              [126.52994038178461, 37.741106328836885],
              [126.52451778610286, 37.72865133605659],
              [126.5216263284261, 37.71441350790454],
              [126.53028702468495, 37.7060965438326],
              [126.53405387959108, 37.687722930271306],
              [126.52786453649276, 37.6733368851349],
              [126.53972356894326, 37.669257491141586],
              [126.54410480531124, 37.6627155316968],
              [126.53393744462088, 37.65569317856226],
              [126.53888742434917, 37.64144135685287],
              [126.55069697381612, 37.631486299597576],
              [126.55525015395041, 37.610799259496346],
              [126.56112495867262, 37.60364954630078],
              [126.57179557920543, 37.59919300574433],
              [126.60546826403036, 37.600264438152095],
              [126.6094704091087, 37.60454392789917],
              [126.62581693829914, 37.60268223745205],
              [126.6372598650949, 37.626509793407585],
              [126.64756423601914, 37.62893380836372],
              [126.65125284998578, 37.63798805013667],
              [126.6724222551306, 37.633842015731425],
              [126.70543637499645, 37.61176375598106],
              [126.70840831926982, 37.6049110664848],
              [126.72566531581131, 37.591842255204725],
              [126.74525885646956, 37.58871665257917],
              [126.75469863233323, 37.58013716898222],
              [126.75801148554505, 37.585221929841694],
              [126.76734477931082, 37.58828839946121],
              [126.77299065864231, 37.58504747258775],
              [126.78704802377312, 37.58557952626782],
              [126.79368152411818, 37.58157609301721],
              [126.80052027688906, 37.59030890233597],
              [126.79708250490569, 37.59773892646615],
              [126.80258140634335, 37.60503275108435],
              [126.81930252917961, 37.59284975496723],
              [126.85362858545642, 37.57379911997899],
              [126.87626055922334, 37.57818522996211],
              [126.87754234323975, 37.58624787206536],
              [126.89685903415011, 37.588566621978785],
              [126.9018297577917, 37.59514135084015],
              [126.90030432202951, 37.61119134553699],
              [126.9071174676412, 37.62194146306285],
              [126.90709624775387, 37.63339794988786],
              [126.91227986090391, 37.64431535800703],
              [126.9241229094111, 37.646106301776115],
              [126.93570568948076, 37.65120265507212],
              [126.94012815874287, 37.65663592714997],
              [126.94788243270189, 37.657125811964214],
              [126.95710810476903, 37.65283723014636],
              [126.96376722240906, 37.62979311657377],
              [126.98141567857158, 37.63482968774594],
              [126.98567650902527, 37.64004446508803],
              [126.97965838956341, 37.65603864809538],
              [126.99222479520425, 37.66523164668971],
              [126.99324753533641, 37.67766063723168],
              [126.99731144674146, 37.68346620535317],
              [127.00844015206751, 37.68543159740976],
              [127.00966648955689, 37.69669983608679],
              [127.01541538466694, 37.701455284723465],
              [127.02928585391011, 37.69929162930645],
              [127.03102640996767, 37.693074532309964],
              [127.04110878638086, 37.69529978214289],
              [127.04982029730989, 37.68797700880907],
              [127.06273214192116, 37.694675910555254],
              [127.08110505186673, 37.696137468108596],
              [127.0865309051924, 37.68991221205332],
              [127.09599623525008, 37.68907104624904],
              [127.09218986533494, 37.678030102512736],
              [127.09623764690504, 37.668829413901705],
              [127.09120718676634, 37.65933455606814],
              [127.09457024652482, 37.64457060015846],
              [127.11075156288545, 37.64273027983882],
              [127.11163259457841, 37.631503282817825],
              [127.10406649287954, 37.62165311230708],
              [127.1171470208813, 37.61788844069134],
              [127.11687775860086, 37.59549705097138],
              [127.10344074333885, 37.58059529734595],
              [127.10423047496235, 37.57138765504911],
              [127.1012049647425, 37.5615799015039],
              [127.10639618953267, 37.55646172249664],
              [127.11733926618616, 37.55946361997952],
              [127.12861049324997, 37.56616043564302],
              [127.14894981939638, 37.568434317764485],
              [127.16674743781502, 37.578975667125256],
              [127.1756831339696, 37.57489908553994],
              [127.18199541949765, 37.560992446166395],
              [127.1828254140902, 37.5463444649922],
              [127.16316277800674, 37.544991401602125],
              [127.15356673835163, 37.53366545267995],
              [127.15268697687713, 37.52852950546074],
              [127.1421362599406, 37.515653249856605],
              [127.13996586275486, 37.508641279182704],
              [127.14595211408187, 37.50322728199594],
              [127.16139035330959, 37.50020144407519],
              [127.15851360244915, 37.489665573325226],
              [127.14777037560927, 37.48262416791918],
              [127.14352658768853, 37.47393041836952],
              [127.13285604904866, 37.47462645849722],
              [127.13101155994151, 37.46780874168975],
            ],
            [
              [126.78880717195398, 37.17382562903142],
              [126.79657041499756, 37.17152966265327],
              [126.80001139056985, 37.15390744883765],
              [126.80449746730596, 37.15240314441261],
              [126.8117841903445, 37.1391099925414],
              [126.80136725809027, 37.1383591723174],
              [126.7950030559191, 37.12875279493771],
              [126.78250758838622, 37.134864816191254],
              [126.77125151684506, 37.128978262399194],
              [126.76040961258808, 37.117926371971265],
              [126.75828684390237, 37.1114213073466],
              [126.7708098751931, 37.10160344546817],
              [126.76472119870388, 37.08689898517008],
              [126.76312501678923, 37.063066342604294],
              [126.75627621181668, 37.05627440817609],
              [126.68612196187306, 37.11163442920425],
              [126.69118362633353, 37.12103619896772],
              [126.69745927646478, 37.122147697478546],
              [126.70617139953826, 37.131739448347304],
              [126.71898653007882, 37.13221464655401],
              [126.72745793924986, 37.13906781174734],
              [126.73081679760195, 37.149341865574875],
              [126.74160593694974, 37.152963094041624],
              [126.75002131950843, 37.16810113910867],
              [126.77750169258213, 37.16520414528457],
              [126.78880717195398, 37.17382562903142],
            ],
            [
              [126.86828392375844, 38.05181699053743],
              [126.87198947313927, 38.070036385991266],
              [126.87863536697478, 38.07308779817144],
              [126.89103475511132, 38.070641262859255],
              [126.88363603169017, 38.06030200282971],
              [126.86828392375844, 38.05181699053743],
            ],
            [
              [126.95177731540423, 38.12309923263551],
              [126.93819665361097, 38.1276639647037],
              [126.94195560393125, 38.134150691712264],
              [126.95133775497024, 38.13404708257826],
              [126.95650621249563, 38.12987379881904],
              [126.95177731540423, 38.12309923263551],
            ],
            [
              [126.9736037806238, 38.184092908698176],
              [126.97657388967387, 38.17647354828669],
              [126.96914624226076, 38.16158807344811],
              [126.96085634681228, 38.16616113895152],
              [126.97015388356711, 38.17069780289761],
              [126.9736037806238, 38.184092908698176],
            ],
          ],
          [
            [
              [127.07014002116107, 38.25893398858475],
              [127.08027296540662, 38.250228349506735],
              [127.08646832031145, 38.25462634537797],
              [127.07338961301153, 38.26859574846892],
              [127.05934129509004, 38.2622315430709],
              [127.07014002116107, 38.25893398858475],
            ],
          ],
        ],
      },
      properties: { CTPRVN_CD: '41', CTP_ENG_NM: 'Gyeonggi-do', CTP_KOR_NM: '경기도' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [127.49257720191127, 36.237953950461446],
            [127.50216746762052, 36.23764581283345],
            [127.51812955998501, 36.24064112710269],
            [127.53257275463179, 36.25088933578063],
            [127.53791797682368, 36.242777690563294],
            [127.54908039166699, 36.23972987307905],
            [127.54644297482145, 36.22527007980044],
            [127.55437136060985, 36.22618641978447],
            [127.5702404108146, 36.2335234097028],
            [127.5835822772373, 36.2312961287983],
            [127.5863624314678, 36.2256504927074],
            [127.59802031438545, 36.217088900860844],
            [127.59952903115776, 36.204560589610864],
            [127.59246547986477, 36.195140302648745],
            [127.59742925689636, 36.18432513031021],
            [127.59306081779968, 36.17737753836699],
            [127.60080099270374, 36.16974260947095],
            [127.60166451304552, 36.160024040793324],
            [127.5935144494921, 36.1501912334288],
            [127.58943705466004, 36.1344551103578],
            [127.59577660886039, 36.12593459278895],
            [127.61307558211784, 36.11180748051009],
            [127.61692314654367, 36.104876456683606],
            [127.61727468971077, 36.09357815033824],
            [127.63214695582195, 36.08236453317758],
            [127.6341994739978, 36.07361546339889],
            [127.6435002335807, 36.06738968902522],
            [127.65283925674997, 36.0571025186649],
            [127.65942157942182, 36.039634792487924],
            [127.67273573114944, 36.04163009622106],
            [127.66916835955287, 36.051154034166984],
            [127.68901549966886, 36.06267155558036],
            [127.69460848617841, 36.0589846999065],
            [127.69646121375838, 36.041102625312824],
            [127.7036165628667, 36.03441373359439],
            [127.71247458445573, 36.03588626379392],
            [127.71918250376078, 36.0318641222635],
            [127.73483525660664, 36.0323194300913],
            [127.73944904224767, 36.02573461360152],
            [127.74730505299377, 36.02970113926672],
            [127.76264473815704, 36.02157423121838],
            [127.75928891326613, 36.01592411162115],
            [127.76618288594646, 36.01220683486871],
            [127.79081414491829, 36.01879837322294],
            [127.80107606336209, 36.026591646474266],
            [127.81979296678607, 36.02979671806226],
            [127.83039572381875, 36.0352287773656],
            [127.85280793526711, 36.03910627725038],
            [127.86773916999739, 36.02377005253592],
            [127.87677397719392, 36.02251176835794],
            [127.88344295547489, 36.03233940846061],
            [127.90351153346823, 36.043423137482236],
            [127.9163396150487, 36.05446515406315],
            [127.93017777286735, 36.04943941843115],
            [127.94989002797436, 36.05972359305671],
            [127.96087454519476, 36.07033909021715],
            [127.96169421900552, 36.082979421948686],
            [127.95971299549777, 36.09451174165854],
            [127.96897777616364, 36.1043479414517],
            [127.96520087455728, 36.11282884282115],
            [127.97015992846327, 36.12188250510837],
            [127.97710501250147, 36.1230990541263],
            [127.98885337529458, 36.13265626033559],
            [127.98748203618054, 36.14738360341281],
            [127.99719738222305, 36.1554671916572],
            [127.9904804932014, 36.15887630810816],
            [127.98926324742847, 36.165875427511246],
            [127.98295199372497, 36.16988003977593],
            [127.98406941433443, 36.177009764108305],
            [127.97533188097722, 36.18771063363267],
            [127.98409954538506, 36.20050104138224],
            [127.9930385339538, 36.20003278583105],
            [127.9987754642383, 36.20746583790264],
            [128.00974801427742, 36.20936207002789],
            [128.0266815432326, 36.20519118297351],
            [128.03863367710144, 36.19415806076283],
            [128.05626553067572, 36.20208421905274],
            [128.05079104830193, 36.20599630487204],
            [128.05009118230348, 36.21646281503392],
            [128.0422247523742, 36.21754894962232],
            [128.03933887549826, 36.228676728034415],
            [128.03071520831656, 36.23971847282436],
            [128.04026226969359, 36.2520250185846],
            [128.04735242872817, 36.256551057454615],
            [128.03132697642758, 36.26199654138116],
            [128.02622489221713, 36.26789600581063],
            [128.0190343290752, 36.267294408369175],
            [128.01134201416463, 36.271954454038145],
            [127.99052819916433, 36.26337827855413],
            [127.9811908652038, 36.263647997848985],
            [127.97832387326025, 36.25458767715308],
            [127.9681150308354, 36.25032935389407],
            [127.94834241058571, 36.25748355888998],
            [127.94280292872554, 36.266729514634314],
            [127.9309072541492, 36.27801330529387],
            [127.9235344654078, 36.27870844557873],
            [127.90712026681523, 36.28649338034851],
            [127.90336658327239, 36.3013056329816],
            [127.89210117596943, 36.29192764534155],
            [127.88263555269211, 36.273749665687546],
            [127.86086183656943, 36.277060248969235],
            [127.85231540921139, 36.27383254330312],
            [127.84686221198541, 36.30076326566841],
            [127.84157007191378, 36.30820894231167],
            [127.84577220057825, 36.31811788055595],
            [127.85039179640133, 36.32025380625643],
            [127.85203284385632, 36.330405187890904],
            [127.86977876641615, 36.33954757638215],
            [127.87014931023292, 36.343486608771485],
            [127.88260665108932, 36.34591549241026],
            [127.88653197444125, 36.363608511963164],
            [127.88416671288064, 36.38001313113299],
            [127.87481868594219, 36.39103862210202],
            [127.86614844811015, 36.39479653729669],
            [127.8638656073705, 36.40304254727482],
            [127.87366791030763, 36.40657237321754],
            [127.87568958902459, 36.414351554700204],
            [127.88259470848394, 36.421546958140404],
            [127.87560137381443, 36.42799974960923],
            [127.87260858608218, 36.44166619414792],
            [127.8819612491331, 36.461838928195796],
            [127.88061861224638, 36.48062719718937],
            [127.87527773725859, 36.48316542956551],
            [127.88046639501417, 36.49327056470492],
            [127.88871470357248, 36.493136730419955],
            [127.90081847343693, 36.500016038036904],
            [127.9031822567765, 36.51101148576502],
            [127.90090791062268, 36.5250148476206],
            [127.89635417529807, 36.531195787420124],
            [127.87901063854217, 36.53470682281165],
            [127.87047577899314, 36.54282464876561],
            [127.87298859420122, 36.55132764511326],
            [127.87032170954504, 36.55915370258958],
            [127.860422748159, 36.56795069977079],
            [127.85236289379587, 36.571153312002615],
            [127.8448273078021, 36.5691091203271],
            [127.83016048382304, 36.57427531538231],
            [127.82447135913783, 36.57090731677174],
            [127.81620322728881, 36.578081410359005],
            [127.80489661924932, 36.58138656840832],
            [127.79847590645187, 36.58644225798901],
            [127.79742505057435, 36.60029872724017],
            [127.82273858101202, 36.61233693916705],
            [127.83216135132072, 36.61260347142098],
            [127.84122712421329, 36.60878768619018],
            [127.85572846049514, 36.61757815302092],
            [127.84784290774883, 36.62493563384262],
            [127.85137266052237, 36.634768995307326],
            [127.86197395024129, 36.63610158141913],
            [127.87013233981678, 36.645523981400075],
            [127.87393601596483, 36.65504552447763],
            [127.87993733051924, 36.656756844258226],
            [127.88199401185024, 36.646420445921095],
            [127.88877729590052, 36.63934817634331],
            [127.88935142851068, 36.628658897314494],
            [127.9085924536108, 36.625926597634155],
            [127.91138143174548, 36.615318941429344],
            [127.92592238800927, 36.60293890025974],
            [127.9240891269121, 36.61545039734157],
            [127.93237731125406, 36.61874310238535],
            [127.93140134549355, 36.62410763942331],
            [127.9390824436063, 36.65274760762485],
            [127.93163707416271, 36.65539951006174],
            [127.92957194753285, 36.66876507708555],
            [127.91755133379081, 36.66844872359289],
            [127.91296921483988, 36.6776706359036],
            [127.89166957987676, 36.68243954336966],
            [127.88194002320978, 36.68001820193966],
            [127.88160031085395, 36.68774032513088],
            [127.88857539382478, 36.691858089294655],
            [127.90436692155437, 36.69349434570012],
            [127.92892217057103, 36.690946190740185],
            [127.93356917634792, 36.706487369783446],
            [127.94952836793827, 36.708050162938896],
            [127.94918362052958, 36.719875687264995],
            [127.95360550707788, 36.722677070248814],
            [127.95697268910777, 36.73558962113788],
            [127.97072201579141, 36.73090502279899],
            [127.98009222111533, 36.72029729193314],
            [127.98684825209817, 36.71754933540022],
            [128.00193910667682, 36.71725680322699],
            [128.00650534516794, 36.725447950365584],
            [128.014842182548, 36.73019132084871],
            [128.02563220911887, 36.719329180234446],
            [128.03086316865384, 36.719291546650474],
            [128.04969493578804, 36.707755431858786],
            [128.07038379891665, 36.70770461857794],
            [128.07272379525932, 36.71188625778709],
            [128.0679879678957, 36.72223411304786],
            [128.05556456315378, 36.73041946440715],
            [128.05071984036863, 36.736709115373245],
            [128.03232468889578, 36.747575854882776],
            [128.03236705915197, 36.75517043273167],
            [128.044804898453, 36.77105116302435],
            [128.05119709497444, 36.78884347735325],
            [128.0549779457519, 36.792662677345454],
            [128.05500712958448, 36.80609669852185],
            [128.0596365627645, 36.816772689471904],
            [128.07179574820023, 36.81455426389212],
            [128.0853734770778, 36.804203973984485],
            [128.09296030345803, 36.8028635346875],
            [128.10818097106082, 36.81044070759657],
            [128.10982293478924, 36.82131777641354],
            [128.11843705810733, 36.82148721240456],
            [128.14106489312496, 36.83348259565653],
            [128.15143198297073, 36.82324314218748],
            [128.1713193955572, 36.822101346907225],
            [128.1847999898248, 36.816632616319225],
            [128.19367597348548, 36.81711640776842],
            [128.207165549773, 36.812424195527015],
            [128.2162123951595, 36.812463617033124],
            [128.21732518845005, 36.81827947550661],
            [128.21450868620144, 36.834851425702944],
            [128.21111988444247, 36.84116622581712],
            [128.2127491653031, 36.84917933615822],
            [128.23012920279967, 36.84536921102928],
            [128.23871417060306, 36.85018323562222],
            [128.2346558529447, 36.86283064865653],
            [128.24184105421025, 36.872328662169245],
            [128.25196331553622, 36.867016906325006],
            [128.26527422833448, 36.863984352533336],
            [128.26831288672471, 36.86054018154211],
            [128.28243416343267, 36.856398985708786],
            [128.29562427271577, 36.83534122380251],
            [128.30905591308016, 36.82895776554439],
            [128.32084903488385, 36.815639949337246],
            [128.33489489904198, 36.81687937305515],
            [128.35318102142907, 36.81244997106148],
            [128.3568679776854, 36.80677457116627],
            [128.36839883759248, 36.80207603348366],
            [128.38126367340004, 36.81388128541542],
            [128.42047892044428, 36.81151370775953],
            [128.43361198348052, 36.82762064711731],
            [128.43411311012736, 36.834144016356916],
            [128.44150473800315, 36.837602954538426],
            [128.44903106133586, 36.847842141566126],
            [128.44665910838853, 36.85337169944001],
            [128.44912627182418, 36.86287414538004],
            [128.4384283247522, 36.87327076749037],
            [128.42396974840432, 36.87652844698594],
            [128.42678632567552, 36.88924491252597],
            [128.44016166795387, 36.90287397213555],
            [128.4451743590655, 36.91741373234174],
            [128.44159366625166, 36.92734857135027],
            [128.45266808767985, 36.930718410786874],
            [128.46019028417365, 36.937720814330454],
            [128.46278173645175, 36.94738430210949],
            [128.47704672699805, 36.95744043722132],
            [128.5064969786908, 36.970052994104755],
            [128.51461435695902, 36.97758149517397],
            [128.51547480050132, 36.98682342031085],
            [128.54420698281152, 36.99257171352882],
            [128.5547312189407, 36.99828606530523],
            [128.55593988618122, 37.00570306521087],
            [128.57034425705797, 37.01399511906374],
            [128.57260799318016, 37.02196670188781],
            [128.56692602915004, 37.02599569796716],
            [128.5692911919477, 37.03488471360921],
            [128.57773407585395, 37.035567102066935],
            [128.5821348970725, 37.042643433589845],
            [128.59683111333553, 37.04176590255746],
            [128.60712591614097, 37.04384649383385],
            [128.60975978816322, 37.05203244484369],
            [128.63292476584294, 37.04050187064341],
            [128.6393488276874, 37.05399598940468],
            [128.65059933703748, 37.06582847082571],
            [128.64267079038817, 37.07076245245771],
            [128.62821291742583, 37.07515610478881],
            [128.6226423191794, 37.087401819944205],
            [128.6061001817181, 37.0767059366402],
            [128.59689532365064, 37.082416524854445],
            [128.5886848891739, 37.07997547938626],
            [128.5744062182068, 37.08131707471691],
            [128.5617021422918, 37.09023626904407],
            [128.5493364366059, 37.08655731069624],
            [128.53683430585315, 37.09013604702496],
            [128.53413586350823, 37.09811230197328],
            [128.51391194815002, 37.10511193004415],
            [128.5107584054521, 37.11395422707644],
            [128.4965539218185, 37.12579069291343],
            [128.49099654001054, 37.12381778263615],
            [128.47780592006015, 37.110154915940704],
            [128.4580456612072, 37.11027554363241],
            [128.4464488013854, 37.10828612994233],
            [128.43645290099312, 37.11186198430885],
            [128.4230626303937, 37.10324867897952],
            [128.41847330962025, 37.11981445600507],
            [128.40728535089744, 37.126378376068764],
            [128.39600247256888, 37.12859406914951],
            [128.4017929724052, 37.134808472516085],
            [128.40087428580438, 37.146876320289536],
            [128.39187668434676, 37.15513354989162],
            [128.38435166609972, 37.158121615639665],
            [128.3780152970759, 37.15171332889375],
            [128.36535289006272, 37.15763801292633],
            [128.36020149860818, 37.15064388222499],
            [128.35080180281906, 37.15757156626238],
            [128.33549881762497, 37.15724738078675],
            [128.33067274422996, 37.15034316074615],
            [128.31672041570388, 37.14755933021572],
            [128.3063609218287, 37.137525926044084],
            [128.29833692718051, 37.13418966904262],
            [128.2846860049886, 37.143153932119205],
            [128.27328634062735, 37.14762916139885],
            [128.27038521759232, 37.16177147541332],
            [128.27366607144916, 37.169641360838504],
            [128.28111415883282, 37.173402468013],
            [128.2896757486084, 37.170148351208304],
            [128.29807280258817, 37.17165939975657],
            [128.2956235467412, 37.1832883377355],
            [128.31048786875633, 37.18733713628256],
            [128.31449903424456, 37.19680937390146],
            [128.3257445153075, 37.196932528039035],
            [128.33339658604535, 37.21578670322304],
            [128.31404062928448, 37.22269086808532],
            [128.30914086027406, 37.21745688325167],
            [128.28818052792488, 37.2150733272646],
            [128.28394710658173, 37.21018101835522],
            [128.26839360449208, 37.20792335100081],
            [128.2597944111685, 37.216409933308626],
            [128.25093332277908, 37.22958235526431],
            [128.2445085852229, 37.22661787987364],
            [128.22849886835806, 37.228026498865916],
            [128.2203134413802, 37.24029825109164],
            [128.2077991932931, 37.24882301093684],
            [128.19279664608626, 37.24486219534914],
            [128.1740986124534, 37.23260505831253],
            [128.17306865077217, 37.21906465270874],
            [128.16404062128166, 37.2133087024429],
            [128.1546681952774, 37.21566575539479],
            [128.15086130209556, 37.22073761284926],
            [128.1253222358373, 37.2345373191495],
            [128.1223620164581, 37.225204321302265],
            [128.11551195268754, 37.220273219182225],
            [128.1115041313603, 37.207671551552345],
            [128.10000090169245, 37.201695346504295],
            [128.07754310210635, 37.19370038785868],
            [128.06047463699, 37.19409295346255],
            [128.04980922662006, 37.189578880748385],
            [128.03720306559956, 37.1892806448625],
            [128.02829804637452, 37.20232335469173],
            [128.03875482051245, 37.216037037645734],
            [128.03212732908278, 37.22380014896214],
            [128.0230152202579, 37.225633520400194],
            [128.0192155029149, 37.244377767970256],
            [128.00796528646632, 37.25212229521813],
            [127.97989775019239, 37.258334282155765],
            [127.96454757653507, 37.251010254100684],
            [127.95268360656725, 37.24792363832456],
            [127.94519119979196, 37.24056211189759],
            [127.93888141168185, 37.24074315897216],
            [127.92661816496984, 37.23159722711702],
            [127.9215833453569, 37.225045280323805],
            [127.92709701105515, 37.22015405217241],
            [127.93247275750154, 37.2069895404969],
            [127.93092101927404, 37.20113078853335],
            [127.93625929382783, 37.18876686570855],
            [127.93362553710698, 37.17580286034507],
            [127.9231682797902, 37.16396165971796],
            [127.91504522321162, 37.168881607099394],
            [127.90863336117201, 37.16712432040128],
            [127.9016397988349, 37.15180229559506],
            [127.88656996897383, 37.16107411206873],
            [127.87205003626937, 37.16434396840685],
            [127.86196495323942, 37.16104554567293],
            [127.847391384085, 37.152935936319814],
            [127.8253702808598, 37.15226266893772],
            [127.81739179939288, 37.147216917324684],
            [127.78952364538515, 37.143408276571705],
            [127.76868914610465, 37.15664987702282],
            [127.75552751815943, 37.17144083329293],
            [127.75104114758561, 37.18246464202165],
            [127.74785164330291, 37.20032959387753],
            [127.74179839594623, 37.21218365331116],
            [127.7367402298564, 37.210193475686175],
            [127.72834995992629, 37.19178691701793],
            [127.72640713870098, 37.18254048546623],
            [127.71763705222713, 37.183831323121375],
            [127.70485484385469, 37.167520112528635],
            [127.70427262235299, 37.15764769450491],
            [127.69449611373015, 37.14882726408367],
            [127.69453452082755, 37.1412589015974],
            [127.68859287296831, 37.13554067900567],
            [127.67021249465037, 37.1361080097025],
            [127.6599435958611, 37.139915136212664],
            [127.64808854906157, 37.15060496988138],
            [127.6386746911931, 37.153106627312006],
            [127.6274548564798, 37.151724013446525],
            [127.63776772321295, 37.14119002899836],
            [127.63397583537886, 37.12373914992601],
            [127.63627266573219, 37.114464161114164],
            [127.63181443344536, 37.096476065586536],
            [127.59955503691965, 37.08230745867919],
            [127.60506990794241, 37.075737902898275],
            [127.58927007796538, 37.0728167462146],
            [127.57797674541933, 37.075341041188],
            [127.56472311893631, 37.05923982759035],
            [127.56708713783331, 37.047523872107995],
            [127.55691317138114, 37.04126453519252],
            [127.53279859048084, 37.055197184402026],
            [127.51251378570858, 37.0563495375856],
            [127.50889249882583, 37.049417924251735],
            [127.4990778421896, 37.04757627797886],
            [127.48647723989829, 37.05478285928746],
            [127.47511081804787, 37.052909523252474],
            [127.46033178488562, 37.04615558620707],
            [127.45974415272646, 37.025063992012996],
            [127.42882398645895, 37.002193148771006],
            [127.42035045657434, 37.00376417906301],
            [127.41391215624934, 36.999470603075494],
            [127.3942128961335, 36.998375028325505],
            [127.38503080707555, 36.984186145067916],
            [127.39431634057848, 36.976983248186855],
            [127.40153405767809, 36.96767809083597],
            [127.38726751052248, 36.96446340613876],
            [127.37872344780058, 36.957894977828],
            [127.37533259375638, 36.94871471227278],
            [127.36730178122103, 36.95029858275508],
            [127.35761192790096, 36.947687875132495],
            [127.34963055864209, 36.952793620556825],
            [127.32681215889271, 36.93593603493173],
            [127.31330066106722, 36.931241590902964],
            [127.29537911036374, 36.92925083481623],
            [127.30336477035068, 36.91639036441238],
            [127.2904101123483, 36.89239677843741],
            [127.30788411713932, 36.88538675367496],
            [127.31129347734273, 36.870488234293525],
            [127.30578833268576, 36.86337595063967],
            [127.31272986283057, 36.85746651357879],
            [127.3193002095436, 36.85906490835345],
            [127.33649498326774, 36.8546868156437],
            [127.33409908077805, 36.83236046024183],
            [127.35605418507743, 36.828653489479],
            [127.35715049239897, 36.82355986351222],
            [127.36661399997413, 36.81696949763938],
            [127.3814904966168, 36.81408274969912],
            [127.39160838798827, 36.80658748668796],
            [127.40171778762458, 36.79514850813252],
            [127.39549717885889, 36.7824775375996],
            [127.40189711375169, 36.77571198025861],
            [127.41295016831671, 36.7732165087013],
            [127.42015132903606, 36.75835357540491],
            [127.4114628382021, 36.75608234842697],
            [127.40401040697448, 36.74487885811952],
            [127.3886552982288, 36.75348920001575],
            [127.38637147123153, 36.759285383773985],
            [127.3714631772275, 36.758563629483255],
            [127.36455797132892, 36.76154080729171],
            [127.34784166312866, 36.75292620812456],
            [127.33550822912511, 36.75264184934132],
            [127.33298052352296, 36.74815125528336],
            [127.34316648399665, 36.73569529741025],
            [127.33755040146785, 36.729303812706625],
            [127.3254642049554, 36.73367054768287],
            [127.31846113810153, 36.72525020182844],
            [127.30930001146322, 36.72176778339226],
            [127.30610094408834, 36.708269698284674],
            [127.30774787092153, 36.70416989673553],
            [127.29201482638955, 36.697282552188675],
            [127.28529036490733, 36.690671497719265],
            [127.30762545683545, 36.682022471984226],
            [127.30485205677898, 36.66808748107479],
            [127.2959277019788, 36.65957002063606],
            [127.28916022891156, 36.65932227377491],
            [127.28161986493868, 36.64514288684431],
            [127.27565073450816, 36.63980367383402],
            [127.27932132703509, 36.63355560724305],
            [127.29226169270461, 36.6351890583924],
            [127.30117454930345, 36.60766150327316],
            [127.30640976268363, 36.602037774917136],
            [127.30404848032276, 36.58333756596166],
            [127.32143964862442, 36.58377967988075],
            [127.32741095382154, 36.576031347159656],
            [127.33655048804877, 36.569986070350716],
            [127.33701705702707, 36.56283938929835],
            [127.34712820679077, 36.56445339772493],
            [127.36048424063664, 36.56227690411581],
            [127.36825983413756, 36.5661965323938],
            [127.37500479563715, 36.560214124265784],
            [127.38318603058023, 36.54786464379421],
            [127.38388437515208, 36.541532742271485],
            [127.40182466750505, 36.541240482884405],
            [127.40854429851633, 36.528521253236796],
            [127.4014931645439, 36.52365381264737],
            [127.40904396812216, 36.509748430284176],
            [127.40982635082817, 36.49532080643088],
            [127.39614094465637, 36.491708392087794],
            [127.39658982721043, 36.49129262167917],
            [127.39689732186439, 36.49099676610255],
            [127.39811383534598, 36.48983869232018],
            [127.40244418174665, 36.48598533284786],
            [127.40329201633055, 36.48440604148276],
            [127.40416267740487, 36.47750960232207],
            [127.4041606024079, 36.47656931443265],
            [127.40283857740575, 36.47390946751753],
            [127.40242187197501, 36.473089974114565],
            [127.39873139548479, 36.47257205210074],
            [127.39858747842787, 36.47235230787421],
            [127.39842887351887, 36.47194787694474],
            [127.39837320800117, 36.47152790953181],
            [127.39832536881214, 36.471206746428464],
            [127.39833923543382, 36.47077950099675],
            [127.3983196972069, 36.47040051535716],
            [127.3982897000989, 36.46950819702247],
            [127.39812321327224, 36.46913421403767],
            [127.39821425347591, 36.46886666659515],
            [127.3981873529832, 36.46878987902709],
            [127.39814671168584, 36.46844249463819],
            [127.39833330662286, 36.4676331010805],
            [127.3983417529096, 36.46751056171041],
            [127.39855930684713, 36.46689424366111],
            [127.39874841283333, 36.466613689961854],
            [127.39913778998529, 36.466360647736025],
            [127.39959343207991, 36.46512483194133],
            [127.39959376989034, 36.46481561901388],
            [127.39900602671831, 36.46425154692237],
            [127.39898461067385, 36.46411897838282],
            [127.39909916506062, 36.463201116718736],
            [127.39911574864682, 36.46303406018792],
            [127.39947341864132, 36.46221028867419],
            [127.39979511084042, 36.4615105436392],
            [127.39954086651261, 36.457536466862166],
            [127.39943991828622, 36.45746189913164],
            [127.39935213416437, 36.457201975520334],
            [127.39936671807406, 36.45688371241107],
            [127.39925087426154, 36.45676018982656],
            [127.39928813523719, 36.456513654387095],
            [127.39927767617894, 36.45637711079573],
            [127.39957520582577, 36.45589738180142],
            [127.399909876562, 36.455627054567415],
            [127.40022636299163, 36.455280451614605],
            [127.40254952276085, 36.4555641368964],
            [127.4031021555594, 36.45531305697113],
            [127.40629396019868, 36.45491308607942],
            [127.4070577154175, 36.45484094165162],
            [127.40796423721122, 36.45473759650643],
            [127.40886334309212, 36.45475002262364],
            [127.41205658373728, 36.454799630392706],
            [127.41303027545119, 36.4548083882918],
            [127.41407664924965, 36.45471887946646],
            [127.41570795863417, 36.45475885493794],
            [127.41629229224827, 36.454808083280234],
            [127.41663349969545, 36.454858703294],
            [127.41703836122133, 36.454918690704964],
            [127.41744413298338, 36.454983457349435],
            [127.41788618471257, 36.455053440675],
            [127.41893353911554, 36.45524550463008],
            [127.41987799823514, 36.45539314111728],
            [127.42377375531761, 36.45602994481879],
            [127.424584476166, 36.45616449153711],
            [127.42470481956288, 36.45617870860726],
            [127.42754603695155, 36.45686418138493],
            [127.43023005402277, 36.45671996609937],
            [127.4306154861276, 36.45669605305661],
            [127.43201824962028, 36.45662735212131],
            [127.43391708619728, 36.456529527455125],
            [127.43540005543635, 36.456465570841516],
            [127.43586167395341, 36.45644502188598],
            [127.43676728279195, 36.456401459379315],
            [127.43700151338233, 36.45605225631414],
            [127.43633669635214, 36.456077767254186],
            [127.43509932690229, 36.45611070874907],
            [127.43412863921587, 36.45614211269369],
            [127.43410128483646, 36.456143897102976],
            [127.43395318607979, 36.45577806156855],
            [127.43762078809857, 36.45561349538777],
            [127.43778943568202, 36.45547432763642],
            [127.43871164354934, 36.45469568376422],
            [127.43894535794307, 36.454505586080806],
            [127.43908975231861, 36.45439466647479],
            [127.43939331551131, 36.454134471423366],
            [127.44005281543218, 36.45353841769393],
            [127.44034246820557, 36.45328530952397],
            [127.44070852111176, 36.452983204577414],
            [127.4411589170411, 36.45261460675066],
            [127.44133482525987, 36.45246949494866],
            [127.44160175952823, 36.452145502456816],
            [127.44170289989482, 36.45203107984582],
            [127.44196131645201, 36.451742037608376],
            [127.44233820114, 36.45135371854724],
            [127.44241219964373, 36.45127853242611],
            [127.44297207213222, 36.45094726355044],
            [127.44328163002398, 36.45079714926851],
            [127.44392490319558, 36.4504844283872],
            [127.44524943019088, 36.449981625330715],
            [127.44539134108521, 36.44992730871074],
            [127.44643101060099, 36.44953791605787],
            [127.447162104742, 36.44919472523753],
            [127.44979336231246, 36.449233310102315],
            [127.45177816648277, 36.44938917272385],
            [127.4525782784052, 36.44962157801889],
            [127.45289409968444, 36.44971500528233],
            [127.45350308045501, 36.449898563235664],
            [127.45396136692166, 36.45003227924802],
            [127.45436540458034, 36.45015888165392],
            [127.4558384729234, 36.45087307877216],
            [127.45653824477077, 36.45125903456054],
            [127.45738650124619, 36.451733687126655],
            [127.45811375301737, 36.452136712894855],
            [127.45857831220616, 36.452444138644495],
            [127.4609622853759, 36.45448059717639],
            [127.46179282303058, 36.4553371484459],
            [127.46212057371801, 36.455672409292916],
            [127.46250044303147, 36.45606632296568],
            [127.462580490065, 36.45616176077321],
            [127.46348776864926, 36.460194555487305],
            [127.46351341138279, 36.460314146360034],
            [127.46358342682532, 36.46289003547725],
            [127.46358958503686, 36.46339944027349],
            [127.46373897708145, 36.46433886780112],
            [127.46378098475631, 36.464514150484305],
            [127.46398727590683, 36.464907882846354],
            [127.46421841079207, 36.46534573774918],
            [127.46494098415042, 36.466693809280244],
            [127.46494435902989, 36.46670393477813],
            [127.46516105413974, 36.467115368357916],
            [127.46530835290423, 36.467406542046675],
            [127.46549338874736, 36.46776938336107],
            [127.46569074525546, 36.46815328859444],
            [127.46590118378846, 36.46856559209051],
            [127.46603907041491, 36.46882666759107],
            [127.4660824767371, 36.4689152073297],
            [127.46615849908778, 36.46906247472934],
            [127.46630434235145, 36.46934210918172],
            [127.46644755049257, 36.469619500982034],
            [127.46956706593102, 36.472840732966134],
            [127.47030887097391, 36.47367701356512],
            [127.47179919634922, 36.47469705186494],
            [127.47420131119222, 36.47567402878578],
            [127.47612818216459, 36.476331823170995],
            [127.48061100717524, 36.47720999235808],
            [127.48078646631363, 36.47719267049221],
            [127.48114783666057, 36.47712673277099],
            [127.48403294933043, 36.47661749781795],
            [127.48413388480635, 36.47619411909549],
            [127.48421227188264, 36.47587389523399],
            [127.48428166964598, 36.47559397027183],
            [127.48450388402986, 36.474682354721125],
            [127.48442909501212, 36.474148729309775],
            [127.48431314788711, 36.473725091821585],
            [127.4842673564706, 36.47356701664678],
            [127.48380786383125, 36.4719169560625],
            [127.48365429750986, 36.471359712833355],
            [127.48337252003971, 36.4703366434371],
            [127.48315398446364, 36.46967376776202],
            [127.48308336824361, 36.46950199597851],
            [127.48287450253466, 36.46899284462886],
            [127.48274994996763, 36.46878270295249],
            [127.48265061861542, 36.46861864352819],
            [127.48257855974961, 36.46849643318174],
            [127.48235765609041, 36.46812362628721],
            [127.48226511126484, 36.46793082018884],
            [127.48226031995503, 36.46791732196729],
            [127.48223477673416, 36.46787489965168],
            [127.48218719583498, 36.46776357404556],
            [127.48213894851078, 36.46765619905216],
            [127.48195497828789, 36.46722354194752],
            [127.48193147797929, 36.4671723875458],
            [127.48191036389971, 36.4671138899921],
            [127.48184404167239, 36.46695899679922],
            [127.48182068747634, 36.46690445455343],
            [127.48179730633666, 36.46684344144444],
            [127.48172624176573, 36.466683206741486],
            [127.48170287536139, 36.46662642002822],
            [127.48165695727543, 36.4665294524958],
            [127.48134021448864, 36.46599341629049],
            [127.48090021322696, 36.46542605579427],
            [127.48078183881368, 36.465282627193766],
            [127.48076514730478, 36.46526241773126],
            [127.48049851447804, 36.464963288870614],
            [127.48010784998547, 36.46465002132279],
            [127.47940048965792, 36.46374635519237],
            [127.4790881579867, 36.46310131154173],
            [127.47905543091159, 36.46296571176314],
            [127.47901651527691, 36.46281801591584],
            [127.47895393163493, 36.46270225279425],
            [127.47848155041069, 36.461993071607075],
            [127.47825947127362, 36.46170813252856],
            [127.47795245828243, 36.4611892250205],
            [127.47759680472977, 36.4600963069468],
            [127.47750062969237, 36.45959064212794],
            [127.47746100860205, 36.4591258612108],
            [127.47748112418239, 36.4589362596416],
            [127.47758356194946, 36.458415438486895],
            [127.47788898982643, 36.45785128014624],
            [127.4781732525656, 36.45741872078654],
            [127.47950552222694, 36.456007888644294],
            [127.4800642740121, 36.45560181792343],
            [127.48210730044279, 36.45388508449654],
            [127.48314738744132, 36.45347086890664],
            [127.48454222211885, 36.45292904894882],
            [127.490566147601, 36.45322414823641],
            [127.49349930518231, 36.45395976983081],
            [127.49397576754568, 36.45411465807194],
            [127.49646645707624, 36.45490693785972],
            [127.49680266247022, 36.455013968974384],
            [127.497208022349, 36.455140699812645],
            [127.49736816233799, 36.45518903059681],
            [127.49747906432093, 36.45522376850415],
            [127.49748781124201, 36.45522908580252],
            [127.49754963119635, 36.455247978273206],
            [127.49757303277981, 36.45525463919211],
            [127.49774857131025, 36.45531248478313],
            [127.4981087266639, 36.45542955050505],
            [127.498121290221, 36.455431741379726],
            [127.49940914278756, 36.455831902966985],
            [127.50059119524357, 36.456203475187436],
            [127.50279040155849, 36.455504600772215],
            [127.50296250723862, 36.45519128832457],
            [127.50445607825743, 36.45189693861687],
            [127.50445981627988, 36.45188143209574],
            [127.50379527727671, 36.450157124189616],
            [127.50291994647371, 36.44893073478193],
            [127.50268389761426, 36.44875712814789],
            [127.50237266722671, 36.44852047627725],
            [127.50132457385968, 36.44771439399264],
            [127.50110268352951, 36.44754720501709],
            [127.50092108131778, 36.44741109803064],
            [127.49996071069576, 36.446691939339125],
            [127.49934290486397, 36.44622958687235],
            [127.49928582832952, 36.446189273266754],
            [127.49714258140891, 36.44471776299447],
            [127.49699685561795, 36.44457531960651],
            [127.49627848597186, 36.44388919850623],
            [127.49610120324262, 36.44371758799962],
            [127.4937664672083, 36.441458023885275],
            [127.49371612871498, 36.441406136367014],
            [127.49301797652107, 36.4404062022656],
            [127.49294340701744, 36.44027189532521],
            [127.49272369316522, 36.43988981118381],
            [127.49258361767822, 36.43964651762143],
            [127.49242974626486, 36.439371452230844],
            [127.4908416846748, 36.43631828267429],
            [127.4905082236587, 36.43569052798665],
            [127.48972175558595, 36.434125182565246],
            [127.49012888039373, 36.43191231544875],
            [127.4909039113787, 36.4303256450164],
            [127.49106244280932, 36.42995974861357],
            [127.49170290055741, 36.4288422242398],
            [127.49190289040315, 36.428420391984275],
            [127.49223929019435, 36.42782960147003],
            [127.4924116016892, 36.42752362876256],
            [127.49259796397024, 36.42720717904558],
            [127.49289191776708, 36.42671286801191],
            [127.49309714399533, 36.42626567312171],
            [127.49361748750678, 36.42542320357696],
            [127.49466250081764, 36.424231622475105],
            [127.4961653660206, 36.421284825306884],
            [127.4965059015565, 36.42034030202523],
            [127.49694526253748, 36.419486889125494],
            [127.49700247493917, 36.41867280178711],
            [127.49710222295755, 36.41649496429442],
            [127.49712025739298, 36.41637295420626],
            [127.4971586917532, 36.41614328840332],
            [127.49775802288798, 36.414915787989024],
            [127.49811113801331, 36.4145324553372],
            [127.4994347545357, 36.41299976569468],
            [127.49963701247971, 36.412699576959504],
            [127.49997896146489, 36.4120704323434],
            [127.50155485214805, 36.408653817612745],
            [127.50231161532129, 36.4085270172253],
            [127.50649482188122, 36.40824158699727],
            [127.50949727547321, 36.40862029707631],
            [127.51006432583216, 36.40921602554106],
            [127.51019413059811, 36.40935317811564],
            [127.5106860490459, 36.40988558427611],
            [127.51101733734019, 36.4103062987686],
            [127.51124856128756, 36.41079560343432],
            [127.51133729695674, 36.41101966698024],
            [127.51263203420247, 36.41581615858156],
            [127.51309464519954, 36.417501588101366],
            [127.51358978120415, 36.419307972873405],
            [127.51362584987079, 36.41941651480182],
            [127.51451044329447, 36.42247353795723],
            [127.51570517670602, 36.42248361089977],
            [127.51614303773954, 36.422487636369524],
            [127.5164920312284, 36.42225183151291],
            [127.5165576770884, 36.422115529306716],
            [127.51666621959644, 36.42203508322306],
            [127.51666795077601, 36.422033948944176],
            [127.51686477033373, 36.421921303629865],
            [127.51749458531091, 36.42149729304104],
            [127.5176783925874, 36.42115434117817],
            [127.51904469363618, 36.42021630107204],
            [127.51906451878716, 36.4200801945575],
            [127.52027102251208, 36.42037036679709],
            [127.52060429769284, 36.4211019519503],
            [127.52283240028918, 36.42258195846768],
            [127.52343255277634, 36.42317156559993],
            [127.5243193762911, 36.423431840405044],
            [127.52600749756755, 36.421931902694936],
            [127.52596831046063, 36.421571335626176],
            [127.52623036881975, 36.42090050917136],
            [127.52699687244046, 36.42117537061363],
            [127.52700491437038, 36.42117899282111],
            [127.5276407181808, 36.42118745779163],
            [127.52872358482173, 36.42032039625115],
            [127.52877437563322, 36.419794681965826],
            [127.53288129842373, 36.419208750716834],
            [127.53365025566966, 36.4192275757928],
            [127.53524439216558, 36.41895152135423],
            [127.53654961215375, 36.419988764212476],
            [127.53743516505256, 36.420317939795424],
            [127.53778279146545, 36.420122910184055],
            [127.5382612244996, 36.420176802991854],
            [127.53923736808296, 36.420426139898225],
            [127.54215434310203, 36.41934257157772],
            [127.54183912236022, 36.41568757111438],
            [127.54607086354923, 36.408646112102744],
            [127.5470727467961, 36.40845961574451],
            [127.54707951164625, 36.408454519515665],
            [127.54716570035544, 36.40842428016071],
            [127.54769302152094, 36.408255147279036],
            [127.54786423112132, 36.408201428971196],
            [127.54848347005284, 36.40775110924396],
            [127.54964649111751, 36.40729547951697],
            [127.55036605917206, 36.40684526573269],
            [127.55047208006178, 36.406737765970085],
            [127.55125655764097, 36.405935230292314],
            [127.5519133617659, 36.40484011520529],
            [127.5519171098468, 36.404827707172394],
            [127.5537964961323, 36.40085282592338],
            [127.55389393350278, 36.40078929385446],
            [127.55395274195237, 36.40075550752152],
            [127.55412477953017, 36.40065024186497],
            [127.55451064661987, 36.40041274062075],
            [127.55501715053168, 36.40011751858551],
            [127.55503744298845, 36.400105602104034],
            [127.55687893536368, 36.39958142163757],
            [127.55700422076313, 36.39956450108753],
            [127.55807420958936, 36.399666252198244],
            [127.55816537395381, 36.399675965430674],
            [127.55878010175519, 36.399856150428015],
            [127.5589880370101, 36.39946205031553],
            [127.55967899075176, 36.398218889333684],
            [127.55915952272314, 36.39781692305376],
            [127.55743107302732, 36.39730653743214],
            [127.5543637889788, 36.394974671409095],
            [127.55107825483309, 36.395209210442324],
            [127.55079111503832, 36.3956633625437],
            [127.55002646841587, 36.39686963927473],
            [127.54465989723226, 36.396158596172384],
            [127.53742885083223, 36.394948224841436],
            [127.53633477247192, 36.394774303292685],
            [127.53452566916103, 36.39402682497976],
            [127.53342884712916, 36.39354903695131],
            [127.53335559833265, 36.39302275499293],
            [127.53367409558417, 36.392939943414916],
            [127.53364411388456, 36.39250188958117],
            [127.53349561348946, 36.39194750184572],
            [127.53177174628973, 36.39091601652533],
            [127.5308689298698, 36.391224440209896],
            [127.53050256362243, 36.391233390455014],
            [127.53014735850282, 36.39119328379012],
            [127.53009920731387, 36.3910518437486],
            [127.52968215483668, 36.39072504673843],
            [127.52905948371736, 36.39009642942814],
            [127.52852096506228, 36.38898249856285],
            [127.52800137480322, 36.38870964817902],
            [127.52708449831023, 36.38804233230587],
            [127.52679979859123, 36.387658619477214],
            [127.52630095419961, 36.38746565794254],
            [127.52512306467467, 36.38762852877632],
            [127.52458284471436, 36.386456002591736],
            [127.52527525832546, 36.38448478454408],
            [127.52508713231155, 36.38213949830068],
            [127.5253153014398, 36.37970536865111],
            [127.52589314472806, 36.37896417200015],
            [127.5251508857988, 36.37676577948932],
            [127.52514118769784, 36.37674695182019],
            [127.52479507862755, 36.375896872057716],
            [127.52592577445586, 36.37204988221516],
            [127.52598637349433, 36.371583545420975],
            [127.52579365082458, 36.367876963460986],
            [127.52482422571325, 36.3664959579067],
            [127.52427928368381, 36.36628854495046],
            [127.52442478405888, 36.36560443221319],
            [127.5244726527844, 36.36505676645879],
            [127.52480137859472, 36.364045747008426],
            [127.5248494125773, 36.36362818202029],
            [127.52450166141367, 36.36327740483336],
            [127.52427214175025, 36.36209563447445],
            [127.52438557593936, 36.361695814788476],
            [127.52408853161533, 36.36103701447487],
            [127.52367958324007, 36.360046118250125],
            [127.52295091921698, 36.35932386491497],
            [127.52209356066359, 36.35812455193825],
            [127.52254417494109, 36.35709216221266],
            [127.5228704089459, 36.356806026139246],
            [127.5230544849814, 36.35598320040117],
            [127.52260970596616, 36.355065955848836],
            [127.52230121686617, 36.35425343311322],
            [127.52160747475811, 36.35374673802014],
            [127.52152702923843, 36.35332494890865],
            [127.52011307548234, 36.35115224229193],
            [127.5197717055304, 36.35086000811884],
            [127.51869278375499, 36.3502459705309],
            [127.51747982784828, 36.34955027967896],
            [127.51711283128986, 36.34906410878016],
            [127.51728257032157, 36.34801324008495],
            [127.51305690920277, 36.34748282068401],
            [127.51300139489835, 36.34745659160118],
            [127.51265120236755, 36.34721956067283],
            [127.51210148768966, 36.346228088621494],
            [127.51042260430468, 36.346478564608084],
            [127.50977963776775, 36.34672095654604],
            [127.507459776602, 36.346287265132986],
            [127.50743079735902, 36.346004359599455],
            [127.5080264175304, 36.34452617847614],
            [127.50788516058208, 36.343757408566475],
            [127.50674404285337, 36.342809255341194],
            [127.5053753745158, 36.34227630846474],
            [127.50483319987374, 36.34211300450162],
            [127.5044462456732, 36.34180739031032],
            [127.5048820425843, 36.34099282016174],
            [127.50383652651804, 36.34085443988585],
            [127.50249513658531, 36.3404139933936],
            [127.50204892572661, 36.340338984575574],
            [127.50100990464792, 36.33982346649115],
            [127.5005588858565, 36.33929423075384],
            [127.5005552652814, 36.33902699576191],
            [127.50055589177434, 36.33896109122962],
            [127.50129494444475, 36.33662961504335],
            [127.50156646390964, 36.33622548657753],
            [127.50124209900753, 36.33500520268565],
            [127.50129296935971, 36.334060450776896],
            [127.50127686434782, 36.3340447481239],
            [127.50097201620949, 36.33312655258345],
            [127.50163260181448, 36.332114762565915],
            [127.50154195044858, 36.33143645424146],
            [127.5016959622876, 36.33018402621441],
            [127.50220025567022, 36.32781579070578],
            [127.50286034949168, 36.32638382600334],
            [127.50292326010417, 36.32588144947309],
            [127.50285620125497, 36.325411149948444],
            [127.50272367641666, 36.325148951204824],
            [127.50259242530275, 36.32492534558555],
            [127.50238854387636, 36.32458036824958],
            [127.501827086234, 36.32353004709083],
            [127.5015291004545, 36.322834861298645],
            [127.50115098860171, 36.32259030561326],
            [127.50070507139719, 36.32213482633602],
            [127.50042965999177, 36.321620904820556],
            [127.4999309806008, 36.32099414000632],
            [127.49888746086285, 36.320523678734006],
            [127.49695767736422, 36.3191833180133],
            [127.49700449945367, 36.31794936915881],
            [127.4971777697028, 36.31769632410295],
            [127.49742513731712, 36.31713910499695],
            [127.49782766625505, 36.31641256134125],
            [127.49764211720007, 36.31612608366595],
            [127.49714809538578, 36.31507038443382],
            [127.49691919403632, 36.3143937625629],
            [127.49646922686722, 36.31383718011537],
            [127.49456811525967, 36.311990040572695],
            [127.49508935859595, 36.31168515010884],
            [127.49617373843535, 36.31063305757592],
            [127.49877411718111, 36.30675990567459],
            [127.49885681576878, 36.30633122606547],
            [127.4989585481984, 36.305777428642486],
            [127.49897684528597, 36.305672871822644],
            [127.49855188943184, 36.30502044312765],
            [127.49733698849627, 36.30242166997986],
            [127.49655544776212, 36.301137638094886],
            [127.49654310427013, 36.30111178096014],
            [127.49601624471671, 36.299411312948905],
            [127.49451204346255, 36.30087037688911],
            [127.49305231709958, 36.30050127437425],
            [127.49248858322058, 36.30017691558989],
            [127.49229201916158, 36.29970432793597],
            [127.49160792327561, 36.29929766893646],
            [127.49146520589817, 36.29845170982824],
            [127.4914084664402, 36.29769580473138],
            [127.49117725513018, 36.29702312550686],
            [127.49184152977485, 36.29615527744207],
            [127.4922901780359, 36.2956073796013],
            [127.49268312462677, 36.29499747335187],
            [127.49277762944297, 36.29450764111756],
            [127.49358189793516, 36.29331027890726],
            [127.49440892338427, 36.29161463093316],
            [127.49464482087002, 36.29134443338097],
            [127.49556883038515, 36.29011389652841],
            [127.49547224500074, 36.28974706754541],
            [127.4957695209265, 36.287792543804514],
            [127.4962916810496, 36.28752285247979],
            [127.49763231690872, 36.285656373106704],
            [127.49771321233958, 36.285191366221206],
            [127.49884458003058, 36.28327504964187],
            [127.49866165893417, 36.282595990835965],
            [127.49703428054328, 36.279780653313225],
            [127.49506055196353, 36.27809038861314],
            [127.49393307126341, 36.27708627782176],
            [127.49298583682466, 36.27631235188009],
            [127.49262251355475, 36.27547265018547],
            [127.49113503650915, 36.27445168813887],
            [127.49069790685282, 36.273929108921386],
            [127.49063835237881, 36.2738879534033],
            [127.49020824006345, 36.27365455914727],
            [127.48989107075738, 36.27348942480344],
            [127.48973583429324, 36.27344190016547],
            [127.48943575172702, 36.273311048622425],
            [127.48907822586094, 36.27300498023834],
            [127.48888625139708, 36.27208176854515],
            [127.48908472864991, 36.27147717043598],
            [127.48927595597344, 36.27090949645107],
            [127.48936970740597, 36.2706055259147],
            [127.48944035659851, 36.2698600813725],
            [127.48944328506323, 36.269826554817456],
            [127.4897021876096, 36.269601610237046],
            [127.48991518176611, 36.268872480697325],
            [127.49004741923592, 36.26866298480979],
            [127.49025512587704, 36.26837038003503],
            [127.48867432484931, 36.26730273450152],
            [127.48833020235062, 36.267217118357166],
            [127.48769988095542, 36.265308897566015],
            [127.48676391950906, 36.262107892290466],
            [127.48658626129424, 36.26202947177803],
            [127.4862124423717, 36.259469108811054],
            [127.48725298105327, 36.258761409240705],
            [127.48985988185353, 36.25758798514338],
            [127.4895296026044, 36.25603254692409],
            [127.48981284297159, 36.25380209913922],
            [127.48872785364759, 36.25273947230291],
            [127.48798821140825, 36.251941558895815],
            [127.4876078537515, 36.25143929235611],
            [127.48808814476763, 36.25028100773443],
            [127.48831999431661, 36.249656285983896],
            [127.4892495026865, 36.24705005367659],
            [127.48939729544963, 36.246524233424836],
            [127.48941375814559, 36.24601162039949],
            [127.49027054965615, 36.2450007744381],
            [127.49270788047168, 36.24306113832144],
            [127.49227388927531, 36.2424033626038],
            [127.49264605505375, 36.239485956128476],
            [127.49264072323955, 36.239355585590154],
            [127.49257720191127, 36.237953950461446],
          ],
        ],
      },
      properties: { CTPRVN_CD: '43', CTP_ENG_NM: 'Chungcheongbuk-do', CTP_KOR_NM: '충청북도' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [126.07031587799956, 36.227983776184274],
              [126.0761741761797, 36.22095288143282],
              [126.09428089112505, 36.226907781950565],
              [126.09214174532246, 36.23425508697609],
              [126.08312529020802, 36.2300439626168],
              [126.07673119396907, 36.234732186480464],
              [126.07031587799956, 36.227983776184274],
            ],
          ],
          [
            [
              [126.36144638561885, 36.32869079769295],
              [126.35977432704257, 36.34573703187137],
              [126.34966649323819, 36.3408417959311],
              [126.35047679564516, 36.33174989487851],
              [126.36144638561885, 36.32869079769295],
            ],
          ],
          [
            [
              [126.43105101596076, 36.36934903299863],
              [126.43324107903827, 36.38432755869677],
              [126.42295485241164, 36.38512805047092],
              [126.40605144328666, 36.3766862215286],
              [126.39446840513494, 36.38048278859533],
              [126.38606841531174, 36.379371217273125],
              [126.38540560133531, 36.366955788529594],
              [126.39567611696063, 36.3688090325054],
              [126.43848252259617, 36.3613181793418],
              [126.44374841404478, 36.355458585551276],
              [126.45325826527163, 36.36049192246534],
              [126.43489691054725, 36.3654096772549],
              [126.43105101596076, 36.36934903299863],
            ],
          ],
          [
            [
              [126.57319212554852, 37.02421331581318],
              [126.56354037681855, 37.02806420865514],
              [126.5584174728027, 37.03489973383769],
              [126.54079924997772, 37.035437478660825],
              [126.52655347460616, 37.04425487110046],
              [126.52719509214364, 37.05004332098312],
              [126.51921208049275, 37.059117493536334],
              [126.49842896718027, 37.06475370154971],
              [126.49675135101006, 37.05281198149192],
              [126.46246605755219, 37.019397958972654],
              [126.47060315457693, 37.008346722667895],
              [126.45510691452884, 36.999315126740676],
              [126.45022959800325, 37.00601648828194],
              [126.43167586585254, 37.008394869305],
              [126.43101768634195, 37.01369267484605],
              [126.4177826269637, 37.01200875915711],
              [126.3896230177757, 37.01121723753175],
              [126.35348509949428, 37.00500588187842],
              [126.32677262141162, 36.99282924040717],
              [126.33173144897616, 36.98534356367329],
              [126.33965118030248, 36.98569527805086],
              [126.35363569165774, 36.981846679625626],
              [126.37050597857537, 36.982545641181005],
              [126.37649095830673, 36.980634120235685],
              [126.37703547184904, 36.96842158150167],
              [126.37029131132638, 36.96020831272211],
              [126.36240162333526, 36.96885010854399],
              [126.34779811660285, 36.96669357681934],
              [126.33703214077458, 36.96828732525864],
              [126.33558752277345, 36.96000937709113],
              [126.34977424202798, 36.96196227193641],
              [126.35098823635322, 36.95261158939545],
              [126.35868774585758, 36.95297250008913],
              [126.35898461638028, 36.939156063220686],
              [126.37197136587959, 36.95114217336087],
              [126.381118722156, 36.94416271320414],
              [126.38558672341597, 36.93308108053126],
              [126.40840891340417, 36.94058381287307],
              [126.41963048947765, 36.9363724285359],
              [126.42112642747594, 36.92727201092618],
              [126.41129783175231, 36.91866873688678],
              [126.40894059134929, 36.90974253367737],
              [126.41704682915734, 36.906402000572484],
              [126.42698349161915, 36.90690852775487],
              [126.43126555793064, 36.898343147805726],
              [126.40501978260322, 36.895547496273586],
              [126.3968133955713, 36.89313730299936],
              [126.39855153688504, 36.881068754607675],
              [126.37468066416633, 36.879592093155374],
              [126.36429288294765, 36.87650115428117],
              [126.37197217222636, 36.867993545819196],
              [126.37042155886553, 36.857135816525606],
              [126.36335576635003, 36.850710011202594],
              [126.356078949142, 36.8494512747147],
              [126.35930804767519, 36.84048653217118],
              [126.35476032682595, 36.83238488989308],
              [126.34147111786555, 36.84837702369233],
              [126.34639055676259, 36.860308393870575],
              [126.3279110423865, 36.860898432149476],
              [126.32510136963421, 36.847576781110305],
              [126.3194104610139, 36.83882084669566],
              [126.32913919680227, 36.834976737785745],
              [126.32729021515802, 36.82740707744364],
              [126.33744074275347, 36.82709949467609],
              [126.3356164608457, 36.81886876475173],
              [126.32973391103764, 36.81358358467068],
              [126.32192352838977, 36.817594942055614],
              [126.3117418068421, 36.81286804569197],
              [126.30726110277602, 36.8149933224851],
              [126.28748936785466, 36.799090305020314],
              [126.28645516593986, 36.810183929805596],
              [126.28095270971153, 36.81760050692788],
              [126.2867096491204, 36.82334508636808],
              [126.29561088141162, 36.8246724250143],
              [126.31115726832707, 36.83778161838796],
              [126.29329395718383, 36.84303359342514],
              [126.29545283220034, 36.852800732320475],
              [126.30445815527881, 36.860140105254715],
              [126.30350851100299, 36.86688020119512],
              [126.31164214865768, 36.87327827027215],
              [126.31300551116335, 36.88415600125109],
              [126.32621805739205, 36.89023055680716],
              [126.31583061097787, 36.903993422710656],
              [126.30028426824452, 36.91922102056966],
              [126.30131727307524, 36.92968520562387],
              [126.30740054532262, 36.931126360529866],
              [126.30146955378812, 36.94389632773871],
              [126.30437845943071, 36.954281256005025],
              [126.28537249437153, 36.964341802298726],
              [126.29111967918102, 36.950566859135826],
              [126.29478432961619, 36.92912977312708],
              [126.29058469456231, 36.923576649232594],
              [126.28527647864, 36.90772614865815],
              [126.2847884103224, 36.898678902603756],
              [126.27678428973292, 36.897488382029266],
              [126.24402950389742, 36.91045469123977],
              [126.21619644154063, 36.90355368674831],
              [126.2067691011776, 36.89892631151454],
              [126.19725960370528, 36.88582694705786],
              [126.18713631151064, 36.88350112719222],
              [126.19202219056776, 36.87720189223764],
              [126.18812351856234, 36.86892877122696],
              [126.19958394628098, 36.85658733527846],
              [126.19013881256988, 36.840799569242904],
              [126.180516417222, 36.83506774021859],
              [126.18879743824671, 36.825073432060634],
              [126.18433294316883, 36.8104308275386],
              [126.1952227841482, 36.79904625078543],
              [126.19099154453286, 36.79091477566194],
              [126.17849891498194, 36.810297102156234],
              [126.1716870252138, 36.811669141882355],
              [126.17081183318739, 36.82426586053889],
              [126.16636119063003, 36.83073223361523],
              [126.169158323737, 36.83836724433894],
              [126.15993680477546, 36.84170393000001],
              [126.1512715769597, 36.834057800689315],
              [126.16010187315155, 36.829551169847356],
              [126.15441696703867, 36.81018778707197],
              [126.14650034176543, 36.79133501781751],
              [126.12916330809264, 36.77251880024526],
              [126.12092367120846, 36.7732986630316],
              [126.12445836966113, 36.75657107475221],
              [126.1343065870153, 36.74838150079401],
              [126.13496056382432, 36.74135432651078],
              [126.12292586520599, 36.724966867209524],
              [126.12888485156395, 36.71603563280159],
              [126.15003508636389, 36.73068914514074],
              [126.15165157331404, 36.73992512844796],
              [126.1461285577596, 36.750226588570996],
              [126.14074107698346, 36.754030299797485],
              [126.16634350994198, 36.75852936590975],
              [126.1850140110603, 36.75317992653335],
              [126.18711232354838, 36.745671540250456],
              [126.19606100464492, 36.73857277070656],
              [126.2057860357983, 36.736574535457116],
              [126.20953045627252, 36.73006142713036],
              [126.22295628480147, 36.722122235265324],
              [126.21782273564988, 36.71078947597026],
              [126.20740006917488, 36.70517178237207],
              [126.19452456157858, 36.706381618621364],
              [126.1836552053412, 36.71313605834116],
              [126.16696450115498, 36.71673832199347],
              [126.1601051720004, 36.70584040212939],
              [126.150836615777, 36.704964329483516],
              [126.15002358627478, 36.69358247222989],
              [126.15575471289019, 36.67746266507601],
              [126.17197904853333, 36.68003743402447],
              [126.19258828721485, 36.67699177351383],
              [126.19859448543343, 36.686453859520505],
              [126.20879438473692, 36.68829299110242],
              [126.20899108235692, 36.693862271073414],
              [126.22219791838923, 36.693553121960164],
              [126.2320542804349, 36.69624223883807],
              [126.23864362685038, 36.70272302894963],
              [126.23341238146084, 36.71028385753699],
              [126.23492458643295, 36.71807036618742],
              [126.25669763210132, 36.71819259076295],
              [126.26939770542353, 36.73002709428196],
              [126.27372693693584, 36.72028657974606],
              [126.27119500074387, 36.71127187299723],
              [126.27333180547095, 36.70355032608317],
              [126.26141610633277, 36.69433853125538],
              [126.26432191537971, 36.67775274966613],
              [126.27405235075513, 36.671562879819206],
              [126.2849321666911, 36.67162599837214],
              [126.29476596509188, 36.659237968368906],
              [126.30151819026429, 36.63887294420369],
              [126.30129256817713, 36.626388002998894],
              [126.29799592997637, 36.620484272435526],
              [126.2887124727189, 36.61504922149225],
              [126.28990034199644, 36.598272369445766],
              [126.28338593289446, 36.594139616073484],
              [126.29563562335818, 36.58650042701394],
              [126.30832791265811, 36.59739258082745],
              [126.31943478794774, 36.594243530930484],
              [126.32451556541422, 36.60925182052527],
              [126.3373241801181, 36.62009980318767],
              [126.34051850021565, 36.616146318352094],
              [126.35449710537725, 36.62009079756693],
              [126.36565872692435, 36.62693073383908],
              [126.37211195268361, 36.620751955568004],
              [126.3985144070638, 36.61911194484678],
              [126.41491291241985, 36.614860758485],
              [126.41609887662905, 36.608609035261466],
              [126.45646406403944, 36.59521069743023],
              [126.46471131212569, 36.582446541234305],
              [126.4634847676375, 36.57781502572105],
              [126.47181127198309, 36.558723252746326],
              [126.46421805998698, 36.546321847972294],
              [126.46927509235894, 36.53920406972857],
              [126.47594237963493, 36.537869142852905],
              [126.48816725661842, 36.5265222218718],
              [126.48218910010426, 36.517642734026204],
              [126.48400232925668, 36.507595146123066],
              [126.47964104400292, 36.488306387963455],
              [126.4811003889677, 36.47771700117648],
              [126.48999967225187, 36.46844045691592],
              [126.49077646482212, 36.4484808283154],
              [126.49876599093334, 36.44580988685783],
              [126.49604721476038, 36.43401728112787],
              [126.50292188757005, 36.43400816591218],
              [126.51535712485003, 36.44316473050684],
              [126.52218641529333, 36.440463539112336],
              [126.50594210974238, 36.42738713245787],
              [126.4955559293123, 36.4244116255985],
              [126.48822288831934, 36.41377283834814],
              [126.48691201057119, 36.39934298607172],
              [126.47958454679484, 36.38509218883996],
              [126.48459062290125, 36.3821815039399],
              [126.51022990704914, 36.380875623802446],
              [126.51686630435233, 36.37468983901518],
              [126.54577819552556, 36.355196581453185],
              [126.56167488754029, 36.351010138978445],
              [126.55042952237596, 36.34665794570969],
              [126.54319521995193, 36.33865453680014],
              [126.52111452627464, 36.33544734265931],
              [126.51535121617835, 36.327502317718235],
              [126.50454522129678, 36.32878906893943],
              [126.50370931630509, 36.323252988589374],
              [126.51802447362502, 36.30179600736261],
              [126.52837330602974, 36.29668691264753],
              [126.54732360572775, 36.26834518838376],
              [126.54036750802422, 36.250513533255464],
              [126.5300708520583, 36.23861976127251],
              [126.53024530394873, 36.22087108280927],
              [126.53822981568482, 36.211691569282465],
              [126.53970615840564, 36.19964502800699],
              [126.53432166566137, 36.198365035306054],
              [126.52455925853408, 36.18611243871128],
              [126.52758358876181, 36.17607608244769],
              [126.5261070009951, 36.16767289887623],
              [126.51802854884029, 36.15889027866436],
              [126.49296860871407, 36.159184899741966],
              [126.49316844423812, 36.13779874369694],
              [126.5008490460975, 36.14084287677874],
              [126.50922353195291, 36.15129905247488],
              [126.52434449558598, 36.15192770416082],
              [126.54187608716124, 36.147130345504976],
              [126.54901704548999, 36.142310917682586],
              [126.55677637903611, 36.13204489256509],
              [126.56757584312643, 36.13518506501023],
              [126.57003510958054, 36.14066888356881],
              [126.59120897654113, 36.12908105661023],
              [126.59942484004307, 36.11957740339088],
              [126.61279472089991, 36.09660869056288],
              [126.6167643273469, 36.102042589809926],
              [126.63199088530342, 36.09969060314685],
              [126.63107075990749, 36.09389219934572],
              [126.64648299460526, 36.08948381776471],
              [126.63253686688073, 36.08154379318905],
              [126.63206023106532, 36.055674584663116],
              [126.64634357699993, 36.053272498248795],
              [126.65000988354618, 36.04714692085566],
              [126.65751325719917, 36.04537538648573],
              [126.66874922538184, 36.031202982718305],
              [126.66160300091593, 36.02930664425511],
              [126.66416290609874, 36.0159028981227],
              [126.66074569220865, 36.01037549902364],
              [126.66794778466898, 36.004436068459995],
              [126.67704654778701, 36.00905875687169],
              [126.70380059454008, 36.00651134951158],
              [126.72668290380173, 36.00031927663637],
              [126.7364830292498, 36.00043186809557],
              [126.74804746811624, 36.025751080296914],
              [126.76165535908768, 36.026024634546445],
              [126.76971288589624, 36.029640575902135],
              [126.80276861975558, 36.03352332718705],
              [126.80832017946283, 36.03574376899403],
              [126.82109766499438, 36.049919017151126],
              [126.84054130818981, 36.05296464676911],
              [126.8638583541115, 36.06018962311506],
              [126.87081799404399, 36.067404606019515],
              [126.87358781604209, 36.08683469306363],
              [126.87381161156769, 36.110438241690986],
              [126.88220546285802, 36.131292695792816],
              [126.88969658404832, 36.13962228320762],
              [126.90080333802433, 36.14240361770313],
              [126.91108948229736, 36.13657003294747],
              [126.91969154966343, 36.13629938231804],
              [126.93080681408291, 36.1422465216462],
              [126.93886168767781, 36.15073698496048],
              [126.95662652924574, 36.156570394366796],
              [126.96302873048107, 36.15627775507275],
              [126.97719233471929, 36.148521524733695],
              [127.01204410275162, 36.14586636811909],
              [127.02343607805784, 36.136649986888024],
              [127.04003008198254, 36.139338439318834],
              [127.05610634197969, 36.12678483511621],
              [127.06300881735115, 36.125223244683646],
              [127.0569580039357, 36.11312014612918],
              [127.06104767596233, 36.105476193431464],
              [127.06045337830372, 36.09391421108677],
              [127.07626540011488, 36.08443194196779],
              [127.0822606203836, 36.07775989658379],
              [127.09441854105737, 36.073264444833804],
              [127.10626085286562, 36.071956644629324],
              [127.12318780602789, 36.06424764186753],
              [127.13370431516029, 36.06936667877887],
              [127.13377439892368, 36.08149245738218],
              [127.13661699977142, 36.08599028306291],
              [127.15120402223903, 36.09003994996911],
              [127.15740323902806, 36.083712574471825],
              [127.16873935062812, 36.08396623804447],
              [127.1835977111748, 36.09431472941609],
              [127.19038409838066, 36.088024746597945],
              [127.20223023221271, 36.088461996082245],
              [127.20591340138974, 36.100590027102164],
              [127.2318005762812, 36.096595195684095],
              [127.24269339418964, 36.08498756375816],
              [127.25471757516283, 36.08744363317413],
              [127.24605268890815, 36.09641009896461],
              [127.2461924869975, 36.10479162533181],
              [127.25213059551062, 36.113131299020786],
              [127.27339923066737, 36.10727973289519],
              [127.2939353370604, 36.11307202985466],
              [127.30169078298914, 36.12520364459201],
              [127.31854765758034, 36.11973383547197],
              [127.32316433434356, 36.12991780856485],
              [127.34009327311843, 36.12897923884696],
              [127.34440657244929, 36.11786441447112],
              [127.35050721442883, 36.11639502053119],
              [127.35492108018119, 36.108337973868366],
              [127.35032821552613, 36.104804617836166],
              [127.34950798793739, 36.09528463078742],
              [127.36005823937006, 36.08938073777961],
              [127.3569504644674, 36.08154638242153],
              [127.35924958845094, 36.07138120254442],
              [127.36423534703306, 36.06543511673278],
              [127.36082894892574, 36.053628220044985],
              [127.37206102509765, 36.04372487985278],
              [127.37354042535947, 36.03452057928338],
              [127.37822917394872, 36.030620568038806],
              [127.376495340113, 36.02288904739743],
              [127.39184979702517, 36.01702522285663],
              [127.40122306682561, 36.008735821740316],
              [127.4134058856261, 36.01515632341883],
              [127.4195896522699, 36.022704024583945],
              [127.43455719939573, 36.029495086579466],
              [127.4372434875169, 36.00933245608994],
              [127.44359198280453, 36.008063570031716],
              [127.44860556213655, 35.99315121333479],
              [127.45674609587554, 35.98327617674316],
              [127.46392571904289, 35.983939280262064],
              [127.48772771923451, 35.97826408516855],
              [127.49933644731743, 35.9873796316203],
              [127.50671308032187, 35.97961408133051],
              [127.51975625804025, 35.98322106040813],
              [127.53364038460391, 35.992007427073844],
              [127.53665557195697, 35.996450529941995],
              [127.53215572730461, 36.007521394346206],
              [127.53869824528127, 36.0105516143586],
              [127.53610366755117, 36.021068810959065],
              [127.53760102018376, 36.03248836254542],
              [127.53142110153878, 36.04084273613731],
              [127.5477793425104, 36.038208761644164],
              [127.55220366298954, 36.03277055908873],
              [127.56776219374454, 36.03046676763353],
              [127.57453301273449, 36.023302375500016],
              [127.58256056943162, 36.027226529587956],
              [127.59123591940238, 36.0251522429599],
              [127.60006511205906, 36.01194125698651],
              [127.61415305436807, 36.000804104150625],
              [127.61866297842687, 36.007981937431296],
              [127.61644154774513, 36.019056255037874],
              [127.63192467714681, 36.036348320576806],
              [127.63053480027257, 36.04215233932123],
              [127.61966857161055, 36.0442928925258],
              [127.62055098897659, 36.0642052115697],
              [127.63829546316235, 36.06793983089481],
              [127.63214698485596, 36.082364493383395],
              [127.61727471998327, 36.09357810103235],
              [127.61692317512956, 36.10487641825354],
              [127.61307561349035, 36.11180744135537],
              [127.59577663761121, 36.12593455477954],
              [127.58943707431281, 36.13445506965905],
              [127.59351447968278, 36.15019119348081],
              [127.60166454219902, 36.160024000074024],
              [127.6008010221942, 36.169742570666415],
              [127.5930608483624, 36.177377498240986],
              [127.59742928688411, 36.184325099328724],
              [127.59246550907345, 36.195140263072304],
              [127.59952907286345, 36.20456055082391],
              [127.59802033544004, 36.21708886988537],
              [127.58636245091476, 36.22565045397333],
              [127.58358230902215, 36.23129608937589],
              [127.57024044127941, 36.23352336977428],
              [127.55437139172047, 36.22618637985941],
              [127.54644299390813, 36.22527004019853],
              [127.54908041043021, 36.239729824585744],
              [127.53791800705419, 36.24277765088372],
              [127.53257278599521, 36.250889296676874],
              [127.51812957912159, 36.24064108759843],
              [127.48997015379464, 36.23348204060843],
              [127.46730263638545, 36.22234678013125],
              [127.46891730420995, 36.21455649308715],
              [127.4602839544282, 36.212918767376735],
              [127.45409252173998, 36.206585871016514],
              [127.45587552013619, 36.20108580683957],
              [127.44871644146241, 36.19672285115477],
              [127.43353065502481, 36.19857565340097],
              [127.42937098837949, 36.20520561423404],
              [127.41955943120291, 36.207126873574225],
              [127.40799932816071, 36.21289290532409],
              [127.40091048443774, 36.23287665737606],
              [127.38734320315938, 36.23415242409013],
              [127.39037008653862, 36.239524674639995],
              [127.38641245174146, 36.25067217477748],
              [127.39025800816972, 36.26227090920647],
              [127.38286736667814, 36.26869281014408],
              [127.37327729638233, 36.27218861212036],
              [127.36406040967144, 36.269400716893],
              [127.35950197889841, 36.26258630234998],
              [127.36415685847363, 36.25155953837927],
              [127.36340241642858, 36.23230320689793],
              [127.36011146928502, 36.22668012616992],
              [127.36419720984716, 36.21890125242586],
              [127.35296772185673, 36.21183901724252],
              [127.34686701551306, 36.20412680993625],
              [127.34073201399931, 36.1889099747055],
              [127.33169787690211, 36.18405554419243],
              [127.33200155696687, 36.201513365337846],
              [127.32394586543566, 36.20315832384125],
              [127.32155039583712, 36.212948048178205],
              [127.31564108990017, 36.22081532167644],
              [127.30638981469691, 36.226159938000144],
              [127.3010948573276, 36.22135870464145],
              [127.28315482217822, 36.23529355004192],
              [127.27914541141008, 36.25310870011325],
              [127.28209274961995, 36.26492791289229],
              [127.26535276117967, 36.2743614165192],
              [127.25877189543881, 36.2760505390333],
              [127.24665302727313, 36.2909595893218],
              [127.25927826795491, 36.2971362573365],
              [127.25841697969325, 36.31763851471957],
              [127.2597527665021, 36.3272494900912],
              [127.26611234420315, 36.32853327154041],
              [127.26572837005843, 36.33803953653346],
              [127.27912603027201, 36.34482653783772],
              [127.27072185748646, 36.36117668144719],
              [127.27768072603185, 36.365288993765105],
              [127.2805519895478, 36.3742103693747],
              [127.27846811726145, 36.39675197759492],
              [127.28210047107, 36.414999338618834],
              [127.26549273182239, 36.417174736525574],
              [127.25790808060235, 36.408232323033346],
              [127.24954152509667, 36.40919318679779],
              [127.23993657441005, 36.41839288391157],
              [127.22564319566565, 36.42229472829232],
              [127.21770737035114, 36.43373745999838],
              [127.20712121577566, 36.43614569439044],
              [127.2013896800907, 36.44197523429803],
              [127.20473354109713, 36.45929019862165],
              [127.20327673862367, 36.46497769339743],
              [127.19388413778444, 36.47011772212441],
              [127.19048199210802, 36.479470955497206],
              [127.1946755279459, 36.489593556890476],
              [127.17346589941299, 36.49920662792493],
              [127.16998973172652, 36.5090378734243],
              [127.18207217518994, 36.52076668022092],
              [127.17266848135003, 36.53614357488803],
              [127.18611435868706, 36.552320829860825],
              [127.19378775225046, 36.56481247180706],
              [127.20310004388618, 36.567443672975266],
              [127.20753781349539, 36.5776389356875],
              [127.20039931808634, 36.58256757070214],
              [127.19403920249754, 36.580645361364596],
              [127.17839050036272, 36.596891202148164],
              [127.17349086588925, 36.59602990406831],
              [127.16271752700513, 36.60437540262741],
              [127.15547823413569, 36.60670285579223],
              [127.15495232395023, 36.61654447557711],
              [127.15042979533926, 36.61974951469935],
              [127.15648994719658, 36.62861680901781],
              [127.15755974234278, 36.63917440818548],
              [127.15314446990489, 36.645213458835045],
              [127.15428942987597, 36.65244973893206],
              [127.16056875882406, 36.65611896597619],
              [127.15485843505842, 36.664274610618044],
              [127.16412366883492, 36.67849754849474],
              [127.16144493214864, 36.690218593268185],
              [127.14382780174341, 36.68899768399717],
              [127.13437856721747, 36.706791946480934],
              [127.14981186861681, 36.725886143572865],
              [127.15964392364808, 36.73284390482772],
              [127.19728343536987, 36.72819282274662],
              [127.20480795002565, 36.720876086735004],
              [127.21813970467964, 36.715588083835065],
              [127.23704734306962, 36.70440873733319],
              [127.24804917220362, 36.69504804798548],
              [127.26522967273254, 36.69220424550056],
              [127.27347692384058, 36.695265828278494],
              [127.28526318280812, 36.69060600253913],
              [127.29201485812332, 36.6972825120283],
              [127.3077479027124, 36.70416985586734],
              [127.30610097480081, 36.70826965725122],
              [127.30930004255785, 36.721767741547445],
              [127.31846117002407, 36.72525016079738],
              [127.32546423481635, 36.73367050607961],
              [127.33755043332103, 36.72930377249926],
              [127.34316651541954, 36.735695257805055],
              [127.33298055477235, 36.748151216004075],
              [127.33550826190543, 36.75264180938836],
              [127.34784169486471, 36.752926166298536],
              [127.3645580021713, 36.761540766722284],
              [127.37146320989287, 36.75856358877258],
              [127.3863715032278, 36.75928534280286],
              [127.38865533081518, 36.75348916012882],
              [127.40401043703767, 36.74487881772186],
              [127.4114628690698, 36.75608230792493],
              [127.42015136152823, 36.75835353483419],
              [127.41295020028367, 36.773216466770656],
              [127.4018971455984, 36.775711939641674],
              [127.39549720923927, 36.782477497365825],
              [127.40171781891519, 36.795148468481315],
              [127.39160842087348, 36.80658744700435],
              [127.3814905394933, 36.81408270753698],
              [127.36661403065328, 36.8169694575201],
              [127.35715052284306, 36.823559822595314],
              [127.35605421629475, 36.82865344827376],
              [127.33409910013447, 36.832360419229964],
              [127.33649501460536, 36.85468677586841],
              [127.31930024098254, 36.85906486675287],
              [127.31272989555339, 36.857466473883434],
              [127.30578836326207, 36.863375909633234],
              [127.31129351163763, 36.870488201308476],
              [127.3078841474703, 36.885386712333975],
              [127.2861467569869, 36.8943381765712],
              [127.27915696559525, 36.90041002741574],
              [127.27328613924352, 36.91224586055961],
              [127.2586093953492, 36.91587386296784],
              [127.25313216755896, 36.92243648135925],
              [127.24404867965262, 36.91759852387316],
              [127.23634653904926, 36.92372335749596],
              [127.2286494917677, 36.924414138221444],
              [127.21948578356155, 36.9303604463572],
              [127.20985783998431, 36.9312337532444],
              [127.21124708960242, 36.93855739853819],
              [127.20129180393913, 36.95200040942869],
              [127.19075054769789, 36.95248623673923],
              [127.1791764585262, 36.95805477649454],
              [127.17819868611112, 36.96251658247996],
              [127.16493638829823, 36.961886797978416],
              [127.1580561222677, 36.968825372679945],
              [127.14366365392641, 36.97105111899759],
              [127.12966314038488, 36.966417484792935],
              [127.11175101172898, 36.97195007541798],
              [127.10250531506031, 36.964760923764985],
              [127.09639524259758, 36.95572052450507],
              [127.0957642494349, 36.94237428574272],
              [127.08621235570239, 36.94773787465254],
              [127.07490317500827, 36.93985612503093],
              [127.06548684163374, 36.94192646038715],
              [127.0475798598065, 36.93321788691247],
              [127.02579677153655, 36.92874679088121],
              [127.01501701414281, 36.93541765744862],
              [126.98555134896169, 36.93248601897961],
              [126.97374578849303, 36.925862846364836],
              [126.93962602229041, 36.91733131177062],
              [126.90970529315007, 36.90160176543907],
              [126.91227715814401, 36.889672998810966],
              [126.88405387923171, 36.88693813706764],
              [126.86284676984377, 36.87968542583512],
              [126.82837022944364, 36.8883338402584],
              [126.81696564600968, 36.89614465205954],
              [126.81239468053937, 36.92368522426382],
              [126.8023739239008, 36.92443705148068],
              [126.79209937762418, 36.93591700566682],
              [126.79335395932758, 36.944530697813526],
              [126.7795894032176, 36.96680085633231],
              [126.7835943403372, 36.972421322694],
              [126.73723156574849, 36.988410697157654],
              [126.7216188105009, 36.991453344812555],
              [126.70466556080042, 36.99933706824639],
              [126.68455679436639, 36.99813805061841],
              [126.64391275497239, 36.999404006702555],
              [126.6276715963358, 37.00342770855134],
              [126.58005863623178, 37.02379892216791],
              [126.57319212554852, 37.02421331581318],
            ],
            [
              [126.22463398130238, 36.88641939854983],
              [126.23501899112044, 36.89105689105314],
              [126.23737311837584, 36.90138553783384],
              [126.24759361977208, 36.904399663194354],
              [126.24008256931431, 36.88303530041086],
              [126.2317603098375, 36.87962195598981],
              [126.22463398130238, 36.88641939854983],
            ],
          ],
          [
            [
              [126.37135933787036, 36.565926959208326],
              [126.35861452340762, 36.57219855600551],
              [126.3636696764393, 36.57732920473598],
              [126.37337426827202, 36.57736670039197],
              [126.37439362361509, 36.5857713481585],
              [126.36701743003115, 36.59958290236877],
              [126.36563357986073, 36.60980543050127],
              [126.34979127465822, 36.61129784482408],
              [126.33288697406188, 36.60452973568643],
              [126.32594585442803, 36.599252054478605],
              [126.32269927004452, 36.58290443899806],
              [126.31285758020262, 36.58032345714964],
              [126.31485811053871, 36.57101366532149],
              [126.32808716751533, 36.55597034599268],
              [126.33076626039261, 36.525098030003655],
              [126.3267112354991, 36.52016986092551],
              [126.33632714507944, 36.49692782027962],
              [126.33492263450297, 36.482431911873796],
              [126.34110724172903, 36.464888567573574],
              [126.33418079706905, 36.45658660419828],
              [126.33599288530782, 36.44074025440995],
              [126.34450099796815, 36.43873792586191],
              [126.3538701186806, 36.44194995139351],
              [126.35849906550584, 36.4367427025749],
              [126.354178376733, 36.42747738575065],
              [126.37213192215957, 36.41152875488719],
              [126.3806947829076, 36.41556521174956],
              [126.38119433170533, 36.42118948623802],
              [126.39736896838944, 36.419080736155735],
              [126.40083708398706, 36.41224618553329],
              [126.40849893849112, 36.414238367546936],
              [126.41334736208928, 36.40520055675448],
              [126.42229555806144, 36.41025156285593],
              [126.43478024142343, 36.421285363867675],
              [126.42777486126884, 36.43198393300824],
              [126.43013686249134, 36.43763101208855],
              [126.42075908483653, 36.44051952486579],
              [126.42153383869858, 36.44553054543867],
              [126.40643197726835, 36.45415990810845],
              [126.41727466011268, 36.464705355769595],
              [126.40864584341426, 36.4745546728865],
              [126.409311156103, 36.48688681774284],
              [126.39807024722872, 36.49082628765663],
              [126.40348652641683, 36.49941449080526],
              [126.40211756435572, 36.50580795389321],
              [126.39397305043956, 36.51456165757762],
              [126.38481561259293, 36.51559019233491],
              [126.386565906985, 36.52666457418447],
              [126.38125368594793, 36.52823952541441],
              [126.37485985653042, 36.542028545101964],
              [126.37968820718991, 36.549449761221666],
              [126.37135933787036, 36.565926959208326],
            ],
          ],
          [
            [
              [126.05462835406456, 36.67541624198406],
              [126.0729223459045, 36.672322880082206],
              [126.08651794474366, 36.67924111025513],
              [126.08390500434734, 36.68416988419815],
              [126.07176185710897, 36.679184433618204],
              [126.06176299468939, 36.679881425982344],
              [126.05462835406456, 36.67541624198406],
            ],
          ],
          [
            [
              [126.14979900434325, 36.67751751961893],
              [126.14722159937521, 36.685475326431984],
              [126.13631163651424, 36.679762096934574],
              [126.13741879737955, 36.67062039634689],
              [126.14979900434325, 36.67751751961893],
            ],
          ],
          [
            [
              [126.37842734379828, 36.928300142271695],
              [126.37008360455755, 36.92232555823713],
              [126.37963319632182, 36.917719052780456],
              [126.3868472680007, 36.924651145969314],
              [126.37842734379828, 36.928300142271695],
            ],
          ],
          [
            [
              [126.82108951409334, 36.959070816594334],
              [126.82918421894455, 36.947558915931275],
              [126.83371685670137, 36.95136449454206],
              [126.8242511496947, 36.96467232125984],
              [126.82108951409334, 36.959070816594334],
            ],
          ],
          [
            [
              [126.42273268981413, 37.06334628282334],
              [126.42653333274576, 37.040490234562405],
              [126.44624375150981, 37.04598513357316],
              [126.44962791566668, 37.05428442939165],
              [126.44360525201787, 37.06155608276299],
              [126.43803401974097, 37.057105756082876],
              [126.42974284632251, 37.05796555604631],
              [126.42273268981413, 37.06334628282334],
            ],
          ],
        ],
      },
      properties: { CTPRVN_CD: '44', CTP_ENG_NM: 'Chungcheongnam-do', CTP_KOR_NM: '충청남도' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [126.30251841477903, 35.61445164537404],
              [126.28713518892475, 35.60853873784338],
              [126.28059644268446, 35.60253391739991],
              [126.27371628702103, 35.605274371066756],
              [126.26875221522364, 35.5890139986627],
              [126.2497443140447, 35.588682307271924],
              [126.25994279701335, 35.57104697449378],
              [126.26633946708971, 35.57655443753279],
              [126.27672501639893, 35.57843244809314],
              [126.28917646342927, 35.588942896324276],
              [126.31068839895387, 35.60350598337352],
              [126.31562488313715, 35.6096253571555],
              [126.30251841477903, 35.61445164537404],
            ],
          ],
          [
            [
              [126.4490180583463, 35.74780456341495],
              [126.44215337652935, 35.74181333688252],
              [126.45868365980697, 35.73655652291979],
              [126.4490180583463, 35.74780456341495],
            ],
          ],
          [
            [
              [126.43740379446862, 35.80504116740495],
              [126.4316773013563, 35.80212425574595],
              [126.42108226118883, 35.80660386445575],
              [126.41442523991616, 35.79849367333736],
              [126.419364074266, 35.79439405345328],
              [126.43778313751126, 35.8017030357206],
              [126.43740379446862, 35.80504116740495],
            ],
          ],
          [
            [
              [126.38699804229749, 35.85613446824723],
              [126.36742510996402, 35.85294992142413],
              [126.36794374260624, 35.84622015405623],
              [126.37929083848512, 35.8478514500536],
              [126.38699804229749, 35.85613446824723],
            ],
          ],
          [
            [
              [126.68587453139997, 35.98686854912874],
              [126.67979866685606, 35.99142951904544],
              [126.6584142869045, 35.9904209949477],
              [126.65823363695986, 35.98632504443826],
              [126.68587453139997, 35.98686854912874],
            ],
          ],
          [
            [
              [126.5547240376682, 36.044628952496105],
              [126.54200565074846, 36.03705930185983],
              [126.55588520619173, 36.0322502200056],
              [126.5547240376682, 36.044628952496105],
            ],
          ],
          [
            [
              [126.43704173056194, 36.0865197057506],
              [126.4287582456767, 36.084404257853585],
              [126.43603253714335, 36.076913194582026],
              [126.44182805161613, 36.08118382025988],
              [126.43704173056194, 36.0865197057506],
            ],
          ],
          [
            [
              [125.97439962448145, 36.12680429069149],
              [125.96724249267997, 36.12707920317471],
              [125.97042822731113, 36.11679403315007],
              [125.97555838987628, 36.11231586444515],
              [125.98461831867564, 36.11330280406721],
              [125.98194993978315, 36.12496452985908],
              [125.97439962448145, 36.12680429069149],
            ],
          ],
          [
            [
              [126.62785445353086, 35.978035389049225],
              [126.54720363327044, 35.97474756425713],
              [126.54760990301487, 35.96966665451349],
              [126.53512095257231, 35.96900657194317],
              [126.52585700367212, 35.97361475412437],
              [126.52299628674844, 35.96836565898904],
              [126.52335175572038, 35.9496896592734],
              [126.53223171979256, 35.93329428771292],
              [126.49724491132903, 35.84822200216342],
              [126.48613814678671, 35.846099342574966],
              [126.4910175235319, 35.83811326997477],
              [126.47717251184191, 35.823589741257976],
              [126.45983488402744, 35.82507781401781],
              [126.44996592871473, 35.83178365368504],
              [126.44765186401666, 35.82174337037628],
              [126.4634894443727, 35.8122911581717],
              [126.48322641758037, 35.81077234486292],
              [126.51904716502922, 35.735531585753975],
              [126.53171840838546, 35.72673534367984],
              [126.55635812099041, 35.697827277974866],
              [126.5392718884896, 35.68913260747255],
              [126.53476537862957, 35.68989357335158],
              [126.52868737956472, 35.67681273804358],
              [126.51863688899027, 35.67270898405253],
              [126.51462791041085, 35.66582606209147],
              [126.50310963491751, 35.65851919233003],
              [126.49238734077724, 35.654815109901655],
              [126.48163618612813, 35.64435702210225],
              [126.46772005447801, 35.64207162557675],
              [126.47005313858608, 35.62796840092036],
              [126.46891411408566, 35.61790724073153],
              [126.46194038948671, 35.61021264869858],
              [126.47386159573476, 35.602231036777304],
              [126.48753213793567, 35.59653955046132],
              [126.4894212371943, 35.590897690998055],
              [126.50308859899273, 35.58291035910849],
              [126.529218890449, 35.57931396966786],
              [126.54618853235226, 35.58609875461001],
              [126.56188513116211, 35.586961311303455],
              [126.57526712012105, 35.58483809887663],
              [126.59344924490115, 35.59013764352215],
              [126.60424126330064, 35.58647960314601],
              [126.62737664573488, 35.58605546259403],
              [126.65119245390883, 35.58061168479033],
              [126.66081385913544, 35.58534343457036],
              [126.66838291076608, 35.57251267633082],
              [126.67080720495211, 35.55378446175276],
              [126.65769894913751, 35.55772991993181],
              [126.64747636371631, 35.56967398935756],
              [126.63212065931732, 35.57229555444018],
              [126.61754901261985, 35.56927488995589],
              [126.61698066001719, 35.55751397097621],
              [126.61043016233957, 35.55442274232863],
              [126.60683748738866, 35.54579228727686],
              [126.59421628968059, 35.53485737946237],
              [126.58707028227859, 35.54184366702622],
              [126.57571770407802, 35.54088735369604],
              [126.56692099578908, 35.54312575788239],
              [126.55543235407204, 35.536300839638855],
              [126.54327390548818, 35.53262077446493],
              [126.53551267423224, 35.53443062603497],
              [126.515031890578, 35.531925539781895],
              [126.50032725732241, 35.52346288268253],
              [126.49552880067382, 35.511612734067434],
              [126.48400031359446, 35.51901472935976],
              [126.47409345683997, 35.50589413956187],
              [126.46426606893918, 35.48607917382972],
              [126.44224235188587, 35.45190433295835],
              [126.43730142634836, 35.44997125685052],
              [126.42921990080396, 35.43576967043388],
              [126.44167358342996, 35.43573739986736],
              [126.45021560484139, 35.427884755130925],
              [126.46855128245821, 35.425150065883805],
              [126.47602825426928, 35.42932853346764],
              [126.48010356800887, 35.42105063071319],
              [126.49287555221649, 35.409238139770125],
              [126.4897198248352, 35.39346587461288],
              [126.48100875850416, 35.38849118705567],
              [126.4832766096247, 35.38056543899941],
              [126.49663649791881, 35.374020436841434],
              [126.49614876643302, 35.357600567321],
              [126.50823631140487, 35.361643591134204],
              [126.51995458193933, 35.349542875992455],
              [126.51750657043068, 35.334138144069364],
              [126.52327961092611, 35.31543910735564],
              [126.53232370682755, 35.30674344801746],
              [126.54813064805361, 35.31347150088431],
              [126.57271038457587, 35.310148828532895],
              [126.57866347721246, 35.3031997129314],
              [126.58797342524534, 35.30553606159294],
              [126.58944780650576, 35.31750648797379],
              [126.58051527600402, 35.3238883874543],
              [126.58706158583946, 35.33081074671744],
              [126.59460655447761, 35.32901941441993],
              [126.60449755718413, 35.335560918873725],
              [126.61909950011491, 35.32447164105638],
              [126.62980917466327, 35.32049452890023],
              [126.6441705055105, 35.32030647821406],
              [126.64704716001454, 35.328463927785734],
              [126.65389285525595, 35.328782028457724],
              [126.66644498172664, 35.351486893538464],
              [126.6858885300158, 35.34492382211654],
              [126.69182010920382, 35.35143113511908],
              [126.6993673914273, 35.34958891236053],
              [126.70630244985576, 35.36459317514614],
              [126.7193520021058, 35.36498861487444],
              [126.73126001990083, 35.376883031532074],
              [126.72963168213855, 35.39461004087472],
              [126.72246863385823, 35.39993254442021],
              [126.7368032146331, 35.403392901031545],
              [126.74451423781615, 35.40875355625555],
              [126.7526686715533, 35.42948787753345],
              [126.74934230131923, 35.43912327591145],
              [126.74381777959385, 35.44068311116945],
              [126.73771534660622, 35.44949358205455],
              [126.74807576322573, 35.45058156444585],
              [126.75777576972983, 35.462285659448895],
              [126.76490261855035, 35.46705828792256],
              [126.781895980611, 35.47062826824474],
              [126.79234781084924, 35.467634067493094],
              [126.81397304848687, 35.468799034899234],
              [126.81387963790006, 35.48419149462842],
              [126.82334269018338, 35.486913825080364],
              [126.83047760373208, 35.48079710475872],
              [126.84284945288901, 35.47895111586847],
              [126.84024990825522, 35.46866813425077],
              [126.8632417661954, 35.46120677322529],
              [126.87009700897082, 35.46149567078186],
              [126.88287925318565, 35.45236035418524],
              [126.89677487813974, 35.44798569500667],
              [126.8996432629992, 35.44269980507028],
              [126.8976143308774, 35.432951577953354],
              [126.90431682211882, 35.429695726415396],
              [126.90187454827603, 35.42301511971206],
              [126.90824857951631, 35.416272873390795],
              [126.91614824943963, 35.41584469977669],
              [126.92077872666594, 35.4108630002095],
              [126.91742715344395, 35.402139050679125],
              [126.93003364421284, 35.40600564560911],
              [126.93352175560405, 35.395130399673654],
              [126.95426973865841, 35.39663514632214],
              [126.96310274022534, 35.394954464658746],
              [126.9764718940869, 35.400742007643736],
              [126.97029084011672, 35.41979232294551],
              [126.97138061224516, 35.42767121522055],
              [126.98162537951244, 35.42664641868517],
              [126.98336751919153, 35.43375207190503],
              [126.99454552646984, 35.439804127257176],
              [127.00302699385176, 35.464463922052815],
              [127.01429200694803, 35.45781934862849],
              [127.02348209841996, 35.46397076184434],
              [127.03472214598375, 35.46657185013247],
              [127.03499522513627, 35.44764458901849],
              [127.04018290673486, 35.43178880170332],
              [127.05231520674168, 35.42651610369655],
              [127.0417109103118, 35.398719374975286],
              [127.02809834122827, 35.3979104806279],
              [127.03909768155305, 35.380143305898244],
              [127.04732145650527, 35.37719767624892],
              [127.05375626007663, 35.38189866945591],
              [127.06498367162816, 35.375953859741244],
              [127.06359463226453, 35.36989715673351],
              [127.07060767149585, 35.36551344020357],
              [127.06521922241913, 35.355909732726076],
              [127.06986201525247, 35.3393447088234],
              [127.06238117522669, 35.336251182349095],
              [127.05525206456639, 35.34106327296941],
              [127.05094607731802, 35.32937276366656],
              [127.04309200772491, 35.321885389309124],
              [127.04620675372708, 35.31859763013599],
              [127.06178389556905, 35.31712925387047],
              [127.06896462759403, 35.311437744060235],
              [127.08119591891221, 35.31003877588418],
              [127.09680272515543, 35.30182206608156],
              [127.11411740407713, 35.29959970359687],
              [127.1245667555646, 35.303444128843985],
              [127.12998387951119, 35.30913177174928],
              [127.1438180296063, 35.308397708620504],
              [127.14625778146348, 35.31505605920398],
              [127.16804631870303, 35.332014693236395],
              [127.18476605657717, 35.33351991457725],
              [127.18773081104433, 35.32258100969032],
              [127.1990469871791, 35.316652728901055],
              [127.21271022185837, 35.31735350567678],
              [127.21701747684075, 35.33111171692429],
              [127.22079332290093, 35.33481120587217],
              [127.23229526389314, 35.33360933381524],
              [127.23478558321061, 35.32992432186027],
              [127.25716334578608, 35.31246204444719],
              [127.2867147009628, 35.314022284257],
              [127.30988802996694, 35.304515548192065],
              [127.32346708443517, 35.30740918226781],
              [127.33898529430387, 35.31766283395216],
              [127.35425609533287, 35.32235514661184],
              [127.36768865927925, 35.314159907278984],
              [127.37663772246765, 35.31131301211306],
              [127.38456738093858, 35.30245770234631],
              [127.39269870979527, 35.30734642888783],
              [127.41507822783068, 35.335998225425165],
              [127.42140982526752, 35.35086998652346],
              [127.42989721600688, 35.35758218574607],
              [127.44245213740639, 35.36128185086349],
              [127.45411052821197, 35.36075401291894],
              [127.47076600039328, 35.365335632107566],
              [127.47876808168013, 35.36419032367935],
              [127.48570574037468, 35.358349676543746],
              [127.49791515607255, 35.359887300345854],
              [127.52648882901292, 35.34309986740223],
              [127.53249202774266, 35.335298112551584],
              [127.54152048033974, 35.33365068633738],
              [127.54228290103961, 35.328500200005095],
              [127.55519245367549, 35.32187765548899],
              [127.56783121420237, 35.31851551459511],
              [127.57748101131162, 35.30890104617455],
              [127.59296428135478, 35.311826561663196],
              [127.60654029640905, 35.320660296061845],
              [127.60768544491852, 35.32504437856997],
              [127.62073946860465, 35.33249121319702],
              [127.62333075001837, 35.34216601294523],
              [127.61223657721263, 35.355850366895396],
              [127.61019736628715, 35.36591811736593],
              [127.62565371906378, 35.37691082178453],
              [127.62487924034147, 35.38238488616919],
              [127.6369157597184, 35.40103882918881],
              [127.64644685589262, 35.402664173318826],
              [127.66047407429994, 35.41443375281706],
              [127.66577460572529, 35.42742632131448],
              [127.66517689304933, 35.435648846995065],
              [127.67406961587419, 35.445720018948414],
              [127.66115707315755, 35.44754357306256],
              [127.65338927783992, 35.451583834126616],
              [127.64518651688067, 35.44912733326541],
              [127.63668808945718, 35.45935201600874],
              [127.6373946349812, 35.47926932982651],
              [127.6531071170161, 35.486868703016604],
              [127.65038819777601, 35.497899883924404],
              [127.64431306028484, 35.49901802872008],
              [127.62533023489802, 35.53140263074097],
              [127.6095778216924, 35.540262264520756],
              [127.5872887846514, 35.55703967098931],
              [127.58877172057953, 35.56476669879009],
              [127.59607493885376, 35.57368719788304],
              [127.61030315821286, 35.58296141761584],
              [127.60745604643665, 35.594912564479664],
              [127.61304571769209, 35.599717824062395],
              [127.61238812113542, 35.60684541904218],
              [127.62139707930334, 35.61511812669063],
              [127.63533525866335, 35.61848395482072],
              [127.62425700756118, 35.63178570375791],
              [127.61977132487685, 35.643455414358606],
              [127.62215793684699, 35.6510165695138],
              [127.62948135868078, 35.656640229749875],
              [127.62791451709272, 35.66221466448383],
              [127.63908064579178, 35.66992281614171],
              [127.64179529862047, 35.69289272996113],
              [127.64907492725365, 35.70299953139328],
              [127.66095634234537, 35.70990593338248],
              [127.66313494032137, 35.74158220591012],
              [127.66228754634732, 35.76082974150393],
              [127.66951338210426, 35.77137366401119],
              [127.67943626750774, 35.76849873735467],
              [127.68481112124876, 35.77767938929976],
              [127.70653074743262, 35.79202013183184],
              [127.71938601936642, 35.7973159943446],
              [127.73947140872991, 35.82971057133844],
              [127.73778335115479, 35.83438732025552],
              [127.7444534287012, 35.8444225692018],
              [127.75947743766578, 35.83690728165314],
              [127.77276494752088, 35.839578799029866],
              [127.77917001840757, 35.84723765239642],
              [127.80435552933716, 35.85868918453313],
              [127.80930999325535, 35.85510150490245],
              [127.81944438107432, 35.85963677161416],
              [127.8265619213583, 35.86834682588406],
              [127.84175146908682, 35.86624703440951],
              [127.84433253177738, 35.875128468302094],
              [127.85367520314688, 35.88134317345748],
              [127.85123590091894, 35.88951334950745],
              [127.85708221462706, 35.8949889502402],
              [127.85954023388045, 35.90649058531378],
              [127.87070877631898, 35.90434621165573],
              [127.88807096990591, 35.914947870584896],
              [127.88253155376302, 35.91924487399143],
              [127.88320637404935, 35.930008211340954],
              [127.8956790498414, 35.93419019468385],
              [127.90859300752084, 35.94159919080043],
              [127.91136737991548, 35.94918150416947],
              [127.90395439878804, 35.95408734351577],
              [127.8964504725648, 35.971582016125765],
              [127.89415529373738, 35.9854336121866],
              [127.87548706324564, 35.9969779537818],
              [127.87677397703617, 36.02251177806038],
              [127.86773917023233, 36.02377005284486],
              [127.85280793458492, 36.03910627723328],
              [127.83039572317934, 36.035228776967365],
              [127.81979296724676, 36.029796719950326],
              [127.80107606325043, 36.02659164689205],
              [127.79081414435367, 36.01879837348202],
              [127.76618288478576, 36.01220683499448],
              [127.75928891368092, 36.015924111187495],
              [127.76264473774016, 36.02157423135554],
              [127.74730505371903, 36.02970113928928],
              [127.73944904228306, 36.02573461435623],
              [127.73483525709246, 36.03231942996216],
              [127.71918250407694, 36.03186412186259],
              [127.71247458379797, 36.03588626368954],
              [127.70361656278072, 36.03441373377491],
              [127.69646121289678, 36.04110262569812],
              [127.69460848694493, 36.05898470074572],
              [127.68901549920433, 36.06267155616778],
              [127.66916835941421, 36.05115403430931],
              [127.67273573159673, 36.04163009608583],
              [127.66441318426372, 36.03751058764076],
              [127.64809131809285, 36.063127118539775],
              [127.6397032173037, 36.068344402819655],
              [127.62055095983325, 36.06420525133896],
              [127.6196685406722, 36.044292932066504],
              [127.63053478109639, 36.0421523803017],
              [127.63192464601794, 36.036348359226544],
              [127.61644151664579, 36.01905629472808],
              [127.61866294808335, 36.00798197867005],
              [127.6141530227796, 36.000804142968875],
              [127.60006508282953, 36.0119412976033],
              [127.59123589006624, 36.02515227357711],
              [127.58256053850266, 36.02722656963963],
              [127.57453298275955, 36.02330241509256],
              [127.5677621635799, 36.030466806828656],
              [127.55220363341412, 36.03277060922779],
              [127.54777931229066, 36.03820880192139],
              [127.53142107031944, 36.040842775022384],
              [127.53760098986012, 36.03248840204444],
              [127.5361036384357, 36.021068851121925],
              [127.53869821475621, 36.01055164528419],
              [127.53215569630764, 36.00752143493391],
              [127.53665554267032, 35.996450570316384],
              [127.53364035497216, 35.992007467543566],
              [127.51975623930777, 35.983221108444226],
              [127.50671305034402, 35.97961412934845],
              [127.49933641729437, 35.9873796807898],
              [127.48772769005161, 35.97826412425744],
              [127.46392570175482, 35.98393931129155],
              [127.4567460651475, 35.98327621672439],
              [127.44860553183611, 35.993151253244655],
              [127.44359195216119, 36.00806360951267],
              [127.43724344610148, 36.00933249560269],
              [127.43455715955092, 36.02949512687848],
              [127.4195896228611, 36.02270406581161],
              [127.4134058662093, 36.01515636268885],
              [127.40122304927169, 36.00873586140448],
              [127.39184976636889, 36.01702526263211],
              [127.37649530932734, 36.02288908891379],
              [127.3782291439797, 36.03062060832695],
              [127.37354039545383, 36.03452061848743],
              [127.37206099645162, 36.043724920299745],
              [127.36082891887352, 36.05362825882271],
              [127.36423531772785, 36.065435157693756],
              [127.35924955919181, 36.07138124266927],
              [127.35695043390206, 36.08154642291711],
              [127.36005819862197, 36.08938077789765],
              [127.34950795893025, 36.09528466962488],
              [127.3503281958275, 36.10480465877222],
              [127.3549210495951, 36.10833801388058],
              [127.35050718449457, 36.11639505954057],
              [127.34440654183737, 36.11786445504626],
              [127.34009324309096, 36.12897928002786],
              [127.32316429370901, 36.129917849315554],
              [127.31854762762191, 36.11973387529407],
              [127.30169075209832, 36.12520368526572],
              [127.29393531733751, 36.11307207934784],
              [127.2733991892526, 36.10727977296901],
              [127.25213056541746, 36.11313134056836],
              [127.24619245695119, 36.1047916648004],
              [127.2460526486303, 36.0964101389658],
              [127.25471754573461, 36.08744367377544],
              [127.2426933650453, 36.08498761233916],
              [127.23180054537957, 36.09659524407799],
              [127.20591336164878, 36.10059006680415],
              [127.20223020346887, 36.08846204640311],
              [127.19038406814221, 36.08802478631894],
              [127.18359769135799, 36.09431476876251],
              [127.16873932006114, 36.0839662877465],
              [127.15740319825103, 36.08371261417872],
              [127.15120399244168, 36.090039991081724],
              [127.13661696902336, 36.08599032255602],
              [127.13377436892803, 36.081492496742065],
              [127.1337042861609, 36.06936671016248],
              [127.12318778724152, 36.064247681446105],
              [127.10626082200953, 36.07195667683718],
              [127.09441851022592, 36.07326448449749],
              [127.08226060184353, 36.07775993619725],
              [127.07626537024755, 36.08443198133409],
              [127.06045334789106, 36.09391425071916],
              [127.06104763592795, 36.105476232734986],
              [127.05695797389143, 36.113120186145096],
              [127.06300879807236, 36.12522328593355],
              [127.05610632279432, 36.126784876270484],
              [127.04003005195581, 36.139338478623245],
              [127.02343603749708, 36.136650036692956],
              [127.01204408354495, 36.145866409000355],
              [126.9771923031015, 36.148521565187615],
              [126.96302870073016, 36.15627779519295],
              [126.95662650004328, 36.15657043393845],
              [126.93886165840534, 36.150737026390054],
              [126.9308067843315, 36.14224656208372],
              [126.91969151941734, 36.13629942225503],
              [126.91108945175795, 36.1365700734331],
              [126.90080330859863, 36.14240365974855],
              [126.88969655342154, 36.13962232324539],
              [126.88220543260394, 36.13129273608924],
              [126.87381158073221, 36.1104382826405],
              [126.87358778594393, 36.08683473425295],
              [126.8708179641293, 36.06740464699574],
              [126.86385826217006, 36.06018913281051],
              [126.84054121352557, 36.05296415496264],
              [126.82109756880408, 36.049918525567016],
              [126.80832008324549, 36.035743274960915],
              [126.80276852364223, 36.03352283451902],
              [126.76971278554602, 36.02964008087674],
              [126.76165525723688, 36.02602414095573],
              [126.74804736800228, 36.02575058565487],
              [126.74156052854678, 36.01194488071273],
              [126.75660045709941, 36.01014379762767],
              [126.74725557506117, 35.991745365623615],
              [126.73911022177063, 35.98661339831184],
              [126.72938707515738, 35.985230116950284],
              [126.7062963762723, 35.99428269867822],
              [126.68413689932507, 35.98387489838852],
              [126.66706731144525, 35.98349744011788],
              [126.64730563273807, 35.97901544446269],
              [126.62785445353086, 35.978035389049225],
            ],
            [
              [126.64172027880718, 35.79492325045319],
              [126.6314602730746, 35.79948558486773],
              [126.62222875434993, 35.78630464530017],
              [126.62558545365265, 35.777448678517864],
              [126.62842610946552, 35.74941456814824],
              [126.61115396429626, 35.736017758468414],
              [126.6024087919218, 35.720104624940625],
              [126.58768499270273, 35.707489238753006],
              [126.5830831511737, 35.706127167518154],
              [126.56902853441541, 35.69280494015032],
              [126.55817054645536, 35.698229079951886],
              [126.53358316584504, 35.72721838286422],
              [126.51978413060056, 35.7375565176708],
              [126.48455174697237, 35.81189792784808],
              [126.4806250203584, 35.81923777820157],
              [126.49588344032101, 35.832823002485554],
              [126.50006675329264, 35.839200767421055],
              [126.49978766846613, 35.85021302770437],
              [126.5344195703329, 35.93410055003589],
              [126.54066239566862, 35.943105768911806],
              [126.59361993644941, 35.94840371574405],
              [126.61633290058593, 35.94248792306043],
              [126.61178416594753, 35.92938906678027],
              [126.61064123851939, 35.917292495029265],
              [126.61313336194316, 35.89677973456521],
              [126.61878905418399, 35.88836483635559],
              [126.64077859791381, 35.8843804016349],
              [126.66760995519186, 35.88362404178362],
              [126.6745508367535, 35.88915356631413],
              [126.6764944808423, 35.86986193103652],
              [126.68344877707487, 35.842017151198],
              [126.69001513871928, 35.84144877038513],
              [126.6915539710716, 35.82531678296138],
              [126.70676209154084, 35.796514950578306],
              [126.69818519717292, 35.79805676900604],
              [126.6896145892488, 35.795558462090206],
              [126.65280577448996, 35.7919363792591],
              [126.64172027880718, 35.79492325045319],
            ],
          ],
        ],
      },
      properties: { CTPRVN_CD: '45', CTP_ENG_NM: 'Jeollabuk-do', CTP_KOR_NM: '전라북도' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [126.92180020534914, 33.9897539217691],
              [126.91250595392275, 33.986125155895806],
              [126.91014493535201, 33.979134432449364],
              [126.91578054825915, 33.969416955651226],
              [126.9302668133204, 33.970654757825784],
              [126.93701760668442, 33.9787527832344],
              [126.93161866767014, 33.985435636584825],
              [126.92180020534914, 33.9897539217691],
            ],
          ],
          [
            [
              [127.31125357838332, 34.0500950773179],
              [127.31315857231007, 34.04050751083945],
              [127.33510169957789, 34.037324595993326],
              [127.32364936087876, 34.04749444043024],
              [127.32358834204966, 34.057752764318494],
              [127.30358177769884, 34.05834671680776],
              [127.31125357838332, 34.0500950773179],
            ],
          ],
          [
            [
              [127.29257204339514, 34.04690505822229],
              [127.29389233188968, 34.05214746871164],
              [127.28789362897194, 34.05769763388399],
              [127.27813251753409, 34.044198298923355],
              [127.29559311204592, 34.01811869476822],
              [127.30567377827306, 34.011210387996535],
              [127.31177983076812, 34.017534990142785],
              [127.30376330622146, 34.02912485217573],
              [127.29664729377366, 34.03219053607437],
              [127.29257204339514, 34.04690505822229],
            ],
          ],
          [
            [
              [125.10885199930345, 34.09272896828049],
              [125.09504881877075, 34.08460448224796],
              [125.09508015165224, 34.07082958141421],
              [125.10334025552403, 34.0691272764255],
              [125.11466709552484, 34.06254005638532],
              [125.11858501660166, 34.048469900526705],
              [125.14327941745199, 34.05244936255091],
              [125.13021999845984, 34.06216875120658],
              [125.12055711489758, 34.07262305374478],
              [125.11941341005013, 34.08009891272479],
              [125.10885199930345, 34.09272896828049],
            ],
          ],
          [
            [
              [126.59345197854023, 34.162098736195915],
              [126.59739204386742, 34.15389523471731],
              [126.6093529140799, 34.1577692918285],
              [126.61631060345461, 34.14997636732625],
              [126.62189383313866, 34.15586764425285],
              [126.62098876903909, 34.16423323851075],
              [126.61117845946185, 34.16133988247277],
              [126.60493094183549, 34.165783009722965],
              [126.58404574039584, 34.169878501934285],
              [126.56348329398773, 34.169951208139665],
              [126.54958803197962, 34.17870651574094],
              [126.53952928564168, 34.181796744204846],
              [126.52944052227572, 34.1742221094094],
              [126.51660386452643, 34.1702966717973],
              [126.51554055376792, 34.165098588036855],
              [126.50526061894612, 34.160291100215986],
              [126.50916946852753, 34.15593745338115],
              [126.50946896040162, 34.14426643945107],
              [126.50561934875296, 34.138925402088255],
              [126.51445341596029, 34.12832403333264],
              [126.5261866344225, 34.121827382624595],
              [126.54694814097937, 34.127344349930524],
              [126.558978951202, 34.135893093928786],
              [126.56625246089179, 34.14524968809714],
              [126.59345197854023, 34.162098736195915],
            ],
          ],
          [
            [
              [126.48310470476571, 34.19193908030835],
              [126.47226974810341, 34.18835313923369],
              [126.47893421547884, 34.18164906006541],
              [126.48310470476571, 34.19193908030835],
            ],
          ],
          [
            [
              [126.64995720496455, 34.19981551641846],
              [126.64678651547379, 34.1823971108672],
              [126.65081050390478, 34.166699821346306],
              [126.64251059168608, 34.16274203099693],
              [126.63618395181987, 34.15042971295427],
              [126.62974579049653, 34.14902634121901],
              [126.63737312971331, 34.13049712935874],
              [126.64902126334009, 34.130993015601916],
              [126.65485276235044, 34.11463806311208],
              [126.66766763274718, 34.12010476552522],
              [126.6658798307834, 34.126897027915554],
              [126.67168620283827, 34.130154275425944],
              [126.67194518755457, 34.14566943971378],
              [126.66786426715841, 34.16207374184882],
              [126.65918351939938, 34.1626623617713],
              [126.65512006943865, 34.16909404984509],
              [126.66230337722682, 34.1743874210135],
              [126.67904432124243, 34.17584726686219],
              [126.67965276860384, 34.185641323648184],
              [126.64995720496455, 34.19981551641846],
            ],
          ],
          [
            [
              [126.51095971360888, 34.19916201765525],
              [126.5062247237518, 34.20397342261179],
              [126.49655160685683, 34.19409691109951],
              [126.50082118099077, 34.18761492632872],
              [126.51006275098732, 34.18721621130695],
              [126.51095971360888, 34.19916201765525],
            ],
          ],
          [
            [
              [126.76363596384135, 34.21118669420806],
              [126.75278399289591, 34.205083457238345],
              [126.7532254608777, 34.18691773668723],
              [126.76221596960067, 34.18456319349925],
              [126.76830245671124, 34.194850895648976],
              [126.76938762222507, 34.2026740407989],
              [126.76363596384135, 34.21118669420806],
            ],
          ],
          [
            [
              [126.8918173881694, 34.21650985765878],
              [126.8722991080238, 34.210075572173494],
              [126.87182533671101, 34.20428524559049],
              [126.86244840920914, 34.200584484502855],
              [126.86225287046543, 34.19465495757136],
              [126.85312435453756, 34.186103792791755],
              [126.85984937492505, 34.170491624532055],
              [126.88148274933411, 34.155587397236026],
              [126.88348505486692, 34.151375682114725],
              [126.89567974158196, 34.15507010647517],
              [126.91500925894796, 34.15622373886375],
              [126.92092156885683, 34.17145591546598],
              [126.92514780392236, 34.17317234952156],
              [126.92201282552898, 34.183607408083915],
              [126.91175224555128, 34.192449588103536],
              [126.90516603657687, 34.20378873285447],
              [126.91163771763827, 34.20699615773813],
              [126.90912213669111, 34.21364195389907],
              [126.89816491649063, 34.21154922791334],
              [126.8918173881694, 34.21650985765878],
            ],
          ],
          [
            [
              [125.84985643054839, 34.21780536583365],
              [125.84777571909623, 34.21418092486464],
              [125.86141377848462, 34.205293590472756],
              [125.86387731198444, 34.20929606670833],
              [125.85668716434179, 34.217504593735946],
              [125.84985643054839, 34.21780536583365],
            ],
          ],
          [
            [
              [126.56522659225833, 34.23520259958124],
              [126.56052819723145, 34.228246482544684],
              [126.5676058976773, 34.22411366340762],
              [126.56007094585856, 34.20613021876051],
              [126.5530303619841, 34.20465899375002],
              [126.55731618642398, 34.19062465661519],
              [126.56399547309456, 34.187849425089986],
              [126.56101201158582, 34.17910132622759],
              [126.58898232315309, 34.173548965141016],
              [126.58235385079884, 34.18159764836602],
              [126.58543690707158, 34.189920609185556],
              [126.59975212998869, 34.18912069321181],
              [126.6006752547875, 34.18200071424688],
              [126.6139452326609, 34.18158238498003],
              [126.61109458659216, 34.19240124627212],
              [126.62199406042508, 34.200130933127184],
              [126.61425352764691, 34.21615204579937],
              [126.59437452959052, 34.22688192846371],
              [126.58902594730185, 34.22252842444431],
              [126.57941041301723, 34.22811769938721],
              [126.57399548953971, 34.22198931064761],
              [126.56522659225833, 34.23520259958124],
            ],
          ],
          [
            [
              [127.25492908946589, 34.25043944388714],
              [127.24283056266681, 34.242967554318184],
              [127.24264195584071, 34.237233349986035],
              [127.23168815183632, 34.233002832201116],
              [127.22743495060742, 34.21803813366786],
              [127.25393524512575, 34.21322215136266],
              [127.2491973270236, 34.22122333934524],
              [127.25728503133014, 34.22929777982241],
              [127.26035531017423, 34.23879372293639],
              [127.25492908946589, 34.25043944388714],
            ],
          ],
          [
            [
              [126.61347729982569, 34.250413113116345],
              [126.6037128989693, 34.248598726394405],
              [126.59534971504112, 34.243349551780376],
              [126.59414026973795, 34.233918335912165],
              [126.60635446185834, 34.237522911329144],
              [126.61573983257931, 34.235957521236166],
              [126.6221752979975, 34.23883808182842],
              [126.62115830513739, 34.24687292935656],
              [126.61347729982569, 34.250413113116345],
            ],
          ],
          [
            [
              [125.93627881827321, 34.24634924994905],
              [125.9274036314482, 34.23611742165804],
              [125.94026233956848, 34.230586872933486],
              [125.95536087769099, 34.240776326615205],
              [125.93627881827321, 34.24634924994905],
            ],
          ],
          [
            [
              [126.05066668572378, 34.2536623473206],
              [126.05444147669293, 34.24716768702941],
              [126.04996253860686, 34.23964546722884],
              [126.04058974168959, 34.235647732515005],
              [126.05038875896142, 34.22806721046878],
              [126.06143038530952, 34.23412451167266],
              [126.06473609470785, 34.24101479388477],
              [126.06127246249979, 34.24742114520991],
              [126.05066668572378, 34.2536623473206],
            ],
          ],
          [
            [
              [125.92429030629403, 34.25934422110115],
              [125.92128245050765, 34.261614882499856],
              [125.90141688549525, 34.25681969309705],
              [125.89872634066278, 34.247630300256674],
              [125.90826253282943, 34.246463561693425],
              [125.92429030629403, 34.25934422110115],
            ],
          ],
          [
            [
              [126.56492971322912, 34.28214692022572],
              [126.54933158038422, 34.28042191541355],
              [126.55177292586028, 34.27500212154833],
              [126.57029447076134, 34.2767623985412],
              [126.56492971322912, 34.28214692022572],
            ],
          ],
          [
            [
              [125.99199680104748, 34.277866006939675],
              [125.97948766688256, 34.27541083770959],
              [125.97944076474423, 34.26708889914747],
              [125.98957292106732, 34.26805022149508],
              [125.99626338424684, 34.27279135601802],
              [125.99199680104748, 34.277866006939675],
            ],
          ],
          [
            [
              [127.35255937847316, 34.28869645542801],
              [127.3485703657784, 34.280907263260694],
              [127.34767613291814, 34.27094121744521],
              [127.35191753253571, 34.26842583862457],
              [127.37036365617124, 34.28877369330156],
              [127.36137383605453, 34.29112983095192],
              [127.35255937847316, 34.28869645542801],
            ],
          ],
          [
            [
              [127.39694973072851, 34.2968962627531],
              [127.38624358845031, 34.28947426585319],
              [127.38856033225923, 34.28078889807381],
              [127.39740268448902, 34.280583324412696],
              [127.39982787715525, 34.291801832097626],
              [127.39694973072851, 34.2968962627531],
            ],
          ],
          [
            [
              [126.01603149421629, 34.3174796009073],
              [126.00392115227874, 34.315257274775874],
              [126.00620255784058, 34.30925726080339],
              [126.01682334554484, 34.311804266437164],
              [126.01603149421629, 34.3174796009073],
            ],
          ],
          [
            [
              [126.03985792848802, 34.31846243485063],
              [126.03011559210269, 34.3097511119394],
              [126.0332022632607, 34.304813759145475],
              [126.01929005220495, 34.30050812365764],
              [126.02831877053251, 34.28977943637845],
              [126.02650437065122, 34.285997462711194],
              [126.04480433225551, 34.28217949160931],
              [126.06079393578982, 34.28936143949176],
              [126.08620386983885, 34.28235761750694],
              [126.08777169002661, 34.309682526075306],
              [126.07997231170371, 34.30715891706942],
              [126.05491568097352, 34.30379288142192],
              [126.04557279365429, 34.30880890702858],
              [126.03985792848802, 34.31846243485063],
            ],
          ],
          [
            [
              [125.97597862274897, 34.32079186831369],
              [125.96850689667258, 34.31917307927522],
              [125.96941017974189, 34.3102337856114],
              [125.97686092670978, 34.30872187852909],
              [125.97998150412593, 34.315433990709046],
              [125.97597862274897, 34.32079186831369],
            ],
          ],
          [
            [
              [126.98493169538999, 34.33985457603417],
              [126.97038691240749, 34.33875265785346],
              [126.95791850538714, 34.327473526872595],
              [126.95837389605734, 34.313583351322876],
              [126.96550459711123, 34.312228244272646],
              [126.97260058667467, 34.302504441708635],
              [126.97725867973035, 34.30665367003184],
              [126.98941797441725, 34.307506759034744],
              [126.99232540912963, 34.3121156141563],
              [127.00241687512812, 34.31391299356036],
              [127.00622305431975, 34.32210681425392],
              [127.01549396932916, 34.32376483818392],
              [127.00463622092988, 34.33700766888265],
              [126.98755623189668, 34.33644573169196],
              [126.98493169538999, 34.33985457603417],
            ],
          ],
          [
            [
              [126.02791865037057, 34.34172893385747],
              [126.01599517142306, 34.33218812405536],
              [125.99983576761034, 34.33667881969054],
              [125.99487257099386, 34.3272588267306],
              [126.01076896883312, 34.32135157360452],
              [126.03686233658982, 34.33043215878584],
              [126.04614601300867, 34.324439992789486],
              [126.05938364907271, 34.32174845275706],
              [126.05251779873768, 34.33228055386868],
              [126.03311269167335, 34.33786908573759],
              [126.02791865037057, 34.34172893385747],
            ],
          ],
          [
            [
              [126.83475894667997, 34.35739593263983],
              [126.8209784878306, 34.35072900178604],
              [126.81541681562246, 34.33608364058191],
              [126.80558081990306, 34.333251945649494],
              [126.78710025417313, 34.34601023434549],
              [126.77950172140973, 34.3359757636416],
              [126.76051971697309, 34.33340338254176],
              [126.76909227127933, 34.32872121243978],
              [126.78033211795473, 34.32818585995268],
              [126.79059085121703, 34.32181171272903],
              [126.80664753454552, 34.327056169755494],
              [126.8188700062756, 34.32736465727013],
              [126.83337346708619, 34.32348575824918],
              [126.83679507988897, 34.30771143371715],
              [126.84116351447337, 34.29938051265894],
              [126.84791150142425, 34.30037861730167],
              [126.85460762579899, 34.30919497462318],
              [126.87019845360925, 34.32026695570733],
              [126.87509163294025, 34.31341574629598],
              [126.88174775702204, 34.311680300572235],
              [126.88573027585633, 34.31906196004392],
              [126.87863082156659, 34.32596528776111],
              [126.88295317446864, 34.332613351860665],
              [126.89703118314034, 34.33287402802746],
              [126.89756670995872, 34.343862658632844],
              [126.89084982885453, 34.3431893623259],
              [126.88139809840408, 34.335993186245055],
              [126.87854812946591, 34.34293410448978],
              [126.86835738565298, 34.350133135113786],
              [126.85733124546432, 34.3440613520187],
              [126.8480698995762, 34.34412625313608],
              [126.83475894667997, 34.35739593263983],
            ],
          ],
          [
            [
              [126.99250780999873, 34.35544522474118],
              [127.00766864131451, 34.34924609894869],
              [127.01267074282049, 34.35563505090805],
              [127.02886301771319, 34.34825672260809],
              [127.03325460079951, 34.34249002698115],
              [127.05086873550295, 34.341131523022916],
              [127.05440296918012, 34.3347062020622],
              [127.05053078742816, 34.328173049047415],
              [127.03688756292486, 34.32502009892703],
              [127.04122885125399, 34.31471795485991],
              [127.05534037995996, 34.330780876618476],
              [127.07354817646195, 34.343983051169985],
              [127.08756548427904, 34.3424824443983],
              [127.08476907225688, 34.35705528671547],
              [127.07259227917032, 34.36120989503213],
              [127.05718486497729, 34.352840218142916],
              [127.0490383545361, 34.352368590180234],
              [127.04241089160405, 34.35720820156151],
              [127.04537230678952, 34.366567017341254],
              [127.02699992270962, 34.3716065719409],
              [127.01746306905878, 34.36849457324498],
              [127.00616289467028, 34.356575948274575],
              [126.99250780999873, 34.35544522474118],
            ],
          ],
          [
            [
              [126.30728229844271, 34.747818286755184],
              [126.30769810032012, 34.75617979317947],
              [126.29851763281317, 34.76210094182703],
              [126.28952580162192, 34.75966591892413],
              [126.28071748132209, 34.74211927948229],
              [126.2745262320364, 34.72521137014427],
              [126.27439931411972, 34.71645552263305],
              [126.26900322675735, 34.70163439057106],
              [126.26202816720047, 34.705586352577676],
              [126.25826418666699, 34.69437050089237],
              [126.2604109631719, 34.67573882473538],
              [126.25618838641115, 34.6679420445216],
              [126.26321409846399, 34.65846601898951],
              [126.26769015862364, 34.637925343231196],
              [126.27203534394981, 34.633029987959624],
              [126.28436859096263, 34.63035267596016],
              [126.28892106075014, 34.626271305241865],
              [126.28074687298393, 34.60985412499208],
              [126.2805172014494, 34.59961721231704],
              [126.29053138619976, 34.59231018798867],
              [126.30615090732172, 34.59056191611194],
              [126.3134411313707, 34.58635199777051],
              [126.30837267549417, 34.57274960229618],
              [126.31394425917625, 34.5669443558715],
              [126.32776351412014, 34.56921478307667],
              [126.33399105710916, 34.57343096548715],
              [126.36058974206793, 34.56417872043458],
              [126.36279022231687, 34.56117392635314],
              [126.38363350161062, 34.56173574267489],
              [126.38912078440062, 34.552505950496574],
              [126.38258479895896, 34.53565097443651],
              [126.38874470397417, 34.532222144841526],
              [126.40274953531392, 34.539449488219965],
              [126.40537577645529, 34.54771638816133],
              [126.4182259612872, 34.54927686975723],
              [126.41683995199729, 34.554326679637484],
              [126.43033719833663, 34.55553886162806],
              [126.43634437627718, 34.54978253751713],
              [126.43232150955502, 34.545227368127954],
              [126.46058433508402, 34.53212355844791],
              [126.44470290605611, 34.52644018492803],
              [126.46234683468799, 34.52065017783916],
              [126.47152864530096, 34.506944356258124],
              [126.45719303211034, 34.501697943725496],
              [126.46637973405828, 34.48549436229817],
              [126.45577720228457, 34.47734431935974],
              [126.46338400204527, 34.46884054987239],
              [126.47223583678053, 34.468566493576326],
              [126.46590689713969, 34.45264525918947],
              [126.45872295196621, 34.44934484477339],
              [126.47161030463309, 34.43452802027867],
              [126.48157485431823, 34.42613524090513],
              [126.48683840035353, 34.43529484561166],
              [126.49624733200862, 34.431629049862096],
              [126.50666627635674, 34.440722739235255],
              [126.51404001938249, 34.43317598737387],
              [126.51071091540621, 34.42511259530264],
              [126.5168535538982, 34.41431945030669],
              [126.50499657263691, 34.405330944903106],
              [126.49353935117747, 34.40808171082625],
              [126.48955395173245, 34.39608329132858],
              [126.49816956926054, 34.38894396220487],
              [126.49564967359676, 34.384079795101044],
              [126.48434631159668, 34.386468936371784],
              [126.47455350238471, 34.37769677150597],
              [126.48341000420466, 34.367622909623236],
              [126.48137963762188, 34.358614417885725],
              [126.4987791633099, 34.35797039277608],
              [126.50276724281275, 34.365105726595516],
              [126.51024243768711, 34.36541942117501],
              [126.52000227346335, 34.36111835846178],
              [126.52241805148208, 34.34171220844711],
              [126.52710427393131, 34.33512436097483],
              [126.51782850086205, 34.31620555674772],
              [126.51718932865717, 34.29564241255625],
              [126.528053572132, 34.2935250191276],
              [126.52878705980649, 34.30031260313258],
              [126.54458240203037, 34.30328433311155],
              [126.55198129675775, 34.31654865130559],
              [126.55793339778715, 34.321772491768776],
              [126.58838505206363, 34.319033547934474],
              [126.59678955550602, 34.3126845503252],
              [126.60099579087253, 34.319023571164365],
              [126.60380011412052, 34.33300132672622],
              [126.60790226507214, 34.34111240759182],
              [126.60637222401351, 34.34954632058366],
              [126.61993864278674, 34.359082995335356],
              [126.61828455628998, 34.372562893726126],
              [126.61098111032321, 34.38600105648034],
              [126.62057759692175, 34.39354068276032],
              [126.61658563378417, 34.40285237839678],
              [126.63489752955184, 34.41225604640546],
              [126.64743170584079, 34.413176403804215],
              [126.64983633725431, 34.42203095234167],
              [126.65804166826291, 34.42103986421044],
              [126.66437529535466, 34.42703986348257],
              [126.67704237147484, 34.41638066940338],
              [126.68087437579898, 34.42657489870349],
              [126.69707921052962, 34.440152387660554],
              [126.71161515753577, 34.44052493269882],
              [126.71893077753923, 34.44566792459864],
              [126.72728676845462, 34.44589486280202],
              [126.74788443217396, 34.47238550364988],
              [126.74702866326876, 34.478004645827106],
              [126.73853657001315, 34.4862635140775],
              [126.75560873156218, 34.492460976519816],
              [126.76144668299851, 34.50267024111427],
              [126.7582414578572, 34.52619249866459],
              [126.76404707819287, 34.53358742520465],
              [126.76445808968396, 34.54593114528989],
              [126.76785794935756, 34.55612724847691],
              [126.76540384966627, 34.5631231320043],
              [126.77120870788933, 34.596840449150086],
              [126.7700223341927, 34.61549588602141],
              [126.7787248970531, 34.616851663667845],
              [126.78106904035182, 34.59060270092692],
              [126.78826808024026, 34.587504970467755],
              [126.78674815007227, 34.57626739070617],
              [126.79584347577706, 34.56689583782143],
              [126.79220427024804, 34.55598314139804],
              [126.79187802481741, 34.52875366256571],
              [126.78671062871591, 34.512438220866905],
              [126.79232894825047, 34.50147171753179],
              [126.79088001327163, 34.49642441337063],
              [126.79699923045632, 34.48476113561165],
              [126.79549438126267, 34.478600077909356],
              [126.7870903768344, 34.47632351236251],
              [126.78573975621111, 34.46894563507877],
              [126.7913701055243, 34.466682364766875],
              [126.80814488156341, 34.468265758446336],
              [126.80482063430408, 34.456606861002584],
              [126.81800156325573, 34.44914118495233],
              [126.82946304547222, 34.44799686859821],
              [126.83920543847859, 34.453504678100785],
              [126.85452502606282, 34.4435666660794],
              [126.87695089068364, 34.434180977283546],
              [126.88202466939563, 34.439701707629936],
              [126.87659730184635, 34.456829539933096],
              [126.8900382870846, 34.456425408732265],
              [126.92539340169132, 34.45285493059925],
              [126.93288721512448, 34.447207746858744],
              [126.94705469040954, 34.45686103420276],
              [126.94125514637516, 34.46229611461549],
              [126.9374781355375, 34.47555265006113],
              [126.94496007217644, 34.48279917545323],
              [126.95441562374384, 34.470076620919485],
              [126.96702170813197, 34.47680873070417],
              [126.97859372613281, 34.477940277173445],
              [126.97647267226571, 34.488435687407495],
              [126.96300622526802, 34.49538677905765],
              [126.96804135694781, 34.51007970467409],
              [126.97370536747619, 34.51433101909637],
              [126.97165450026246, 34.52111380475097],
              [126.9648459363316, 34.52305924114858],
              [126.9605360994473, 34.53062971076412],
              [126.9648253638988, 34.537477808847505],
              [126.97421785641228, 34.54351694344919],
              [126.98728212969287, 34.53989083999662],
              [126.98961431934663, 34.55190989591903],
              [126.98882521635532, 34.56180190625912],
              [126.97921199596935, 34.572367312371746],
              [126.99355660546269, 34.58508766343848],
              [126.9932182043646, 34.59289089880256],
              [127.00433773136564, 34.60766649878129],
              [126.9934207675323, 34.614873768807215],
              [126.98436567007569, 34.62800091078046],
              [127.01253204097854, 34.6245507709453],
              [127.03010779459026, 34.62968823086958],
              [127.03486514541036, 34.63533190087274],
              [127.0454337286914, 34.635426241657385],
              [127.05297387860712, 34.64185401413768],
              [127.0675220557214, 34.66352466383835],
              [127.0878503481347, 34.66957787074031],
              [127.1095472094975, 34.679641198314194],
              [127.11476452500624, 34.693840256252905],
              [127.12953588997365, 34.70290299312636],
              [127.1352223665473, 34.701817901933246],
              [127.14325464118366, 34.693185746849416],
              [127.17709910568699, 34.69195529107968],
              [127.18456885269224, 34.694599291150965],
              [127.19081135866848, 34.70415934264315],
              [127.19748044789989, 34.706277154387124],
              [127.20050756117932, 34.714264647302144],
              [127.21084872990465, 34.72912257089612],
              [127.20944005074051, 34.738055943692636],
              [127.22878280918133, 34.75717871973029],
              [127.22885000554366, 34.7616413664719],
              [127.24082886342467, 34.7648434947939],
              [127.25224835899067, 34.74834148536929],
              [127.25252805970636, 34.74206389894123],
              [127.25956679405449, 34.733438866858705],
              [127.27202488772137, 34.74175537192149],
              [127.28624743812287, 34.73617962188462],
              [127.29523086047689, 34.739004498431406],
              [127.30354700753715, 34.749786029869675],
              [127.31529273115493, 34.75317969538622],
              [127.32703054650948, 34.7519606761971],
              [127.32700180936037, 34.73438676037404],
              [127.33282653309193, 34.71517939538591],
              [127.32780582498224, 34.69053557164057],
              [127.31770863953514, 34.68124259505685],
              [127.31977845896992, 34.66992954522038],
              [127.31461948205595, 34.664386165253205],
              [127.29746647900957, 34.66785863997813],
              [127.28744976003897, 34.666996532779436],
              [127.27933846005355, 34.67231162609569],
              [127.27713647266057, 34.678138485303066],
              [127.27983874102709, 34.68689405737704],
              [127.28582275446415, 34.691819667390114],
              [127.2800417038948, 34.71002682460356],
              [127.26481518637463, 34.71326185811195],
              [127.25417566544004, 34.71036906954081],
              [127.25426378606011, 34.70553531656497],
              [127.23970628046125, 34.697335460356044],
              [127.23852868463054, 34.690956406091196],
              [127.24367149238468, 34.68579662249924],
              [127.23426099247855, 34.68002153387996],
              [127.23000552773348, 34.66910750524713],
              [127.22794513447654, 34.65451377892834],
              [127.19947983601206, 34.64792365581531],
              [127.1898870828344, 34.64351437139782],
              [127.18037117737498, 34.63051691835077],
              [127.17291324098287, 34.62687966143741],
              [127.17309300457984, 34.606307284589974],
              [127.16800994352174, 34.60249093399305],
              [127.171171556487, 34.594151043570484],
              [127.16294445117829, 34.58991645587052],
              [127.1452917155683, 34.59493845902605],
              [127.14577787775103, 34.58514257437762],
              [127.13679473864602, 34.57518127359411],
              [127.12444734158655, 34.56978958856988],
              [127.11541626071296, 34.556305099600266],
              [127.11241136734844, 34.546579188816004],
              [127.1226718956964, 34.53898354870946],
              [127.12158333080454, 34.53020553090601],
              [127.13445007076028, 34.52714314615104],
              [127.13661883313277, 34.52350134787888],
              [127.16190046204014, 34.52470729284392],
              [127.16921346569237, 34.5226890939825],
              [127.17842083966778, 34.53121305771476],
              [127.19520133709896, 34.53250992762816],
              [127.19983328968296, 34.524506577060635],
              [127.20703365831655, 34.52201107316646],
              [127.22086799223156, 34.53473720443114],
              [127.22314201883871, 34.530009279097015],
              [127.23424872599769, 34.5239905232605],
              [127.23075430499485, 34.51857694004967],
              [127.24501254430814, 34.51594155188482],
              [127.24410656194419, 34.521558911333194],
              [127.25672473197434, 34.520188178774156],
              [127.26093679039624, 34.513179322541085],
              [127.26843095366337, 34.510958908246906],
              [127.27405696165185, 34.50275743895502],
              [127.28325576302682, 34.50194774479449],
              [127.26807654646356, 34.48187152422735],
              [127.27954956967558, 34.481146273950415],
              [127.3012707474823, 34.47081172575927],
              [127.30299468428514, 34.46448404280375],
              [127.31034535894085, 34.46211705858326],
              [127.31541902640768, 34.45299991165253],
              [127.31264180891885, 34.449801220920975],
              [127.32229481448289, 34.44177358603627],
              [127.33903487076464, 34.44691432710889],
              [127.33829699666109, 34.45279322457135],
              [127.32757538256226, 34.46623744131777],
              [127.33716417178503, 34.4674874331582],
              [127.33106007763634, 34.47616724045591],
              [127.34262656608502, 34.48335817103116],
              [127.35252747431748, 34.481979640104925],
              [127.35478190267092, 34.491564025825824],
              [127.36129277390242, 34.49166483692655],
              [127.37080374254347, 34.48009945223792],
              [127.37581169213678, 34.486096488562104],
              [127.39137570370228, 34.488299156240934],
              [127.3777605076486, 34.50431368897323],
              [127.3921241762632, 34.506363848417934],
              [127.4038080362049, 34.505067033856214],
              [127.40568023797847, 34.51949023537689],
              [127.4139012615449, 34.521630503014016],
              [127.41823309977033, 34.51558620042881],
              [127.43085751238644, 34.513081944711786],
              [127.42486279368141, 34.5230890289696],
              [127.42990122499005, 34.54164416933078],
              [127.43740080895417, 34.55048864734545],
              [127.42082801336399, 34.552597038814966],
              [127.39624681907202, 34.559392132796944],
              [127.41198853231276, 34.563392544254526],
              [127.41973478950271, 34.56328249653299],
              [127.42681398011072, 34.5699161902117],
              [127.4170842450947, 34.573800307524955],
              [127.4069455192268, 34.56753687253678],
              [127.39383794070307, 34.581616023161075],
              [127.40097965571907, 34.589721367549224],
              [127.41209420510101, 34.590591070503436],
              [127.4199664946294, 34.582863659079855],
              [127.4330854956559, 34.58852664064159],
              [127.44458385586518, 34.57666434379644],
              [127.45288062878383, 34.58341017778728],
              [127.47520502482755, 34.575479802917506],
              [127.48609102179209, 34.57911992105725],
              [127.49659618982706, 34.59059856881647],
              [127.5055100865597, 34.594620993313804],
              [127.50584771628677, 34.60415011116526],
              [127.49772008394659, 34.61411580522536],
              [127.4939957125353, 34.626705228876936],
              [127.49668581031827, 34.63140646519548],
              [127.48378460430372, 34.63642973959912],
              [127.47403563205333, 34.63524919162806],
              [127.46894760727506, 34.64183182601359],
              [127.48221734454371, 34.64974179475881],
              [127.47510842426448, 34.65807750805249],
              [127.45741808991966, 34.66570019681479],
              [127.44545991183452, 34.661726367079346],
              [127.44609544717193, 34.67026341416558],
              [127.4399656166652, 34.677287010651554],
              [127.42865926432262, 34.68226301475381],
              [127.4141720090392, 34.69439252517214],
              [127.40743598996306, 34.69638349142599],
              [127.38883104782762, 34.71433616730964],
              [127.38901893160006, 34.71954268333253],
              [127.37854491216426, 34.72711734034641],
              [127.3784734935811, 34.73464958657457],
              [127.37280367724581, 34.74162218155653],
              [127.37993318119183, 34.75095249290288],
              [127.39034091677783, 34.75285923508346],
              [127.39976860834615, 34.76036727581126],
              [127.40195747194899, 34.76869840618971],
              [127.38523469437966, 34.77467329312323],
              [127.39070519210597, 34.79124478799022],
              [127.39457878030645, 34.7961215767864],
              [127.41276310096373, 34.802593975491966],
              [127.4184227969812, 34.8112078501547],
              [127.39839112760056, 34.81672527763686],
              [127.3919147772182, 34.8145233220775],
              [127.38307458006173, 34.82657013150072],
              [127.36677890095943, 34.831005642471226],
              [127.36750784957074, 34.835242674668194],
              [127.38070389191272, 34.836882119258746],
              [127.39087406162952, 34.827806362477176],
              [127.40119704461964, 34.824846696537094],
              [127.41702198632002, 34.832670176101864],
              [127.42598662685096, 34.8322895082708],
              [127.43241932344847, 34.83595401569391],
              [127.44778098911605, 34.83651805289064],
              [127.47248461048227, 34.84501474352492],
              [127.48449345904461, 34.840959838758515],
              [127.49243302413856, 34.8469397648017],
              [127.49045515388008, 34.85799157627912],
              [127.49492522379094, 34.86087133773234],
              [127.48993957038853, 34.87396402394875],
              [127.50223848349708, 34.874775320801724],
              [127.51428767884643, 34.878218807387405],
              [127.51936657058258, 34.86027549158283],
              [127.52629220054354, 34.844753352048585],
              [127.53303107161885, 34.841364865913214],
              [127.54352161082055, 34.842022419925165],
              [127.53864856412717, 34.83238414107986],
              [127.52681542998762, 34.822566326883155],
              [127.5261297371838, 34.809546647572006],
              [127.53780910438816, 34.805831419069065],
              [127.54658878648273, 34.810439923359986],
              [127.5574504096607, 34.80721380833396],
              [127.55860870150374, 34.796282122152256],
              [127.56694939340161, 34.79062465783846],
              [127.57302026712716, 34.78221489864001],
              [127.56957833018667, 34.776727358779894],
              [127.57943976250175, 34.76192279607747],
              [127.58525031024637, 34.76736883617449],
              [127.59030824208827, 34.75610969040442],
              [127.57829893570987, 34.738819734961005],
              [127.5781774711352, 34.73245266498289],
              [127.56432365357954, 34.726459406913186],
              [127.54897634503968, 34.71316526887747],
              [127.56318066440225, 34.70503466315512],
              [127.55122633111861, 34.6899200693419],
              [127.55129527588852, 34.681602145560504],
              [127.56273143658282, 34.67711127610592],
              [127.56156447827848, 34.67148621890424],
              [127.55263729770778, 34.66938671204256],
              [127.55174644923295, 34.6630877377514],
              [127.565508627909, 34.653526639552126],
              [127.57105110237741, 34.643210526889426],
              [127.5822750114793, 34.6521997031425],
              [127.58989478917107, 34.6520060903281],
              [127.6212646237126, 34.639277789209004],
              [127.6263346350392, 34.63257870674982],
              [127.63425337572322, 34.63282027473536],
              [127.63703673261075, 34.62608718605767],
              [127.64540501541605, 34.62877718397084],
              [127.63532927756395, 34.639301834244684],
              [127.63786353166955, 34.64889240090264],
              [127.63033764801204, 34.65323644129859],
              [127.63291310982073, 34.66989405832822],
              [127.6230526143558, 34.682031551147766],
              [127.62467679750299, 34.69874664937362],
              [127.61353313339656, 34.70643784559252],
              [127.62502905877766, 34.718399668134396],
              [127.62720520208688, 34.71288043264488],
              [127.6392784752217, 34.714748494772486],
              [127.64117439809723, 34.727035922853865],
              [127.64820977182599, 34.733992247583856],
              [127.65763618143433, 34.75560530835569],
              [127.678229699736, 34.73574266382057],
              [127.69616042175875, 34.72741258398144],
              [127.70452726304826, 34.720450392770154],
              [127.72596627209174, 34.7299706702961],
              [127.73346397760729, 34.73732973444906],
              [127.750674064619, 34.73633314656949],
              [127.7559849640582, 34.741376521749096],
              [127.7482581369704, 34.74829853826699],
              [127.75355422739416, 34.762067017363464],
              [127.7452708076061, 34.77455359167221],
              [127.7473621084968, 34.781276787607275],
              [127.7558443612653, 34.78523564613875],
              [127.75488557758649, 34.79349734647396],
              [127.76621543044297, 34.80814073973462],
              [127.76957522325073, 34.8215725858845],
              [127.76756703581206, 34.83141386106506],
              [127.77474409084824, 34.837523308830846],
              [127.77604973662669, 34.85611792923395],
              [127.77272849701211, 34.86155713466762],
              [127.76179997977637, 34.863454315495375],
              [127.75209849379566, 34.86022211941174],
              [127.7397770299985, 34.86146504609165],
              [127.73366954585913, 34.854779678451905],
              [127.72653899489137, 34.86204502188875],
              [127.71989079332874, 34.8588857124133],
              [127.69835152477935, 34.85920283132654],
              [127.69501037253586, 34.864688867295655],
              [127.68019049138525, 34.84495530680913],
              [127.67012868688064, 34.83788071900903],
              [127.66163531181664, 34.84455158586389],
              [127.64288999769526, 34.8304638551067],
              [127.63108529558586, 34.827766597176264],
              [127.62663995901812, 34.82986454010385],
              [127.62879410258255, 34.83931497477081],
              [127.61372214136549, 34.853903570104535],
              [127.60467643003088, 34.85330688139021],
              [127.60154016278662, 34.86131288935088],
              [127.59207402140153, 34.87049186927664],
              [127.59035571929451, 34.87728855033408],
              [127.61358382911116, 34.89242007709809],
              [127.60125187381279, 34.898598958525206],
              [127.60510348913326, 34.90352344715198],
              [127.59055762235309, 34.918681313429154],
              [127.58083549192929, 34.92229540584315],
              [127.60471455586179, 34.928341914604154],
              [127.60812728998287, 34.92181648477291],
              [127.61746620710322, 34.91599801174017],
              [127.62288068484675, 34.907555561248834],
              [127.64016684062385, 34.891471423952936],
              [127.63931314391395, 34.88380294504598],
              [127.67097979880423, 34.90310586037627],
              [127.66292959801456, 34.910676818381035],
              [127.66293177136042, 34.915391877825954],
              [127.67147674293676, 34.930863957261295],
              [127.68024756261008, 34.92968213706088],
              [127.69584624631023, 34.918964913167784],
              [127.70059958655388, 34.93145699666405],
              [127.71017434989099, 34.93584383042301],
              [127.72579156833642, 34.95173247950177],
              [127.7541332691179, 34.96231632414271],
              [127.763496185331, 34.976086840037524],
              [127.78057083944391, 34.99040012200792],
              [127.78682345018649, 35.01021416146907],
              [127.78484109250063, 35.020935262637025],
              [127.77162534095297, 35.033722486817574],
              [127.76965863082606, 35.046452934270384],
              [127.76344671252672, 35.05483220296884],
              [127.75154159341368, 35.05672430020706],
              [127.73994448646447, 35.06336231028046],
              [127.73421674192849, 35.07533448423651],
              [127.71768906430749, 35.08261479704845],
              [127.69485371308919, 35.10629310132482],
              [127.69384841654968, 35.12793095950257],
              [127.67570302552447, 35.14734482779391],
              [127.65933580505596, 35.158964701706275],
              [127.64837181608272, 35.16039165134756],
              [127.6374956378278, 35.17312581371367],
              [127.62462476488928, 35.182574034707805],
              [127.6180262251906, 35.19974202534853],
              [127.61706654934872, 35.20958179120909],
              [127.62072795478282, 35.2126567515901],
              [127.61928671308326, 35.23560286897091],
              [127.61282049217968, 35.24161658109167],
              [127.61015835537853, 35.26204548264998],
              [127.59569683143822, 35.26813323253147],
              [127.58407164111954, 35.291104676900815],
              [127.57736797475187, 35.29515677975062],
              [127.57607080230393, 35.306080308983624],
              [127.5678312730309, 35.31851543853918],
              [127.5551925130498, 35.32187757834085],
              [127.54228297068526, 35.328500122854635],
              [127.54152053948384, 35.333650608473015],
              [127.53249208632067, 35.33529803526385],
              [127.5264888879478, 35.34309978987188],
              [127.49791521497805, 35.359887222956786],
              [127.48570579989416, 35.358349599250246],
              [127.4787681408196, 35.3641902457251],
              [127.47076605945689, 35.36533555490958],
              [127.45411058697587, 35.360753935768656],
              [127.44245219664239, 35.36128177259349],
              [127.42989726398218, 35.35758210807296],
              [127.4214098833385, 35.35086990899613],
              [127.41507828715088, 35.33599814802933],
              [127.39269876886756, 35.307346342039764],
              [127.38456743913838, 35.30245762507839],
              [127.37663778094642, 35.31131293509373],
              [127.36768870707176, 35.31415983005637],
              [127.35425615360515, 35.32235506023385],
              [127.33898536397865, 35.317662756256695],
              [127.32346715449538, 35.30740910445524],
              [127.30988808881308, 35.304515470560446],
              [127.28671476025474, 35.31402220685003],
              [127.2571634042908, 35.31246196736321],
              [127.23478564253541, 35.32992424414051],
              [127.23229532325277, 35.33360925587962],
              [127.22079338119285, 35.33481112863619],
              [127.21701753573315, 35.33111163044875],
              [127.21271027953226, 35.31735342874731],
              [127.1990470345454, 35.31665265173848],
              [127.18773086918166, 35.32258093228477],
              [127.18476853008849, 35.333522645736764],
              [127.16804637742112, 35.33201461611768],
              [127.14625784017073, 35.31505598197519],
              [127.14381808782655, 35.30839763096958],
              [127.12998393725411, 35.30913169413502],
              [127.12456681355187, 35.30344405127486],
              [127.11411746266316, 35.299599626250725],
              [127.09680278253043, 35.30182198822332],
              [127.08119597760363, 35.310038697952756],
              [127.06896468598487, 35.3114376661858],
              [127.06178395323612, 35.317129176807505],
              [127.0462068116152, 35.31859755270823],
              [127.04309206603834, 35.321885311582136],
              [127.05094613620108, 35.32937268643562],
              [127.05525212303152, 35.34106319531651],
              [127.0623812341824, 35.33625110490696],
              [127.06986207316561, 35.33934463140995],
              [127.06521928117847, 35.35590965464778],
              [127.07060773052608, 35.36551336277998],
              [127.06359469112252, 35.36989707938544],
              [127.06498373037199, 35.375953782628734],
              [127.05375631855289, 35.38189859211876],
              [127.04732151528569, 35.377197598701486],
              [127.03909774087637, 35.38014322789924],
              [127.02809839977414, 35.39791040248571],
              [127.04171096902769, 35.398719297196806],
              [127.05231526612259, 35.42651602611442],
              [127.04018296595325, 35.43178872351557],
              [127.03499528492418, 35.44764451086027],
              [127.03472220501224, 35.466571772398716],
              [127.02348215795222, 35.463970684213],
              [127.0142920663687, 35.457819270297875],
              [127.00302705336276, 35.4644638437121],
              [126.99454558577423, 35.439804049107146],
              [126.98336757791009, 35.43375199428866],
              [126.9816254387653, 35.426646340425656],
              [126.97138067074779, 35.42767113769521],
              [126.97029089903016, 35.419792245525095],
              [126.9764719528808, 35.40074192982901],
              [126.96310279848791, 35.39495438691406],
              [126.95426979824681, 35.396635068062544],
              [126.933521814721, 35.39513032195322],
              [126.93003370395743, 35.40600556785863],
              [126.91742721257883, 35.40213897289345],
              [126.92077878589232, 35.410862921921996],
              [126.91614830856241, 35.41584462163901],
              [126.90824863882717, 35.41627279514487],
              [126.90187460790942, 35.42301504171008],
              [126.90431688067784, 35.42969564846238],
              [126.89761433525845, 35.432951463957416],
              [126.89964332174584, 35.44269972475038],
              [126.89677493680543, 35.44798561641906],
              [126.88287931289737, 35.4523602744501],
              [126.87009706875295, 35.461495590454],
              [126.86324182595082, 35.46120669526228],
              [126.84024997842202, 35.468668054174216],
              [126.84284951196177, 35.47895103603071],
              [126.83047766394081, 35.48079702467958],
              [126.82334275021579, 35.486913745216654],
              [126.81387969718007, 35.484191414275635],
              [126.8139731069995, 35.46879896465843],
              [126.7923478593749, 35.46763398756478],
              [126.78189604072377, 35.470628188409115],
              [126.76490267806622, 35.46705821727894],
              [126.75777582876307, 35.4622855799203],
              [126.74807582273382, 35.45058148519258],
              [126.73771540629619, 35.44949350233468],
              [126.74381783845564, 35.440683031994766],
              [126.74934236028224, 35.43912319602207],
              [126.75266872996187, 35.42948779791626],
              [126.74451429737252, 35.40875347628768],
              [126.7368032738201, 35.40339282078349],
              [126.72246869271727, 35.399932465207314],
              [126.7296317410414, 35.3946099629897],
              [126.73126007821966, 35.37688295350819],
              [126.71935206026173, 35.364988534957725],
              [126.70630250842774, 35.36459309568622],
              [126.69936745017434, 35.34958883438883],
              [126.6918201676572, 35.35143105581273],
              [126.68588858846822, 35.34492374291419],
              [126.6664450396074, 35.351486813853874],
              [126.65282066544964, 35.327792012759836],
              [126.64417028701743, 35.32030639992187],
              [126.62980895528055, 35.320494450543805],
              [126.61909928154249, 35.324471562551686],
              [126.60449733806219, 35.335560839982676],
              [126.59460633529348, 35.32901933602451],
              [126.58706136654403, 35.3308106684376],
              [126.58051505692254, 35.323888308730396],
              [126.58944758651832, 35.31750640935294],
              [126.58797320583174, 35.305535982485864],
              [126.57866325772152, 35.30319963493529],
              [126.57271016543848, 35.31014874979619],
              [126.54813042876725, 35.31347142244731],
              [126.5323234874447, 35.306743369552315],
              [126.52327939155491, 35.315439028518796],
              [126.51750635100724, 35.33413806533472],
              [126.5199543634221, 35.34954279721181],
              [126.50823609227984, 35.361643512378926],
              [126.49614854818275, 35.35760048793412],
              [126.49663627945829, 35.374020357921886],
              [126.48327639067125, 35.380565359639476],
              [126.48100853923349, 35.388491108430586],
              [126.48971960639562, 35.39346579592557],
              [126.49287533328491, 35.409238060791644],
              [126.48010334948316, 35.42105055195956],
              [126.47602803544781, 35.42932845404771],
              [126.4685510636699, 35.42514998627984],
              [126.43870573207923, 35.429937054250395],
              [126.42719209238014, 35.42580806291047],
              [126.42243678583027, 35.42835063420214],
              [126.40705109658535, 35.417116909613014],
              [126.4052141242811, 35.40765862624548],
              [126.40923697350955, 35.398814033087675],
              [126.40643738528246, 35.38699353338101],
              [126.41488203522184, 35.377113095875295],
              [126.42210317752215, 35.363689857365216],
              [126.41260804192582, 35.362762760290536],
              [126.40323633548799, 35.368577657105206],
              [126.39695301925609, 35.36822584142872],
              [126.38781389747193, 35.352765490604035],
              [126.38714933224662, 35.341648808036666],
              [126.37913583454693, 35.32848757010876],
              [126.37741955189792, 35.306769043932135],
              [126.36986160969673, 35.29163473472339],
              [126.37049486833972, 35.284165350156016],
              [126.35261233417513, 35.28287049789661],
              [126.35025290279157, 35.286480353172806],
              [126.33445780418604, 35.28331838821486],
              [126.32539285496267, 35.26230148552893],
              [126.32424071678538, 35.2526613214139],
              [126.3283711355942, 35.24132844327677],
              [126.31511794502708, 35.247464696704846],
              [126.31213144864445, 35.25316698712075],
              [126.30121774397615, 35.23436568015708],
              [126.29975673727053, 35.21101357114961],
              [126.31424260482062, 35.210135766495455],
              [126.32150478652478, 35.20392280888045],
              [126.33540343166783, 35.20467392939984],
              [126.33677256977546, 35.19413459446694],
              [126.3536339127309, 35.1961687105537],
              [126.35369614201414, 35.20183370479348],
              [126.36573822803155, 35.205193452325005],
              [126.37523496243952, 35.21200266549892],
              [126.37885412428132, 35.20831538987199],
              [126.36784137843776, 35.195679425469216],
              [126.36774789181894, 35.18622307516266],
              [126.35520093054005, 35.184072372729204],
              [126.3728018867909, 35.16127653863565],
              [126.3834205202805, 35.158849862124185],
              [126.38251920592714, 35.1537619384506],
              [126.38766035357156, 35.142805202826914],
              [126.39678367182712, 35.13454292758582],
              [126.40228995507313, 35.137781191780284],
              [126.41885822487654, 35.11036727526664],
              [126.43699784757641, 35.10522073009308],
              [126.46186314639277, 35.102426582964725],
              [126.46521641618386, 35.099975799670275],
              [126.45819239063641, 35.090204554941224],
              [126.44171581582437, 35.08409300328216],
              [126.45672189022442, 35.07606350318916],
              [126.4519411598393, 35.07155811778332],
              [126.44514569848796, 35.05831029371854],
              [126.42404666614948, 35.04826858834393],
              [126.4181037170642, 35.04011342298466],
              [126.42669115550481, 35.03005925484485],
              [126.41661967767536, 35.02660507922533],
              [126.40383311505279, 35.02645491723761],
              [126.39832955899351, 35.03280182438046],
              [126.40090411576699, 35.04290018215541],
              [126.39785700878477, 35.04869893191588],
              [126.40598385301845, 35.05798607336719],
              [126.40383755238207, 35.07079593160857],
              [126.39561983385494, 35.07397307522493],
              [126.39219982646789, 35.066305293749785],
              [126.38515932557885, 35.06585153833078],
              [126.38634761780388, 35.07887302936265],
              [126.37645705609718, 35.07033184277105],
              [126.37242781116694, 35.0619386044135],
              [126.3650272522442, 35.06519354556724],
              [126.36391010695282, 35.07532066542273],
              [126.35332257771273, 35.07841190199512],
              [126.34789649786894, 35.075193820238695],
              [126.34247525157518, 35.086473427414425],
              [126.33463703374501, 35.091401494687474],
              [126.33479969885249, 35.103523716705396],
              [126.32964717363674, 35.108070321982424],
              [126.3465894942612, 35.13873335469284],
              [126.34217915831717, 35.155196587356755],
              [126.33295470871148, 35.148544167603916],
              [126.32746670428656, 35.13529344635449],
              [126.32103992730373, 35.12738312491637],
              [126.31098865782728, 35.128336702252135],
              [126.30740565233947, 35.13770316252594],
              [126.30120047888542, 35.13850009456846],
              [126.28786652235053, 35.13469576207621],
              [126.27895008419817, 35.13565699991603],
              [126.2745632420476, 35.14435721692824],
              [126.26263310345354, 35.145157730097104],
              [126.246544464387, 35.121189675383135],
              [126.24917997302119, 35.108546854633126],
              [126.2601593680293, 35.10433648881222],
              [126.259743603379, 35.093174198980456],
              [126.23579826262625, 35.1006120643871],
              [126.23258553838475, 35.09818814348934],
              [126.2180011653552, 35.10655105624092],
              [126.2114422885505, 35.101935266244794],
              [126.19036987244147, 35.11260549969904],
              [126.1727324674794, 35.10599223562674],
              [126.16046491513545, 35.09853591397274],
              [126.15837729228222, 35.087255116106505],
              [126.16850444974601, 35.080974047030516],
              [126.16188487452112, 35.07637126254628],
              [126.16268517558433, 35.06752862813799],
              [126.17994042010278, 35.066012326068424],
              [126.18522891734939, 35.05771624570978],
              [126.19885692094581, 35.063000802256106],
              [126.19957034690205, 35.05164351005721],
              [126.20560065172153, 35.039638476808676],
              [126.20954351068508, 35.0411335242442],
              [126.20703440449047, 35.05457682139747],
              [126.22254381670145, 35.05792731748197],
              [126.23273586243113, 35.05320679856369],
              [126.2352896948421, 35.04411991169879],
              [126.23095758438123, 35.035195447293034],
              [126.23098556376847, 35.02420382512629],
              [126.24899917846189, 35.01185338402097],
              [126.25652325717805, 35.0138438857993],
              [126.25611703692003, 35.021213977002475],
              [126.26682844819406, 35.024377220050965],
              [126.26637715298891, 35.029304403736624],
              [126.27450549829919, 35.03448741723353],
              [126.26412265487346, 35.04236418764906],
              [126.25996877052103, 35.05333517477579],
              [126.27772754656041, 35.0547475324571],
              [126.28250627936042, 35.06219560151964],
              [126.29157321423905, 35.05978403531015],
              [126.29661157953524, 35.04996308494839],
              [126.30413716587091, 35.045531684268994],
              [126.31385740944712, 35.05395612278147],
              [126.3050669342081, 35.06643311050735],
              [126.31626412599347, 35.070379430485296],
              [126.31602993772987, 35.08693097915676],
              [126.33164234111867, 35.08863259356079],
              [126.34476737860454, 35.0707867564779],
              [126.33765925040795, 35.06090505298299],
              [126.34789605666367, 35.05806946805094],
              [126.34683149848993, 35.0514906261481],
              [126.35229887748469, 35.0392795873483],
              [126.37132593206857, 35.04754170508728],
              [126.3820247008517, 35.048477408278984],
              [126.39052368531868, 35.03241648751057],
              [126.39023098970225, 35.02427367583147],
              [126.37654348348639, 35.018208608765455],
              [126.3590734898726, 35.00751862572415],
              [126.34602498294906, 35.00217466610191],
              [126.34120191626727, 34.9973957275094],
              [126.35874752277168, 34.99286383024152],
              [126.35732003729487, 34.98355714947433],
              [126.34881065823431, 34.97653051046588],
              [126.32741345570973, 34.96677792576658],
              [126.32645917409715, 34.97167949161922],
              [126.29900478236647, 34.976920270108266],
              [126.29493768579849, 34.965280713418835],
              [126.30852827558668, 34.94942020486329],
              [126.32050341808973, 34.944351802970466],
              [126.31694932753638, 34.93783559687846],
              [126.32640363743255, 34.93067534549642],
              [126.33252685253757, 34.917102452241465],
              [126.34324797112926, 34.91482406992147],
              [126.352988251938, 34.92235578283524],
              [126.36728681043961, 34.92051764783482],
              [126.36625243378965, 34.932662107313945],
              [126.37366616073378, 34.94132805189266],
              [126.36987961717641, 34.94770215032247],
              [126.37217837140318, 34.95497287439226],
              [126.36886291645776, 34.9623705372401],
              [126.35949751512533, 34.962689130032516],
              [126.36093097082362, 34.972196708912456],
              [126.36612700776283, 34.98008164702328],
              [126.36689521995508, 34.9927599713214],
              [126.38065869277494, 34.98770908352353],
              [126.37947926149526, 34.97162502497329],
              [126.39016834146766, 34.96755110756318],
              [126.3946569269611, 34.96210332539981],
              [126.3878706432401, 34.9474723617419],
              [126.38939330013464, 34.94085901193518],
              [126.39896995278737, 34.93497481715512],
              [126.39033950918362, 34.928879095750375],
              [126.39147485993652, 34.92167146626122],
              [126.40316287930257, 34.91528822987205],
              [126.40508500573488, 34.91055113967261],
              [126.38966426028377, 34.88969740465812],
              [126.39161626963735, 34.88258850354699],
              [126.40167213400666, 34.88062044476073],
              [126.39585599321146, 34.867634531635446],
              [126.40739173317988, 34.85191213084318],
              [126.39704341105437, 34.838103201527986],
              [126.38826137140911, 34.83678449921113],
              [126.37028907478177, 34.81334065901434],
              [126.35090754019708, 34.7970904852369],
              [126.36704926739695, 34.7878585994443],
              [126.36917213459925, 34.7807838191315],
              [126.38852639394412, 34.780611924594844],
              [126.40989066599795, 34.78626960254644],
              [126.417503535439, 34.79118862833598],
              [126.4288401653974, 34.79358525628482],
              [126.44098893645156, 34.79939043463584],
              [126.44971763648908, 34.78238525872785],
              [126.43406907505624, 34.77704772736806],
              [126.42532803148065, 34.77834412517315],
              [126.40507991684964, 34.77178390186566],
              [126.39950019081907, 34.77417739208032],
              [126.38139255128428, 34.76866000961522],
              [126.38050918666355, 34.75265266242342],
              [126.36250462593836, 34.74491694496687],
              [126.3634993267498, 34.74080016229436],
              [126.38550993255612, 34.73166428275853],
              [126.38680950981816, 34.72228934080541],
              [126.3763843740374, 34.71467226047564],
              [126.36886109760567, 34.69836882845698],
              [126.35484107034127, 34.693467247773036],
              [126.3469788859978, 34.69998358493025],
              [126.34996013683222, 34.70549094931729],
              [126.3392643145802, 34.717990015912974],
              [126.33037123897003, 34.72118360416598],
              [126.33051494096614, 34.73347138549088],
              [126.31407521586887, 34.74612937409963],
              [126.30728229844271, 34.747818286755184],
            ],
            [
              [126.54642832033441, 34.66048503691192],
              [126.54391516849235, 34.65783588238085],
              [126.49955717162034, 34.6873704851465],
              [126.49279851491544, 34.69036401731418],
              [126.46594504461473, 34.70868325423673],
              [126.42330056038793, 34.71930525530944],
              [126.38861660532874, 34.7257206445901],
              [126.39670481841071, 34.74022328177474],
              [126.40700439362622, 34.74393451712799],
              [126.43098465786993, 34.74321521890685],
              [126.43827084298456, 34.73818079682533],
              [126.4489009754423, 34.74397610493592],
              [126.45099704724502, 34.731149622860556],
              [126.45874774586458, 34.72943897992099],
              [126.46447098890901, 34.737058911552296],
              [126.48087730908573, 34.739639003642],
              [126.47717503258262, 34.71833121395799],
              [126.48894757182852, 34.713593750684765],
              [126.50882036097637, 34.69255565123522],
              [126.51128444034859, 34.68347573676893],
              [126.51984382769095, 34.67480236677602],
              [126.53371994732001, 34.6678109195613],
              [126.55109505011498, 34.672930669815386],
              [126.56116030954512, 34.679495719473216],
              [126.55757755993774, 34.664765240901794],
              [126.54642832033441, 34.66048503691192],
            ],
            [
              [126.48932089548764, 34.74769389658233],
              [126.49282713713191, 34.76078033647345],
              [126.50473832551465, 34.75717142127484],
              [126.49919988223763, 34.74900794090836],
              [126.48932089548764, 34.74769389658233],
            ],
            [
              [126.49152344395445, 34.76152556225361],
              [126.48764519308628, 34.755229594614164],
              [126.47448986797664, 34.76679138046967],
              [126.4719816187331, 34.77557352766438],
              [126.46230201783071, 34.768737484480745],
              [126.45914993562427, 34.773693057030236],
              [126.46478121811482, 34.77899527494488],
              [126.49152344395445, 34.76152556225361],
            ],
            [
              [126.80850925329754, 35.05220967840085],
              [126.79921145810087, 35.05941730725169],
              [126.79156757615469, 35.06048808360078],
              [126.7761034029782, 35.05280295259529],
              [126.76921075917548, 35.05397130564612],
              [126.76510882969461, 35.06436177604403],
              [126.77054437067835, 35.07268170528654],
              [126.76480212389892, 35.07875456771812],
              [126.76187240588783, 35.09103297657861],
              [126.75428206536769, 35.09167756877342],
              [126.74912340372913, 35.100290866638765],
              [126.73643749463741, 35.10822702573021],
              [126.70862259619388, 35.10953254641966],
              [126.68510243994837, 35.10843703444145],
              [126.66942094382881, 35.104602366398346],
              [126.66910875722574, 35.11125788659654],
              [126.65705895167369, 35.113283576002694],
              [126.65165866448113, 35.12041177729405],
              [126.65495160531896, 35.13701402027205],
              [126.65355690667708, 35.153010685936614],
              [126.65707851130486, 35.1666159033295],
              [126.67042960766027, 35.16951742836837],
              [126.65907094217833, 35.19226258375556],
              [126.66960261793461, 35.194491599661724],
              [126.68712239395205, 35.21521275132333],
              [126.70255618526264, 35.207564373703796],
              [126.71769492723082, 35.212389582853724],
              [126.71847740134815, 35.22179861070089],
              [126.72990016264336, 35.243388198176035],
              [126.73630104611375, 35.250762507991524],
              [126.76118341650577, 35.258546813894995],
              [126.76370520687165, 35.25336741296829],
              [126.75559666482505, 35.24334143799266],
              [126.7538498673295, 35.23708666524952],
              [126.77536343796308, 35.230574881975194],
              [126.7801971282483, 35.225677268706235],
              [126.79527052261055, 35.21979854029588],
              [126.80622448406083, 35.219307996120435],
              [126.8156441420432, 35.224655680186],
              [126.83326460496804, 35.22838060229593],
              [126.84080656166157, 35.234394341624075],
              [126.86023022416953, 35.24054204787678],
              [126.86351945481252, 35.245730099801364],
              [126.87420890416217, 35.25005767829503],
              [126.88632129713879, 35.24622178462893],
              [126.90546617321147, 35.258242220054335],
              [126.91466134321134, 35.258201553350176],
              [126.93125027944701, 35.25081020291608],
              [126.93228489677524, 35.24065226021466],
              [126.9428021995677, 35.235495373239246],
              [126.95184105904814, 35.22459104732857],
              [126.94895764498922, 35.22090473803916],
              [126.95412689977437, 35.2105873066372],
              [126.96450588826866, 35.20025809618917],
              [126.95954623893984, 35.19050670023115],
              [126.97212057945916, 35.184952311676895],
              [126.99996896515265, 35.1888160171961],
              [127.0133854178123, 35.18038344651768],
              [127.02227528101419, 35.17135956655651],
              [127.00819005742055, 35.15549100853735],
              [127.00868043789305, 35.133495905529834],
              [127.01183213317917, 35.127816134965464],
              [126.99993191028037, 35.11405012583782],
              [126.98933602673415, 35.11073956147939],
              [126.98635179178463, 35.105945252857964],
              [126.98895074840934, 35.094987513520785],
              [126.97403366558542, 35.091861969286725],
              [126.96304578182884, 35.08733062293965],
              [126.95498657013083, 35.07484261519979],
              [126.94674305976619, 35.07269871143002],
              [126.93599505813073, 35.074481619792486],
              [126.9276874073557, 35.08044206000967],
              [126.92057630183162, 35.091686138797634],
              [126.91071150347304, 35.08743121089234],
              [126.90453190099676, 35.08139043034369],
              [126.88540287916005, 35.08159018961225],
              [126.8716767564796, 35.0743377487458],
              [126.85560930418788, 35.07835945173927],
              [126.84397738831427, 35.06538115403569],
              [126.82185932771058, 35.059948137802216],
              [126.81861327701989, 35.052810790433405],
              [126.80850925329754, 35.05220967840085],
            ],
          ],
          [
            [
              [127.09057543610157, 34.391496190262885],
              [127.07254008266273, 34.38491682175933],
              [127.08216746700931, 34.37542394425524],
              [127.0921686951545, 34.38553126105713],
              [127.09057543610157, 34.391496190262885],
            ],
          ],
          [
            [
              [127.04572825879276, 34.394607335051866],
              [127.0338503442056, 34.391278637726764],
              [127.03676710094506, 34.38630042938667],
              [127.0483166692475, 34.38495078874351],
              [127.04572825879276, 34.394607335051866],
            ],
          ],
          [
            [
              [126.30235979010659, 34.394582518020606],
              [126.28379642093184, 34.38668757358897],
              [126.28074618818358, 34.36940255709609],
              [126.28585172988386, 34.36570605651811],
              [126.30847471074784, 34.37388472476376],
              [126.30694812354282, 34.38460915251415],
              [126.30235979010659, 34.394582518020606],
            ],
          ],
          [
            [
              [126.65406451340188, 34.328343775037325],
              [126.66989591287512, 34.322969057281384],
              [126.67728846167822, 34.31499729092211],
              [126.68896781634533, 34.29687983021835],
              [126.69429702081177, 34.29321921968424],
              [126.70348847792937, 34.29797445730489],
              [126.71896004999726, 34.29632614433312],
              [126.73511378423468, 34.286522930632636],
              [126.73635964683179, 34.30127627479058],
              [126.74462252866347, 34.29370466679437],
              [126.75210006613933, 34.29110410162563],
              [126.77209594090954, 34.29416836840903],
              [126.76151974192629, 34.30035132956253],
              [126.77094305563801, 34.31171314871083],
              [126.76367254019408, 34.318150308425416],
              [126.75563591274445, 34.314981252592105],
              [126.74845370653213, 34.320570833243245],
              [126.7501110358303, 34.32660865117551],
              [126.73565614061161, 34.34293586794762],
              [126.73172065623524, 34.35112981872996],
              [126.73326597859995, 34.36758718589038],
              [126.73171697489413, 34.37632757283797],
              [126.72594891853736, 34.38343160960516],
              [126.71287052628492, 34.388485343385284],
              [126.7024300685856, 34.39828834098663],
              [126.69263191451904, 34.39729989330069],
              [126.68491238511012, 34.4021942501748],
              [126.67233415496065, 34.39688097768585],
              [126.64825808841712, 34.39284044141422],
              [126.6394633792471, 34.38268279873859],
              [126.64363468978463, 34.36671403830875],
              [126.64143647753811, 34.362038981006116],
              [126.6453565819723, 34.35148658767006],
              [126.64480646441702, 34.3438867486198],
              [126.65451641340917, 34.32861868902466],
              [126.65406451340188, 34.328343775037325],
            ],
          ],
          [
            [
              [126.94355082978596, 34.41260099680857],
              [126.94315843853336, 34.402885735353344],
              [126.93051558189995, 34.39060489322768],
              [126.92124940296803, 34.39465971244903],
              [126.91655172930673, 34.391411664830606],
              [126.90610276980797, 34.39931032529256],
              [126.89381992987148, 34.39581617718395],
              [126.88495546895454, 34.403520203494686],
              [126.87948318437995, 34.40087878572978],
              [126.86473911119158, 34.41074794987209],
              [126.8620912724334, 34.406895526152695],
              [126.87156785656211, 34.400331466764776],
              [126.8641649410774, 34.37251406004478],
              [126.87033687467124, 34.3684562804785],
              [126.88861731341044, 34.36535812712309],
              [126.89471166572679, 34.36005033867172],
              [126.91811287098199, 34.356319483650275],
              [126.92419000742096, 34.36081240816039],
              [126.92869308573073, 34.37079258169162],
              [126.93725652038127, 34.365582028084745],
              [126.94730833836064, 34.36786665252385],
              [126.94749795616791, 34.37754167141324],
              [126.94175126300195, 34.38150692738993],
              [126.94316656488625, 34.39547243038665],
              [126.95111035056267, 34.403846511830544],
              [126.94355082978596, 34.41260099680857],
            ],
          ],
          [
            [
              [127.24425774239359, 34.41412091144418],
              [127.24462141014295, 34.40472807624309],
              [127.2506011271722, 34.40469759907005],
              [127.25434135437246, 34.39716758166791],
              [127.2511054279445, 34.39111628942961],
              [127.2607872566529, 34.38155724678263],
              [127.2668655132891, 34.38265382989081],
              [127.26567456269322, 34.39415416459048],
              [127.25904895305415, 34.395526838061386],
              [127.25726452302399, 34.40668747496679],
              [127.24959291332021, 34.407952157007344],
              [127.24425774239359, 34.41412091144418],
            ],
          ],
          [
            [
              [125.28780723641727, 34.4009500210666],
              [125.28735125834544, 34.394554154321206],
              [125.29651291457398, 34.38506605686795],
              [125.30620935664403, 34.383705420726095],
              [125.30947561894742, 34.38890878398546],
              [125.29162462642813, 34.391149447786056],
              [125.28780723641727, 34.4009500210666],
            ],
          ],
          [
            [
              [127.30153943777542, 34.44245373774134],
              [127.29749171429744, 34.43735523388775],
              [127.31151046878276, 34.433076616734084],
              [127.31500664943842, 34.441191122708936],
              [127.30153943777542, 34.44245373774134],
            ],
          ],
          [
            [
              [126.83427545256637, 34.442812882409136],
              [126.81968442715392, 34.438893490706754],
              [126.80088878953143, 34.43145968430985],
              [126.78715230335567, 34.43194514980398],
              [126.77490690025228, 34.42152841886754],
              [126.77162735372849, 34.413764641718316],
              [126.76373141654773, 34.40651388988438],
              [126.76861528703633, 34.400071363664466],
              [126.75565310018942, 34.390403547202354],
              [126.75559170622628, 34.383221989494615],
              [126.77966088179546, 34.38186602117913],
              [126.77239763830678, 34.37512319590094],
              [126.76581627102718, 34.360015938398455],
              [126.77350056923247, 34.35432438717916],
              [126.78156241706336, 34.36276192711478],
              [126.79088021283114, 34.3805388516104],
              [126.80713798489937, 34.383461108940196],
              [126.82811284380766, 34.37981402742756],
              [126.85366110091582, 34.39229337114714],
              [126.86601397182544, 34.3905732828212],
              [126.85580094942051, 34.40831003857806],
              [126.84852989376053, 34.40640942562635],
              [126.82389266745474, 34.4195666898901],
              [126.83528164989407, 34.419936772910326],
              [126.84498223072879, 34.4282724075703],
              [126.83427545256637, 34.442812882409136],
            ],
          ],
          [
            [
              [127.04560521597092, 34.45898724105142],
              [127.03407366662313, 34.45006528961444],
              [127.04013622707566, 34.42079871670186],
              [127.04905540630756, 34.41948538848021],
              [127.05464234544648, 34.43053650917766],
              [127.06128127074759, 34.42600977921242],
              [127.05809603037359, 34.418269865176],
              [127.06289138067177, 34.402789540923],
              [127.07100190952096, 34.41368246274619],
              [127.07539167728874, 34.423543883718565],
              [127.06874573280287, 34.442733568460504],
              [127.0618313956968, 34.45440141841354],
              [127.04967386373788, 34.45197743310833],
              [127.04560521597092, 34.45898724105142],
            ],
          ],
          [
            [
              [127.7947837753822, 34.42858845901734],
              [127.786094211783, 34.41887846043682],
              [127.80009121643008, 34.40993497630845],
              [127.80934616613774, 34.42412717052624],
              [127.80781247805893, 34.43155070720519],
              [127.81092439834127, 34.439934702194975],
              [127.80750867602217, 34.448797119884446],
              [127.79850707705587, 34.444150510751484],
              [127.79144803429288, 34.43572310777777],
              [127.7947837753822, 34.42858845901734],
            ],
          ],
          [
            [
              [127.45666814922973, 34.47618922247013],
              [127.45245324932206, 34.47076371558464],
              [127.4541819118922, 34.46107217802378],
              [127.45941434705969, 34.45132075115078],
              [127.47862631275282, 34.4511651014655],
              [127.4825815762053, 34.4423526892398],
              [127.46597039883368, 34.4398793385474],
              [127.47536735290164, 34.432685135327525],
              [127.48051351396845, 34.43663790538739],
              [127.49368305723712, 34.43105395045347],
              [127.49444665601538, 34.42525954345622],
              [127.48675401739295, 34.41757512659691],
              [127.4917980254029, 34.41175958166943],
              [127.5176649512247, 34.42321130492009],
              [127.53015123125331, 34.422349366427234],
              [127.53815251998886, 34.43287538492358],
              [127.5342702439994, 34.4446333336892],
              [127.53588579119622, 34.4486722821873],
              [127.52078940202107, 34.45330202166538],
              [127.52161863027906, 34.457305569295556],
              [127.50670793910324, 34.47007115842577],
              [127.50554820538484, 34.46374369108293],
              [127.49041613696377, 34.46546996535112],
              [127.47249848040568, 34.46433332337437],
              [127.46671522208825, 34.47105422429174],
              [127.45666814922973, 34.47618922247013],
            ],
          ],
          [
            [
              [127.44623211447801, 34.48344774331397],
              [127.43645040459428, 34.47253796335029],
              [127.44574591624541, 34.47182905540297],
              [127.44623211447801, 34.48344774331397],
            ],
          ],
          [
            [
              [127.21749978088815, 34.49512647255984],
              [127.19935682026328, 34.48761248495577],
              [127.18821231861538, 34.49388932660778],
              [127.15722436944799, 34.477996243916245],
              [127.15207879900038, 34.47982985332924],
              [127.1427431601842, 34.472755051842036],
              [127.13611435970296, 34.47273038988702],
              [127.12810987162389, 34.47858719671969],
              [127.12309131207965, 34.48652030211372],
              [127.11307928054985, 34.47570116722093],
              [127.09844889351074, 34.466165210655966],
              [127.1060340428777, 34.45560170776696],
              [127.10786467746723, 34.44702840957417],
              [127.11482179770908, 34.440388567059465],
              [127.12402761091359, 34.436894499017036],
              [127.12435244979493, 34.431699760198654],
              [127.14299021932494, 34.426121953581884],
              [127.1449857546055, 34.429612316911076],
              [127.17010028102185, 34.43530022862784],
              [127.17758197407389, 34.43153348887294],
              [127.20671534039565, 34.430226504389914],
              [127.21650484530355, 34.43616824413709],
              [127.22240380928874, 34.456385427939644],
              [127.22913596508933, 34.471002484445215],
              [127.23510538816129, 34.475777579533464],
              [127.23407407870342, 34.482618404597595],
              [127.21749978088815, 34.49512647255984],
            ],
          ],
          [
            [
              [127.79738581213581, 34.4811597126814],
              [127.80495817235915, 34.48323740828125],
              [127.8125594486065, 34.47764795761733],
              [127.8211281414244, 34.47651088506483],
              [127.82325910764872, 34.482574244176284],
              [127.81264040181387, 34.49143316432571],
              [127.79856261021509, 34.487409010212126],
              [127.79738581213581, 34.4811597126814],
            ],
          ],
          [
            [
              [126.05700955194315, 34.49682226567499],
              [126.04523203431032, 34.488878061558154],
              [126.03929207901969, 34.475910641396155],
              [126.04355274428859, 34.46122079244331],
              [126.05709203053236, 34.479375878343426],
              [126.0598116783712, 34.48899042382504],
              [126.05700955194315, 34.49682226567499],
            ],
          ],
          [
            [
              [127.12946495595973, 34.52310630775785],
              [127.12235523429139, 34.51237853316332],
              [127.10365140747957, 34.515095299125086],
              [127.09775747653471, 34.50994819933759],
              [127.13032943474239, 34.50617308545398],
              [127.13504816421211, 34.520074010420814],
              [127.12946495595973, 34.52310630775785],
            ],
          ],
          [
            [
              [127.4603151158627, 34.54497081137262],
              [127.44754580589807, 34.537774641227806],
              [127.44009391198479, 34.5242528463308],
              [127.45514833917956, 34.51158668905698],
              [127.45066918003124, 34.50014696676173],
              [127.44164770347449, 34.493339610995335],
              [127.45145949717991, 34.48279168068741],
              [127.46756003192814, 34.48630477687908],
              [127.48127886299034, 34.48391717575786],
              [127.48806614935357, 34.489823935293664],
              [127.49322244991758, 34.4841365072729],
              [127.5067706808196, 34.491860673633525],
              [127.49914428463975, 34.50216108334355],
              [127.48932308779061, 34.50813957383798],
              [127.46132147670572, 34.51083700007736],
              [127.46281131749816, 34.517028027881274],
              [127.46990609673735, 34.52341670359431],
              [127.47868776403517, 34.53724044835699],
              [127.4729166562148, 34.54414982657713],
              [127.4603151158627, 34.54497081137262],
            ],
          ],
          [
            [
              [127.76724791699056, 34.511158144451],
              [127.78154216161325, 34.51146791507716],
              [127.77986733311069, 34.52012662929789],
              [127.76296665104572, 34.53355236010445],
              [127.76244493678045, 34.544019297317],
              [127.75684969429084, 34.54935008518595],
              [127.74007454618882, 34.55295639284484],
              [127.72525563925944, 34.54692883760181],
              [127.70158948898327, 34.53279758596554],
              [127.71294157338158, 34.52995289127897],
              [127.7209717242888, 34.52324916049342],
              [127.73254707125449, 34.527409079315966],
              [127.72874835270792, 34.5134850570083],
              [127.73758383771457, 34.51274230080176],
              [127.73853428753178, 34.50283411072282],
              [127.7610830306104, 34.49962020999675],
              [127.76728305430795, 34.496501473758975],
              [127.7707509312258, 34.48879589050531],
              [127.79058672889671, 34.48777655444231],
              [127.79226992460593, 34.50109603883863],
              [127.7863743295575, 34.506372363767404],
              [127.77192167883081, 34.506879974310976],
              [127.76724791699056, 34.511158144451],
            ],
          ],
          [
            [
              [127.72555649852417, 34.57927374467906],
              [127.70992817071959, 34.57605376535466],
              [127.72322186898782, 34.568642360196435],
              [127.72555649852417, 34.57927374467906],
            ],
          ],
          [
            [
              [127.6893489154924, 34.57008985325387],
              [127.690218253589, 34.56506481737986],
              [127.70082816947648, 34.56525293409007],
              [127.69671114659612, 34.57479349518751],
              [127.69044305432139, 34.57674986065238],
              [127.68090577417972, 34.5697535039898],
              [127.67052999960579, 34.58018352798945],
              [127.6604051319853, 34.585475421535136],
              [127.64917165438328, 34.58143166292212],
              [127.63806534533161, 34.57316680570601],
              [127.64714725962403, 34.5683704565968],
              [127.64827367397832, 34.5583104096166],
              [127.65959202671196, 34.554061213766786],
              [127.6780008224224, 34.566778293555195],
              [127.6893489154924, 34.57008985325387],
            ],
          ],
          [
            [
              [127.736696627192, 34.586575686473026],
              [127.7312494884991, 34.59484379681758],
              [127.72177046597999, 34.58875838098892],
              [127.73404733217228, 34.574256124708945],
              [127.7432753594356, 34.583042019944834],
              [127.736696627192, 34.586575686473026],
            ],
          ],
          [
            [
              [126.25029616654638, 34.5878004158118],
              [126.24052367324084, 34.586756098724145],
              [126.24469047876056, 34.57972081259114],
              [126.2402332567509, 34.571215148369824],
              [126.25082725654646, 34.56117230714368],
              [126.23590319800148, 34.53635965161928],
              [126.2182770361671, 34.53224080170939],
              [126.21275095637706, 34.52423701826982],
              [126.2232108823916, 34.516256638427194],
              [126.20404990601901, 34.514947609715904],
              [126.1981822207009, 34.5094998644019],
              [126.2077752586287, 34.500138890986555],
              [126.20537751242034, 34.49596151247832],
              [126.19142995542782, 34.49391431214656],
              [126.18843419994369, 34.5003009557002],
              [126.17930353958039, 34.502295431715325],
              [126.17271526632516, 34.48454952632326],
              [126.15945978367138, 34.482359247777275],
              [126.14660979807584, 34.47662608968643],
              [126.14286911853489, 34.470634536897336],
              [126.13344936537496, 34.46517403305553],
              [126.12705427568103, 34.46539739667527],
              [126.11918393793165, 34.459454743486546],
              [126.12691134143459, 34.452753924769205],
              [126.10173256261402, 34.44082655427821],
              [126.09349572443821, 34.42767648074903],
              [126.09333763717663, 34.41617006827327],
              [126.09934944113913, 34.401729672313294],
              [126.11739357166479, 34.38023301213353],
              [126.1303294734694, 34.38560369845385],
              [126.14328125826034, 34.38518577105396],
              [126.13623383611713, 34.364246678096166],
              [126.15093671289263, 34.36687305936209],
              [126.16107405795702, 34.35387118978781],
              [126.17401160260155, 34.35237912073012],
              [126.19033663573973, 34.35718642681064],
              [126.20241657253378, 34.35796448047808],
              [126.21062065216398, 34.36218416960347],
              [126.20847356774485, 34.371891084669585],
              [126.22163002947684, 34.36769679191936],
              [126.22426183706904, 34.370490717804564],
              [126.23886905760818, 34.37063271119419],
              [126.24668383885552, 34.37985303611659],
              [126.26252990425078, 34.37873252898498],
              [126.26068531840382, 34.39289390453234],
              [126.26549867488258, 34.39743636308858],
              [126.28959815418591, 34.393549090008094],
              [126.29673423654599, 34.398473844906555],
              [126.29138069082, 34.4028956043787],
              [126.29274479022952, 34.40907140078321],
              [126.30996548445287, 34.40672751117534],
              [126.31650760110327, 34.41999880500675],
              [126.32481130328267, 34.408168648109736],
              [126.32425862002346, 34.3998453981205],
              [126.33657908414955, 34.40055892089833],
              [126.33536926716938, 34.414131435194584],
              [126.3516246151512, 34.426475739210034],
              [126.3516123001139, 34.43138241160818],
              [126.3653800073091, 34.442997269298964],
              [126.35792936351633, 34.45623862916115],
              [126.37101930818893, 34.46595088174406],
              [126.37144117422254, 34.471225645495565],
              [126.35855047913947, 34.47467897282254],
              [126.36352139498531, 34.48485748565278],
              [126.37883134170983, 34.48606791711883],
              [126.37898363596061, 34.492412965531265],
              [126.37270626177192, 34.500743177137835],
              [126.38281097774225, 34.50531473565833],
              [126.37687994293915, 34.51292777765097],
              [126.36912207586485, 34.51459396590567],
              [126.36192910345655, 34.524893992577304],
              [126.35116506138512, 34.52749577373904],
              [126.33854763729695, 34.54819531254579],
              [126.32640917353791, 34.54625213604095],
              [126.32462664619673, 34.5405238010491],
              [126.3141799537942, 34.54371336030531],
              [126.3109910643117, 34.55054254718925],
              [126.30061485489477, 34.55637437309237],
              [126.30802871386115, 34.55992533453719],
              [126.3038138682747, 34.57070401901404],
              [126.28235560572791, 34.57645602102519],
              [126.27778468058888, 34.58136741216677],
              [126.2664052943283, 34.581948597333245],
              [126.25029616654638, 34.5878004158118],
            ],
          ],
          [
            [
              [127.53300075173686, 34.599650188738366],
              [127.54948121991771, 34.59602471905538],
              [127.55121256952026, 34.602253536473015],
              [127.56488985536889, 34.60405777482966],
              [127.56418507839032, 34.612181642608824],
              [127.55086556971862, 34.61806364803252],
              [127.54029932410991, 34.61162434589245],
              [127.5266879959929, 34.61705047540078],
              [127.52445944824275, 34.60819389858061],
              [127.53300075173686, 34.599650188738366],
            ],
          ],
          [
            [
              [127.65193632585515, 34.60398666404558],
              [127.65193666027248, 34.587351283109044],
              [127.65863209451724, 34.59283731107201],
              [127.65193632585515, 34.60398666404558],
            ],
          ],
          [
            [
              [127.09856050168112, 34.609848421210486],
              [127.08927896420396, 34.6042533989697],
              [127.09132777495458, 34.596415925598556],
              [127.10874278248362, 34.599565664413404],
              [127.09856050168112, 34.609848421210486],
            ],
          ],
          [
            [
              [125.98563711711051, 34.6014227682961],
              [125.97115810208741, 34.60035410854022],
              [125.97486364954747, 34.59031797042531],
              [125.96746385966202, 34.58032361073946],
              [125.9756022160996, 34.57865373855559],
              [125.97758129625463, 34.59104758804114],
              [125.97474256763904, 34.594832160787924],
              [125.98563711711051, 34.6014227682961],
            ],
          ],
          [
            [
              [127.63515788580449, 34.62453704473183],
              [127.62616829639568, 34.61929709961293],
              [127.6251646319183, 34.614368233034405],
              [127.63324209058932, 34.60746286652614],
              [127.65024017530348, 34.615696154740505],
              [127.63515788580449, 34.62453704473183],
            ],
          ],
          [
            [
              [126.05688131024293, 34.63044773161874],
              [126.05066587346354, 34.62985033467255],
              [126.04829078303547, 34.6101329729386],
              [126.05937303092726, 34.6128020479438],
              [126.06772987286901, 34.60345152212207],
              [126.0686009406109, 34.59404511416464],
              [126.07446540238946, 34.584353199254075],
              [126.08519968837429, 34.57979185945764],
              [126.07281729165781, 34.57091428657496],
              [126.06445131319208, 34.55970152600222],
              [126.04309951713888, 34.56522281228231],
              [126.03147291434937, 34.56157368248831],
              [126.02590642223777, 34.55439143897388],
              [126.03380182691204, 34.55215533946144],
              [126.04013269938109, 34.55837117431277],
              [126.06140211377111, 34.55394371962161],
              [126.03846151500628, 34.537597925185196],
              [126.03302928153106, 34.542893215359264],
              [126.02612891455377, 34.53616309348561],
              [126.03113548728712, 34.53258821126267],
              [126.04136247935263, 34.533900194144934],
              [126.0513134832971, 34.5314321625639],
              [126.06198096480958, 34.53329233105213],
              [126.06650313997525, 34.53776433772222],
              [126.07718391701567, 34.54066118218974],
              [126.08559955249343, 34.5466736109468],
              [126.08192837148015, 34.55500643795672],
              [126.09890843827924, 34.55496640726218],
              [126.09745956245305, 34.56668778472158],
              [126.09177902573957, 34.56878329071606],
              [126.1027003160401, 34.583504879126295],
              [126.1099167097935, 34.58642015616202],
              [126.0984142677451, 34.596712171457305],
              [126.10277844619132, 34.605554099591735],
              [126.09364656304162, 34.60611463999032],
              [126.08306534595941, 34.61328558381615],
              [126.0829722875434, 34.618275982079915],
              [126.07413184561659, 34.6263895632542],
              [126.05857701118059, 34.62745513087683],
              [126.05688131024293, 34.63044773161874],
            ],
          ],
          [
            [
              [125.85431006654873, 34.62927785554746],
              [125.84635002397215, 34.62691092427293],
              [125.83645646955286, 34.618271904201976],
              [125.82630151555568, 34.61347759500969],
              [125.82548124736144, 34.60302706783424],
              [125.80935945179486, 34.60194311591445],
              [125.80887712895625, 34.59437873834795],
              [125.81605868566527, 34.59187596915336],
              [125.82171526748844, 34.598224076506334],
              [125.84364557071407, 34.59435589011553],
              [125.8547746538234, 34.6035718908349],
              [125.8616197532813, 34.604087516150784],
              [125.85431006654873, 34.62927785554746],
            ],
          ],
          [
            [
              [126.00388772937315, 34.62840250137492],
              [125.99432012373465, 34.62585782166168],
              [125.98772895506859, 34.615731708977236],
              [126.00162758213746, 34.61015095679529],
              [126.01004830133846, 34.61687583068799],
              [126.00388772937315, 34.62840250137492],
            ],
          ],
          [
            [
              [126.01720002765956, 34.63482447001762],
              [126.01027965946227, 34.63029037739305],
              [126.01688274875352, 34.61846945804066],
              [126.01100437566254, 34.60576733022835],
              [126.01964128522701, 34.600687466981896],
              [126.02694228712264, 34.591832626815105],
              [126.0147183945872, 34.58519209750741],
              [126.02272922675945, 34.5745856598317],
              [126.01906075753858, 34.5648248619973],
              [126.02936099208456, 34.56559255435007],
              [126.03641061102651, 34.57578438494506],
              [126.04279858148551, 34.56897539170705],
              [126.06078939882849, 34.571996286142365],
              [126.06156170821794, 34.59068039573462],
              [126.05248369388853, 34.60172685559906],
              [126.04479332227343, 34.602073379303924],
              [126.03320581968084, 34.61105410167288],
              [126.0397877339265, 34.621946685292734],
              [126.03944742117177, 34.629950926449986],
              [126.01720002765956, 34.63482447001762],
            ],
          ],
          [
            [
              [125.96207258750351, 34.64273834104504],
              [125.94687540953912, 34.63542479990944],
              [125.95784336615695, 34.62393983461119],
              [125.96457601002135, 34.630001913781214],
              [125.9706410185178, 34.62014670052943],
              [125.97937288414923, 34.62493436774429],
              [125.97469954166182, 34.63460048553031],
              [125.96207258750351, 34.64273834104504],
            ],
          ],
          [
            [
              [125.46792001728026, 34.65555989487748],
              [125.46217115539187, 34.65300104930021],
              [125.45999674340528, 34.643212472887555],
              [125.46718900197554, 34.64220726227799],
              [125.47729598782547, 34.648734578127055],
              [125.46792001728026, 34.65555989487748],
            ],
          ],
          [
            [
              [126.04752879526067, 34.667013381424894],
              [126.04473424612121, 34.65348165911519],
              [126.0514017768234, 34.65303599822725],
              [126.04752879526067, 34.667013381424894],
            ],
          ],
          [
            [
              [126.15400739785157, 34.67202504784484],
              [126.14764696945316, 34.67031752088907],
              [126.1414092819125, 34.662263443218734],
              [126.11622795473542, 34.652501205933866],
              [126.11447849891215, 34.646781872629866],
              [126.13232014933727, 34.64172403306052],
              [126.1248056986094, 34.63045255770801],
              [126.12980325393734, 34.62105898901862],
              [126.14313303882047, 34.6188373295097],
              [126.16319148834444, 34.62855677654354],
              [126.17506860623037, 34.62185099239811],
              [126.18070765944331, 34.630373377897065],
              [126.20015227337974, 34.63696364996739],
              [126.19975677777902, 34.641808340282566],
              [126.18470330193996, 34.638302426232805],
              [126.18251296025197, 34.64444532017103],
              [126.18737532010674, 34.65043568167664],
              [126.15400739785157, 34.67202504784484],
            ],
          ],
          [
            [
              [125.37509731805045, 34.679862162998596],
              [125.36298138710966, 34.67513304682192],
              [125.37025591411539, 34.66696104279351],
              [125.37818661487012, 34.67577360444764],
              [125.37509731805045, 34.679862162998596],
            ],
          ],
          [
            [
              [127.4283726949276, 34.70170769541441],
              [127.43114577273244, 34.690481338060394],
              [127.4445686319964, 34.68995011640483],
              [127.43958674047796, 34.69740204982529],
              [127.4283726949276, 34.70170769541441],
            ],
          ],
          [
            [
              [126.19364539444878, 34.70487102077313],
              [126.18473180554248, 34.70104859478546],
              [126.17759603392108, 34.68799631216134],
              [126.16773844528669, 34.6899331851469],
              [126.16350326840103, 34.68419527602745],
              [126.17050194502066, 34.67958327939043],
              [126.1861114366754, 34.68497247546714],
              [126.19653570808701, 34.68550160293264],
              [126.19264500164319, 34.69720576441921],
              [126.19364539444878, 34.70487102077313],
            ],
          ],
          [
            [
              [125.40578156987966, 34.680257333317826],
              [125.39737384711945, 34.67413407514223],
              [125.39727986821521, 34.66109476185169],
              [125.38883789505309, 34.660177906314885],
              [125.39101667905953, 34.650870171999436],
              [125.38756045558388, 34.6420965138311],
              [125.40329500163514, 34.628866537013266],
              [125.40991521593718, 34.63168223642007],
              [125.41164336645389, 34.643114318138714],
              [125.42446052805658, 34.64619468770521],
              [125.42040249774723, 34.65938760330522],
              [125.42482086903215, 34.66297655974089],
              [125.43579428381211, 34.66192549442924],
              [125.43613706453938, 34.667531156407584],
              [125.45216610275105, 34.68870195019214],
              [125.44543201498472, 34.692498005191325],
              [125.44189546906927, 34.684107100714115],
              [125.42977118459252, 34.68449130032395],
              [125.4303096083115, 34.69632698758939],
              [125.4159156582903, 34.69826627793984],
              [125.40896746017611, 34.6937702055836],
              [125.41038880551997, 34.68742170591727],
              [125.40578156987966, 34.680257333317826],
            ],
          ],
          [
            [
              [126.110253867712, 34.712653974610305],
              [126.10193909042758, 34.711552042832395],
              [126.09400911808905, 34.70461006099032],
              [126.10361235437924, 34.69789121715731],
              [126.11409649945772, 34.707492334145044],
              [126.110253867712, 34.712653974610305],
            ],
          ],
          [
            [
              [126.12300788650828, 34.71309208087275],
              [126.12620909207206, 34.703754179428955],
              [126.13684687244145, 34.70676230625085],
              [126.13075328216611, 34.71243117245397],
              [126.12300788650828, 34.71309208087275],
            ],
          ],
          [
            [
              [127.72540901440301, 34.72177042354663],
              [127.71855168469669, 34.7186655619204],
              [127.7198731482422, 34.70624934248298],
              [127.73179358544347, 34.699917658297586],
              [127.74232084586455, 34.70461189689408],
              [127.72820683984976, 34.70964376438741],
              [127.72540901440301, 34.72177042354663],
            ],
          ],
          [
            [
              [127.743633654269, 34.665277683854875],
              [127.72913433422943, 34.655957636138886],
              [127.72382674049256, 34.6556406153577],
              [127.71660492993973, 34.64382309363277],
              [127.7246143706593, 34.63754089651286],
              [127.72144777612073, 34.63030853610292],
              [127.7104702927858, 34.62309843257701],
              [127.7182091417898, 34.61539038186324],
              [127.73640655587825, 34.611655440887986],
              [127.73939681786472, 34.6031890224075],
              [127.74954597494995, 34.59292042638779],
              [127.76559066838271, 34.59310864321991],
              [127.77108508089972, 34.587730211482906],
              [127.77843464357942, 34.58996577693579],
              [127.78992937696565, 34.584881421763704],
              [127.80547589428465, 34.59133884401378],
              [127.80253855136142, 34.60128548430968],
              [127.78867778352995, 34.60518633039245],
              [127.792153117343, 34.61192483716885],
              [127.788927580135, 34.617251284587944],
              [127.79958321747877, 34.63055936580208],
              [127.79607834900189, 34.64303689052828],
              [127.79793027161656, 34.65512069288132],
              [127.79536342588133, 34.666904194594224],
              [127.78472174088012, 34.67001172422729],
              [127.7770507059993, 34.67897926148584],
              [127.78118588355608, 34.6904260172148],
              [127.77606090835019, 34.697300923857405],
              [127.76583278157963, 34.69426558170059],
              [127.75897853227536, 34.70386051311622],
              [127.76604246084419, 34.71109012601563],
              [127.78822701887766, 34.70016279917954],
              [127.79028729104068, 34.70623600616287],
              [127.78365979808565, 34.71678778577295],
              [127.77290810625087, 34.72412971248669],
              [127.76572968222959, 34.72523603874673],
              [127.75559694742442, 34.73148346289884],
              [127.73952883846333, 34.73349772007501],
              [127.74694362769353, 34.71463314643231],
              [127.7566219516198, 34.706921032987395],
              [127.75617247236204, 34.69621334056941],
              [127.76132330251247, 34.68434445588673],
              [127.75399554372538, 34.68181956391307],
              [127.743633654269, 34.665277683854875],
            ],
          ],
          [
            [
              [125.20151920055365, 34.71184508314912],
              [125.19986619199602, 34.70257440575413],
              [125.19460849600496, 34.69811262776703],
              [125.19274557873753, 34.688250825945175],
              [125.1764508419778, 34.68001221297345],
              [125.18143057127821, 34.66737914189515],
              [125.19331515837115, 34.68443028149795],
              [125.20237545992183, 34.68190356922899],
              [125.20782748660505, 34.689265862443634],
              [125.21332187495887, 34.704682070493696],
              [125.21164091363777, 34.71586778079674],
              [125.20151920055365, 34.71184508314912],
            ],
          ],
          [
            [
              [125.96274248548626, 34.73691757898286],
              [125.94786074733604, 34.72227761751985],
              [125.94684502842588, 34.71475369217228],
              [125.93287913476642, 34.7155927188629],
              [125.9278893818319, 34.71220776697572],
              [125.91565444705815, 34.71139781076367],
              [125.91737086203679, 34.701078553116986],
              [125.91464009006087, 34.68949188689793],
              [125.91582630715303, 34.68086688102419],
              [125.92279258640686, 34.677079132249546],
              [125.93322926393051, 34.679843058315164],
              [125.93388817739708, 34.67077502102368],
              [125.9400021063983, 34.66493857789838],
              [125.9479934391811, 34.67229349963],
              [125.95818129340532, 34.66888119319908],
              [125.95308058146964, 34.66132783663824],
              [125.95902877536913, 34.6563289697034],
              [125.9741878188781, 34.65916594591189],
              [125.97840588914623, 34.662644618247036],
              [125.97995998486748, 34.6733726798926],
              [125.9875607207744, 34.67562782775097],
              [126.00994301451696, 34.68839079487392],
              [126.01063314104758, 34.702925985633726],
              [125.9997700313097, 34.70270526970144],
              [125.99040457606796, 34.71069882089229],
              [125.99054791268205, 34.719189084235495],
              [125.96838928044149, 34.72693566770691],
              [125.96274248548626, 34.73691757898286],
            ],
          ],
          [
            [
              [126.0156131227041, 34.748451282807444],
              [126.01373755213831, 34.737672343894],
              [126.01942106639726, 34.73083622448129],
              [126.02947913890716, 34.727562181793346],
              [126.02219114954472, 34.74508886520191],
              [126.0156131227041, 34.748451282807444],
            ],
          ],
          [
            [
              [125.45842939071375, 34.7419493736184],
              [125.4631521988634, 34.7308592113426],
              [125.45480468660455, 34.72841473531698],
              [125.45524869222655, 34.72085791115579],
              [125.47312253863326, 34.72878455303231],
              [125.45842939071375, 34.7419493736184],
            ],
          ],
          [
            [
              [126.01876830095921, 34.765717975982426],
              [126.0226546929173, 34.75369495900416],
              [126.0285374991081, 34.75964344818715],
              [126.01876830095921, 34.765717975982426],
            ],
          ],
          [
            [
              [126.08974576694224, 34.77411375999138],
              [126.08871595038488, 34.767203473271636],
              [126.07762162837537, 34.76176432148786],
              [126.08203092760941, 34.74997487378777],
              [126.07115890702765, 34.74163963950509],
              [126.07032749732356, 34.737336955472756],
              [126.08174283532163, 34.71962681448101],
              [126.08763499686032, 34.71860816193279],
              [126.110279647137, 34.72198356116797],
              [126.11794124963326, 34.71496421632569],
              [126.12399767531595, 34.72469212698242],
              [126.13701742291026, 34.72868215872297],
              [126.13815475679084, 34.722512588517965],
              [126.1461686571909, 34.71818487642596],
              [126.15342893191568, 34.70355296442065],
              [126.1675915565346, 34.69982925839971],
              [126.17782683143925, 34.706266219260215],
              [126.17649684075253, 34.71662839450559],
              [126.18259609213476, 34.723851077708595],
              [126.17133766147514, 34.74934119943085],
              [126.15665498826489, 34.75799438956053],
              [126.14414345120976, 34.75167702638902],
              [126.13500643524131, 34.755800899320846],
              [126.12481473120876, 34.77084531769758],
              [126.10571362177136, 34.766059369516796],
              [126.08974576694224, 34.77411375999138],
            ],
          ],
          [
            [
              [126.3556138401118, 34.77999030824394],
              [126.3587035355952, 34.771968871951294],
              [126.35875643210468, 34.75967586324193],
              [126.35041979065868, 34.76166264217958],
              [126.35045663036836, 34.750578717269164],
              [126.35989672119662, 34.74526240339713],
              [126.36425423349922, 34.75990170852419],
              [126.37482640264497, 34.77118562847074],
              [126.3556138401118, 34.77999030824394],
            ],
            [
              [126.35808252540996, 34.77479722413737],
              [126.36547717200499, 34.76341709227564],
              [126.35920979001808, 34.759664463510795],
              [126.35808252540996, 34.77479722413737],
            ],
          ],
          [
            [
              [126.32104603527807, 34.78821843448837],
              [126.31421361993473, 34.780759013346255],
              [126.30811973845475, 34.780473686633734],
              [126.30465444068835, 34.76825223390229],
              [126.30962346106338, 34.761506243609205],
              [126.3185676070738, 34.75922558575743],
              [126.32228890628353, 34.77367160183967],
              [126.32851035638694, 34.78180528263934],
              [126.32104603527807, 34.78821843448837],
            ],
          ],
          [
            [
              [127.46332942550968, 34.80521015797963],
              [127.4600478987979, 34.792466791534515],
              [127.4504837147782, 34.79552250823222],
              [127.44561283045098, 34.78041141989526],
              [127.45428325365194, 34.78246792324577],
              [127.4524187192011, 34.78908443575464],
              [127.4696006763199, 34.79577936306227],
              [127.46332942550968, 34.80521015797963],
            ],
          ],
          [
            [
              [125.99425172108432, 34.80528249934709],
              [125.97315708691849, 34.79808492739034],
              [125.96611560276321, 34.78853182388057],
              [125.9394675481089, 34.776700862670005],
              [125.92823279869334, 34.77488529505712],
              [125.91250660707587, 34.77556190502639],
              [125.90166637609289, 34.77948053667163],
              [125.9001511587102, 34.76900367251537],
              [125.89228408198952, 34.76792100315972],
              [125.89556160578988, 34.7599629195406],
              [125.89090556033483, 34.7549611662987],
              [125.88744242948968, 34.73857542159849],
              [125.90551048725992, 34.72173162040916],
              [125.91725687650819, 34.71667846694183],
              [125.92698861481662, 34.72102621826538],
              [125.94035019999167, 34.722677547128754],
              [125.94361949508787, 34.73686322348189],
              [125.93620699205619, 34.74743091086074],
              [125.93887129812127, 34.754711848616616],
              [125.94937978814828, 34.757605734210394],
              [125.96380298122297, 34.75331191443908],
              [125.97713098734111, 34.753603380455765],
              [125.98348654490783, 34.7607733383242],
              [125.99821058763327, 34.76176456158164],
              [125.99961468491828, 34.77123647091869],
              [125.98540055377859, 34.77525471482487],
              [125.99331543055635, 34.780798963140505],
              [126.00065850123072, 34.79406544031838],
              [125.99425172108432, 34.80528249934709],
            ],
          ],
          [
            [
              [126.14876080402148, 34.81167526300862],
              [126.14435521245399, 34.80602235405536],
              [126.14769025858337, 34.79736734642357],
              [126.1367892753413, 34.799675271104604],
              [126.12976682515352, 34.79622085318084],
              [126.10007468273014, 34.79198887045251],
              [126.09308383809605, 34.78818934110822],
              [126.10440944077243, 34.77837853271112],
              [126.12146547948761, 34.78159765937046],
              [126.12765911940062, 34.780478688909135],
              [126.14121393104324, 34.761085923865494],
              [126.16506874891023, 34.76729092225595],
              [126.16352575262097, 34.779673970894414],
              [126.15713158406771, 34.78157623474025],
              [126.16143117493219, 34.79089044611208],
              [126.15240144014034, 34.80121623722474],
              [126.14876080402148, 34.81167526300862],
            ],
          ],
          [
            [
              [126.32677441008013, 34.81566122869338],
              [126.31547405135453, 34.8059008878507],
              [126.32150758218833, 34.7957782849454],
              [126.33089179652795, 34.79964157703696],
              [126.33109367523171, 34.81238065164467],
              [126.32677441008013, 34.81566122869338],
            ],
          ],
          [
            [
              [126.04892219450907, 34.82499284768686],
              [126.04474522846337, 34.81962465274677],
              [126.06660895867147, 34.80179661616591],
              [126.0748075855648, 34.80095079213888],
              [126.07359138799235, 34.81249188235856],
              [126.06490198861005, 34.81832790311402],
              [126.04892219450907, 34.82499284768686],
            ],
          ],
          [
            [
              [126.37851015119, 34.87800159652169],
              [126.36620921159785, 34.877102469364196],
              [126.3607034802958, 34.873616584856045],
              [126.36640523201005, 34.86586642943806],
              [126.37851015119, 34.87800159652169],
            ],
          ],
          [
            [
              [126.11558435516191, 34.881951005561596],
              [126.10936041233917, 34.86813401125906],
              [126.11622889599758, 34.85824120394961],
              [126.11523773712766, 34.85063417840315],
              [126.10284488041157, 34.85090875378212],
              [126.08180196454302, 34.85930355370318],
              [126.07308724034614, 34.85045289435158],
              [126.05853922067088, 34.84959387565403],
              [126.06095060308671, 34.84386363668667],
              [126.07615969563555, 34.828517058345355],
              [126.07710312599323, 34.82217935551831],
              [126.09652585818428, 34.80596496501049],
              [126.09416719117819, 34.797098512916676],
              [126.11752977549357, 34.80016365655638],
              [126.12288774443091, 34.811210645106236],
              [126.11725334025607, 34.81665604987546],
              [126.11412574624165, 34.82618191177061],
              [126.12445889881069, 34.83603906142318],
              [126.13889713210284, 34.83022456016041],
              [126.13952386627996, 34.835797134987466],
              [126.14898130136282, 34.83974653008664],
              [126.14782104319796, 34.848208190188295],
              [126.13491445641185, 34.85133196807076],
              [126.13523583628617, 34.86246044299303],
              [126.14887405346458, 34.85907549956655],
              [126.15707910591999, 34.86633650760823],
              [126.1475126599963, 34.8731913783147],
              [126.13130598197884, 34.875457544828784],
              [126.11558435516191, 34.881951005561596],
            ],
          ],
          [
            [
              [127.7275297613026, 34.89189699848351],
              [127.71636215474884, 34.8990716315645],
              [127.69827556241886, 34.89254301556331],
              [127.69259699898079, 34.8818766664986],
              [127.70029854659629, 34.87744150358119],
              [127.70437251487589, 34.870625420982485],
              [127.71431226959656, 34.87237184110615],
              [127.7171882674821, 34.86818607160192],
              [127.72765168754086, 34.874374093024606],
              [127.74611336637315, 34.873361713585105],
              [127.75068047161133, 34.87803727733182],
              [127.74503563139598, 34.89123566108783],
              [127.7275297613026, 34.89189699848351],
            ],
          ],
          [
            [
              [126.18027052563848, 34.902334713800265],
              [126.18062539962852, 34.89120503956751],
              [126.17321777156666, 34.88807631424688],
              [126.1779081974978, 34.88191320243101],
              [126.18840841345194, 34.88911989338835],
              [126.18920051263417, 34.89552609661796],
              [126.18027052563848, 34.902334713800265],
            ],
          ],
          [
            [
              [126.35191932936968, 34.910731304993966],
              [126.34337560466895, 34.90670105248056],
              [126.35115704724363, 34.9008514195904],
              [126.35666054612099, 34.906654334317224],
              [126.35191932936968, 34.910731304993966],
            ],
          ],
          [
            [
              [126.30025020274675, 34.92117145161299],
              [126.29650916161644, 34.9219560709661],
              [126.2807861861755, 34.91054360462213],
              [126.30234678803559, 34.893505370532715],
              [126.30335973849583, 34.88703833676753],
              [126.29283577583337, 34.88123411527157],
              [126.28154271483355, 34.88537548068099],
              [126.27857319392011, 34.872989527311496],
              [126.28441196248154, 34.863350174276555],
              [126.26789460185844, 34.86713784351634],
              [126.26280399574813, 34.857326193452124],
              [126.24198999610363, 34.858975500094914],
              [126.23284257771911, 34.86466907603791],
              [126.22911294924478, 34.85044246743247],
              [126.24671805549681, 34.84569317256624],
              [126.25188379629009, 34.84126390533135],
              [126.26540689567925, 34.84159189672356],
              [126.27659944568671, 34.85583154397853],
              [126.31248534063718, 34.85327274450779],
              [126.33446303792984, 34.84842747797641],
              [126.33937156781705, 34.83855870618887],
              [126.33178611552809, 34.818874415073246],
              [126.34734321040247, 34.81456270988401],
              [126.35772559009273, 34.815469683608555],
              [126.36119035002477, 34.82251852381669],
              [126.36778273113131, 34.82431193298329],
              [126.36494965674994, 34.839078694172045],
              [126.37120074309821, 34.846535051419686],
              [126.35745608334496, 34.86235325401217],
              [126.33754054182067, 34.86416283807234],
              [126.3207739564501, 34.862034861718065],
              [126.32043548686578, 34.87587910216161],
              [126.32616393350624, 34.882397005452155],
              [126.32534773860723, 34.89016330642385],
              [126.34666302684712, 34.89411743085223],
              [126.33824056411144, 34.907810924836845],
              [126.32840322536082, 34.90897253791283],
              [126.31145028919887, 34.907462736059415],
              [126.30025020274675, 34.92117145161299],
            ],
          ],
          [
            [
              [127.67747898171197, 34.92932487464317],
              [127.66555420805761, 34.91831146303602],
              [127.66466302357021, 34.910913286963506],
              [127.67317268101009, 34.90444193448633],
              [127.69317586033847, 34.917032279966],
              [127.67747898171197, 34.92932487464317],
            ],
          ],
          [
            [
              [126.23004105811766, 34.937556297151836],
              [126.22011148759368, 34.92490024717358],
              [126.22307553000869, 34.91546804887111],
              [126.23383813831722, 34.9100872862914],
              [126.23963954237071, 34.91506491696657],
              [126.25147843831392, 34.91857702690832],
              [126.25148614575626, 34.9349582493704],
              [126.23861004864929, 34.93282451287509],
              [126.23004105811766, 34.937556297151836],
            ],
          ],
          [
            [
              [126.08984418332551, 34.90321410165825],
              [126.09580937598534, 34.90842306674655],
              [126.08373825436435, 34.911358465184534],
              [126.08094527049963, 34.91907578615171],
              [126.07447794218784, 34.924330657440045],
              [126.07936946398233, 34.930227970943065],
              [126.06854983303928, 34.93638805323326],
              [126.06031803444017, 34.932033009445476],
              [126.06175495837842, 34.92122092925687],
              [126.0548852990643, 34.911420430329024],
              [126.03427269321946, 34.910781590904584],
              [126.02606741515275, 34.90741104220616],
              [126.01744751121443, 34.909557453941915],
              [126.0038982261014, 34.889037647331655],
              [125.99680832092957, 34.887963093460804],
              [125.99554699659576, 34.88104341700446],
              [125.9879063486772, 34.87457226941568],
              [125.97955221011173, 34.8742528415279],
              [125.9839772999726, 34.86368588281765],
              [125.99823217231358, 34.86610364076356],
              [126.00870915683494, 34.85951767016356],
              [126.02459108793444, 34.86681159702195],
              [126.02408963108832, 34.859172985612446],
              [126.03262271684741, 34.85938745181416],
              [126.0402860804605, 34.84722951292943],
              [126.05013632824492, 34.855104703737304],
              [126.06678978700921, 34.85728780355253],
              [126.06786238575422, 34.86408628756804],
              [126.08250825657625, 34.866464737371],
              [126.07776185074187, 34.8762426816654],
              [126.08969823116495, 34.87572286112028],
              [126.09704780419796, 34.89009988581409],
              [126.08376649955166, 34.89418424203307],
              [126.08984418332551, 34.90321410165825],
            ],
          ],
          [
            [
              [127.73126562338128, 34.95191265907354],
              [127.71529734188029, 34.937991923975595],
              [127.71490535375715, 34.93253999302752],
              [127.70529121267033, 34.93010703096904],
              [127.70536098382527, 34.9134783884054],
              [127.73161064878082, 34.90773151688747],
              [127.76142203882733, 34.90852435000014],
              [127.76193534602419, 34.895631185326344],
              [127.77617129323181, 34.886633718681445],
              [127.78415727766654, 34.886581826997975],
              [127.7844331146427, 34.91550651329029],
              [127.76514975611293, 34.93164008313546],
              [127.73853228185733, 34.93187461732434],
              [127.73537379457191, 34.935192301307104],
              [127.73970252099687, 34.94590086510219],
              [127.73126562338128, 34.95191265907354],
            ],
            [
              [127.76837530430102, 34.91461167893032],
              [127.7830847826748, 34.91130775853487],
              [127.78398093831814, 34.89104510307408],
              [127.77544012044028, 34.891099328324295],
              [127.76656750191026, 34.89621243224689],
              [127.76837530430102, 34.91461167893032],
            ],
          ],
          [
            [
              [126.19954661839415, 34.95001223441738],
              [126.19015773706965, 34.9459451404972],
              [126.19547239991954, 34.939800551691775],
              [126.20591847099676, 34.938269365225864],
              [126.2114476547767, 34.94275474995164],
              [126.19954661839415, 34.95001223441738],
            ],
          ],
          [
            [
              [127.76334604848431, 34.95806066727718],
              [127.76059997043227, 34.96031224501747],
              [127.74646434302925, 34.95498725251816],
              [127.73985455091902, 34.94903948559429],
              [127.74693196199077, 34.93393480957177],
              [127.76851626200221, 34.933803268771186],
              [127.76887759163094, 34.952175188550086],
              [127.76334604848431, 34.95806066727718],
            ],
          ],
          [
            [
              [126.24189481858231, 34.954123823287915],
              [126.23304245786737, 34.95525971512385],
              [126.23479993407719, 34.94565925842819],
              [126.24385291464648, 34.94446874959349],
              [126.24883114042629, 34.95244305109749],
              [126.24189481858231, 34.954123823287915],
            ],
          ],
          [
            [
              [126.15984262232676, 34.959606992461744],
              [126.16106285591165, 34.94382789945535],
              [126.16645615504997, 34.944771911952515],
              [126.15984262232676, 34.959606992461744],
            ],
          ],
          [
            [
              [126.27324830293188, 34.96984939538338],
              [126.26944375028208, 34.96041598812299],
              [126.27373178013309, 34.95261203432453],
              [126.28741479340647, 34.94230733919685],
              [126.28153217174487, 34.9352011642929],
              [126.29111576172782, 34.93244661244234],
              [126.30005481070359, 34.93825887096154],
              [126.28806569948422, 34.96301493496264],
              [126.27324830293188, 34.96984939538338],
            ],
          ],
          [
            [
              [126.21448665441459, 34.98477992056175],
              [126.21185913170319, 34.98016444065394],
              [126.1982208206807, 34.96908507163132],
              [126.20616535609523, 34.95671287376824],
              [126.21451339419886, 34.955122964204136],
              [126.21448665441459, 34.98477992056175],
            ],
          ],
          [
            [
              [126.24863822456753, 35.006263407665614],
              [126.25146330232047, 34.99257199721124],
              [126.25036242819937, 34.98126262848319],
              [126.25486878763601, 34.97338164178184],
              [126.26119210622696, 34.97676360417815],
              [126.27049147621278, 34.976200747717016],
              [126.26708162443094, 34.986248683132644],
              [126.26987719348577, 34.99402589251942],
              [126.2602299211023, 35.00614963823799],
              [126.24863822456753, 35.006263407665614],
            ],
          ],
          [
            [
              [126.13629331436174, 35.02526133657956],
              [126.12352486164268, 35.017674950465015],
              [126.10711728910913, 35.004567270243065],
              [126.10570181259759, 34.99655139458813],
              [126.11544994946452, 34.99607220704811],
              [126.13329752274933, 35.00161187487006],
              [126.13879365425414, 34.99533686844729],
              [126.1358858157924, 34.98411008733137],
              [126.13667831061056, 34.96572591866448],
              [126.12885327426713, 34.95217879163863],
              [126.14337139390601, 34.95776691745433],
              [126.14410047660814, 34.968817172700405],
              [126.15480499529734, 34.968593948352634],
              [126.16294764201605, 34.97162809073764],
              [126.16866372761119, 34.967797343165714],
              [126.1756008719887, 34.97330503675139],
              [126.17971819354372, 34.99445341466942],
              [126.16528187406364, 35.003722454094635],
              [126.1609114804962, 35.017246685946525],
              [126.13629331436174, 35.02526133657956],
            ],
          ],
          [
            [
              [126.1472787034683, 35.0580116551088],
              [126.13552190214129, 35.04819434017084],
              [126.14885760928009, 35.03371929586734],
              [126.16378271371012, 35.03548753792022],
              [126.17037911566486, 35.02724802317654],
              [126.1822637615021, 35.02754781729913],
              [126.18584269550651, 35.02145083120415],
              [126.19638003304736, 35.01785885225824],
              [126.19493067106927, 35.02805727331535],
              [126.20078256658739, 35.038851221950765],
              [126.195770770605, 35.04321600774928],
              [126.1854166088588, 35.04256304193756],
              [126.16946575866635, 35.055557675461294],
              [126.15238770517267, 35.05437246831902],
              [126.1472787034683, 35.0580116551088],
            ],
          ],
          [
            [
              [126.13370750451816, 35.09329088648436],
              [126.13148426893194, 35.08329514193491],
              [126.1473120655119, 35.08452845644355],
              [126.14646192994199, 35.091360589813256],
              [126.13370750451816, 35.09329088648436],
            ],
          ],
          [
            [
              [126.02163226447972, 35.09924175835694],
              [126.01053459097342, 35.09445779542264],
              [126.01181473594566, 35.088009071276225],
              [126.02606005571516, 35.07862204577526],
              [126.03015137742509, 35.08455689619819],
              [126.02163226447972, 35.09924175835694],
            ],
          ],
          [
            [
              [126.151201408582, 35.14632846328621],
              [126.14243109129382, 35.14007390427412],
              [126.13488103558718, 35.14180612987119],
              [126.11767940363582, 35.14014372757261],
              [126.111138661051, 35.13156328467559],
              [126.10340151170334, 35.12754226519284],
              [126.08725987905048, 35.11138312591741],
              [126.07469967586096, 35.104679775225954],
              [126.04944664753904, 35.1022894422194],
              [126.05617717701257, 35.09480918552201],
              [126.0494815539432, 35.09076556095641],
              [126.04805393344245, 35.081459711253885],
              [126.0579813665162, 35.076240131383386],
              [126.06278213243141, 35.0696316741467],
              [126.07019012264938, 35.067049250775206],
              [126.07433458551792, 35.06053644920768],
              [126.09540121329438, 35.05161369146008],
              [126.11352690314729, 35.06382016452957],
              [126.10865970495189, 35.06974574034495],
              [126.11946346242742, 35.07315524236551],
              [126.122750268089, 35.088392045604955],
              [126.11621440008601, 35.096425837197955],
              [126.11653806159052, 35.110252122389525],
              [126.12198080193575, 35.131290180513],
              [126.1278177157668, 35.1366846626642],
              [126.14064506121665, 35.135880770436394],
              [126.151201408582, 35.14632846328621],
            ],
          ],
          [
            [
              [126.20084831388404, 35.14749739311944],
              [126.18661776085258, 35.14253124458738],
              [126.19093653223028, 35.131997505312505],
              [126.20084831388404, 35.14749739311944],
            ],
          ],
          [
            [
              [126.14688980918619, 35.29274269246238],
              [126.13463649176128, 35.28895685826521],
              [126.13222385198388, 35.2820601364201],
              [126.14148938336653, 35.278733801869436],
              [126.14732316180275, 35.27137268236713],
              [126.15422586336157, 35.278393014631135],
              [126.15074989298617, 35.29140656773793],
              [126.14688980918619, 35.29274269246238],
            ],
          ],
          [
            [
              [126.0263465006101, 35.358995994052684],
              [126.01791921266961, 35.35586920586344],
              [126.02124631247302, 35.336389796170124],
              [126.02904873944756, 35.33523295596754],
              [126.03751408766676, 35.34228052233835],
              [126.03674477692091, 35.352630363927005],
              [126.0263465006101, 35.358995994052684],
            ],
          ],
          [
            [
              [127.61394043100664, 34.85807058918018],
              [127.62345780671318, 34.847564055371876],
              [127.63436104949955, 34.847682145350056],
              [127.62055524974367, 34.86209138066626],
              [127.61394043100664, 34.85807058918018],
            ],
          ],
        ],
      },
      properties: { CTPRVN_CD: '46', CTP_ENG_NM: 'Jellanam-do', CTP_KOR_NM: '전라남도' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [129.5789248801101, 36.05175776575508],
              [129.57444120700325, 36.063013647845146],
              [129.56846343606557, 36.06757975711361],
              [129.56987755161427, 36.07757293273481],
              [129.56194441235692, 36.078307696348574],
              [129.5556879530415, 36.085811726175734],
              [129.54722492884486, 36.08462845975423],
              [129.5395598889621, 36.0661301285344],
              [129.52605017063658, 36.05771808866487],
              [129.51635844550125, 36.04376319210205],
              [129.50343962459405, 36.03442339483545],
              [129.5037437887487, 36.02593974019006],
              [129.4880482265892, 36.01616288618703],
              [129.4824166646387, 36.016372322861685],
              [129.46986517670945, 36.01012305354963],
              [129.4566213295722, 36.00002827631691],
              [129.45645424960966, 35.99335707751397],
              [129.44998640264268, 35.990961364814],
              [129.42957296582705, 35.99585241045257],
              [129.4153422649291, 36.00599066970855],
              [129.40708774991808, 36.008951384421074],
              [129.395564909939, 36.01794103636737],
              [129.40761734401406, 36.029226302378476],
              [129.4183620727804, 36.02642757239164],
              [129.4314003100542, 36.0302989675594],
              [129.40132017634232, 36.03861923617244],
              [129.38583247618368, 36.028448949296234],
              [129.37921906110446, 36.03706254556582],
              [129.3771191811103, 36.04651714375958],
              [129.38026118207858, 36.06047118768103],
              [129.38646436549107, 36.06449422374191],
              [129.39586506323562, 36.0631525994935],
              [129.40937698182984, 36.07325247514531],
              [129.41790349458233, 36.073685594454304],
              [129.41701412677648, 36.08636728832967],
              [129.42721240238794, 36.09619576533617],
              [129.43965727051997, 36.097303540393845],
              [129.43963467538933, 36.11064251509314],
              [129.43221966524175, 36.110661933362394],
              [129.4053230056388, 36.12543930602987],
              [129.39487922275035, 36.14029544907236],
              [129.3990289418363, 36.15246456213271],
              [129.39940131481512, 36.16413721790759],
              [129.39337645120685, 36.18075514245105],
              [129.38196452451805, 36.18547844559336],
              [129.37285488698163, 36.19496310788583],
              [129.37244753412065, 36.20800491182052],
              [129.384068433227, 36.21216280352586],
              [129.38595753663049, 36.21723496355147],
              [129.38009055721068, 36.22998013856474],
              [129.38505018892394, 36.238075583390604],
              [129.37410115624337, 36.24992444883581],
              [129.37566766949286, 36.2693026443271],
              [129.3805342824244, 36.27521012811891],
              [129.37513494373522, 36.283306839454994],
              [129.37932398164398, 36.29848636700923],
              [129.3788736725235, 36.318816919820996],
              [129.38167485842828, 36.32175866803279],
              [129.37898067950516, 36.332504017268874],
              [129.38630379093573, 36.34426376471033],
              [129.3887165038995, 36.35826244717676],
              [129.40590011644755, 36.38196047165462],
              [129.40748023703568, 36.38940876860626],
              [129.41500880334686, 36.393489125304],
              [129.42921984941188, 36.40912372994192],
              [129.4354835270332, 36.42633071464895],
              [129.43263196329625, 36.4380835323144],
              [129.4362357910406, 36.446662044863125],
              [129.43458690243517, 36.452882513223365],
              [129.43739093064136, 36.46368609593939],
              [129.43262276958396, 36.47614545261733],
              [129.43425505053088, 36.48378894961105],
              [129.44438286783628, 36.489141000338606],
              [129.44643818342095, 36.50328353214891],
              [129.43892495564728, 36.536563054401796],
              [129.43966276481, 36.55228240479877],
              [129.42960397717135, 36.56365648149524],
              [129.41462973002916, 36.57698836070969],
              [129.40952091714016, 36.59345803064736],
              [129.4156364951235, 36.60333604119093],
              [129.41203255124367, 36.616832915170896],
              [129.41684297395017, 36.63757114358838],
              [129.4279135231676, 36.64889088802877],
              [129.4307904112025, 36.65927610316369],
              [129.4375643143004, 36.67070387665282],
              [129.44684794267522, 36.67798002547351],
              [129.459020830907, 36.68177359644134],
              [129.46773041929296, 36.688476586130285],
              [129.46791807870795, 36.69330657453762],
              [129.47600487812824, 36.69934465172557],
              [129.47223592764666, 36.72432509075691],
              [129.4767540254365, 36.72713687481088],
              [129.467506231375, 36.75093365568458],
              [129.46750297686296, 36.75692239695525],
              [129.47728340470215, 36.765549303890126],
              [129.46898773952188, 36.78132330127196],
              [129.4617151496266, 36.78863831859501],
              [129.46254343363273, 36.79615095971466],
              [129.45751667373446, 36.80269456379363],
              [129.45623690539637, 36.81470220891838],
              [129.44789794977146, 36.823466405828135],
              [129.44583788402406, 36.8310177197585],
              [129.43077489522167, 36.846113716813946],
              [129.4218597768753, 36.86174429221009],
              [129.4206158556048, 36.87652542610875],
              [129.41502399557814, 36.89091139381585],
              [129.42035508920574, 36.8974289549222],
              [129.41545852543928, 36.90834007438965],
              [129.4154281706803, 36.91642908504184],
              [129.4204651405151, 36.9361712864231],
              [129.41837824881344, 36.954017235029234],
              [129.40804479195074, 36.97998386195612],
              [129.4182237288576, 36.993069365944],
              [129.41596066936887, 37.0107466585248],
              [129.40952052942146, 37.023240121110774],
              [129.41560758732234, 37.03337003640886],
              [129.41307000331201, 37.04436362858044],
              [129.41510537332485, 37.05385757066326],
              [129.42748150015836, 37.059804273442744],
              [129.4270126934522, 37.063661763434155],
              [129.40174147648725, 37.07874018734874],
              [129.38351893325037, 37.097088550901915],
              [129.37559721981495, 37.10229283785145],
              [129.37488835891523, 37.113614596284926],
              [129.37832555856986, 37.11680039909298],
              [129.37054654985212, 37.1265349690083],
              [129.37140602264637, 37.13518320882664],
              [129.3638535403386, 37.14600725806842],
              [129.3446111616912, 37.146021517643504],
              [129.3332413649665, 37.140707309926746],
              [129.32482988965282, 37.14228617990737],
              [129.3181472873558, 37.13295228578203],
              [129.29800394403398, 37.124536905373496],
              [129.2945916558938, 37.11436507499286],
              [129.2712383033275, 37.11638052990746],
              [129.26565830608598, 37.1021494796578],
              [129.24903019687974, 37.09615133182007],
              [129.24045946413824, 37.08503509393097],
              [129.22537774021006, 37.07372007284283],
              [129.2330750242127, 37.06388190026384],
              [129.22852085591703, 37.05723467029108],
              [129.23281801082592, 37.0502429896743],
              [129.2253141642037, 37.04455995277499],
              [129.21380230330965, 37.043034776012],
              [129.20504613118632, 37.044972439457354],
              [129.19475225248314, 37.04062974100226],
              [129.18511880910668, 37.04648070958197],
              [129.16676227441877, 37.065261065013694],
              [129.1422452735085, 37.08038546631202],
              [129.1264434118514, 37.08506916438676],
              [129.11798936629032, 37.09272673164154],
              [129.10773519576514, 37.09347632935645],
              [129.0957808794628, 37.10040196999555],
              [129.07695404284627, 37.09298916527266],
              [129.07009297641093, 37.087574513987676],
              [129.0657376069107, 37.07878574537765],
              [129.06430144652427, 37.06806641936215],
              [129.04174903085408, 37.07105664874421],
              [129.03664291093585, 37.076297585554634],
              [129.00885361800215, 37.07913799399648],
              [128.98406382735567, 37.08462704051508],
              [128.959315644888, 37.07747585940764],
              [128.94748552723652, 37.09168382704852],
              [128.92331555870223, 37.09211691180013],
              [128.91504794159664, 37.083729490315406],
              [128.91693021081826, 37.078695334943475],
              [128.91041665097302, 37.06613479624504],
              [128.89807449134423, 37.05760403172465],
              [128.89764877731628, 37.045460480706375],
              [128.88734118683732, 37.05035518259569],
              [128.87835200560838, 37.05086349591689],
              [128.8724794858179, 37.043945222967395],
              [128.86594854832265, 37.04794268680716],
              [128.84687479658183, 37.05160657571351],
              [128.83595272308668, 37.06594270351832],
              [128.83166602247806, 37.067404020099225],
              [128.8293836069843, 37.07845901916788],
              [128.80787116409206, 37.076004603884854],
              [128.7999656160524, 37.07897488203289],
              [128.7994233931379, 37.086944220414004],
              [128.78580644913617, 37.08785349450499],
              [128.7802823078218, 37.092342683764294],
              [128.77359139334285, 37.087508015824355],
              [128.7777733461891, 37.078831970902385],
              [128.77134040047684, 37.07634922778155],
              [128.7647522091427, 37.06354811725454],
              [128.75717866324342, 37.070005175363974],
              [128.75302127650502, 37.05371790120584],
              [128.76142039969804, 37.04443884644176],
              [128.76217591424518, 37.036155388355176],
              [128.7490790246708, 37.02886285259928],
              [128.7358280683208, 37.03975381911877],
              [128.7186689217466, 37.04375137985111],
              [128.7090990407987, 37.039355751355636],
              [128.7004036010153, 37.04082751878793],
              [128.6890734993416, 37.05305451710111],
              [128.6837324050241, 37.051435174618],
              [128.67565096249535, 37.058847580721],
              [128.64613418733998, 37.06108781092847],
              [128.63934886223538, 37.053995951789446],
              [128.63292480932535, 37.040501831629136],
              [128.60975981231172, 37.05203241661278],
              [128.60712595036242, 37.04384645480743],
              [128.5968311486659, 37.04176586240073],
              [128.58213493250247, 37.042643393988286],
              [128.57773411017465, 37.035567062633135],
              [128.56929122670942, 37.034884673166296],
              [128.56692605308098, 37.02599565976014],
              [128.57260802794292, 37.02196667149919],
              [128.57034429022377, 37.013995080156484],
              [128.55593992127964, 37.00570302627081],
              [128.55473125032893, 36.99828602550996],
              [128.5442070164041, 36.992571676950654],
              [128.51547483372883, 36.98682338078539],
              [128.5146143903805, 36.97758145758042],
              [128.5064970259319, 36.970052956068194],
              [128.477046749771, 36.9574403966324],
              [128.46278177061473, 36.94738426382328],
              [128.46019031904572, 36.93772077418884],
              [128.45266813336022, 36.93071836260546],
              [128.4415936987791, 36.92734853253238],
              [128.44517439336823, 36.917413693589914],
              [128.44016170179103, 36.902873932928486],
              [128.42678635989503, 36.889244872827696],
              [128.42396978316043, 36.876528416379564],
              [128.43842836045994, 36.87327072883713],
              [128.44912630793277, 36.8628741061219],
              [128.44665915170032, 36.853371660041056],
              [128.44903109456848, 36.847842101309055],
              [128.44150477176322, 36.8376029142983],
              [128.43411314453334, 36.83414397822753],
              [128.4336120165361, 36.827620607994355],
              [128.42047895449406, 36.811513670225686],
              [128.38126371868955, 36.813881246301484],
              [128.36839886987562, 36.802075995050586],
              [128.3568680118093, 36.806774533622885],
              [128.35318104303911, 36.81244993051014],
              [128.33489493235982, 36.81687934403247],
              [128.32084906872993, 36.815639910645544],
              [128.30905594667948, 36.82895771785223],
              [128.2956243057417, 36.83534119374746],
              [128.2824341981418, 36.85639894709342],
              [128.26831292161452, 36.860540143392754],
              [128.265274263915, 36.86398430560355],
              [128.25196335910755, 36.8670168590052],
              [128.24184107549854, 36.872328633358386],
              [128.23465588798967, 36.8628306088751],
              [128.2387142045034, 36.850183196713814],
              [128.23012923723897, 36.845369171888336],
              [128.2127491987657, 36.84917929680791],
              [128.21111991819004, 36.841166187190765],
              [128.2145087183441, 36.83485138656064],
              [128.21732522153044, 36.818279438066554],
              [128.2162124298282, 36.812463578323104],
              [128.20716558337395, 36.81242415649512],
              [128.1936760066727, 36.817116369003145],
              [128.18480002303107, 36.81663257728459],
              [128.17131943002258, 36.82210130791891],
              [128.15143201702736, 36.823243101477225],
              [128.14106492693887, 36.833482556215884],
              [128.11843709009787, 36.82148717809649],
              [128.1098229684788, 36.821317740316225],
              [128.1081809999604, 36.81044066565221],
              [128.09296032965332, 36.80286349820751],
              [128.08537351016253, 36.804203936283216],
              [128.0717957782531, 36.81455422576261],
              [128.05963659850315, 36.8167726524595],
              [128.05500716183076, 36.80609666557783],
              [128.05497797949232, 36.79266263528368],
              [128.05119713226034, 36.788843433693856],
              [128.0448049384306, 36.77105112447188],
              [128.03236708888394, 36.75517039430232],
              [128.0323247224032, 36.7475758156365],
              [128.0507198686076, 36.73670908051646],
              [128.05556459424602, 36.73041942656902],
              [128.06798800405792, 36.72223407229226],
              [128.07272383648123, 36.71188622121908],
              [128.0703838373922, 36.70770457340375],
              [128.04969497022122, 36.70775539103702],
              [128.03086320643055, 36.71929150573405],
              [128.0256322419191, 36.71932914004755],
              [128.01484222488392, 36.730191280717506],
              [128.0065053831324, 36.72544791096238],
              [128.00193913757957, 36.717256770114844],
              [127.98684829263593, 36.717549291581],
              [127.9800922570988, 36.7202972603574],
              [127.97072204166922, 36.7309049856602],
              [127.95697271782487, 36.735589582124305],
              [127.95360553437587, 36.72267702974234],
              [127.94918365185731, 36.719875647111635],
              [127.94952839907616, 36.70805012680927],
              [127.93356920170172, 36.70648733040905],
              [127.92892220487705, 36.690946145575474],
              [127.90436696405075, 36.6934943088851],
              [127.88857542818894, 36.69185804554507],
              [127.88160034265756, 36.68774027997601],
              [127.88194006515778, 36.68001815680996],
              [127.89166961440164, 36.68243949832776],
              [127.91296923706824, 36.67767060149153],
              [127.91755136613654, 36.66844868149278],
              [127.92957198723424, 36.66876503926768],
              [127.93163710291884, 36.655399467194385],
              [127.9390824768776, 36.65274756688731],
              [127.93140138546913, 36.62410760455077],
              [127.93237734983714, 36.61874305893499],
              [127.92408915090108, 36.61545035878742],
              [127.92592241677791, 36.602938859579474],
              [127.91138146144871, 36.61531890333376],
              [127.90859248374551, 36.6259265590432],
              [127.88935145704154, 36.628658857082634],
              [127.88877733013965, 36.639348137407254],
              [127.88199404097904, 36.64642041074551],
              [127.87993736389082, 36.656756807143175],
              [127.8739360456735, 36.65504548500154],
              [127.87013237118732, 36.64552394474685],
              [127.86197398984386, 36.63610154744543],
              [127.8513726937494, 36.63476895166231],
              [127.84784294156994, 36.62493559288076],
              [127.85572849299864, 36.61757811733797],
              [127.84122715687741, 36.60878764667637],
              [127.83216138167664, 36.612603430946464],
              [127.82273860820663, 36.61233689891748],
              [127.79742508575848, 36.60029868277705],
              [127.79847594101258, 36.58644221650636],
              [127.8048966513431, 36.581386531495525],
              [127.81620326262744, 36.578081373081965],
              [127.82447139075609, 36.57090727623643],
              [127.83016051723423, 36.57427527152786],
              [127.8448273394569, 36.56910908055698],
              [127.85236292791791, 36.57115327639641],
              [127.86042277831534, 36.5679506581668],
              [127.87032173977542, 36.55915365884258],
              [127.87298863175097, 36.55132760514976],
              [127.87047580786084, 36.542824614144244],
              [127.87901066368764, 36.53470678465281],
              [127.89635420677506, 36.53119574695537],
              [127.9009079492493, 36.52501481133322],
              [127.90318229300941, 36.51101144080678],
              [127.90081850359029, 36.500016001822054],
              [127.8887147343936, 36.49313669215095],
              [127.88046642327478, 36.49327052489216],
              [127.87527776461663, 36.48316539134536],
              [127.88061864725385, 36.48062715877147],
              [127.88196128641391, 36.46183888812433],
              [127.87260861863047, 36.44166615613122],
              [127.87560140096343, 36.42799971372612],
              [127.88259474341477, 36.42154692542452],
              [127.87568962492563, 36.414351511077705],
              [127.8736679390787, 36.40657233078242],
              [127.8638656401721, 36.403042506906274],
              [127.86614847423708, 36.39479650239775],
              [127.8748187218609, 36.39103858838929],
              [127.88416675296344, 36.380013088721356],
              [127.88653201320028, 36.363608471347064],
              [127.88260668039037, 36.34591545558624],
              [127.8701493455985, 36.34348656750698],
              [127.86977880322799, 36.33954753743188],
              [127.85203287224873, 36.33040514744285],
              [127.85039183337764, 36.32025376315772],
              [127.84577222767602, 36.31811783817017],
              [127.8415701021432, 36.30820889645378],
              [127.84686223757558, 36.300763222301356],
              [127.85231543909384, 36.27383250430116],
              [127.86086186386258, 36.27706021244633],
              [127.8826355765326, 36.27374962940749],
              [127.8921012077163, 36.29192760991249],
              [127.90336661737025, 36.301305589093424],
              [127.90712030263221, 36.28649333997783],
              [127.92353449848807, 36.27870841217854],
              [127.93090728241165, 36.278013262592744],
              [127.94280296158091, 36.26672947231171],
              [127.94834244926682, 36.257483517577256],
              [127.96811506005962, 36.25032931905285],
              [127.9783239016983, 36.254587639312895],
              [127.98119089695136, 36.263647960713854],
              [127.99052822987889, 36.263378233096184],
              [128.0113420427177, 36.271954414067125],
              [128.01903435844733, 36.26729437033541],
              [128.02622492458758, 36.267895971184444],
              [128.03132701140746, 36.26199649689955],
              [128.04735245955808, 36.256551022253525],
              [128.04026230901079, 36.25202497928195],
              [128.03071524063392, 36.23971843732924],
              [128.0393389112546, 36.22867668997222],
              [128.04222477974017, 36.21754891171034],
              [128.05009120865049, 36.21646277859051],
              [128.05079107902202, 36.2059962675872],
              [128.05626555969022, 36.20208417737482],
              [128.03863370183709, 36.19415802354844],
              [128.02668156840963, 36.20519113799615],
              [128.00974805160982, 36.20936203072581],
              [127.9987754922946, 36.207465796164456],
              [127.99303856493552, 36.20003274828284],
              [127.98409956928637, 36.20050099998089],
              [127.97533191403011, 36.18771059162237],
              [127.98406945152084, 36.17700973043409],
              [127.9829520203949, 36.169880007167855],
              [127.9892632783553, 36.16587538133598],
              [127.99048052517112, 36.15887626812704],
              [127.99719741891403, 36.155467155101086],
              [127.98748207623674, 36.147383560336564],
              [127.98885340972234, 36.13265621604098],
              [127.97710505092873, 36.123099010452854],
              [127.97015995943582, 36.12188246857405],
              [127.96520090131084, 36.112828806429214],
              [127.96897781225047, 36.104347905102706],
              [127.95971302710781, 36.09451170048728],
              [127.96169424823663, 36.08297938380862],
              [127.96087456709091, 36.07033905676176],
              [127.94989005819934, 36.05972355481354],
              [127.93017780427968, 36.04943937642822],
              [127.91633964642661, 36.05446511135859],
              [127.90351156336895, 36.04342309721577],
              [127.88344298727718, 36.03233936466896],
              [127.876787948156, 36.02270680307634],
              [127.87548709124067, 35.996977919371126],
              [127.89415532190596, 35.98543356724167],
              [127.89645049906068, 35.97158197922939],
              [127.90395442994196, 35.95408729888679],
              [127.91136740942893, 35.949181475667785],
              [127.9085930472391, 35.941599150924304],
              [127.89567907074571, 35.93419014640031],
              [127.88320640453067, 35.930008164387644],
              [127.88253159371068, 35.91924483878816],
              [127.88807099477344, 35.91494783785241],
              [127.88219224291133, 35.90318583125338],
              [127.88478337990468, 35.89310649228597],
              [127.8931383860829, 35.88707986570345],
              [127.9185156286592, 35.8903806927212],
              [127.92287401117848, 35.88258145559758],
              [127.93022047589817, 35.87862940330325],
              [127.9287930586181, 35.8703473261409],
              [127.93320827420165, 35.864240142292516],
              [127.93034655865985, 35.85637444288167],
              [127.94223974072737, 35.85454243289292],
              [127.95011241919948, 35.8616666980254],
              [127.97397997888928, 35.85206809801664],
              [127.98174929088462, 35.85873529486966],
              [127.9964760290134, 35.83763749982641],
              [128.01178055433107, 35.8289339788742],
              [128.02978171786685, 35.83564864353426],
              [128.0516537002443, 35.829882596620294],
              [128.0697858205533, 35.84120186089345],
              [128.0947837664187, 35.83226385188704],
              [128.11092186126157, 35.823881974190215],
              [128.11937177649256, 35.82489863811108],
              [128.12399270801848, 35.82004078456447],
              [128.12242537851145, 35.80304417158321],
              [128.12863036792453, 35.78934148810499],
              [128.13578013670997, 35.784839890800654],
              [128.14796519011725, 35.784008062430736],
              [128.15437044199027, 35.78644798282093],
              [128.16351000578516, 35.77701087584446],
              [128.16153431397709, 35.770011134887795],
              [128.1649997956414, 35.76348933315547],
              [128.1892794391125, 35.75175968260513],
              [128.19663342839252, 35.730383233660895],
              [128.20124798440403, 35.72315944943172],
              [128.20025178963016, 35.70931137174764],
              [128.2045904015764, 35.696183861298806],
              [128.2048185271672, 35.68392316637625],
              [128.1913109180896, 35.678777123209294],
              [128.18413846057263, 35.680047370786575],
              [128.17887869156849, 35.6729279384743],
              [128.16659563388964, 35.674090041054015],
              [128.16009489420014, 35.667500001166715],
              [128.16149829235934, 35.653787320535585],
              [128.16589426360537, 35.65299194035895],
              [128.18523706163435, 35.65767252645787],
              [128.1988700036126, 35.64915372487561],
              [128.2012310164282, 35.64372188177157],
              [128.2103900503786, 35.643787617104124],
              [128.22017926184088, 35.63998696410061],
              [128.23572809718777, 35.64043810889796],
              [128.23636069957482, 35.65108305807392],
              [128.24184035402385, 35.655117187654696],
              [128.25864362025519, 35.647796725626016],
              [128.26234383961037, 35.6427369006206],
              [128.2773565030063, 35.64728843057333],
              [128.2794851065741, 35.65231173379952],
              [128.29625393946313, 35.65072942576377],
              [128.30598971154933, 35.655476153681136],
              [128.31791047755652, 35.65149191099686],
              [128.32404184476593, 35.64661221212702],
              [128.34916809153793, 35.6464456522295],
              [128.3579385960468, 35.63735571627762],
              [128.36276807640579, 35.625998629933335],
              [128.36463419617917, 35.61335692723782],
              [128.37174765470095, 35.61088090579447],
              [128.38837584571053, 35.61792824857897],
              [128.40125144382299, 35.63272865814472],
              [128.40003665592357, 35.64555484479471],
              [128.39227034955817, 35.65344911118913],
              [128.37251114000492, 35.666620598002055],
              [128.35718645318704, 35.68219519471886],
              [128.35154839592352, 35.69745775616849],
              [128.35179677455073, 35.70401559999629],
              [128.35887832892075, 35.708701191502094],
              [128.3819729974412, 35.701547666577426],
              [128.39706280795002, 35.70022322150204],
              [128.41220178694525, 35.69584186306676],
              [128.42545837060564, 35.699229361815256],
              [128.43398081242876, 35.70707025385726],
              [128.4348893963111, 35.71475768417546],
              [128.43181594128185, 35.72559806206973],
              [128.42164610166526, 35.73313463075921],
              [128.3912469802169, 35.74835263407732],
              [128.38329419163054, 35.75858518019945],
              [128.38963138128844, 35.769987096362755],
              [128.39690321356363, 35.777683839560716],
              [128.4081191979015, 35.79920833126816],
              [128.42082954640162, 35.809354536719226],
              [128.4409455135943, 35.809294144527286],
              [128.44102909216195, 35.80601668292826],
              [128.47043318567134, 35.8059222979374],
              [128.48153708364057, 35.816012114222],
              [128.48121715955142, 35.83008643806328],
              [128.47278366323025, 35.833449357026986],
              [128.4726338062446, 35.833554774801044],
              [128.4725462810764, 35.8336077919734],
              [128.46554007068008, 35.83723314163651],
              [128.46365136923296, 35.83777109707654],
              [128.45064806980665, 35.84399825318101],
              [128.4361822573171, 35.84833354555371],
              [128.41598218918676, 35.8517570168141],
              [128.38351020186965, 35.85283461302318],
              [128.38359484838696, 35.862554649646015],
              [128.39806680103558, 35.8927085159598],
              [128.3989767186248, 35.89992648667319],
              [128.40677158723466, 35.90142304813206],
              [128.41829471895844, 35.91663239590781],
              [128.43103625803323, 35.930526434407824],
              [128.45033821053528, 35.935041618134655],
              [128.45415530540473, 35.94314939935484],
              [128.47641889790594, 35.93443929883262],
              [128.47275540488064, 35.914435884210356],
              [128.4653990502513, 35.90859042946906],
              [128.46775468018384, 35.90021845073586],
              [128.47526959351617, 35.894457501096106],
              [128.49061700005907, 35.89757913613943],
              [128.49472189808023, 35.89078923206137],
              [128.5041609055795, 35.889590161989375],
              [128.50574077567313, 35.903253153362996],
              [128.51012076935856, 35.909933781376644],
              [128.51690282053784, 35.91184339831891],
              [128.52945581207004, 35.92359000784154],
              [128.53505489062465, 35.937888820865034],
              [128.53254869328563, 35.95054231119151],
              [128.5348108363556, 35.958383131793184],
              [128.5304973373554, 35.9619897024782],
              [128.52689563496185, 35.97585063158502],
              [128.5311950018583, 35.98034694787185],
              [128.5420124497535, 35.97515510530895],
              [128.545871949473, 35.96609456802868],
              [128.55332244969588, 35.9607645484782],
              [128.55636684160837, 35.971738405076685],
              [128.56470736739942, 35.97293733449849],
              [128.5728375999815, 35.97831250423818],
              [128.5850970532879, 35.97795756412297],
              [128.60335926221677, 35.98798730570394],
              [128.61748585130158, 36.0067373275414],
              [128.63058112940286, 36.007120814204114],
              [128.63922986403898, 36.01287425359197],
              [128.63690108603248, 36.01688668640306],
              [128.6213522140278, 36.02523583223414],
              [128.6225905509415, 36.03781053573491],
              [128.62790928787228, 36.04566934380001],
              [128.6284374019421, 36.05994702687936],
              [128.63269469064224, 36.06684292395705],
              [128.6277576995303, 36.080162407643385],
              [128.61820840448254, 36.07693746265952],
              [128.59787945398816, 36.074961343087416],
              [128.5944568940213, 36.06283483745738],
              [128.5689223430552, 36.06199632010587],
              [128.56384185453595, 36.06975615490443],
              [128.56900515205004, 36.088499806021524],
              [128.56492970136068, 36.10391199587123],
              [128.56400288757104, 36.11585808893645],
              [128.55487898958856, 36.121616902396674],
              [128.54858712571277, 36.13215703735082],
              [128.55018583558456, 36.15064806358539],
              [128.5400784433219, 36.16109016938275],
              [128.54486878279872, 36.166100870360125],
              [128.55236996836948, 36.16490839927763],
              [128.5568787723304, 36.177174994028356],
              [128.54882752636698, 36.177810861866256],
              [128.5366098406781, 36.19493314306114],
              [128.52277665260428, 36.201424633362386],
              [128.51600742973088, 36.199698621607936],
              [128.5071113516454, 36.18556903155394],
              [128.49321498933855, 36.20069811587173],
              [128.49406798399704, 36.206223188607396],
              [128.48300815264315, 36.22466247236918],
              [128.48506247841772, 36.233202453377885],
              [128.47844953155547, 36.234713056140954],
              [128.45089722455936, 36.22173550516502],
              [128.43784807799244, 36.2227508304761],
              [128.43400176361365, 36.23434605409781],
              [128.42544825618026, 36.23615681592106],
              [128.41765350348487, 36.245856538888674],
              [128.42073665116257, 36.266194186440345],
              [128.42643694876529, 36.27541312884045],
              [128.41043911324016, 36.28720079765964],
              [128.41650968697775, 36.298719353112695],
              [128.4278899334339, 36.29891464616116],
              [128.43803981543587, 36.31404220638877],
              [128.44704445481065, 36.322688958255405],
              [128.45575607320754, 36.32501782113018],
              [128.46857889860422, 36.321798317263735],
              [128.4731853634752, 36.31217725004985],
              [128.48772934050373, 36.30810987664881],
              [128.49643750602732, 36.30295024807478],
              [128.50851348877313, 36.30331872507967],
              [128.52588221400472, 36.299307949828794],
              [128.54551415326918, 36.29195247244926],
              [128.55182727961784, 36.27502887136945],
              [128.56675378672682, 36.274214077337206],
              [128.57581283713407, 36.2799333431721],
              [128.59450131681882, 36.2777185422456],
              [128.59763008860804, 36.27133025680234],
              [128.6089065791427, 36.27120920117853],
              [128.62448266949943, 36.26672300539117],
              [128.64060022603974, 36.257512989313916],
              [128.64136950423878, 36.244804869751114],
              [128.63312567331013, 36.23866176469421],
              [128.63665195308167, 36.23310046607819],
              [128.63431079101974, 36.2136720090787],
              [128.63941162023664, 36.20748355206648],
              [128.6487011937086, 36.21806849181752],
              [128.6597553276225, 36.22138032154586],
              [128.66464136142932, 36.218961527826686],
              [128.66937833486895, 36.209371158489446],
              [128.68271222242248, 36.21529432345302],
              [128.69806885886373, 36.21166634289682],
              [128.6963324149586, 36.202150582895364],
              [128.71913175832518, 36.19808316229516],
              [128.7274758734602, 36.20075863585955],
              [128.7495908195845, 36.19595939563883],
              [128.7579766440633, 36.202862035647755],
              [128.76995776075609, 36.19342569216862],
              [128.7806611817336, 36.194380464393376],
              [128.79644714116478, 36.19081957771242],
              [128.80522552729366, 36.20700192951233],
              [128.82655683905065, 36.21824196687059],
              [128.8342171919454, 36.214601251193805],
              [128.8485108292413, 36.21471163759874],
              [128.85837441255006, 36.207807288248695],
              [128.87121588807472, 36.20515941294576],
              [128.88076604159798, 36.198857575197934],
              [128.88508455172072, 36.184014700217716],
              [128.90019665889142, 36.1623775255328],
              [128.89160576255838, 36.1550406226499],
              [128.88985883441788, 36.142528312097795],
              [128.8585741361697, 36.14496944183862],
              [128.8508659104219, 36.13804972055591],
              [128.85344317951626, 36.128418468392354],
              [128.8509529967127, 36.1181767773717],
              [128.83783877026852, 36.113051977263545],
              [128.83261903064223, 36.1019919505713],
              [128.82228009783353, 36.10046797397884],
              [128.81131060743274, 36.08932785310147],
              [128.79853153320173, 36.08531733142869],
              [128.78762375299513, 36.08914288711465],
              [128.7645200614892, 36.100656907012485],
              [128.7536734054537, 36.09078022262692],
              [128.7516447904074, 36.103049667707815],
              [128.73633725738404, 36.099408267405565],
              [128.72673702162325, 36.093267431046726],
              [128.72938552469728, 36.08096995517677],
              [128.72143917116068, 36.07312967945609],
              [128.71403901133357, 36.0754840491703],
              [128.71146161563092, 36.06781836037871],
              [128.70316516669317, 36.056420169180946],
              [128.7041064037075, 36.04440505824871],
              [128.69686041795444, 36.03624520911845],
              [128.69983930153, 36.02865517840634],
              [128.69559651052666, 36.016165006819186],
              [128.70138210297915, 36.01085255781967],
              [128.71786487719004, 36.008127032404865],
              [128.72781431030856, 36.002226845443545],
              [128.73485573927945, 35.99295600286883],
              [128.73097397796994, 35.985361397581805],
              [128.74621032695333, 35.97286851012772],
              [128.74299466366676, 35.95994535224924],
              [128.7389060693179, 35.95723711826342],
              [128.7440867377692, 35.94395803481052],
              [128.7376461605649, 35.92810285610847],
              [128.74267752633034, 35.92039870252302],
              [128.75529585383165, 35.91500515345335],
              [128.75980144823612, 35.90683330499632],
              [128.7575073678913, 35.89626584496114],
              [128.76229634417962, 35.88883685031773],
              [128.75873205268294, 35.87855299154266],
              [128.7597953221116, 35.86607486396476],
              [128.75075172493922, 35.85750869408419],
              [128.73857242999256, 35.85129815164566],
              [128.72551086836535, 35.85780095259665],
              [128.72687160072314, 35.847212394888295],
              [128.72438351433172, 35.84055134907259],
              [128.70863737751017, 35.82656790451589],
              [128.71388539098876, 35.81750814257012],
              [128.71605772701182, 35.80528426569761],
              [128.7102364471469, 35.80429701626985],
              [128.69747087739506, 35.79435140886392],
              [128.682511733246, 35.79014858174963],
              [128.68156239287902, 35.783962785846214],
              [128.68707050059518, 35.775498822105426],
              [128.6863501883175, 35.7687236367578],
              [128.69548566367192, 35.75574214608529],
              [128.68928394685864, 35.740193516361416],
              [128.6909642841554, 35.730888798013005],
              [128.68323973956888, 35.72145440593755],
              [128.65661027333368, 35.717859515071034],
              [128.64621200070067, 35.70817374671371],
              [128.63050115450076, 35.70667217661944],
              [128.62449763322823, 35.7033549166987],
              [128.61391608676632, 35.70984083841225],
              [128.61582492756656, 35.72016726351707],
              [128.60993450388247, 35.72487572374943],
              [128.6147984549315, 35.73094197089817],
              [128.60749899345745, 35.73899831100811],
              [128.59562185441305, 35.737211320232554],
              [128.5896009072803, 35.73150372477465],
              [128.58051593511644, 35.73866656402559],
              [128.5523308064528, 35.72635378620684],
              [128.54408575674427, 35.7194340518726],
              [128.5279048976907, 35.712740757250444],
              [128.5338866945384, 35.70326014616877],
              [128.53131982971368, 35.68786028100339],
              [128.52680847840736, 35.673504401076165],
              [128.53145555130956, 35.662170869428614],
              [128.5374342090492, 35.6597607603391],
              [128.5347682373404, 35.643701547863884],
              [128.53816987079347, 35.63190816696778],
              [128.53655430836235, 35.62449656354367],
              [128.55873263765056, 35.61479999125932],
              [128.5619761307177, 35.602684380554855],
              [128.56903358457328, 35.60245401949777],
              [128.57295717814924, 35.593215970520774],
              [128.5999692642194, 35.5804225143181],
              [128.6147036578387, 35.58165587697476],
              [128.63074674401875, 35.58742014742415],
              [128.63653243576132, 35.584697886683664],
              [128.64409083429098, 35.59305249450147],
              [128.658292509517, 35.59768679171489],
              [128.6644187920741, 35.593752785844835],
              [128.674242870834, 35.5960996812476],
              [128.68760369700345, 35.59502509248808],
              [128.6949403109378, 35.58341751567546],
              [128.70330844363193, 35.578010074340256],
              [128.71495800586172, 35.577597251739775],
              [128.72258381913187, 35.58140139127079],
              [128.7319727337543, 35.57595304922907],
              [128.73741830938914, 35.57715395393361],
              [128.75813557306387, 35.56749333769461],
              [128.7710373013558, 35.56863107566637],
              [128.78552872191628, 35.56688812495843],
              [128.7987805973354, 35.578306270697745],
              [128.80071577637077, 35.587625029188686],
              [128.80956362379345, 35.58898419981097],
              [128.8262947190356, 35.596775257292656],
              [128.83364831432212, 35.59735409916629],
              [128.84263873119167, 35.588993732295826],
              [128.85407518869732, 35.597181957685564],
              [128.87387630862278, 35.62163602953766],
              [128.8753785137906, 35.63232979686285],
              [128.88146073175616, 35.63547782769492],
              [128.88724490087102, 35.62910771711776],
              [128.90166727501986, 35.63321108394291],
              [128.91505373373354, 35.640618707820735],
              [128.9411451849236, 35.63507340061891],
              [128.95119798421243, 35.63015348983031],
              [128.96126138086285, 35.62056224152491],
              [128.9608768636794, 35.61558123571811],
              [128.97280750489645, 35.613446927143336],
              [128.98264230135928, 35.60870513001109],
              [128.99709612803528, 35.61500440676605],
              [129.00966641569465, 35.6258933883787],
              [129.0266107582606, 35.63639544593337],
              [129.03548625334153, 35.63202087808107],
              [129.04334343363493, 35.640967434631484],
              [129.0469011119154, 35.65051757011016],
              [129.08085482930946, 35.64325309452839],
              [129.07035917719648, 35.658635869690954],
              [129.06809485636947, 35.67319060400944],
              [129.06987686277347, 35.682372203351775],
              [129.0802851226358, 35.69627962605399],
              [129.10175906756237, 35.70606710636044],
              [129.12421215417106, 35.70827519541651],
              [129.1262053869808, 35.71357266698849],
              [129.13529286000417, 35.712342367463975],
              [129.1420466918291, 35.72434964712786],
              [129.1540485496662, 35.72196757392782],
              [129.16031498955832, 35.71481006897859],
              [129.1719409289506, 35.71394338211046],
              [129.18664929884807, 35.71951810379457],
              [129.197645731116, 35.71579428239802],
              [129.20546625323317, 35.72117416911088],
              [129.23400764939876, 35.70387461948881],
              [129.25685046098206, 35.70070332877304],
              [129.26187935682006, 35.69340310879857],
              [129.2591046122736, 35.67110689230865],
              [129.2547450790719, 35.66641173313801],
              [129.2604448632365, 35.654637523140416],
              [129.26977734048006, 35.651079426383305],
              [129.28289857797955, 35.65173309281344],
              [129.2962573372198, 35.64474146116541],
              [129.30305932391272, 35.64830266811479],
              [129.30427273754535, 35.65700609488588],
              [129.31114252660313, 35.6605244032031],
              [129.32071435843747, 35.656676217053594],
              [129.32782072785818, 35.65883631957254],
              [129.33408878477687, 35.66976047221531],
              [129.34005789362647, 35.669636889934594],
              [129.3535587565175, 35.679380194821924],
              [129.36435416373206, 35.678252755642276],
              [129.37265446082216, 35.66922674979665],
              [129.3818494213668, 35.67118476458077],
              [129.41096982104943, 35.663827344550334],
              [129.4283988752348, 35.65558029389366],
              [129.43926912395003, 35.6552446251305],
              [129.44958245234778, 35.65106746628835],
              [129.45270416381155, 35.6649254481438],
              [129.46462995154218, 35.66672345734035],
              [129.46449093186925, 35.67806241089344],
              [129.47075633220842, 35.6805466427818],
              [129.47571728109446, 35.69756312719368],
              [129.47219619323627, 35.70727031814127],
              [129.47919344046196, 35.71279186764915],
              [129.48156180650037, 35.72527582201702],
              [129.48554905717177, 35.73043832270151],
              [129.48305198789095, 35.7436728812505],
              [129.49161339852463, 35.75109872629511],
              [129.49092391955304, 35.75896628340948],
              [129.4962948107477, 35.772015187814716],
              [129.49061402113605, 35.784306892902244],
              [129.4925139827127, 35.79068678699083],
              [129.50352847086486, 35.80744238673837],
              [129.51327686982668, 35.81604735600722],
              [129.51013880453175, 35.82520734352595],
              [129.51830814020954, 35.837405483405284],
              [129.51827861941575, 35.848107654362536],
              [129.52523842235033, 35.853395680062896],
              [129.5261010134147, 35.86271211658524],
              [129.5317361490364, 35.871394170931204],
              [129.5191967648278, 35.87291196428635],
              [129.52041421918096, 35.88176529915316],
              [129.52842888577044, 35.88365398506444],
              [129.52487830264707, 35.895802642404234],
              [129.53331314305444, 35.89970707220391],
              [129.51834912768766, 35.92045676568595],
              [129.51828833304756, 35.92779669612935],
              [129.52362614924527, 35.933996005943825],
              [129.5330511851987, 35.93648483727412],
              [129.53520539608857, 35.94390250199637],
              [129.54656063171225, 35.952898076382425],
              [129.55422849466814, 35.96812180649942],
              [129.55193493843583, 35.98559966898641],
              [129.57496233990503, 36.00405629176989],
              [129.58252729381007, 36.01763720799393],
              [129.5775870968924, 36.02424466689013],
              [129.5787363543701, 36.03968699901228],
              [129.5831924125158, 36.04587861410864],
              [129.5789248801101, 36.05175776575508],
            ],
          ],
          [
            [
              [130.9061238717943, 37.54948520773862],
              [130.89316193806258, 37.541717424254486],
              [130.87582887021884, 37.54311057417443],
              [130.86739760716026, 37.53666652759466],
              [130.8467157130075, 37.53536851255729],
              [130.8302707580572, 37.527041467585406],
              [130.81719241123605, 37.52571764304104],
              [130.8013595689306, 37.51853181471898],
              [130.79403712507144, 37.51278788490897],
              [130.80123185176404, 37.50826588637137],
              [130.8050698989322, 37.49787918524845],
              [130.8011663458593, 37.48892552671753],
              [130.81173149989422, 37.4734510427085],
              [130.828730978846, 37.470889472871626],
              [130.8326180385561, 37.46647628564434],
              [130.8508128513238, 37.463802615277054],
              [130.85634929415622, 37.460401305013626],
              [130.87538930005454, 37.45767138758134],
              [130.87830608704562, 37.46511637017765],
              [130.89036626771073, 37.47389036895257],
              [130.90365264371138, 37.47546903136562],
              [130.91392384532648, 37.48673334566754],
              [130.91012371905708, 37.49704195242118],
              [130.9171457845553, 37.515558588800616],
              [130.907606799566, 37.52825030782557],
              [130.91199739275348, 37.538037202996],
              [130.9061238717943, 37.54948520773862],
            ],
          ],
        ],
      },
      properties: { CTPRVN_CD: '47', CTP_ENG_NM: 'Gyeongsangbuk-do', CTP_KOR_NM: '경상북도' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [128.53941274800383, 34.75732443320983],
              [128.5210659989018, 34.766354528961145],
              [128.51509516447607, 34.7592206614762],
              [128.5262312663556, 34.754816835083794],
              [128.5370820286835, 34.75492543099923],
              [128.55234561457542, 34.748216997092754],
              [128.55992056364644, 34.75540110133377],
              [128.55851910575856, 34.75982343789115],
              [128.5473810177998, 34.7613170958655],
              [128.53941274800383, 34.75732443320983],
            ],
          ],
          [
            [
              [128.22433306061532, 34.8066802922876],
              [128.22807622428343, 34.8002717102428],
              [128.24586299525177, 34.79970010051591],
              [128.24278257479136, 34.808393185697355],
              [128.2536842180228, 34.808039207577266],
              [128.26500797292198, 34.81817780590566],
              [128.2484464522287, 34.82571266124937],
              [128.2479078372774, 34.82987561876043],
              [128.23769193245568, 34.83763584720475],
              [128.21833506590372, 34.83878175542467],
              [128.19956666621994, 34.817702536195405],
              [128.21105222124766, 34.81728362891256],
              [128.2133208253652, 34.80692277277599],
              [128.22433306061532, 34.8066802922876],
            ],
          ],
          [
            [
              [128.45881748591722, 34.71660247166479],
              [128.4506541601864, 34.713217830728475],
              [128.452021510031, 34.70542097843006],
              [128.46205384377942, 34.70473585158869],
              [128.46587427110248, 34.711149962152014],
              [128.46020469010045, 34.71686905204184],
              [128.47021136717333, 34.728987518536556],
              [128.46579238775115, 34.734769384891415],
              [128.45641552202812, 34.729867990011506],
              [128.45881748591722, 34.71660247166479],
            ],
          ],
          [
            [
              [128.46401787669623, 34.79782290527679],
              [128.46020832294892, 34.78682744122956],
              [128.47336577953132, 34.77580413384668],
              [128.47253238038417, 34.76104055955001],
              [128.47860087460288, 34.762519670735536],
              [128.48993931820002, 34.757484106529795],
              [128.50291731270735, 34.766454878280115],
              [128.50840318405946, 34.7667687599323],
              [128.51063666817637, 34.77830170262354],
              [128.50231855712983, 34.78303331535604],
              [128.49345186567052, 34.78174601385595],
              [128.4900836932953, 34.79808238380652],
              [128.4913749414246, 34.80167429400989],
              [128.47942624466478, 34.809392845979204],
              [128.4736404031848, 34.81732952036377],
              [128.4682419885016, 34.81680327056693],
              [128.46938700112128, 34.80466917953538],
              [128.46401787669623, 34.79782290527679],
            ],
          ],
          [
            [
              [128.28607868909708, 34.62447882964627],
              [128.29468158860723, 34.63673075123292],
              [128.29023783211315, 34.64041565627205],
              [128.2799255538634, 34.6349375480633],
              [128.27588595317306, 34.6261719016044],
              [128.26588070827577, 34.63190897128131],
              [128.2757111702256, 34.639195032310155],
              [128.2645356941464, 34.64530226621909],
              [128.25859285984515, 34.64473834178316],
              [128.24407011812917, 34.65215003588608],
              [128.2289074051051, 34.648080614248656],
              [128.2341679993027, 34.63896741232366],
              [128.22627546148487, 34.63301137403476],
              [128.24312656636036, 34.62359326804379],
              [128.2368943781959, 34.616636711436314],
              [128.24437953066504, 34.613225559783864],
              [128.2490619071841, 34.61933341601601],
              [128.25966586175662, 34.62313713130501],
              [128.26418172156502, 34.628064135689876],
              [128.2766321938313, 34.62053248738535],
              [128.28607868909708, 34.62447882964627],
            ],
          ],
          [
            [
              [128.1869626784046, 34.82691809031154],
              [128.1983026406937, 34.832800088607364],
              [128.2036833370811, 34.8424929226055],
              [128.22907279434384, 34.84234466912061],
              [128.22991178098087, 34.84837743279802],
              [128.2225568135029, 34.85213421215619],
              [128.21222721054832, 34.85105936095458],
              [128.20212946410118, 34.859647924026824],
              [128.19038355483255, 34.859363455385505],
              [128.16783320079318, 34.85124510166341],
              [128.1685191112697, 34.841385773976135],
              [128.18171656102123, 34.83792700894917],
              [128.1869626784046, 34.82691809031154],
            ],
          ],
          [
            [
              [128.12892321125912, 34.83549236786376],
              [128.12558737436916, 34.83035494785702],
              [128.13503560722694, 34.824535448345245],
              [128.14181145773438, 34.83249625583871],
              [128.12892321125912, 34.83549236786376],
            ],
          ],
          [
            [
              [128.23580191409647, 34.67583703389576],
              [128.24633194428566, 34.669512843857255],
              [128.2522211588338, 34.67630097870321],
              [128.23580191409647, 34.67583703389576],
            ],
          ],
          [
            [
              [128.37658986896076, 34.82612172260212],
              [128.3571547292069, 34.83475394637092],
              [128.33963585124422, 34.83212378665748],
              [128.3335009101431, 34.82271390027748],
              [128.34034038605253, 34.820530718722026],
              [128.34627630529917, 34.825506642486],
              [128.35645905843992, 34.824265044224425],
              [128.36682816146998, 34.81872410231358],
              [128.37966468309568, 34.81496535865405],
              [128.38078724516416, 34.80602873763897],
              [128.377604182776, 34.79820631155123],
              [128.36912605794208, 34.80071934699759],
              [128.36425432119748, 34.7955682881942],
              [128.38747499309562, 34.79109515706632],
              [128.39730658634696, 34.77955981951648],
              [128.3945902213183, 34.773500794695664],
              [128.4065406788802, 34.76245883104897],
              [128.42491470774647, 34.76536315536736],
              [128.42427298312157, 34.77081802352396],
              [128.43516547837586, 34.77974313197339],
              [128.43393722066145, 34.78914702628176],
              [128.43998764236395, 34.794816957236485],
              [128.44180973147954, 34.80904584895878],
              [128.4364175336667, 34.825290270237886],
              [128.42774985091455, 34.83182351255226],
              [128.4081464382439, 34.833953993678335],
              [128.40431814779427, 34.828210663643326],
              [128.39425542507342, 34.82476637366107],
              [128.38579131696608, 34.82785693567458],
              [128.37658986896076, 34.82612172260212],
            ],
          ],
          [
            [
              [128.19943018949635, 34.93347467378001],
              [128.22257872267116, 34.94660935320959],
              [128.2271602242671, 34.940969787577814],
              [128.24151634556586, 34.94398496681243],
              [128.25214634504232, 34.9421293935507],
              [128.25575101583706, 34.93719332722859],
              [128.2674284768148, 34.93950419609412],
              [128.26847957139842, 34.929930628825474],
              [128.26067898422681, 34.92672296347951],
              [128.2798943299131, 34.90830534656202],
              [128.29701694989782, 34.91436847771774],
              [128.30098500601693, 34.92071180352992],
              [128.30038368833866, 34.93654775495679],
              [128.31341083757036, 34.94021235347296],
              [128.31935683884538, 34.94676363377684],
              [128.316806880113, 34.95563327804825],
              [128.32875384084653, 34.95526684846732],
              [128.33236946189868, 34.94571546578617],
              [128.34198543802304, 34.94553495991665],
              [128.34665424428158, 34.932688996976495],
              [128.34277742014788, 34.92556562710532],
              [128.34978584237567, 34.919210228133146],
              [128.35590137086848, 34.90901029605357],
              [128.34636622526776, 34.904831904139755],
              [128.33860842720048, 34.9085165145186],
              [128.32013887493375, 34.90694802104091],
              [128.30789254940444, 34.90854898041134],
              [128.29750885830188, 34.90140699107782],
              [128.31000957770053, 34.89247364567105],
              [128.31116760027575, 34.88511153168556],
              [128.32146185183998, 34.8839573116867],
              [128.3276752113524, 34.87720361998286],
              [128.3425179487259, 34.880808359331375],
              [128.34869860064455, 34.873665313424574],
              [128.36373215766451, 34.870191833414204],
              [128.37168230943183, 34.87536754326588],
              [128.37983323927875, 34.88510548737731],
              [128.3852819279323, 34.88045689949077],
              [128.3822403595098, 34.87231363259591],
              [128.38678397955596, 34.86725386462563],
              [128.4192370174287, 34.86561187107545],
              [128.4140517772547, 34.85909021593094],
              [128.39645312304972, 34.86300905388555],
              [128.38448341280522, 34.859409123270964],
              [128.37053194874272, 34.84932575250781],
              [128.38852700325825, 34.84225969780846],
              [128.38831748942425, 34.835938419380106],
              [128.3970295250911, 34.831396987222696],
              [128.40504416341656, 34.83269793087823],
              [128.41889936616244, 34.83902486024396],
              [128.43064174191494, 34.83891198160566],
              [128.45209568838737, 34.847377964322206],
              [128.4535466590223, 34.85434004107802],
              [128.44660720808574, 34.863683350238645],
              [128.45341974900725, 34.87128493794121],
              [128.46732019010986, 34.87235067851827],
              [128.47109505696204, 34.884437880236554],
              [128.46384655884071, 34.8945262812782],
              [128.45604688228886, 34.89969949643512],
              [128.4574242801992, 34.90546364331772],
              [128.45196018242416, 34.910619440020184],
              [128.4364925070469, 34.889493513432186],
              [128.43278868083328, 34.87745055460854],
              [128.42146306837392, 34.87410639861203],
              [128.42335088904196, 34.88317913354134],
              [128.41785474123483, 34.89201873698727],
              [128.42202241673013, 34.902003660564816],
              [128.41772938549474, 34.90920905141722],
              [128.42948979501503, 34.91755525213863],
              [128.42833041531853, 34.92831357545842],
              [128.4344880552992, 34.930410663423714],
              [128.42475799457281, 34.94027356079812],
              [128.42945014259072, 34.94424643320145],
              [128.43131447525042, 34.95695428993996],
              [128.4438180375984, 34.96846316251853],
              [128.44150394647636, 34.9823542311435],
              [128.41781977944, 34.986774925262985],
              [128.40887877616916, 34.98244268633527],
              [128.40727774343787, 34.99401371140084],
              [128.41461363709232, 34.99695142001198],
              [128.42954782688992, 34.99340799939374],
              [128.4384517082911, 34.99473887983453],
              [128.47042071037652, 34.990208882484055],
              [128.47622738255333, 34.99851672661891],
              [128.48435500274977, 35.00022641703662],
              [128.5014787524487, 35.014735719007795],
              [128.50009625971933, 35.02097408351112],
              [128.4807717049749, 35.029043426450194],
              [128.4844466220302, 35.03295351555737],
              [128.4764749574751, 35.04214162494217],
              [128.4624308448226, 35.043424841759816],
              [128.46094016649428, 35.05034241811653],
              [128.47862898479076, 35.04782358383189],
              [128.4753268749542, 35.05380967968908],
              [128.48191068288995, 35.065523032612916],
              [128.4705571287529, 35.07441447107202],
              [128.46686814431732, 35.06664981652893],
              [128.46007087484944, 35.062648172395114],
              [128.45205467138035, 35.071248932088636],
              [128.44452061443104, 35.066064633164125],
              [128.44463980240823, 35.05605864034937],
              [128.43813726461414, 35.04552555858715],
              [128.43280383747384, 35.04730883705094],
              [128.41803769575543, 35.04258049920639],
              [128.40927183512116, 35.04312289037489],
              [128.39018378097632, 35.034546836578464],
              [128.3884253861955, 35.016659112972526],
              [128.3824447476859, 35.01860381559382],
              [128.3680232647239, 35.0162470828981],
              [128.37409814270583, 35.030089647351424],
              [128.38215083228647, 35.03657355594122],
              [128.374210691967, 35.03970093722703],
              [128.37325797590648, 35.04990361311933],
              [128.39676364239793, 35.053280857270394],
              [128.41212335069773, 35.06192350105304],
              [128.42834105271564, 35.055523432796804],
              [128.43983519610703, 35.0720669085385],
              [128.45398667152722, 35.0737236217817],
              [128.46150234674772, 35.07170109520513],
              [128.46548231297717, 35.079852340649985],
              [128.47094033853273, 35.0813753977203],
              [128.44721711281883, 35.0982378065182],
              [128.45967457831244, 35.10582516608311],
              [128.4687376697275, 35.09899154695957],
              [128.48145117597304, 35.09972101551322],
              [128.48836045240586, 35.10825459644218],
              [128.49599300329731, 35.10679942042533],
              [128.5050589204201, 35.099557901323536],
              [128.51739556133802, 35.098022522767586],
              [128.51981236224282, 35.105020586395796],
              [128.53875363538262, 35.1144775721217],
              [128.54886770801485, 35.10739590391868],
              [128.54752337684764, 35.096079596963456],
              [128.5689078806352, 35.09343664914072],
              [128.5733268775544, 35.086167394387395],
              [128.5640938917793, 35.08219861785314],
              [128.56594663221233, 35.070094687601326],
              [128.58089067174475, 35.06124479429317],
              [128.5811061091781, 35.054322232296556],
              [128.60686782371695, 35.05786562501387],
              [128.61297521755648, 35.06253607737726],
              [128.6341435232204, 35.06840327841978],
              [128.62597097688803, 35.07387211008163],
              [128.61436980398616, 35.069321987141194],
              [128.6112089989857, 35.07514623334687],
              [128.6185752204685, 35.08145782407672],
              [128.62138309026466, 35.090199421377626],
              [128.60160764639994, 35.10209039300235],
              [128.59900878298978, 35.13281426377055],
              [128.58375233918056, 35.127908303965505],
              [128.57515304665705, 35.13018765246337],
              [128.57656993258794, 35.13709683873285],
              [128.58856497118546, 35.1331023530805],
              [128.5965956200759, 35.14348623986954],
              [128.59132216717015, 35.15030143654875],
              [128.58561927188995, 35.16534027487887],
              [128.57973822307073, 35.172736712844625],
              [128.57038209238388, 35.174965092642395],
              [128.56447730494546, 35.186741932010776],
              [128.58764882332798, 35.20972807894387],
              [128.6180454572542, 35.212940157688166],
              [128.63232638164138, 35.221046145617436],
              [128.62520784848996, 35.21305516821229],
              [128.6080911995129, 35.21167451364026],
              [128.5893221304954, 35.199399278026156],
              [128.5924114972457, 35.19132297596443],
              [128.5914711800971, 35.178207035482345],
              [128.59978744105638, 35.16496305829208],
              [128.6055205743418, 35.160481213041734],
              [128.610364975724, 35.14363474246922],
              [128.61875374587828, 35.135871947149745],
              [128.62628845889597, 35.14834772377569],
              [128.64349326556606, 35.14961728302454],
              [128.6444559003611, 35.13561768827915],
              [128.6585611113196, 35.1369565336694],
              [128.66365001541317, 35.13020099952343],
              [128.6628431543692, 35.121515610419515],
              [128.6771549694281, 35.124784631442644],
              [128.67328445232192, 35.14093434777596],
              [128.6795759825086, 35.146783196662106],
              [128.69631157090143, 35.13878023832692],
              [128.69338965862082, 35.13294086824834],
              [128.6997223504793, 35.12577752138874],
              [128.7006198105567, 35.1157448678334],
              [128.68831299661414, 35.103692600688476],
              [128.69463678216798, 35.09724161127086],
              [128.7103422554564, 35.103562017039316],
              [128.71414267248772, 35.09758258070994],
              [128.73599196841067, 35.09108642204407],
              [128.73925863894723, 35.084029621618186],
              [128.74878213614264, 35.084042723472145],
              [128.75583156861805, 35.07794547976655],
              [128.76502729562014, 35.08301647555246],
              [128.77918177421807, 35.08289460648011],
              [128.78410341685733, 35.092330617409935],
              [128.77960291310427, 35.10341289837974],
              [128.78437451114965, 35.11391699417764],
              [128.79166572582412, 35.101716788111894],
              [128.80256516514712, 35.09920485106967],
              [128.79758610362134, 35.092614264826324],
              [128.7904394063583, 35.094588273863984],
              [128.7824673504588, 35.08534174765629],
              [128.78622083581996, 35.080180169059865],
              [128.79729211045725, 35.0775570123468],
              [128.81151489723274, 35.077580387994935],
              [128.82865581219284, 35.08993281508192],
              [128.82327176648073, 35.094236913993825],
              [128.82346827332793, 35.10187713607726],
              [128.83392173022364, 35.10180741771753],
              [128.8417004846229, 35.10598958110983],
              [128.8381870402218, 35.12308843415938],
              [128.8297926639854, 35.12821818949784],
              [128.81535669842532, 35.13263491083167],
              [128.8021325898126, 35.14190153733854],
              [128.7943032923664, 35.15391330136755],
              [128.80059522822089, 35.15806778641577],
              [128.81596562785288, 35.16016205972138],
              [128.82299253496046, 35.15615874739609],
              [128.84293309137033, 35.157988705716434],
              [128.84628864170864, 35.16468788850529],
              [128.85974323399188, 35.16817075102121],
              [128.87209641546556, 35.16261680021644],
              [128.8652675634407, 35.15817232004302],
              [128.8746945485576, 35.1536007728617],
              [128.87603808827419, 35.16554301612889],
              [128.8804342620702, 35.17152975832314],
              [128.88141714946318, 35.18281581254458],
              [128.87035480986864, 35.201558715279646],
              [128.8860685136527, 35.214398864745625],
              [128.9046679924945, 35.21530132711628],
              [128.9125032724265, 35.22251513733535],
              [128.9201282469602, 35.21642265903371],
              [128.93979665890973, 35.22724985856567],
              [128.95669620875506, 35.22525197297932],
              [128.98415781389892, 35.22975593562994],
              [128.9988030011557, 35.23808216144401],
              [129.01712048166112, 35.275459531334405],
              [129.03068288940074, 35.27687802697409],
              [129.0445979187604, 35.27450352600174],
              [129.05386888004975, 35.28286741948215],
              [129.05349915397684, 35.28899667338586],
              [129.0589450008685, 35.294979082001845],
              [129.07055411116576, 35.29452232133119],
              [129.07360693452088, 35.29084310927832],
              [129.09055058248774, 35.303423400081634],
              [129.0990941541465, 35.3040207248637],
              [129.11240680729944, 35.31013829556189],
              [129.11217580276892, 35.317350502247315],
              [129.1253374232516, 35.33141514295069],
              [129.12738336677998, 35.345762191212536],
              [129.13467749339242, 35.35291988659815],
              [129.1270351517531, 35.36240099958312],
              [129.1335210676203, 35.365593802919335],
              [129.1487584860452, 35.364251310391204],
              [129.162805842078, 35.35680641922786],
              [129.17818812126205, 35.35177492872864],
              [129.1987624675347, 35.36649641797086],
              [129.19918184613417, 35.37597753746919],
              [129.1935947927483, 35.38208857938124],
              [129.20281549928274, 35.39261065252199],
              [129.21888378273817, 35.40697148167368],
              [129.2102397299687, 35.419747667486355],
              [129.2001574499011, 35.424147739941226],
              [129.2021121777715, 35.43207423200624],
              [129.19650269035475, 35.438343314162125],
              [129.16804993542732, 35.431792540845585],
              [129.1395930171028, 35.44852933716424],
              [129.13808867645955, 35.452108125742896],
              [129.12176606465593, 35.46344269925687],
              [129.11727716751415, 35.475976541058735],
              [129.10962854019797, 35.47949859106452],
              [129.10672323035217, 35.49513585358124],
              [129.0904559331893, 35.498379564142965],
              [129.06161364816688, 35.509625655514114],
              [129.05263706394067, 35.51444823923767],
              [129.05211296660198, 35.52440149936061],
              [129.05582321066794, 35.53226752654746],
              [129.03245577397593, 35.52567997656478],
              [129.02734328092757, 35.527114386008286],
              [129.0108778923061, 35.52321416512821],
              [129.00969338755868, 35.52806099384718],
              [128.9953923803078, 35.52782439602157],
              [128.99883355200413, 35.53854209034339],
              [128.9969937483252, 35.54497222835463],
              [128.98934785209656, 35.55160482418218],
              [128.98092199174886, 35.54637320738784],
              [128.97291613963483, 35.5560626206297],
              [128.9779054757454, 35.56344699847247],
              [128.9958142353311, 35.56788550709078],
              [129.00793073120397, 35.58019162822856],
              [129.01889543224152, 35.583819933373086],
              [129.02462285805115, 35.59991614495987],
              [129.02245486012046, 35.61422335947839],
              [129.00791724209955, 35.61619165874287],
              [128.99709609850885, 35.61500444382023],
              [128.98264227075683, 35.60870517535865],
              [128.97280747374222, 35.613446965705776],
              [128.96087683371977, 35.61558127315585],
              [128.9612613512429, 35.62056227801958],
              [128.95119795263184, 35.63015352621416],
              [128.94114515578846, 35.635073438420555],
              [128.915053692309, 35.64061874571379],
              [128.90166724623734, 35.633211120115796],
              [128.8872448602404, 35.629107754661625],
              [128.8814607021125, 35.63547786465956],
              [128.87537847272935, 35.632329843840395],
              [128.8738762788404, 35.62163606680753],
              [128.85407515895534, 35.597181995229306],
              [128.84263870174073, 35.58899376140317],
              [128.83364828200567, 35.59735413694637],
              [128.82629469037585, 35.59677529358729],
              [128.80956359315093, 35.588984237082485],
              [128.80071574662355, 35.58762507624867],
              [128.7987805677373, 35.57830629867241],
              [128.78552869170696, 35.56688816193611],
              [128.7710372604493, 35.56863110408572],
              [128.75813554241338, 35.56749336592896],
              [128.7374182691524, 35.57715400036595],
              [128.7319727145176, 35.575953086614],
              [128.7225838008235, 35.58140142928353],
              [128.71495797722207, 35.57759729715749],
              [128.70330840163084, 35.57801011312454],
              [128.69494028131376, 35.58341755399668],
              [128.6876036571472, 35.59502512110598],
              [128.67424283943507, 35.596099719367],
              [128.66441875053778, 35.59375283114483],
              [128.65829246912114, 35.597686828468504],
              [128.64409080548143, 35.59305252429447],
              [128.6365323954697, 35.584697924759794],
              [128.63074670394673, 35.58742017676587],
              [128.61470361687984, 35.5816559141978],
              [128.5999692444708, 35.58042255127049],
              [128.57295715854792, 35.593216008769055],
              [128.56903355516948, 35.602454057437434],
              [128.56197610017844, 35.602684428957396],
              [128.55873261747348, 35.614800027813416],
              [128.5365542797871, 35.624496600474586],
              [128.53816984168492, 35.631908203544626],
              [128.53476820700436, 35.64370158475903],
              [128.53743417995432, 35.65976079725143],
              [128.53145551952838, 35.66217090677324],
              [128.52680844774218, 35.673504438949976],
              [128.52792537859423, 35.68315511508097],
              [128.5094550584378, 35.67471463805491],
              [128.50623621142753, 35.639556969865964],
              [128.48134003227548, 35.63526569928214],
              [128.47618743192413, 35.64020682204027],
              [128.46626306318095, 35.636744051548284],
              [128.44647601723554, 35.63841360819008],
              [128.43098032341467, 35.621638800327766],
              [128.42271637496827, 35.62508179843372],
              [128.41903981659428, 35.619697784872336],
              [128.4065426164422, 35.61419723696319],
              [128.39929244896598, 35.615919124076306],
              [128.38775183390356, 35.61015130667274],
              [128.37981875806705, 35.6092520034395],
              [128.36463416583447, 35.613356964355575],
              [128.36276804844792, 35.625998667138056],
              [128.35793856734017, 35.63735575397075],
              [128.3491680617255, 35.64644569091839],
              [128.32404181458892, 35.64661224963002],
              [128.31791044652508, 35.651491949585036],
              [128.30598968186578, 35.65547619200579],
              [128.2962539104263, 35.65072946411507],
              [128.27948507711363, 35.65231177225837],
              [128.27735647256566, 35.64728846819786],
              [128.2623438099503, 35.64273693844256],
              [128.25864358938512, 35.64779676430127],
              [128.24184032472584, 35.655117227049516],
              [128.23636066960955, 35.65108309634665],
              [128.2357280670248, 35.6404381483557],
              [128.2201792322164, 35.63998700297601],
              [128.21039002050492, 35.64378765599316],
              [128.20123098632706, 35.64372192012672],
              [128.19886997399087, 35.64915376261456],
              [128.18523703237545, 35.657672565260334],
              [128.16589423304586, 35.65299196954737],
              [128.16149826149245, 35.65378735901507],
              [128.16009486257448, 35.66750003941349],
              [128.16659560359773, 35.674090078021074],
              [128.17887866159876, 35.67292797652148],
              [128.18413842925517, 35.68004740993397],
              [128.1913108883589, 35.67877716095768],
              [128.20481849565306, 35.683923204531716],
              [128.20459037052044, 35.696183899268796],
              [128.20025176097496, 35.70931141056335],
              [128.20124795528076, 35.72315948745937],
              [128.19663339749778, 35.7303832717866],
              [128.1892794102309, 35.75175972156863],
              [128.16499976449572, 35.76348937273931],
              [128.16153428418497, 35.770011172452115],
              [128.16350997612307, 35.77701091540335],
              [128.15437040986748, 35.786448021805995],
              [128.14796516022608, 35.7840081016594],
              [128.1357801073544, 35.78483993060165],
              [128.12863033691582, 35.78934152668807],
              [128.12242534801706, 35.803044209573706],
              [128.12399266735378, 35.82004082278412],
              [128.11937174535223, 35.82489867673363],
              [128.11092183188583, 35.823882021843545],
              [128.09478373693884, 35.832263890134996],
              [128.0697857891432, 35.84120189896299],
              [128.05165366975268, 35.8298826358592],
              [128.02978168873804, 35.835648681136455],
              [128.0117805245253, 35.82893401834474],
              [127.99647599891745, 35.837637539880845],
              [127.98174926125353, 35.85873533204672],
              [127.97397994927877, 35.852068136837886],
              [127.95011238902106, 35.861666735405386],
              [127.94223971093874, 35.854542472629156],
              [127.9303465283538, 35.85637448210019],
              [127.93320824516755, 35.86424018046272],
              [127.9287930284566, 35.87034736373107],
              [127.93022044531327, 35.87862944300057],
              [127.92287398130749, 35.8825814943136],
              [127.91851559946078, 35.89038073287879],
              [127.89313835522239, 35.88707990409176],
              [127.88478334861787, 35.89310653166989],
              [127.87951079172635, 35.90985022983464],
              [127.87070877818688, 35.90434621207427],
              [127.8595402333288, 35.906490587964],
              [127.85708221802344, 35.89498894637609],
              [127.85123590699932, 35.88951334558023],
              [127.85367520121515, 35.881343176730205],
              [127.84433253715912, 35.87512847378948],
              [127.84175147729822, 35.866247035182816],
              [127.82656192210135, 35.86834682624664],
              [127.81944438046958, 35.859636773753],
              [127.80930998286965, 35.85510150586474],
              [127.80435552384655, 35.85868918376961],
              [127.7791700119988, 35.84723764355158],
              [127.77276495227616, 35.83957880729549],
              [127.75947743390985, 35.836907274778724],
              [127.74445342248646, 35.84442257418028],
              [127.73778334750179, 35.83438732265031],
              [127.73947140950268, 35.82971056962444],
              [127.71938601485131, 35.797316001680954],
              [127.7065307521923, 35.79202013511757],
              [127.68481111971424, 35.77767938979793],
              [127.67943626552773, 35.768498736097875],
              [127.66951338331404, 35.77137366499873],
              [127.66228754779715, 35.76082974263145],
              [127.66313494156225, 35.74158220718722],
              [127.66095634391797, 35.70990593459445],
              [127.64907492849068, 35.702999530770064],
              [127.64179529949295, 35.692892730623235],
              [127.63908064708555, 35.66992281717549],
              [127.62791451819886, 35.66221466562331],
              [127.62948135860101, 35.65664023052889],
              [127.62215793705572, 35.65101656957186],
              [127.61977132597636, 35.64345541356236],
              [127.62425700774342, 35.631785704565154],
              [127.63533525863174, 35.61848395452059],
              [127.62139708077316, 35.61511812709079],
              [127.61238812208157, 35.606845418884404],
              [127.61304571755683, 35.59971782418282],
              [127.60745604666575, 35.59491256459256],
              [127.61030315852383, 35.58296141890452],
              [127.59607493930098, 35.57368719747978],
              [127.5887717221526, 35.56476669986048],
              [127.58728878429415, 35.55703967125678],
              [127.60957781033652, 35.54026226380971],
              [127.6253302361938, 35.53140263090089],
              [127.64431306181886, 35.499018019456194],
              [127.65038819881981, 35.49789988386088],
              [127.65310711782337, 35.48686870307815],
              [127.63739464759828, 35.47926933945758],
              [127.63668808903857, 35.45935201634297],
              [127.6451865167013, 35.44912733429724],
              [127.65338927709017, 35.451583834944394],
              [127.66115708434138, 35.44754357276237],
              [127.67406961648572, 35.44572001918926],
              [127.6651768944584, 35.43564884721128],
              [127.66577460540408, 35.42742632211401],
              [127.66047407466593, 35.41443375374226],
              [127.64644684529453, 35.40266417388475],
              [127.63691577224253, 35.401038829539814],
              [127.62487924194093, 35.38238489532321],
              [127.62565371870635, 35.37691082310529],
              [127.6101973772039, 35.36591811779902],
              [127.61223658809101, 35.35585036787703],
              [127.62333075063204, 35.34216601299156],
              [127.62073946811694, 35.33249121385457],
              [127.60768544496752, 35.325044378436075],
              [127.60654029677785, 35.32066029672286],
              [127.59296427053276, 35.31182656146774],
              [127.57954911880474, 35.30959012241386],
              [127.57607074422863, 35.30608038679251],
              [127.57736791676054, 35.29515685768229],
              [127.58407158210257, 35.29110475418583],
              [127.59569677414879, 35.26813330860577],
              [127.61015829782758, 35.26204555802802],
              [127.61282043497616, 35.24161665813405],
              [127.61928665504779, 35.23560294639895],
              [127.62072789786743, 35.21265682746316],
              [127.61706649168038, 35.20958186733488],
              [127.61802616860885, 35.19974210309674],
              [127.62462470167377, 35.18257410989442],
              [127.63749559149545, 35.17312588045732],
              [127.6483717591199, 35.16039172671087],
              [127.659335747074, 35.158964768325966],
              [127.67570296867632, 35.147344894117495],
              [127.6938483602407, 35.12793104390614],
              [127.69485365627102, 35.10629316776135],
              [127.71768900689072, 35.0826148721262],
              [127.7342166853004, 35.0753345601027],
              [127.73994442899881, 35.06336237659752],
              [127.75154153835263, 35.05672437506181],
              [127.76344665571408, 35.05483227829474],
              [127.76965857423282, 35.04645301000651],
              [127.77162528479377, 35.033722562034775],
              [127.78484104792233, 35.020935328955716],
              [127.78682339474823, 35.010214236106044],
              [127.78057078392658, 34.99040019734347],
              [127.76349613046544, 34.976086915732346],
              [127.77254312346811, 34.963362488994676],
              [127.77394812820809, 34.95504750052236],
              [127.78207637283424, 34.94369160716833],
              [127.79134463000688, 34.94138885905307],
              [127.80764953537133, 34.94454473117991],
              [127.81550792027898, 34.93986735244315],
              [127.82189932713592, 34.94579646413169],
              [127.844171997596, 34.95127865509765],
              [127.85049180492187, 34.94719445271492],
              [127.87220530916429, 34.946472725154976],
              [127.88121259966346, 34.95293338612948],
              [127.89816224508209, 34.959783934016485],
              [127.90109715938608, 34.971540061733606],
              [127.91037306749405, 34.974799009326745],
              [127.91780560305882, 34.98916608762879],
              [127.91641328426775, 34.99691335525999],
              [127.92673472439232, 35.01346849323329],
              [127.94256898440216, 34.9982317771341],
              [127.93218140236887, 34.99219642365782],
              [127.94122211416291, 34.98793428126179],
              [127.93473160614175, 34.98196720290606],
              [127.94540284023122, 34.977743343161436],
              [127.95656504281149, 34.984722397406735],
              [127.96210792981665, 34.99283760710999],
              [127.96777040112165, 34.99207922507152],
              [127.98304067644553, 34.97647173424908],
              [127.99175325393968, 34.98226279452776],
              [127.993189248253, 34.99148644506927],
              [127.99777347021066, 34.99613392195087],
              [128.00847708007325, 34.992948975937274],
              [128.01510503263424, 34.99539313359262],
              [128.01984419503802, 35.00465170523603],
              [128.00684449659337, 35.014943024226476],
              [128.0079575747713, 35.02288601058521],
              [128.00381402556874, 35.02699360408561],
              [127.98136704359628, 35.039267304692096],
              [127.98712568277139, 35.04663599880706],
              [127.99430652664117, 35.04646871471854],
              [128.00777000566933, 35.03892482472396],
              [128.00839728176823, 35.03146059121455],
              [128.0187129195099, 35.02826821391243],
              [128.0251345821916, 35.03317825714341],
              [128.02876475282014, 35.046335192774535],
              [128.0254740876854, 35.05230925772078],
              [128.0325171020533, 35.06957529780324],
              [128.054223157989, 35.08177924036503],
              [128.05734062084667, 35.076044010371405],
              [128.0456541560744, 35.06757063757596],
              [128.03912343841168, 35.05561185220436],
              [128.0390025833256, 35.036202871143914],
              [128.04321082995517, 35.02498476427309],
              [128.05076490828637, 35.01547364973885],
              [128.03878538387923, 34.997826918791105],
              [128.03934225955922, 34.99285501410469],
              [128.04896757411652, 34.978712727079866],
              [128.05013200492365, 34.969143714135384],
              [128.0308097317762, 34.95572606419962],
              [128.03931058187473, 34.946573058694526],
              [128.03946878922187, 34.94184680307665],
              [128.05505662628374, 34.92879964330402],
              [128.0756237843248, 34.92380952742214],
              [128.0769691634104, 34.927407005031824],
              [128.102311950397, 34.92598298319627],
              [128.11010264036543, 34.916716528484095],
              [128.102095686579, 34.914746840340776],
              [128.10976433376018, 34.90409658278291],
              [128.11451954781674, 34.90949263369484],
              [128.12508038847383, 34.90169277933078],
              [128.12785748588567, 34.89395470351185],
              [128.13757229759426, 34.89184467919231],
              [128.1407241201665, 34.90241234800197],
              [128.1475180546132, 34.901079817698275],
              [128.15687574091942, 34.909569434176944],
              [128.16029291297292, 34.90267938317477],
              [128.1691860145449, 34.90078762152134],
              [128.17470235436792, 34.90761369277372],
              [128.181313866645, 34.89636447231568],
              [128.19975833177998, 34.89351002096927],
              [128.20310669254113, 34.89965792191182],
              [128.19597954523815, 34.91141556409013],
              [128.20402972150515, 34.92780590826205],
              [128.19943018949635, 34.93347467378001],
            ],
          ],
          [
            [
              [128.50191662366785, 34.7398197612841],
              [128.494450018462, 34.750030560094075],
              [128.48474748727642, 34.74489726176638],
              [128.48374555438028, 34.73726650266452],
              [128.49718967716365, 34.73289320537786],
              [128.50191662366785, 34.7398197612841],
            ],
          ],
          [
            [
              [128.50894144139542, 34.80012526007862],
              [128.49890261198018, 34.802779199633854],
              [128.49496240995157, 34.79165288802729],
              [128.5041191704274, 34.788512059221695],
              [128.50894144139542, 34.80012526007862],
            ],
          ],
          [
            [
              [128.46607761227972, 34.905990649954504],
              [128.4754450396709, 34.904396307617645],
              [128.47257599079313, 34.91487310652647],
              [128.46560144616527, 34.91563112729632],
              [128.46607761227972, 34.905990649954504],
            ],
          ],
          [
            [
              [128.35395153938396, 34.650210459453724],
              [128.34494031821416, 34.64844660244624],
              [128.34951757214193, 34.63979005211791],
              [128.35746815832925, 34.64014734227601],
              [128.35395153938396, 34.650210459453724],
            ],
          ],
          [
            [
              [128.17807846588616, 34.71054540549528],
              [128.16799278942833, 34.706642988632275],
              [128.1713753524009, 34.69909314238183],
              [128.18420095477853, 34.69199694061595],
              [128.20184066694947, 34.69224234590398],
              [128.19851267100478, 34.70629640191902],
              [128.19139678110804, 34.710843919302],
              [128.17807846588616, 34.71054540549528],
            ],
          ],
          [
            [
              [128.29613307942668, 34.761330985954736],
              [128.2888359815625, 34.75798697930781],
              [128.29082511246932, 34.74917677960891],
              [128.2971838631063, 34.748976062500375],
              [128.29961930796287, 34.75815741810479],
              [128.29613307942668, 34.761330985954736],
            ],
          ],
          [
            [
              [128.0311218560985, 34.92174899980216],
              [128.00946575723185, 34.91778766173089],
              [127.99606465171941, 34.90991326063739],
              [127.97629561622668, 34.87851924286765],
              [127.9620421065053, 34.86937003059241],
              [127.96519085996269, 34.85260208173276],
              [127.971221659878, 34.842159253302675],
              [127.98670264455988, 34.836863232322585],
              [128.00071572683734, 34.835986235148745],
              [128.01898489196046, 34.839430726748134],
              [128.0226740473057, 34.848458754803204],
              [128.0454734862259, 34.8364355609467],
              [128.05579779944583, 34.83722371530318],
              [128.06526967940403, 34.83074528404711],
              [128.076414567089, 34.8384997460896],
              [128.07546088025842, 34.84414116448097],
              [128.0607598996757, 34.84452643859964],
              [128.0643452546421, 34.861338300154685],
              [128.06053959297438, 34.879093913353664],
              [128.04200050976146, 34.895159910439176],
              [128.03552511634035, 34.89747340422246],
              [128.0296964041698, 34.88714930300392],
              [128.02306355375663, 34.88291859608213],
              [128.02445891784302, 34.86594960340018],
              [128.01176890079466, 34.86574883990333],
              [128.00961659099084, 34.87436997386663],
              [128.0148317038343, 34.8857146705535],
              [128.01586771698092, 34.89437749858406],
              [128.02594479508863, 34.9030064769029],
              [128.03265201595505, 34.91948417821424],
              [128.0311218560985, 34.92174899980216],
            ],
          ],
          [
            [
              [127.89106754839015, 34.946782582228906],
              [127.87335212047797, 34.9409758060018],
              [127.86512535015451, 34.93618493527883],
              [127.85414414367847, 34.91833245213298],
              [127.86210794697547, 34.90136248038447],
              [127.85107852352913, 34.902776388167666],
              [127.83307581860342, 34.89275761771983],
              [127.82622740092246, 34.87360840177707],
              [127.81042062420126, 34.859431688810666],
              [127.81287721295192, 34.83465970121804],
              [127.82807587371194, 34.81109169494182],
              [127.8354570322897, 34.80294916653806],
              [127.83684016834587, 34.79097266388704],
              [127.84449247121064, 34.788024035451684],
              [127.8524279225081, 34.76898056145766],
              [127.83664434656174, 34.757285168508986],
              [127.83676810096786, 34.75042763832544],
              [127.85171123690708, 34.749297036984444],
              [127.85254141673941, 34.73933488364271],
              [127.86203021147017, 34.73418010711533],
              [127.85965530325288, 34.72872831738752],
              [127.87532263592819, 34.727681442151514],
              [127.88528163475198, 34.72303705451374],
              [127.9061055695995, 34.72827037153045],
              [127.91239772724248, 34.73650501029712],
              [127.91034236466743, 34.749710318057254],
              [127.90491339311986, 34.75449368242618],
              [127.9025983442081, 34.76336829859936],
              [127.91095473346229, 34.769530717326084],
              [127.92854215749709, 34.7760395082879],
              [127.94945832867678, 34.777729096932944],
              [127.95470990397705, 34.77283130107994],
              [127.94852153107071, 34.765881077634226],
              [127.94584396529604, 34.74975430244257],
              [127.94635300636837, 34.73386298361319],
              [127.95319979081236, 34.71518424623988],
              [127.95915307901583, 34.710216484567255],
              [127.98704033570503, 34.711928711876816],
              [127.9944089548585, 34.714860999752005],
              [128.0111226696231, 34.71662946751779],
              [128.01513357048046, 34.72448165600888],
              [128.02657276584839, 34.71814326382155],
              [128.02277238129136, 34.70700161316789],
              [128.05674139655417, 34.70881123372502],
              [128.05354235103727, 34.71483163200674],
              [128.04463865007506, 34.71413201761836],
              [128.03435462473232, 34.72151003710138],
              [128.03518706501248, 34.731564434444515],
              [128.04884597529414, 34.74310623335852],
              [128.0561800696882, 34.74606674815303],
              [128.05411641276137, 34.769397457455916],
              [128.0497644342603, 34.77335676155049],
              [128.0488878485284, 34.78242984689509],
              [128.05692228116487, 34.79228857212636],
              [128.0512020321657, 34.798625505583914],
              [128.06135383558063, 34.804452127475166],
              [128.06359670683148, 34.81703383939099],
              [128.0493034469093, 34.8259344211238],
              [128.04243241951934, 34.822588439676124],
              [128.03525956885912, 34.82611199598355],
              [128.03058196045401, 34.83405394174433],
              [128.01666709503044, 34.83007264390902],
              [127.99051931876672, 34.833066528622716],
              [127.98132595055831, 34.82606519660319],
              [127.97921164697453, 34.820600440235424],
              [127.96061364590652, 34.813086716989154],
              [127.9542114058909, 34.804987844335976],
              [127.94388345052582, 34.80947201547015],
              [127.94088370982779, 34.81573127020935],
              [127.94234401878717, 34.82686199085262],
              [127.93252371571026, 34.8332155117545],
              [127.92685779017857, 34.83072043682692],
              [127.91725336640634, 34.83703613802006],
              [127.91287732194701, 34.85028378131519],
              [127.90889154155383, 34.85177181521414],
              [127.89743199972277, 34.874440424623785],
              [127.90684739482539, 34.8836226867736],
              [127.92017799912466, 34.89227523742687],
              [127.92052459256048, 34.90013825200301],
              [127.92598917902731, 34.90536751050152],
              [127.92876448778264, 34.915538318283225],
              [127.92476997466964, 34.91965636696275],
              [127.92615267737663, 34.92790338178374],
              [127.91578565948166, 34.93857554051344],
              [127.90255783157858, 34.94109808502155],
              [127.89106754839015, 34.946782582228906],
            ],
          ],
          [
            [
              [127.96755583529186, 34.989490336478724],
              [127.96226660732529, 34.980022283575416],
              [127.96908002824544, 34.96729044588616],
              [127.97923761391188, 34.96412255987664],
              [127.98071646134659, 34.971918910108386],
              [127.96708161232915, 34.98124328309994],
              [127.96755583529186, 34.989490336478724],
            ],
          ],
          [
            [
              [128.55297345663385, 35.069660968427115],
              [128.54227932092158, 35.06904427453389],
              [128.55519466156795, 35.053836573815786],
              [128.56697290193347, 35.0563088198274],
              [128.55297345663385, 35.069660968427115],
            ],
          ],
          [
            [
              [128.5387194316719, 34.80642455003237],
              [128.546431045375, 34.816314585540006],
              [128.54361885426033, 34.82459948381681],
              [128.53461205083073, 34.82243644657456],
              [128.52799127362525, 34.80277559067909],
              [128.5387194316719, 34.80642455003237],
            ],
          ],
          [
            [
              [128.52729125856132, 34.92872487532452],
              [128.5327260711028, 34.93825776540671],
              [128.53217240580776, 34.94383814636175],
              [128.5240514618688, 34.948974980189384],
              [128.52227551529194, 34.95692267759972],
              [128.53662644034358, 34.965205347933875],
              [128.53199113484047, 34.97263147468455],
              [128.52093114430053, 34.97462166020102],
              [128.5146216141044, 34.96895610677145],
              [128.51819237297633, 34.95904766253682],
              [128.5178190780946, 34.94617392986393],
              [128.51304648674449, 34.94006769112713],
              [128.52729125856132, 34.92872487532452],
            ],
          ],
          [
            [
              [128.64739388078317, 34.988733232512935],
              [128.64510627767928, 34.99409964187153],
              [128.65480091619503, 35.012598052820145],
              [128.6437461306082, 35.01223305042374],
              [128.6383733968322, 35.0155671790279],
              [128.63136653213058, 35.00570393131156],
              [128.62223673727664, 34.98621010603479],
              [128.61588168090324, 34.986483635117],
              [128.60883424311905, 34.97593681205536],
              [128.6177744577001, 34.97589655617109],
              [128.61899780077877, 34.98192051960277],
              [128.63400056411166, 34.97727213533417],
              [128.64354332901695, 34.978426037760485],
              [128.64739388078317, 34.988733232512935],
            ],
          ],
          [
            [
              [128.52596263855742, 34.92120297169717],
              [128.51586900138236, 34.909719344105994],
              [128.49516918005568, 34.900646008619596],
              [128.48431284574096, 34.888208082673756],
              [128.47610388960254, 34.88375731203024],
              [128.47278949900706, 34.87674045848025],
              [128.47488766876165, 34.86061469347918],
              [128.4819995126699, 34.84030336561941],
              [128.50165205319743, 34.83323960566318],
              [128.50146863938946, 34.82280746768182],
              [128.50913190166375, 34.817860449241735],
              [128.51593696216665, 34.808222891557165],
              [128.52383312880244, 34.81695041593496],
              [128.51908792727892, 34.822305661623695],
              [128.5291910381056, 34.83384276050769],
              [128.56094016329007, 34.83271317142118],
              [128.56244916257558, 34.84302029647592],
              [128.57295255121477, 34.85438243943771],
              [128.58897299328737, 34.846441355287354],
              [128.58515659171684, 34.83358560045669],
              [128.59566384367818, 34.826732608175995],
              [128.58498242908263, 34.8181018399067],
              [128.58654624217175, 34.81047242692774],
              [128.58422861860194, 34.79784720422867],
              [128.57986593891562, 34.79427604682898],
              [128.5656552227407, 34.79357119704173],
              [128.5664539026999, 34.788011092777175],
              [128.5612871248922, 34.778361482321515],
              [128.55216618553973, 34.77444824144078],
              [128.5535315839227, 34.76772351076322],
              [128.563252489763, 34.76699460605957],
              [128.56806148098633, 34.77385278009173],
              [128.57761593621782, 34.77887962133937],
              [128.59068555726438, 34.776211469334235],
              [128.60112147240312, 34.767132515741395],
              [128.58802498677508, 34.761796305140365],
              [128.57814021033448, 34.75334003688476],
              [128.57703351194297, 34.741769192071544],
              [128.58626488627874, 34.737393735344696],
              [128.60661796816052, 34.734874668530104],
              [128.6049925302573, 34.7279208771689],
              [128.59232173445045, 34.722408732620764],
              [128.5873629009894, 34.716413316911314],
              [128.57895530863175, 34.71497095940374],
              [128.57675857523586, 34.70725087540235],
              [128.58849081162637, 34.70987376562734],
              [128.59963319842558, 34.70466942216532],
              [128.60942025473398, 34.703587661376645],
              [128.6190123545243, 34.70694123530166],
              [128.62602839198394, 34.71407821948228],
              [128.63716573440473, 34.70756958309485],
              [128.63891660513113, 34.7141722483772],
              [128.63038900757311, 34.72017131046559],
              [128.62653282452223, 34.72777662995129],
              [128.6395676395696, 34.736194386132134],
              [128.6450492525678, 34.73477520928345],
              [128.66229927821857, 34.739580774957275],
              [128.67253378124303, 34.732554252623046],
              [128.67745319019465, 34.73832441985248],
              [128.67028713151623, 34.744493679336216],
              [128.65576390636147, 34.74203687066756],
              [128.637901052972, 34.761314239609476],
              [128.641058457651, 34.77459356701729],
              [128.64908484121153, 34.77916846689565],
              [128.65798610346673, 34.77468065822754],
              [128.6680279387275, 34.78019839920624],
              [128.67285661417753, 34.78758291928458],
              [128.66599883053937, 34.793327628076746],
              [128.67247525658934, 34.814682838611645],
              [128.69178923496307, 34.80826471636647],
              [128.68911398764214, 34.79783978039924],
              [128.69859545049223, 34.79780325507139],
              [128.69680770797223, 34.80742185022506],
              [128.7086160367876, 34.812917726943745],
              [128.71527998312666, 34.80053955358729],
              [128.7094977803702, 34.79623711744738],
              [128.72399966123336, 34.79203319067244],
              [128.7390947084245, 34.79187983206143],
              [128.72807488361937, 34.8113454409343],
              [128.72172145472248, 34.813984888645315],
              [128.72488729423247, 34.831271637207074],
              [128.71844398441414, 34.83581246112434],
              [128.71031185963292, 34.82835864313249],
              [128.70289398818707, 34.832560852474735],
              [128.7027665797139, 34.84240471862511],
              [128.71731991465265, 34.849736108019265],
              [128.72524436324363, 34.8416652906652],
              [128.73514869819098, 34.84378510058803],
              [128.72924093088952, 34.85299343640822],
              [128.73038450279472, 34.86274285638024],
              [128.74300604881736, 34.86769957869435],
              [128.73377424125786, 34.890940172740656],
              [128.72391302687777, 34.88692120921574],
              [128.70902001048134, 34.87653185190725],
              [128.69972526791057, 34.87870720964212],
              [128.69608550629164, 34.88948756849601],
              [128.70399968147765, 34.89254001740475],
              [128.70732500593078, 34.899354894466285],
              [128.71445737722925, 34.89980039024144],
              [128.71226384352045, 34.912742437904484],
              [128.72375747302948, 34.91463223846585],
              [128.71931162557783, 34.92643015298995],
              [128.71746954571495, 34.940241059236385],
              [128.72694006378097, 34.93984989143393],
              [128.71475485511908, 34.95836726815302],
              [128.69687511199126, 34.972706683856046],
              [128.6947767305563, 34.98012209777993],
              [128.7007797532548, 35.00406367281782],
              [128.71198622553496, 35.00498617246493],
              [128.72010384472657, 35.01741615196906],
              [128.7195359076563, 35.02270135560736],
              [128.71184185111133, 35.03128914420722],
              [128.69356440368955, 35.03033440885565],
              [128.67650444740144, 35.03264667810867],
              [128.66945277767306, 35.007138781105404],
              [128.6714243585712, 34.99866360303312],
              [128.66426516616676, 34.99717387193934],
              [128.6547479084792, 34.9896676174893],
              [128.64727889760817, 34.959918041127395],
              [128.6245805151472, 34.963886813039906],
              [128.60909977984727, 34.95804346033995],
              [128.60594557099913, 34.96991784163621],
              [128.599442167783, 34.96730136535687],
              [128.59894402441043, 34.95341298086788],
              [128.58652975890155, 34.94507289914394],
              [128.59226661858864, 34.9351693793337],
              [128.603608442232, 34.92477718953258],
              [128.60819832215736, 34.917413638553114],
              [128.6173786893625, 34.91262782644159],
              [128.6179806821651, 34.906343897280074],
              [128.6258515591388, 34.89851929522647],
              [128.6156316655631, 34.89548521041136],
              [128.61111552690878, 34.901502974392876],
              [128.59638457587295, 34.90621791830248],
              [128.585379443834, 34.905365525311225],
              [128.58517958954937, 34.91302262346391],
              [128.5708117807798, 34.90823204623536],
              [128.57303816742603, 34.89873904001116],
              [128.56538243858742, 34.89919586290896],
              [128.55751513583422, 34.90535137851969],
              [128.54955961116056, 34.90688700002554],
              [128.54494134701974, 34.91443030424026],
              [128.53515192292514, 34.922235261897015],
              [128.52596263855742, 34.92120297169717],
            ],
          ],
        ],
      },
      properties: { CTPRVN_CD: '48', CTP_ENG_NM: 'Gyeongsangnam-do', CTP_KOR_NM: '경상남도' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [126.27309484831437, 33.17466450437732],
              [126.26453233098769, 33.16962746058689],
              [126.27112234490838, 33.16406717823019],
              [126.27803643968652, 33.17018931502452],
              [126.27309484831437, 33.17466450437732],
            ],
          ],
          [
            [
              [126.95314326899152, 33.52442096221677],
              [126.94933356382506, 33.515029490279474],
              [126.94124412723639, 33.50647686944156],
              [126.94758132762338, 33.49338025058287],
              [126.96421341582425, 33.490750060870226],
              [126.97042798934733, 33.49916459082379],
              [126.9641309396869, 33.514144484271256],
              [126.95314326899152, 33.52442096221677],
            ],
          ],
          [
            [
              [126.24969154814548, 33.21838802224369],
              [126.25646624842939, 33.21040229598091],
              [126.26336627954603, 33.20985946478923],
              [126.2625174190231, 33.199409409723415],
              [126.26979089238384, 33.19605392425911],
              [126.29009887239555, 33.20379221479638],
              [126.2944227395777, 33.220250808863035],
              [126.3011567314909, 33.22684275958981],
              [126.30851458186119, 33.2281788571721],
              [126.3146538824132, 33.236361531968804],
              [126.32821509757476, 33.24136450908541],
              [126.3381308151734, 33.23620295601526],
              [126.35816168650632, 33.23726215316833],
              [126.37017572944407, 33.231730797129096],
              [126.38615966815384, 33.23546618663193],
              [126.4099359336336, 33.2460277131773],
              [126.4178635646615, 33.24400034867719],
              [126.42428244658834, 33.23751104991232],
              [126.4328375460576, 33.23407085135639],
              [126.43787102994433, 33.238767252166085],
              [126.45489968216393, 33.241473829785114],
              [126.46084489421013, 33.2393498057647],
              [126.47090148793934, 33.22657848691363],
              [126.4795540311919, 33.22657113810878],
              [126.49812577610828, 33.23317926145373],
              [126.5081770317649, 33.23087461738321],
              [126.51977134812914, 33.24082043433588],
              [126.54361994565461, 33.23903926712979],
              [126.56620451352701, 33.24079322697458],
              [126.57203056145, 33.24510750951383],
              [126.58901738388529, 33.24371564858888],
              [126.59928143623945, 33.23621090523174],
              [126.61721092328948, 33.24226168158846],
              [126.61954165749964, 33.250010906637534],
              [126.6393057115612, 33.25775312384312],
              [126.6411065601322, 33.26498539027485],
              [126.6530727737642, 33.270175944586924],
              [126.670987461567, 33.271283002587765],
              [126.67687358595134, 33.268321019519654],
              [126.69949145550483, 33.27108878711658],
              [126.71859461623791, 33.277949039285296],
              [126.74335319544278, 33.27885179485493],
              [126.76349500719182, 33.29250004621314],
              [126.77572999970242, 33.30700503319891],
              [126.79180304518907, 33.30362580297479],
              [126.81634323835902, 33.30799653595631],
              [126.82909341899216, 33.306514277536266],
              [126.84669533448546, 33.321591116588],
              [126.83665754401987, 33.328748650089146],
              [126.85305345040734, 33.33916098429963],
              [126.8681786914644, 33.3547231320706],
              [126.86719523751599, 33.36421791813146],
              [126.88014972201528, 33.38231096707575],
              [126.89158393071719, 33.3880016733693],
              [126.90554917633813, 33.39164571528765],
              [126.90285423089153, 33.403373706650456],
              [126.90764500785289, 33.40724593585546],
              [126.91138635428896, 33.42005627592052],
              [126.92292610750525, 33.435075152533194],
              [126.92920217384695, 33.423604361518755],
              [126.93500812834067, 33.42935827703826],
              [126.92451268657601, 33.434811561058766],
              [126.92082054722025, 33.44445508955085],
              [126.92437630387711, 33.4530216291358],
              [126.92167877220373, 33.46866001924429],
              [126.90168871449093, 33.480950347551776],
              [126.90506967132356, 33.488832284205664],
              [126.91061281255786, 33.48865280188544],
              [126.91310370824388, 33.503334976604144],
              [126.90641549623865, 33.51058727264864],
              [126.89963006687066, 33.509489762418674],
              [126.90054782137727, 33.51944586551438],
              [126.89281325620968, 33.52643714256141],
              [126.8719395570168, 33.52938898384292],
              [126.86073654032289, 33.524697048729706],
              [126.83089414168704, 33.540594952427],
              [126.8290122590966, 33.55081244472066],
              [126.82412463028146, 33.55874442101414],
              [126.81549838367505, 33.56067524738435],
              [126.80811250530469, 33.55627895716765],
              [126.79617507000812, 33.555746104278825],
              [126.79326307274538, 33.559592555641785],
              [126.77187037386206, 33.56507013538936],
              [126.7637480526987, 33.565059716337274],
              [126.7601924663383, 33.55714499120379],
              [126.74939607407144, 33.558853413018134],
              [126.73773549175452, 33.55484836769894],
              [126.73025492919014, 33.5603612385839],
              [126.71271239833449, 33.55439791641051],
              [126.6980059992255, 33.5526258313709],
              [126.68808093217656, 33.54847357631862],
              [126.6777776434858, 33.552442248217005],
              [126.67391585199167, 33.546107144437045],
              [126.66405077843154, 33.543359330722936],
              [126.65435040853382, 33.551195042882526],
              [126.64452727390227, 33.55461532856034],
              [126.63534008202491, 33.53637452420272],
              [126.61310465023737, 33.53811588312183],
              [126.6044864645253, 33.53534873365114],
              [126.5974393791676, 33.53760122988441],
              [126.58622640245171, 33.525532578917385],
              [126.56524872496372, 33.524227469185156],
              [126.55091717348776, 33.52034142090908],
              [126.54317359397606, 33.52380365506919],
              [126.5308805272955, 33.51759241572286],
              [126.51856736242704, 33.519349472778174],
              [126.51135964981633, 33.51555085263629],
              [126.49490785069155, 33.520540464220765],
              [126.48593761455014, 33.517367831153585],
              [126.4837665372637, 33.51135543928955],
              [126.46040552157295, 33.50416562387502],
              [126.45400069294823, 33.49777855154111],
              [126.42715696271021, 33.493893195834936],
              [126.40833057042937, 33.48576086389053],
              [126.3945419516398, 33.48410628870753],
              [126.3855075727957, 33.488984137888764],
              [126.36854009544949, 33.478167537778994],
              [126.35361347647476, 33.477496534555286],
              [126.33807996206527, 33.4670267545822],
              [126.31905674683927, 33.467054921100456],
              [126.31394976836005, 33.46921567102442],
              [126.30634944589275, 33.45217704378347],
              [126.29213079821942, 33.443413121546925],
              [126.27792939978083, 33.4426250460489],
              [126.27367573535449, 33.43507473079661],
              [126.26334752627754, 33.435817508553114],
              [126.26290374317051, 33.41728391683455],
              [126.2558485367982, 33.412652630540215],
              [126.25038658770575, 33.40113060876257],
              [126.24404432637266, 33.399210026994716],
              [126.23418093175206, 33.38920850795201],
              [126.22291577129948, 33.39003625950717],
              [126.2001334358422, 33.36498622133974],
              [126.18282506167077, 33.35841576026802],
              [126.18054519952403, 33.34911117724828],
              [126.16411862526397, 33.336914358649544],
              [126.16287904524448, 33.324597394070395],
              [126.16868052402097, 33.31643525023105],
              [126.16370300280576, 33.30796576620057],
              [126.16795687435739, 33.29883891183214],
              [126.16164603242164, 33.292265060527846],
              [126.17370692121519, 33.271950548582346],
              [126.183520787717, 33.25938801115593],
              [126.20304852513662, 33.24623926839668],
              [126.21930008802093, 33.24355543182323],
              [126.23541484106852, 33.23589622557547],
              [126.24129676527374, 33.22384399468559],
              [126.24969154814548, 33.21838802224369],
            ],
          ],
          [
            [
              [126.33770484998426, 33.95655915570492],
              [126.32567926380636, 33.95126329184101],
              [126.31464427360866, 33.95475467183295],
              [126.31128299366354, 33.94704518145897],
              [126.3169481332331, 33.941191267060645],
              [126.32663715340959, 33.944898822944445],
              [126.34095797183085, 33.946466095684556],
              [126.33770484998426, 33.95655915570492],
            ],
          ],
          [
            [
              [126.28497807444067, 33.96734188186132],
              [126.2895421146793, 33.95840582632899],
              [126.29850007487774, 33.95249111635456],
              [126.30142854948062, 33.95881700362465],
              [126.29538023739514, 33.96561715202253],
              [126.28497807444067, 33.96734188186132],
            ],
          ],
        ],
      },
      properties: { CTPRVN_CD: '50', CTP_ENG_NM: 'Jeju-do', CTP_KOR_NM: '제주특별자치도' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [127.70247453770094, 38.33613184425116],
              [127.69752917034414, 38.33474508238401],
              [127.69142009658509, 38.32544305964673],
              [127.68559745229535, 38.32400637133282],
              [127.68866146935733, 38.31479226666726],
              [127.6971553838019, 38.32114853082143],
              [127.70247453770094, 38.33613184425116],
            ],
          ],
          [
            [
              [128.54880989369866, 38.301950820562006],
              [128.52823150966034, 38.32096750403076],
              [128.5275968023611, 38.3323790941485],
              [128.5126705662088, 38.346258103461984],
              [128.5060309150307, 38.363620666148776],
              [128.50894144468913, 38.37304724465468],
              [128.4761932264563, 38.4051544449717],
              [128.46339678843648, 38.420942017636484],
              [128.45579087293757, 38.433269403385154],
              [128.45475565013737, 38.4442768762486],
              [128.46098120942023, 38.454919816494396],
              [128.43740988667145, 38.48095471333288],
              [128.430131838897, 38.49067501624919],
              [128.41854493346813, 38.511795296152776],
              [128.41877417949436, 38.523484295868066],
              [128.41234328800502, 38.534978736407346],
              [128.40511561413464, 38.542613611907875],
              [128.40991840015988, 38.55258981839283],
              [128.40478018732696, 38.55535775018421],
              [128.40307744233493, 38.565549688900994],
              [128.39705138979818, 38.56630487537746],
              [128.37204739210125, 38.59062604176471],
              [128.36449563176745, 38.583332606854626],
              [128.36736919705717, 38.57616428729347],
              [128.353324483307, 38.56874790443547],
              [128.34578869216915, 38.57663450240717],
              [128.34089941211195, 38.570918546736465],
              [128.3486495076886, 38.55770412232104],
              [128.34580790796468, 38.55331244622577],
              [128.34829224583862, 38.539516398119645],
              [128.3347007659578, 38.52596638225158],
              [128.34559822640108, 38.50061987486458],
              [128.3395924724799, 38.49171136936256],
              [128.33920919744097, 38.478895789593636],
              [128.32580692023058, 38.47056451098956],
              [128.32023585626874, 38.46224523200206],
              [128.32080002604596, 38.449427082076994],
              [128.3164479274195, 38.44169682594051],
              [128.3237951379771, 38.43328505020008],
              [128.3098138731233, 38.42035823985973],
              [128.29369573222297, 38.42693770714599],
              [128.28437345135802, 38.4260372207757],
              [128.27920350822438, 38.41956992763475],
              [128.268538636767, 38.415747536577925],
              [128.27050346512604, 38.38609067553039],
              [128.2674223748485, 38.376808622148005],
              [128.24852406264628, 38.370777920409616],
              [128.24221747687722, 38.37485674395948],
              [128.23368002161192, 38.372381448349635],
              [128.22917183249254, 38.37896620994445],
              [128.21445316668908, 38.36983304274975],
              [128.2060895636795, 38.359010246349996],
              [128.19623452903, 38.36173842590475],
              [128.1934930192177, 38.353681566612394],
              [128.19791562074832, 38.333033610678974],
              [128.19267967278267, 38.324294118811345],
              [128.18185478089592, 38.32287531132185],
              [128.1706821481264, 38.315648793691906],
              [128.15924201521207, 38.32299722740226],
              [128.15680152610304, 38.32827866546843],
              [128.13698352473935, 38.324401190306304],
              [128.12785468270388, 38.3284806803721],
              [128.11299165785584, 38.32769934494455],
              [128.09030608314617, 38.314217666920335],
              [128.08240603062018, 38.299604819057784],
              [128.08592697453085, 38.29030510918942],
              [128.07956138957812, 38.28825548827675],
              [128.0159659351578, 38.28988664766824],
              [128.0062394776861, 38.277803087451645],
              [127.98246829607251, 38.28064101697041],
              [127.97224408869317, 38.289908958056564],
              [127.96314031262987, 38.293641153783625],
              [127.95822438725943, 38.300219502092986],
              [127.94222791263559, 38.30638452031699],
              [127.92679177254836, 38.30938089545819],
              [127.89490512127861, 38.31291458931926],
              [127.8884681007168, 38.308765195351825],
              [127.87516850367295, 38.29212180335468],
              [127.86081375264075, 38.282554433761376],
              [127.81065972384191, 38.28812464619964],
              [127.79970850501579, 38.298204866473185],
              [127.7817999633969, 38.31078684850587],
              [127.75893324289099, 38.31930443710487],
              [127.74315751909582, 38.31340016116074],
              [127.72827697671163, 38.31360167005567],
              [127.70289307373402, 38.30915906766731],
              [127.68259538602199, 38.31021158042285],
              [127.68754422931616, 38.316655618426964],
              [127.68247163150671, 38.32574823110984],
              [127.66879760375348, 38.322798994006284],
              [127.6614410141789, 38.32527197490606],
              [127.62190944845497, 38.324754497640654],
              [127.60904551144588, 38.336745510970914],
              [127.57721539830214, 38.33614477938804],
              [127.57057386135322, 38.33127971073101],
              [127.54719155326369, 38.32546374162998],
              [127.51574418070365, 38.3046793022386],
              [127.49830723136014, 38.29987096996314],
              [127.48833530845721, 38.30692395983132],
              [127.48162327006575, 38.30679706851162],
              [127.47667954733978, 38.3139095030754],
              [127.46476519462233, 38.31863508471466],
              [127.44526379365051, 38.31682692661221],
              [127.43199641452303, 38.32205411165307],
              [127.42678887134711, 38.32690717070104],
              [127.40997341354387, 38.331544130304664],
              [127.3837252015426, 38.334338391925904],
              [127.38076564558718, 38.33714495126512],
              [127.36356421506568, 38.326727712218734],
              [127.36445346452936, 38.315559534336145],
              [127.3532002948707, 38.30369538963337],
              [127.34393352430746, 38.30254772149025],
              [127.32499156811983, 38.30856924379796],
              [127.3143084278426, 38.30684728909226],
              [127.31058721219213, 38.30190589628111],
              [127.29911385232359, 38.301158260751514],
              [127.30092963018193, 38.313162004843676],
              [127.29330323058116, 38.312343248120044],
              [127.29609461911097, 38.304113444009225],
              [127.29103048309412, 38.300941646146136],
              [127.2855374841623, 38.319040945831624],
              [127.28804621604078, 38.323889027299145],
              [127.27072389396027, 38.32694571900317],
              [127.2601285021999, 38.31584553244418],
              [127.25839590556421, 38.32449692689799],
              [127.24236426228639, 38.33313448845578],
              [127.21889912677217, 38.326248547770454],
              [127.21572155878268, 38.32031161170881],
              [127.19718614611332, 38.31621416316331],
              [127.18524817031852, 38.30552667677945],
              [127.17272256624868, 38.30845283027429],
              [127.16484184971705, 38.2965326623969],
              [127.16640986765728, 38.285961149227376],
              [127.1464050633562, 38.27882887559617],
              [127.13073465816848, 38.30086456822699],
              [127.11080228618182, 38.294982433704746],
              [127.11740638906988, 38.29065177596707],
              [127.11723896433433, 38.28193678285608],
              [127.10721064452754, 38.28528647198229],
              [127.10167790580212, 38.27338775780843],
              [127.10965335462626, 38.271654371760654],
              [127.10875126859983, 38.26088767032874],
              [127.11356982977287, 38.236817975712334],
              [127.13115669560547, 38.232753450276405],
              [127.14892264337992, 38.242343671327866],
              [127.16329367183695, 38.23848128824034],
              [127.16008392272126, 38.219194275318564],
              [127.17116639660127, 38.21349255409076],
              [127.17513521138335, 38.20548395498522],
              [127.16961667028754, 38.19812396807261],
              [127.18055979834706, 38.186145914754206],
              [127.18832005479666, 38.18776273956708],
              [127.18585654816148, 38.17387962366549],
              [127.18893160343661, 38.16181931730787],
              [127.19894530868429, 38.15570737906855],
              [127.21255358149885, 38.14342089691324],
              [127.22093397127313, 38.138373061669725],
              [127.22382150658753, 38.14703522818295],
              [127.23465224873006, 38.147107351874055],
              [127.23929359923814, 38.156501742037065],
              [127.25618917525634, 38.16433221034411],
              [127.26435350852655, 38.171576780443445],
              [127.26602128671477, 38.18023767389728],
              [127.28392173978789, 38.18258791604001],
              [127.29619197082826, 38.17248248620694],
              [127.2889957905912, 38.169456708163594],
              [127.28401324035401, 38.15735240437994],
              [127.28640541213544, 38.15263893713501],
              [127.27590700555264, 38.13889877389534],
              [127.27574627537791, 38.12486281912119],
              [127.2827512636685, 38.11648798595882],
              [127.29229295998148, 38.1143107790269],
              [127.30982194778086, 38.118025365429006],
              [127.3134754037448, 38.10601340188726],
              [127.32067039675483, 38.09468368515179],
              [127.33761773492567, 38.09007284172209],
              [127.33926539614721, 38.10076720974251],
              [127.34813424477248, 38.10482602292673],
              [127.36677516449446, 38.108190228756094],
              [127.37861383445167, 38.11842887282638],
              [127.38389354012934, 38.114601764571745],
              [127.40067174761823, 38.113761131910444],
              [127.40552367017982, 38.102953835493814],
              [127.41340856362515, 38.10201250879012],
              [127.43293663020543, 38.11150583575644],
              [127.44045277622018, 38.10883216232186],
              [127.44516756343232, 38.097469582094774],
              [127.44707601211033, 38.08072855870904],
              [127.4445837954499, 38.05726059255934],
              [127.45290604213851, 38.04718610029926],
              [127.45102199819411, 38.03808503260267],
              [127.45752913794077, 38.016990225526065],
              [127.47155605147863, 38.006452483662386],
              [127.49739967985832, 38.00371417760483],
              [127.50392259514621, 37.99795320961993],
              [127.53109483974366, 38.00238837687408],
              [127.53987722230579, 38.00056767212369],
              [127.54716581395357, 37.97828118709569],
              [127.54737632929958, 37.96645822734833],
              [127.56189128166527, 37.96276970643951],
              [127.57133068757396, 37.963999444441434],
              [127.5847226144783, 37.96175219925418],
              [127.60244484958602, 37.95499848703346],
              [127.60373636176111, 37.944490565783724],
              [127.61267186946228, 37.94047567234347],
              [127.6165840333409, 37.92826556493997],
              [127.61204548891337, 37.92405543717724],
              [127.61705261376977, 37.905995713618275],
              [127.6074026131262, 37.889660206279075],
              [127.60909536701564, 37.88351785439574],
              [127.60321203820091, 37.874200659895],
              [127.58462096729362, 37.87629397434135],
              [127.5685955520566, 37.86697273109062],
              [127.56323907796187, 37.85587948467844],
              [127.5500881781318, 37.851930926420806],
              [127.52944304397563, 37.83972299426381],
              [127.5256188413857, 37.83292392089552],
              [127.52563897387203, 37.82287245227435],
              [127.53494045311166, 37.817710541017284],
              [127.53735452809818, 37.81054048444156],
              [127.52304984208727, 37.796169611622325],
              [127.52225815136116, 37.788947538670165],
              [127.54092429740628, 37.770875059188924],
              [127.54498756750726, 37.76363162851273],
              [127.54208583914001, 37.75466448648626],
              [127.5340756238138, 37.74860208612431],
              [127.51687153893818, 37.74026732638559],
              [127.50711205560003, 37.731359171939474],
              [127.50614819495685, 37.724152571354054],
              [127.51342515403734, 37.71759151321385],
              [127.52470491840013, 37.7264682141252],
              [127.54017203772813, 37.719457833922796],
              [127.5566022394398, 37.729226516341456],
              [127.56186276371152, 37.720071593726736],
              [127.55804510738602, 37.71391475705489],
              [127.5506395450077, 37.68704210400239],
              [127.5490494133041, 37.668614141800326],
              [127.55281595280647, 37.661528264713965],
              [127.5438544933778, 37.65173014664389],
              [127.53565514361559, 37.65069455838031],
              [127.53793696434572, 37.64147830408337],
              [127.5482576137907, 37.63320791872819],
              [127.55946128556232, 37.62848563876724],
              [127.56468093927275, 37.63315713668921],
              [127.58065493744066, 37.63339825230667],
              [127.58486118326044, 37.64230244425472],
              [127.60903120448563, 37.64988228882742],
              [127.61893104897182, 37.64341322612554],
              [127.62643945953315, 37.6430831346721],
              [127.6394328483217, 37.63264266103836],
              [127.64698799769768, 37.63273671810437],
              [127.64985091677872, 37.62414919288033],
              [127.6617073386634, 37.62432221087063],
              [127.67943040472855, 37.60940760991053],
              [127.69998286890036, 37.59695973280319],
              [127.69743103998043, 37.591847464368044],
              [127.70789509996605, 37.586353030965995],
              [127.7231254591103, 37.59062609043578],
              [127.73939617013178, 37.587094512448104],
              [127.75502264994772, 37.59154454366757],
              [127.76657092175476, 37.58266867023072],
              [127.78328722646322, 37.578438647330124],
              [127.79290252726202, 37.58528947850008],
              [127.79997635056104, 37.582774606382316],
              [127.80908917408567, 37.57377195483655],
              [127.81413018597513, 37.56415194317516],
              [127.83232034083942, 37.561566266500286],
              [127.84800416807384, 37.552446628300174],
              [127.84202301094696, 37.53890081347527],
              [127.81046869763513, 37.53778509299143],
              [127.80647305792638, 37.53117138707275],
              [127.79778033371112, 37.52852154472985],
              [127.78663983650671, 37.51427817286649],
              [127.77484938801602, 37.5066595585467],
              [127.76026394732476, 37.503419156430226],
              [127.76019297572111, 37.49221820542035],
              [127.77468910397442, 37.49174626514208],
              [127.78018816031576, 37.488651083940624],
              [127.78775847699832, 37.476423722926434],
              [127.80097399376127, 37.47003734086696],
              [127.79626629653356, 37.46304386644709],
              [127.79938199418697, 37.451770121734185],
              [127.79838851260283, 37.442590868235925],
              [127.80386893710852, 37.43195404233276],
              [127.7936436281986, 37.422508580052856],
              [127.78782851829065, 37.401131137931394],
              [127.77665850270535, 37.38332581708397],
              [127.7773652371066, 37.371234592544454],
              [127.76287266112658, 37.36997727467863],
              [127.76075797350106, 37.35263509324173],
              [127.7579838733374, 37.345770061808715],
              [127.7629657797376, 37.33442770303469],
              [127.75978397485291, 37.330098264071914],
              [127.76814804298711, 37.309527075861304],
              [127.75003766151933, 37.29196239481144],
              [127.7590841406423, 37.27704576491108],
              [127.75944075940264, 37.26429189677742],
              [127.746882998298, 37.239973222663025],
              [127.74893530631913, 37.21833581195656],
              [127.74413482399318, 37.211231038161635],
              [127.75104121690761, 37.18246456089369],
              [127.75552758811821, 37.17144075219242],
              [127.76868921325219, 37.156649795981785],
              [127.78952371248586, 37.143408195597324],
              [127.81739186653752, 37.14721683640034],
              [127.82537034804362, 37.152262589671004],
              [127.84739145128468, 37.152935855446444],
              [127.86196502050012, 37.16104546646506],
              [127.87205010355552, 37.164343889213626],
              [127.88657003625683, 37.161074032911266],
              [127.90163986607662, 37.15180221483511],
              [127.90863342849603, 37.167124239627505],
              [127.91504529055896, 37.16888152798605],
              [127.9231683471111, 37.163961578979865],
              [127.9336255955486, 37.175802777988785],
              [127.93625936609726, 37.188766784934266],
              [127.93092108886259, 37.201130709936386],
              [127.9324728202208, 37.20698945806637],
              [127.92709707177998, 37.22015397136474],
              [127.92158341093494, 37.22504520277964],
              [127.92661824160606, 37.23159715173258],
              [127.9388814814729, 37.24074307976971],
              [127.94519126751365, 37.24056203106555],
              [127.95268367225792, 37.247923555852054],
              [127.96454764845515, 37.25101017327331],
              [127.9798978207515, 37.258334195850175],
              [128.0079653522467, 37.25212221615304],
              [128.0192155748978, 37.244377694416706],
              [128.02301528590857, 37.225633439763605],
              [128.0321273988984, 37.223800073830716],
              [128.03875488824312, 37.216036964201834],
              [128.02829810708795, 37.20232327247957],
              [128.03720314004804, 37.189280568132496],
              [128.04980929421677, 37.18957880572537],
              [128.06047470456633, 37.19409287130124],
              [128.07754317175343, 37.1937003051732],
              [128.10000096046764, 37.20169527325809],
              [128.1115041942181, 37.20767146784577],
              [128.11551202047985, 37.22027314203767],
              [128.12236208012632, 37.225204240883606],
              [128.12532230777012, 37.23453723372519],
              [128.15086136995393, 37.22073753962784],
              [128.15466826300474, 37.21566566953747],
              [128.1640406869549, 37.21330861827129],
              [128.17306872265755, 37.21906456685988],
              [128.17409867344892, 37.23260497800463],
              [128.19279672092023, 37.24486211497816],
              [128.2077992612778, 37.248822930629835],
              [128.2203134976347, 37.240298170897184],
              [128.2284989362547, 37.22802641864014],
              [128.24450865520532, 37.226617801321176],
              [128.25093340248435, 37.229582283810295],
              [128.2597944907251, 37.21640985309465],
              [128.26839367231904, 37.207923270895485],
              [128.28394717444934, 37.21018093992847],
              [128.28818059582068, 37.21507324883749],
              [128.30914092819873, 37.217456804863815],
              [128.31404069722174, 37.22269078804752],
              [128.3333966560443, 37.21578662487446],
              [128.32574458312357, 37.19693244807416],
              [128.31449910206902, 37.19680929556365],
              [128.31048793652968, 37.18733705795433],
              [128.29562361446503, 37.183288257733416],
              [128.29807287027825, 37.17165932198222],
              [128.28967582728308, 37.170148273346136],
              [128.28111422642198, 37.173402380847726],
              [128.27366613908697, 37.16964128081641],
              [128.27038528518784, 37.16177139539933],
              [128.2732864109027, 37.14762908140006],
              [128.28468607250124, 37.14315385217082],
              [128.29833699263733, 37.134189593004855],
              [128.30636098934696, 37.1375258478024],
              [128.3167204832633, 37.14755925032607],
              [128.3306728118321, 37.150343082530824],
              [128.3354988852477, 37.157247300917966],
              [128.3508018704735, 37.15757148807549],
              [128.36020156623485, 37.150643804071166],
              [128.36535295771, 37.15763793311953],
              [128.3780153647027, 37.15171324912503],
              [128.3843517337637, 37.15812153587192],
              [128.3918767520206, 37.155133471795885],
              [128.40087435548523, 37.14687624056275],
              [128.40179303998994, 37.134808395030774],
              [128.39600254009176, 37.128593989463646],
              [128.40728541841747, 37.12637829641111],
              [128.41847337711516, 37.11981437638386],
              [128.42306269782782, 37.10324860105095],
              [128.43645296846074, 37.1118619047414],
              [128.44644886886257, 37.10828605205345],
              [128.45804572868235, 37.11027546411394],
              [128.47780599029625, 37.110154836441765],
              [128.49099660760686, 37.123817705361304],
              [128.49655398940016, 37.12579061344608],
              [128.51075847298353, 37.113954147662724],
              [128.51391201566065, 37.105111852304944],
              [128.53413593097537, 37.098112222640864],
              [128.53683437330395, 37.09013596936451],
              [128.54933650402464, 37.086557231419434],
              [128.56170220976855, 37.090236191986676],
              [128.57440628767577, 37.081316995485636],
              [128.5886849566096, 37.07997540185718],
              [128.59689539108084, 37.08241644568776],
              [128.60610024912532, 37.076705857504805],
              [128.62264238939903, 37.087401740796736],
              [128.62821298486443, 37.0751560273543],
              [128.64267085778954, 37.07076237341295],
              [128.65739772028377, 37.0611667143225],
              [128.67565099669355, 37.05884753975158],
              [128.68373243891412, 37.05143513472432],
              [128.68907353354456, 37.053054477872365],
              [128.7004036335776, 37.040827478697025],
              [128.70909906524935, 37.03935569879916],
              [128.71866895435022, 37.043751340402366],
              [128.73582810185457, 37.03975377893979],
              [128.74907905868298, 37.02886281272924],
              [128.76217594639283, 37.03615534895548],
              [128.76142043345985, 37.044438807270446],
              [128.75302131179575, 37.053717861050835],
              [128.75717869711073, 37.070005134797334],
              [128.76475224092826, 37.063548079899654],
              [128.77134043509756, 37.07634918933144],
              [128.77777338078243, 37.078831931996795],
              [128.77359142793776, 37.087507976716786],
              [128.7802823402968, 37.09234264419118],
              [128.78580648262948, 37.087853455515784],
              [128.79942342605298, 37.086944181201375],
              [128.79996565177998, 37.07897484266633],
              [128.8078711993021, 37.07600456360578],
              [128.82938364072, 37.07845897867223],
              [128.83166605431504, 37.06740398041583],
              [128.83595275745336, 37.06594266491564],
              [128.84687483082698, 37.051606535625915],
              [128.8659485814915, 37.04794264619481],
              [128.8724795190983, 37.04394518457747],
              [128.87835203840115, 37.050863457373644],
              [128.88734121909465, 37.05035514323254],
              [128.89764881112094, 37.04546044057774],
              [128.8980745227118, 37.05760399132665],
              [128.91041668386256, 37.06613475698662],
              [128.9168751356104, 37.078607745356805],
              [128.9150116955151, 37.08367935378068],
              [128.92319827324252, 37.09212064401912],
              [128.9474448141312, 37.09180594615927],
              [128.9592744524821, 37.07757656280514],
              [128.98417415529596, 37.08469362223542],
              [129.00062540615085, 37.080364393005475],
              [129.02187927407417, 37.07689457714888],
              [129.0366899865125, 37.07617843942861],
              [129.0418803834628, 37.07104050020544],
              [129.0639450686188, 37.068440286294766],
              [129.07001527420456, 37.08738130432925],
              [129.07685834208345, 37.092919922069214],
              [129.0957869099912, 37.100401024548475],
              [129.10777955349536, 37.0934972993937],
              [129.1180736604033, 37.09274206410743],
              [129.12718836707467, 37.08444348872346],
              [129.1421809271688, 37.08034593841184],
              [129.161692410403, 37.068883557427355],
              [129.17570592096985, 37.057803157414085],
              [129.1850295662, 37.04657953030384],
              [129.1947522846396, 37.04062970283727],
              [129.20504616516465, 37.0449724009831],
              [129.21380233678266, 37.04303473615029],
              [129.22531419923223, 37.04455991297757],
              [129.23281804732505, 37.05024295156741],
              [129.22852089056659, 37.05723463003117],
              [129.2330750579368, 37.06388186169005],
              [129.22537777431683, 37.07372003423822],
              [129.2404594981957, 37.08503505447317],
              [129.24903022945935, 37.096151291810486],
              [129.2656583393889, 37.1021494413726],
              [129.27123833579736, 37.1163804903187],
              [129.29459169058958, 37.114365036286166],
              [129.298003979214, 37.124536867894165],
              [129.31814732181473, 37.13295224717369],
              [129.32482992358584, 37.14228614024928],
              [129.33324139796628, 37.140707271992476],
              [129.34461119456896, 37.1460214795104],
              [129.3620115744009, 37.14493680145603],
              [129.3563793951416, 37.16582349144063],
              [129.3498664208196, 37.17385419330036],
              [129.34119182806722, 37.17718338214953],
              [129.34253797349922, 37.19555519192924],
              [129.34778313421847, 37.21063589990851],
              [129.34087552702275, 37.22601260450948],
              [129.35527819347098, 37.23505980402364],
              [129.3502593432846, 37.23851619197102],
              [129.3484997523533, 37.247505255731966],
              [129.3269194792666, 37.26471076973473],
              [129.32906435065777, 37.27254773814598],
              [129.32662923664282, 37.27975051877443],
              [129.30059800912545, 37.291858405453254],
              [129.30170675282395, 37.29950130430427],
              [129.2976631081195, 37.310682938836294],
              [129.28936026500983, 37.309032182950894],
              [129.26743481231176, 37.32293784859489],
              [129.26771521872777, 37.33803894164308],
              [129.26052425780713, 37.35213066157432],
              [129.25067721197482, 37.36236887419418],
              [129.25132339783744, 37.380088360629045],
              [129.22664842448768, 37.39304175696046],
              [129.21106223886258, 37.40331661145301],
              [129.19776432621373, 37.415214147283734],
              [129.18922849178654, 37.43439959666315],
              [129.19336261799796, 37.440887774108376],
              [129.1893219623564, 37.45204451027228],
              [129.17958161426878, 37.46258843383827],
              [129.16743496753077, 37.469201474525285],
              [129.15796659204068, 37.481156707407216],
              [129.14217072984593, 37.494905942722006],
              [129.13620907876378, 37.496438307536486],
              [129.1354468479632, 37.504389850314354],
              [129.12163400695363, 37.520662014333496],
              [129.12383224109627, 37.525608638583044],
              [129.11611598282167, 37.53409041438098],
              [129.112461130357, 37.54442088972324],
              [129.11391381937165, 37.55167790065886],
              [129.12014390889107, 37.55346164388008],
              [129.12007270479995, 37.56586651762251],
              [129.1155087856648, 37.578550362296475],
              [129.0951550944742, 37.589744645530764],
              [129.05392180243499, 37.62123228302248],
              [129.0456371974527, 37.63373470824402],
              [129.0435331308893, 37.64274596325913],
              [129.0489957052748, 37.65196583057941],
              [129.05678080010745, 37.65882166733839],
              [129.05299716543593, 37.665595620978365],
              [129.05505018452877, 37.67522404407006],
              [129.01482411619247, 37.70600771917483],
              [129.010676494388, 37.7132921437638],
              [128.99524890429583, 37.72622340897451],
              [128.98527711721323, 37.740454424705405],
              [128.9672240435286, 37.753196824101565],
              [128.94835682291986, 37.77184135782634],
              [128.92217272982825, 37.792126555215496],
              [128.878622669908, 37.82942514828334],
              [128.87658719515073, 37.84059798982952],
              [128.84683275718987, 37.86495806752344],
              [128.8300199719606, 37.88458455424665],
              [128.83410927791124, 37.89424283176108],
              [128.8300407065638, 37.90592505015995],
              [128.8233689458848, 37.90753318800694],
              [128.7936960834236, 37.92955738801834],
              [128.78865494097374, 37.939861425436554],
              [128.76938124590035, 37.95680955107689],
              [128.76277814612365, 37.96613467442398],
              [128.75705243658888, 37.98176516349132],
              [128.73963974754557, 37.996345319860346],
              [128.73049116636997, 38.00862693915031],
              [128.73485803112987, 38.018818853489456],
              [128.72251066479393, 38.02438131394258],
              [128.69792013601696, 38.04263492480984],
              [128.6764044733201, 38.065083917314],
              [128.67485623029611, 38.08093018546205],
              [128.64147873215293, 38.10910735639655],
              [128.63284332246198, 38.11851596723964],
              [128.62863974079843, 38.12877613664473],
              [128.61566767149904, 38.13942689074291],
              [128.6076594287513, 38.15215810018165],
              [128.61015562737, 38.156171284636144],
              [128.6078073219331, 38.173620488008964],
              [128.6088308165015, 38.18299444848075],
              [128.59559722785477, 38.20009984829458],
              [128.5917373957394, 38.192302229829],
              [128.5833806204454, 38.19209196778187],
              [128.58349145427988, 38.19939745261548],
              [128.5922093970601, 38.20143613595739],
              [128.59761716763077, 38.21480959201828],
              [128.58654291450532, 38.229349282124],
              [128.57404052038737, 38.24163342699631],
              [128.56749971602923, 38.25185005496955],
              [128.56009217328116, 38.25735515111186],
              [128.55598028507714, 38.27485056558833],
              [128.54861279655356, 38.28581451672712],
              [128.54880989369866, 38.301950820562006],
            ],
          ],
        ],
      },
      properties: { CTPRVN_CD: '51', CTP_ENG_NM: 'Gangwon-do', CTP_KOR_NM: '강원특별자치도' },
    },
  ],
};
